webpackJsonp([1],Array(169).concat([
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Request_vue__ = __webpack_require__(444);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bd63f58_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Request_vue__ = __webpack_require__(629);
function injectStyle (ssrContext) {
  __webpack_require__(625)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Request_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bd63f58_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Request_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(181), __esModule: true };

/***/ }),
/* 174 */,
/* 175 */,
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(173);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_currency_formatter__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_currency_formatter__);







var UtilFormatter = function () {
  function UtilFormatter() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, UtilFormatter);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(UtilFormatter, null, [{
    key: "setFormatValue",
    value: function setFormatValue() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      return __WEBPACK_IMPORTED_MODULE_3_currency_formatter___default.a.format(value, {
        code: "BRL",
        precision: 4
      });
    }
  }, {
    key: "setUnformatValue",
    value: function setUnformatValue() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      if (value) return parseFloat(__WEBPACK_IMPORTED_MODULE_3_currency_formatter___default.a.unformat(value, {
        code: "BRL"
      }));

      return "R$ 0,0000";
    }

    // padrão dd/mm/yyyy

  }, {
    key: "formatDateBR",
    value: function formatDateBR(date) {
      if (!date) return null;

      var _date$split = date.split('-'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + "/" + month + "/" + year;
    }
    //de isoDate para data dd/mm/yyyy

  }, {
    key: "formatDateISOToBR",
    value: function formatDateISOToBR(date) {
      if (!date) return null;

      var _date$substring$split = date.substring(0, 10).split('-'),
          _date$substring$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$substring$split, 3),
          year = _date$substring$split2[0],
          month = _date$substring$split2[1],
          day = _date$substring$split2[2];

      return day + "/" + month + "/" + year;
    }
    // padrão yyyy-mm-dd

  }, {
    key: "formatDateUS",
    value: function formatDateUS(date) {
      if (!date) return null;

      var _date$split3 = date.split('-'),
          _date$split4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split3, 3),
          year = _date$split4[0],
          month = _date$split4[1],
          day = _date$split4[2];

      return year + "-" + month + "-" + day;
    }
  }]);

  return UtilFormatter;
}(); // class


/* harmony default export */ __webpack_exports__["a"] = (UtilFormatter);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_min_safe_integer__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_min_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_min_safe_integer__);


/* harmony default export */ __webpack_exports__["a"] = ({
  normal: {
    decimal: ',',
    thousands: '.',
    precision: 4,
    masked: false,
    allowBlank: false,
    min: 0
  },
  real: {
    decimal: ',',
    thousands: '.',
    prefix: 'R$ ',
    precision: 4,
    masked: false,
    allowBlank: false,
    min: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_min_safe_integer___default.a,
    max: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default.a
  },
  percent: {
    decimal: ',',
    thousands: '.',
    suffix: ' %',
    precision: 4,
    masked: false,
    allowBlank: false,
    min: 0,
    max: 100
  }
});

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(188), __esModule: true };

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__service_CityService_js__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__service_SystemConfigurationService__ = __webpack_require__(215);







var SheetDefaultData = function () {
  function SheetDefaultData() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SheetDefaultData);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(SheetDefaultData, null, [{
    key: "findCityByNameAndState",
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(address) {
        var city, cities, i;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                city = {};
                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__service_CityService_js__["a" /* default */].getAll();

              case 4:
                cities = _context.sent;
                i = 0;

              case 6:
                if (!(i < cities.length)) {
                  _context.next = 12;
                  break;
                }

                if (!(address.city.toUpperCase() == cities[i].name.toUpperCase() && address.state.toUpperCase() == cities[i].uf.toUpperCase())) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", cities[i]);

              case 9:
                i++;
                _context.next = 6;
                break;

              case 12:
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](1);

                console.log(_context.t0);

              case 17:
                return _context.abrupt("return", city);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 14]]);
      }));

      function findCityByNameAndState(_x) {
        return _ref.apply(this, arguments);
      }

      return findCityByNameAndState;
    }()
  }, {
    key: "getHeader",
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(budget) {
        var systemConfigurations, address, header;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__service_SystemConfigurationService__["a" /* default */].getConfigurations();

              case 2:
                systemConfigurations = _context2.sent;
                address = { sectorType: "SEDE", sector: "SEDE" };

                if (!(budget && budget.client && budget.client.address)) {
                  _context2.next = 15;
                  break;
                }

                _context2.next = 7;
                return this.findCityByNameAndState(budget.client.address);

              case 7:
                address.cityOfService = _context2.sent;

                address.complement = budget.client.address.complement;
                address.district = budget.client.address.district;
                address.number = budget.client.address.number;
                address.addressType = budget.client.address.addressType;
                address.cep = budget.client.address.cep;
                _context2.next = 16;
                break;

              case 15:
                address.sectorType = "", address.cityOfService = {}, address.name = "", address.complement = "", address.district = "", address.number = "", address.addressType = "", address.cep = "", address.sector = "SEDE";

              case 16:
                header = {
                  deliveryAddress: address,
                  professionalCategory: {
                    occupation: {},
                    basicSalary: 0,
                    cbo: ""
                  },
                  unitOfMeasurement: "Posto de Serviço",
                  numberOfEmployees: 1,
                  dataBaseOfTheCategory: new Date().toISOString().substr(0, 10),
                  minimalSalary: 0,
                  mainNotes: systemConfigurations.sheetDefault.header.mainNotes,
                  complementariesNotes: systemConfigurations.sheetDefault.header.complementariesNotes,
                  amountMonthly: 0
                };
                return _context2.abrupt("return", header);

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getHeader(_x2) {
        return _ref2.apply(this, arguments);
      }

      return getHeader;
    }()
  }, {
    key: "getModuleOne",
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var systemConfigurations, moduleOne;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__service_SystemConfigurationService__["a" /* default */].getConfigurations();

              case 2:
                systemConfigurations = _context3.sent;
                moduleOne = {
                  serviceStationGratification: [],
                  percentOfAdditionalHealth: 0,
                  percentOfAdditionalDanger: 0,
                  additionalNocturne: {
                    has: false,
                    workedHours: 0,
                    percent: 0,
                    workJournie: 0
                  },
                  extraHour: {
                    has: false,
                    workJournie: 0,
                    hours50: 0,
                    hours75: 0,
                    hours100: 0
                  },
                  others: [],
                  dsr: {},
                  notes: systemConfigurations.sheetDefault.moduleOne.notes
                };
                return _context3.abrupt("return", moduleOne);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getModuleOne() {
        return _ref3.apply(this, arguments);
      }

      return getModuleOne;
    }()
  }, {
    key: "getModuleTwo",
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var systemConfigurations, moduleTwo;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__service_SystemConfigurationService__["a" /* default */].getConfigurations();

              case 2:
                systemConfigurations = _context4.sent;
                moduleTwo = {
                  fap: 0.5,
                  fgts: 8,
                  incra: 0.2,
                  inss: 20,
                  educationSalary: 2.5,
                  foodAid: {
                    has: false,
                    mealByDay: 0,
                    daysByMonth: 0,
                    value: 0
                  },
                  others: [{
                    description: 'Benefício Social Familiar',
                    value: 9.7
                  }, {
                    description: 'Benefício Assistencial',
                    value: 4
                  }],
                  rat: 2,
                  sebrae: 0.6,
                  senaiSenac: 1,
                  sesiSesc: 1.5,
                  thirteenFirstSalary: 8.33,
                  transport: {
                    has: false,
                    ticketByDay: 0,
                    daysByMonth: 0,
                    tariffValue: 0
                  },
                  vacationAdditional: 11.11,
                  notesOne: systemConfigurations.sheetDefault.moduleTwo.notesOne,
                  notesTwo: systemConfigurations.sheetDefault.moduleTwo.notesTwo,
                  notesThree: systemConfigurations.sheetDefault.moduleTwo.notesThree
                };
                return _context4.abrupt("return", moduleTwo);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getModuleTwo() {
        return _ref4.apply(this, arguments);
      }

      return getModuleTwo;
    }()
  }, {
    key: "getModuleThree",
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var systemConfigurations, fgts, amountOfModuleTwoTwoPercent, basisIndemnifiedValue, basisWorkedValue, moduleThree;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__service_SystemConfigurationService__["a" /* default */].getConfigurations();

              case 2:
                systemConfigurations = _context5.sent;
                fgts = 0.08;
                amountOfModuleTwoTwoPercent = 0;
                basisIndemnifiedValue = 0.05 * (1 / 12) * 100;
                basisWorkedValue = 7 / 30 / 12 * 100;
                moduleThree = {
                  previousNoticeIndemnified: basisIndemnifiedValue,
                  fgtsIncidencePreviousNoticeIndemnified: basisIndemnifiedValue * fgts / 100,
                  fgtsPenaltyPreviousNoticeIndemnified: 100 * (0.08 * (0.4 + 0.1) * 0.9 * (1 + 5 / 56 + 5 / 56 + 1 / 3 * 5 / 56)),
                  previousNoticeWorked: basisWorkedValue,
                  fgtsIncidencePreviousNoticeWorked: amountOfModuleTwoTwoPercent * basisWorkedValue / 100,
                  fgtsPenaltyPreviousNoticeWorked: 0.08 * (0.4 + 0.1) * basisWorkedValue
                };
                return _context5.abrupt("return", moduleThree);

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getModuleThree() {
        return _ref5.apply(this, arguments);
      }

      return getModuleThree;
    }()
  }, {
    key: "getModuleFour",
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var systemConfigurations, moduleFour;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__service_SystemConfigurationService__["a" /* default */].getConfigurations();

              case 2:
                systemConfigurations = _context6.sent;
                moduleFour = {
                  vacation: 1 / 12 * 100,
                  legalAbsences: 5 / 360 * 100,
                  paternityLicence: 5 / 365 * 0.015 * 100,
                  workAccident: 15 / 360 * 3.02,
                  maternityLicence: 0.5 * 0.01416 * (4 / 12) * (0.0893 + 0.0893 + 0.0298) * 100,
                  professionalAbsent: 0,
                  restAndFeeding: 0,
                  others: [],
                  notes: systemConfigurations.sheetDefault.moduleFour.notes
                };
                return _context6.abrupt("return", moduleFour);

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getModuleFour() {
        return _ref6.apply(this, arguments);
      }

      return getModuleFour;
    }()
  }, {
    key: "getModuleFive",
    value: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var systemConfigurations, moduleFive;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__service_SystemConfigurationService__["a" /* default */].getConfigurations();

              case 2:
                systemConfigurations = _context7.sent;
                moduleFive = {
                  consumables: {
                    bond: null,
                    depreciation: false,
                    items: []
                  },
                  equipments: {
                    bond: null,
                    depreciation: false,
                    items: []
                  },

                  uniformsAndEPIs: {
                    bond: null,
                    depreciation: false,
                    items: []
                  },
                  utensils: {
                    bond: null,
                    depreciation: false,
                    items: []
                  },
                  others: [],
                  notes: systemConfigurations.sheetDefault.moduleFive.notes
                };
                return _context7.abrupt("return", moduleFive);

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getModuleFive() {
        return _ref7.apply(this, arguments);
      }

      return getModuleFive;
    }()
  }, {
    key: "getModuleSix",
    value: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var systemConfigurations, moduleSix;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__service_SystemConfigurationService__["a" /* default */].getConfigurations();

              case 2:
                systemConfigurations = _context8.sent;
                moduleSix = {
                  administrativeCosts: 0,
                  lucre: 0,
                  others: [],
                  notes: systemConfigurations.sheetDefault.moduleSix.notes
                };
                return _context8.abrupt("return", moduleSix);

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getModuleSix() {
        return _ref8.apply(this, arguments);
      }

      return getModuleSix;
    }()
  }]);

  return SheetDefaultData;
}();

/* harmony default export */ __webpack_exports__["a"] = (SheetDefaultData);

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(182);
module.exports = __webpack_require__(3).Object.assign;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(8);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(183) });


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(5);
var getKeys = __webpack_require__(63);
var gOPS = __webpack_require__(184);
var pIE = __webpack_require__(185);
var toObject = __webpack_require__(65);
var IObject = __webpack_require__(64);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(34)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 184 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 185 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configuration__ = __webpack_require__(59);









var url = __WEBPACK_IMPORTED_MODULE_5__configuration__["a" /* default */].apiHost + "products";

var ProductService = function () {
  function ProductService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ProductService);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ProductService, null, [{
    key: 'validade',
    value: function validade(product) {
      var errors = [];
      if (!product.category) errors.push('categoria');
      if (!product.description) errors.push('descrição');
      if (!product.unity) errors.push('unidade de medida');
      if (!product.value) errors.push('valor unitário');

      if (errors.length > 0) return errors;else return null;
    }
  }, {
    key: 'getAll',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var products;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url);

              case 3:
                products = _context.sent;
                return _context.abrupt('return', products.data);

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);
                throw _context.t0.response.data;

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function getAll() {
        return _ref.apply(this, arguments);
      }

      return getAll;
    }() // getAll()

  }, {
    key: 'getByCategory',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(type) {
        var products;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url + "/getByCategory", type);

              case 3:
                products = _context2.sent;
                return _context2.abrupt('return', products.data);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0.response.data;

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function getByCategory(_x) {
        return _ref2.apply(this, arguments);
      }

      return getByCategory;
    }()
  }, {
    key: 'save',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(product) {
        var productSaved;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url, product);

              case 3:
                productSaved = _context3.sent;
                return _context3.abrupt('return', productSaved.data);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);
                throw _context3.t0.response.data;

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function save(_x2) {
        return _ref3.apply(this, arguments);
      }

      return save;
    }() // save()

  }, {
    key: 'update',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(product) {
        var productUpdated;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(url, product);

              case 3:
                productUpdated = _context4.sent;
                return _context4.abrupt('return', productUpdated.data);

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4['catch'](0);
                throw _context4.t0.response.data;

              case 10:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 7]]);
      }));

      function update(_x3) {
        return _ref4.apply(this, arguments);
      }

      return update;
    }() // update()

  }, {
    key: 'remove',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(product) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete(url, {
                  data: product
                });

              case 3:
                _context5.next = 8;
                break;

              case 5:
                _context5.prev = 5;
                _context5.t0 = _context5['catch'](0);
                throw _context5.t0.response.data;

              case 8:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 5]]);
      }));

      function remove(_x4) {
        return _ref5.apply(this, arguments);
      }

      return remove;
    }() // remove()

  }]);

  return ProductService;
}(); // class


/* harmony default export */ __webpack_exports__["a"] = (ProductService);

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configuration__ = __webpack_require__(59);









var url = __WEBPACK_IMPORTED_MODULE_5__configuration__["a" /* default */].apiHost;

var CityService = function () {
  function CityService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CityService);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CityService, null, [{
    key: 'getAll',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var officces;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url + "city");

              case 3:
                officces = _context.sent;
                return _context.abrupt('return', officces.data);

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);
                throw _context.t0.response.data;

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function getAll() {
        return _ref.apply(this, arguments);
      }

      return getAll;
    }() // getAll()

  }, {
    key: 'save',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(city) {
        var citySaved;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url + "city", city);

              case 3:
                citySaved = _context2.sent;
                return _context2.abrupt('return', citySaved.data);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0.response.data;

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function save(_x) {
        return _ref2.apply(this, arguments);
      }

      return save;
    }() // save()

  }, {
    key: 'update',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(city) {
        var cityUpdated;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(url + "city", city);

              case 3:
                cityUpdated = _context3.sent;
                return _context3.abrupt('return', cityUpdated.data);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);
                throw _context3.t0.response.data;

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function update(_x2) {
        return _ref3.apply(this, arguments);
      }

      return update;
    }() // update()

  }, {
    key: 'remove',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(city) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete(url + "city", {
                  data: city
                });

              case 3:
                _context4.next = 8;
                break;

              case 5:
                _context4.prev = 5;
                _context4.t0 = _context4['catch'](0);
                throw _context4.t0.response.data;

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 5]]);
      }));

      function remove(_x3) {
        return _ref4.apply(this, arguments);
      }

      return remove;
    }() // remove()

  }]);

  return CityService;
}(); // class


/* harmony default export */ __webpack_exports__["a"] = (CityService);

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(62);
__webpack_require__(61);
module.exports = __webpack_require__(189);


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(4);
var get = __webpack_require__(66);
module.exports = __webpack_require__(3).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configuration__ = __webpack_require__(59);








var url = __WEBPACK_IMPORTED_MODULE_5__configuration__["a" /* default */].apiHost;

var UserService = function () {
  function UserService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, UserService);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(UserService, null, [{
    key: 'validade',
    value: function validade(person) {
      var errors = [];
      if (person.isLegalPerson) {
        if (!person.name) errors.push('nome');
        if (!person.email) errors.push('e-mail');
        if (!person.cpf) errors.push('cpf');
        if (!person.rg) errors.push('rg');
      }

      if (errors.length > 0) return errors;else return null;
    }
  }, {
    key: 'getAll',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var users;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url + "persons");

              case 3:
                users = _context.sent;
                return _context.abrupt('return', users.data);

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);
                throw _context.t0.response.data;

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function getAll() {
        return _ref.apply(this, arguments);
      }

      return getAll;
    }() // getAll()

  }, {
    key: 'getPersonsForSpecificData',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var personsSaved;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url + 'persons/find/ _id name socialName  address');

              case 3:
                personsSaved = _context2.sent;
                return _context2.abrupt('return', personsSaved.data);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0.response.data;

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function getPersonsForSpecificData() {
        return _ref2.apply(this, arguments);
      }

      return getPersonsForSpecificData;
    }()
  }, {
    key: 'save',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(person) {
        var personSaved;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url + "persons", person);

              case 3:
                personSaved = _context3.sent;
                return _context3.abrupt('return', personSaved.data);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);
                throw _context3.t0.response.data;

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function save(_x) {
        return _ref3.apply(this, arguments);
      }

      return save;
    }() // save()

  }, {
    key: 'update',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(person) {
        var personUpdated;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(url + "persons", person);

              case 3:
                personUpdated = _context4.sent;
                return _context4.abrupt('return', personUpdated.data);

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4['catch'](0);
                throw _context4.t0.response.data;

              case 10:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 7]]);
      }));

      function update(_x2) {
        return _ref4.apply(this, arguments);
      }

      return update;
    }() // update()

  }, {
    key: 'remove',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(person) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete(url + "persons", {
                  data: person
                });

              case 3:
                _context5.next = 8;
                break;

              case 5:
                _context5.prev = 5;
                _context5.t0 = _context5['catch'](0);
                throw _context5.t0.response.data;

              case 8:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 5]]);
      }));

      function remove(_x3) {
        return _ref5.apply(this, arguments);
      }

      return remove;
    }() // remove()

  }, {
    key: 'searchCnpj',
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(cnpj) {
        var validCnpj;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url + "searchCnpj", cnpj);

              case 3:
                validCnpj = _context6.sent;
                return _context6.abrupt('return', validCnpj.data);

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6['catch'](0);
                throw _context6.t0.response.data;

              case 10:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 7]]);
      }));

      function searchCnpj(_x4) {
        return _ref6.apply(this, arguments);
      }

      return searchCnpj;
    }() // searchCnpj()

  }]);

  return UserService;
}(); // class


/* harmony default export */ __webpack_exports__["a"] = (UserService);

/***/ }),
/* 191 */,
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(193);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(179);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(194), __esModule: true };

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(62);
__webpack_require__(61);
module.exports = __webpack_require__(195);


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(35);
var ITERATOR = __webpack_require__(2)('iterator');
var Iterators = __webpack_require__(10);
module.exports = __webpack_require__(3).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var accounting = __webpack_require__(197)
var assign = __webpack_require__(198)
var localeCurrency = __webpack_require__(199)
var currencies = __webpack_require__(201)
var localeFormats = __webpack_require__(202)

var defaultCurrency = {
  symbol: '',
  thousandsSeparator: ',',
  decimalSeparator: '.',
  symbolOnLeft: true,
  spaceBetweenAmountAndSymbol: false,
  decimalDigits: 2
}

var defaultLocaleFormat = {}

var formatMapping = [
  {
    symbolOnLeft: true,
    spaceBetweenAmountAndSymbol: false,
    format: {
      pos: '%s%v',
      neg: '-%s%v',
      zero: '%s%v'
    }
  },
  {
    symbolOnLeft: true,
    spaceBetweenAmountAndSymbol: true,
    format: {
      pos: '%s %v',
      neg: '-%s %v',
      zero: '%s %v'
    }
  },
  {
    symbolOnLeft: false,
    spaceBetweenAmountAndSymbol: false,
    format: {
      pos: '%v%s',
      neg: '-%v%s',
      zero: '%v%s'
    }
  },
  {
    symbolOnLeft: false,
    spaceBetweenAmountAndSymbol: true,
    format: {
      pos: '%v %s',
      neg: '-%v %s',
      zero: '%v %s'
    }
  }
]

function format(value, options) {
  var code = options.code || (options.locale && localeCurrency.getCurrency(options.locale))
  var localeMatch = /^([a-z]+)([_-]([a-z]+))?$/i.exec(options.locale) || []
  var language = localeMatch[1]
  var region = localeMatch[3]
  var localeFormat = assign({}, defaultLocaleFormat,
                            localeFormats[language] || {},
                            localeFormats[language + '-' + region] || {})
  var currency = assign({}, defaultCurrency, findCurrency(code), localeFormat)
  
  var symbolOnLeft = currency.symbolOnLeft
  var spaceBetweenAmountAndSymbol = currency.spaceBetweenAmountAndSymbol

  var format = formatMapping.filter(function(f) {
    return f.symbolOnLeft == symbolOnLeft && f.spaceBetweenAmountAndSymbol == spaceBetweenAmountAndSymbol
  })[0].format

  return accounting.formatMoney(value, {
    symbol: isUndefined(options.symbol)
              ? currency.symbol
              : options.symbol,

    decimal: isUndefined(options.decimal)
              ? currency.decimalSeparator
              : options.decimal,

    thousand: isUndefined(options.thousand)
              ? currency.thousandsSeparator
              : options.thousand,

    precision: typeof options.precision === 'number'
              ? options.precision
              : currency.decimalDigits,

    format: ['string', 'object'].indexOf(typeof options.format) > -1
              ? options.format
              : format
  })
}

function findCurrency (currencyCode) {
  return currencies[currencyCode]
}

function isUndefined (val) {
  return typeof val === 'undefined'
}

function unformat(value, options) {
  var code = options.code || (options.locale && localeCurrency.getCurrency(options.locale))
  var localeFormat = localeFormats[options.locale] || defaultLocaleFormat
  var currency = assign({}, defaultCurrency, findCurrency(code), localeFormat)
  var decimal = isUndefined(options.decimal) ? currency.decimalSeparator : options.decimal
  return accounting.unformat(value, decimal)
}

module.exports = {
  defaultCurrency: defaultCurrency,
  get currencies() {
    // In favor of backwards compatibility, the currencies map is converted to an array here
    return Object.keys(currencies).map(function(key) {
      return currencies[key]
    })
  },
  findCurrency: findCurrency,
  format: format,
  unformat: unformat
}

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * accounting.js v0.4.1
 * Copyright 2014 Open Exchange Rates
 *
 * Freely distributable under the MIT license.
 * Portions of accounting.js are inspired or borrowed from underscore.js
 *
 * Full details and documentation:
 * http://openexchangerates.github.io/accounting.js/
 */

(function(root, undefined) {

	/* --- Setup --- */

	// Create the local library object, to be exported or referenced globally later
	var lib = {};

	// Current version
	lib.version = '0.4.1';


	/* --- Exposed settings --- */

	// The library's settings configuration object. Contains default parameters for
	// currency and number formatting
	lib.settings = {
		currency: {
			symbol : "$",		// default currency symbol is '$'
			format : "%s%v",	// controls output: %s = symbol, %v = value (can be object, see docs)
			decimal : ".",		// decimal point separator
			thousand : ",",		// thousands separator
			precision : 2,		// decimal places
			grouping : 3		// digit grouping (not implemented yet)
		},
		number: {
			precision : 0,		// default precision on numbers is 0
			grouping : 3,		// digit grouping (not implemented yet)
			thousand : ",",
			decimal : "."
		}
	};


	/* --- Internal Helper Methods --- */

	// Store reference to possibly-available ECMAScript 5 methods for later
	var nativeMap = Array.prototype.map,
		nativeIsArray = Array.isArray,
		toString = Object.prototype.toString;

	/**
	 * Tests whether supplied parameter is a string
	 * from underscore.js
	 */
	function isString(obj) {
		return !!(obj === '' || (obj && obj.charCodeAt && obj.substr));
	}

	/**
	 * Tests whether supplied parameter is a string
	 * from underscore.js, delegates to ECMA5's native Array.isArray
	 */
	function isArray(obj) {
		return nativeIsArray ? nativeIsArray(obj) : toString.call(obj) === '[object Array]';
	}

	/**
	 * Tests whether supplied parameter is a true object
	 */
	function isObject(obj) {
		return obj && toString.call(obj) === '[object Object]';
	}

	/**
	 * Extends an object with a defaults object, similar to underscore's _.defaults
	 *
	 * Used for abstracting parameter handling from API methods
	 */
	function defaults(object, defs) {
		var key;
		object = object || {};
		defs = defs || {};
		// Iterate over object non-prototype properties:
		for (key in defs) {
			if (defs.hasOwnProperty(key)) {
				// Replace values with defaults only if undefined (allow empty/zero values):
				if (object[key] == null) object[key] = defs[key];
			}
		}
		return object;
	}

	/**
	 * Implementation of `Array.map()` for iteration loops
	 *
	 * Returns a new Array as a result of calling `iterator` on each array value.
	 * Defers to native Array.map if available
	 */
	function map(obj, iterator, context) {
		var results = [], i, j;

		if (!obj) return results;

		// Use native .map method if it exists:
		if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);

		// Fallback for native .map:
		for (i = 0, j = obj.length; i < j; i++ ) {
			results[i] = iterator.call(context, obj[i], i, obj);
		}
		return results;
	}

	/**
	 * Check and normalise the value of precision (must be positive integer)
	 */
	function checkPrecision(val, base) {
		val = Math.round(Math.abs(val));
		return isNaN(val)? base : val;
	}


	/**
	 * Parses a format string or object and returns format obj for use in rendering
	 *
	 * `format` is either a string with the default (positive) format, or object
	 * containing `pos` (required), `neg` and `zero` values (or a function returning
	 * either a string or object)
	 *
	 * Either string or format.pos must contain "%v" (value) to be valid
	 */
	function checkCurrencyFormat(format) {
		var defaults = lib.settings.currency.format;

		// Allow function as format parameter (should return string or object):
		if ( typeof format === "function" ) format = format();

		// Format can be a string, in which case `value` ("%v") must be present:
		if ( isString( format ) && format.match("%v") ) {

			// Create and return positive, negative and zero formats:
			return {
				pos : format,
				neg : format.replace("-", "").replace("%v", "-%v"),
				zero : format
			};

		// If no format, or object is missing valid positive value, use defaults:
		} else if ( !format || !format.pos || !format.pos.match("%v") ) {

			// If defaults is a string, casts it to an object for faster checking next time:
			return ( !isString( defaults ) ) ? defaults : lib.settings.currency.format = {
				pos : defaults,
				neg : defaults.replace("%v", "-%v"),
				zero : defaults
			};

		}
		// Otherwise, assume format was fine:
		return format;
	}


	/* --- API Methods --- */

	/**
	 * Takes a string/array of strings, removes all formatting/cruft and returns the raw float value
	 * Alias: `accounting.parse(string)`
	 *
	 * Decimal must be included in the regular expression to match floats (defaults to
	 * accounting.settings.number.decimal), so if the number uses a non-standard decimal 
	 * separator, provide it as the second argument.
	 *
	 * Also matches bracketed negatives (eg. "$ (1.99)" => -1.99)
	 *
	 * Doesn't throw any errors (`NaN`s become 0) but this may change in future
	 */
	var unformat = lib.unformat = lib.parse = function(value, decimal) {
		// Recursively unformat arrays:
		if (isArray(value)) {
			return map(value, function(val) {
				return unformat(val, decimal);
			});
		}

		// Fails silently (need decent errors):
		value = value || 0;

		// Return the value as-is if it's already a number:
		if (typeof value === "number") return value;

		// Default decimal point comes from settings, but could be set to eg. "," in opts:
		decimal = decimal || lib.settings.number.decimal;

		 // Build regex to strip out everything except digits, decimal point and minus sign:
		var regex = new RegExp("[^0-9-" + decimal + "]", ["g"]),
			unformatted = parseFloat(
				("" + value)
				.replace(/\((.*)\)/, "-$1") // replace bracketed values with negatives
				.replace(regex, '')         // strip out any cruft
				.replace(decimal, '.')      // make sure decimal point is standard
			);

		// This will fail silently which may cause trouble, let's wait and see:
		return !isNaN(unformatted) ? unformatted : 0;
	};


	/**
	 * Implementation of toFixed() that treats floats more like decimals
	 *
	 * Fixes binary rounding issues (eg. (0.615).toFixed(2) === "0.61") that present
	 * problems for accounting- and finance-related software.
	 */
	var toFixed = lib.toFixed = function(value, precision) {
		precision = checkPrecision(precision, lib.settings.number.precision);
		var power = Math.pow(10, precision);

		// Multiply up by precision, round accurately, then divide and use native toFixed():
		return (Math.round(lib.unformat(value) * power) / power).toFixed(precision);
	};


	/**
	 * Format a number, with comma-separated thousands and custom precision/decimal places
	 * Alias: `accounting.format()`
	 *
	 * Localise by overriding the precision and thousand / decimal separators
	 * 2nd parameter `precision` can be an object matching `settings.number`
	 */
	var formatNumber = lib.formatNumber = lib.format = function(number, precision, thousand, decimal) {
		// Resursively format arrays:
		if (isArray(number)) {
			return map(number, function(val) {
				return formatNumber(val, precision, thousand, decimal);
			});
		}

		// Clean up number:
		number = unformat(number);

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(
				(isObject(precision) ? precision : {
					precision : precision,
					thousand : thousand,
					decimal : decimal
				}),
				lib.settings.number
			),

			// Clean up precision
			usePrecision = checkPrecision(opts.precision),

			// Do some calc:
			negative = number < 0 ? "-" : "",
			base = parseInt(toFixed(Math.abs(number || 0), usePrecision), 10) + "",
			mod = base.length > 3 ? base.length % 3 : 0;

		// Format the number:
		return negative + (mod ? base.substr(0, mod) + opts.thousand : "") + base.substr(mod).replace(/(\d{3})(?=\d)/g, "$1" + opts.thousand) + (usePrecision ? opts.decimal + toFixed(Math.abs(number), usePrecision).split('.')[1] : "");
	};


	/**
	 * Format a number into currency
	 *
	 * Usage: accounting.formatMoney(number, symbol, precision, thousandsSep, decimalSep, format)
	 * defaults: (0, "$", 2, ",", ".", "%s%v")
	 *
	 * Localise by overriding the symbol, precision, thousand / decimal separators and format
	 * Second param can be an object matching `settings.currency` which is the easiest way.
	 *
	 * To do: tidy up the parameters
	 */
	var formatMoney = lib.formatMoney = function(number, symbol, precision, thousand, decimal, format) {
		// Resursively format arrays:
		if (isArray(number)) {
			return map(number, function(val){
				return formatMoney(val, symbol, precision, thousand, decimal, format);
			});
		}

		// Clean up number:
		number = unformat(number);

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(
				(isObject(symbol) ? symbol : {
					symbol : symbol,
					precision : precision,
					thousand : thousand,
					decimal : decimal,
					format : format
				}),
				lib.settings.currency
			),

			// Check format (returns object with pos, neg and zero):
			formats = checkCurrencyFormat(opts.format),

			// Choose which format to use for this value:
			useFormat = number > 0 ? formats.pos : number < 0 ? formats.neg : formats.zero;

		// Return with currency symbol added:
		return useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(number), checkPrecision(opts.precision), opts.thousand, opts.decimal));
	};


	/**
	 * Format a list of numbers into an accounting column, padding with whitespace
	 * to line up currency symbols, thousand separators and decimals places
	 *
	 * List should be an array of numbers
	 * Second parameter can be an object containing keys that match the params
	 *
	 * Returns array of accouting-formatted number strings of same length
	 *
	 * NB: `white-space:pre` CSS rule is required on the list container to prevent
	 * browsers from collapsing the whitespace in the output strings.
	 */
	lib.formatColumn = function(list, symbol, precision, thousand, decimal, format) {
		if (!list) return [];

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(
				(isObject(symbol) ? symbol : {
					symbol : symbol,
					precision : precision,
					thousand : thousand,
					decimal : decimal,
					format : format
				}),
				lib.settings.currency
			),

			// Check format (returns object with pos, neg and zero), only need pos for now:
			formats = checkCurrencyFormat(opts.format),

			// Whether to pad at start of string or after currency symbol:
			padAfterSymbol = formats.pos.indexOf("%s") < formats.pos.indexOf("%v") ? true : false,

			// Store value for the length of the longest string in the column:
			maxLength = 0,

			// Format the list according to options, store the length of the longest string:
			formatted = map(list, function(val, i) {
				if (isArray(val)) {
					// Recursively format columns if list is a multi-dimensional array:
					return lib.formatColumn(val, opts);
				} else {
					// Clean up the value
					val = unformat(val);

					// Choose which format to use for this value (pos, neg or zero):
					var useFormat = val > 0 ? formats.pos : val < 0 ? formats.neg : formats.zero,

						// Format this value, push into formatted list and save the length:
						fVal = useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(val), checkPrecision(opts.precision), opts.thousand, opts.decimal));

					if (fVal.length > maxLength) maxLength = fVal.length;
					return fVal;
				}
			});

		// Pad each number in the list and send back the column of numbers:
		return map(formatted, function(val, i) {
			// Only if this is a string (not a nested array, which would have already been padded):
			if (isString(val) && val.length < maxLength) {
				// Depending on symbol position, pad after symbol or at index 0:
				return padAfterSymbol ? val.replace(opts.symbol, opts.symbol+(new Array(maxLength - val.length + 1).join(" "))) : (new Array(maxLength - val.length + 1).join(" ")) + val;
			}
			return val;
		});
	};


	/* --- Module Definition --- */

	// Export accounting for CommonJS. If being loaded as an AMD module, define it as such.
	// Otherwise, just add `accounting` to the global object
	if (true) {
		if (typeof module !== 'undefined' && module.exports) {
			exports = module.exports = lib;
		}
		exports.accounting = lib;
	} else if (typeof define === 'function' && define.amd) {
		// Return the library as an AMD module:
		define([], function() {
			return lib;
		});
	} else {
		// Use accounting.noConflict to restore `accounting` back to its original value.
		// Returns a reference to the library's `accounting` object;
		// e.g. `var numbers = accounting.noConflict();`
		lib.noConflict = (function(oldAccounting) {
			return function() {
				// Reset the value of the root's `accounting` variable:
				root.accounting = oldAccounting;
				// Delete the noConflict method:
				lib.noConflict = undefined;
				// Return reference to the library to re-assign it:
				return lib;
			};
		})(root.accounting);

		// Declare `fx` on the root (global/window) object:
		root['accounting'] = lib;
	}

	// Root will be `window` in browser or `global` on the server:
}(this));


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var map = __webpack_require__(200);

var getCountryCode = function(localeString) {
    var components = localeString.split("_");
    if (components.length == 2) {
        return components.pop();
    }
    components = localeString.split("-");
    if (components.length == 2) {
        return components.pop();
    }
    return localeString;
}

exports.getCurrency = function(locale) {
    var countryCode = getCountryCode(locale).toUpperCase();
    if (countryCode in map) {
        return map[countryCode];
    }
    return null;
}

exports.getLocales = function(currencyCode) {
    currencyCode = currencyCode.toUpperCase();
    var locales = [];
    for (countryCode in map) {
        if (map[countryCode] === currencyCode) {
            locales.push(countryCode);
        }
    }
    return locales;
}

/***/ }),
/* 200 */
/***/ (function(module, exports) {

// Generated using ShowCurrencies.java
var map = {
AD: 'EUR',
AE: 'AED',
AF: 'AFN',
AG: 'XCD',
AI: 'XCD',
AL: 'ALL',
AM: 'AMD',
AN: 'ANG',
AO: 'AOA',
AR: 'ARS',
AS: 'USD',
AT: 'EUR',
AU: 'AUD',
AW: 'AWG',
AX: 'EUR',
AZ: 'AZN',
BA: 'BAM',
BB: 'BBD',
BD: 'BDT',
BE: 'EUR',
BF: 'XOF',
BG: 'BGN',
BH: 'BHD',
BI: 'BIF',
BJ: 'XOF',
BL: 'EUR',
BM: 'BMD',
BN: 'BND',
BO: 'BOB',
BQ: 'USD',
BR: 'BRL',
BS: 'BSD',
BT: 'BTN',
BV: 'NOK',
BW: 'BWP',
BY: 'BYR',
BZ: 'BZD',
CA: 'CAD',
CC: 'AUD',
CD: 'CDF',
CF: 'XAF',
CG: 'XAF',
CH: 'CHF',
CI: 'XOF',
CK: 'NZD',
CL: 'CLP',
CM: 'XAF',
CN: 'CNY',
CO: 'COP',
CR: 'CRC',
CU: 'CUP',
CV: 'CVE',
CW: 'ANG',
CX: 'AUD',
CY: 'EUR',
CZ: 'CZK',
DE: 'EUR',
DJ: 'DJF',
DK: 'DKK',
DM: 'XCD',
DO: 'DOP',
DZ: 'DZD',
EC: 'USD',
EE: 'EUR',
EG: 'EGP',
EH: 'MAD',
ER: 'ERN',
ES: 'EUR',
ET: 'ETB',
FI: 'EUR',
FJ: 'FJD',
FK: 'FKP',
FM: 'USD',
FO: 'DKK',
FR: 'EUR',
GA: 'XAF',
GB: 'GBP',
GD: 'XCD',
GE: 'GEL',
GF: 'EUR',
GG: 'GBP',
GH: 'GHS',
GI: 'GIP',
GL: 'DKK',
GM: 'GMD',
GN: 'GNF',
GP: 'EUR',
GQ: 'XAF',
GR: 'EUR',
GS: 'GBP',
GT: 'GTQ',
GU: 'USD',
GW: 'XOF',
GY: 'GYD',
HK: 'HKD',
HM: 'AUD',
HN: 'HNL',
HR: 'HRK',
HT: 'HTG',
HU: 'HUF',
ID: 'IDR',
IE: 'EUR',
IL: 'ILS',
IM: 'GBP',
IN: 'INR',
IO: 'USD',
IQ: 'IQD',
IR: 'IRR',
IS: 'ISK',
IT: 'EUR',
JE: 'GBP',
JM: 'JMD',
JO: 'JOD',
JP: 'JPY',
KE: 'KES',
KG: 'KGS',
KH: 'KHR',
KI: 'AUD',
KM: 'KMF',
KN: 'XCD',
KP: 'KPW',
KR: 'KRW',
KW: 'KWD',
KY: 'KYD',
KZ: 'KZT',
LA: 'LAK',
LB: 'LBP',
LC: 'XCD',
LI: 'CHF',
LK: 'LKR',
LR: 'LRD',
LS: 'LSL',
LT: 'LTL',
LU: 'EUR',
LV: 'LVL',
LY: 'LYD',
MA: 'MAD',
MC: 'EUR',
MD: 'MDL',
ME: 'EUR',
MF: 'EUR',
MG: 'MGA',
MH: 'USD',
MK: 'MKD',
ML: 'XOF',
MM: 'MMK',
MN: 'MNT',
MO: 'MOP',
MP: 'USD',
MQ: 'EUR',
MR: 'MRO',
MS: 'XCD',
MT: 'EUR',
MU: 'MUR',
MV: 'MVR',
MW: 'MWK',
MX: 'MXN',
MY: 'MYR',
MZ: 'MZN',
NA: 'NAD',
NC: 'XPF',
NE: 'XOF',
NF: 'AUD',
NG: 'NGN',
NI: 'NIO',
NL: 'EUR',
NO: 'NOK',
NP: 'NPR',
NR: 'AUD',
NU: 'NZD',
NZ: 'NZD',
OM: 'OMR',
PA: 'PAB',
PE: 'PEN',
PF: 'XPF',
PG: 'PGK',
PH: 'PHP',
PK: 'PKR',
PL: 'PLN',
PM: 'EUR',
PN: 'NZD',
PR: 'USD',
PS: 'ILS',
PT: 'EUR',
PW: 'USD',
PY: 'PYG',
QA: 'QAR',
RE: 'EUR',
RO: 'RON',
RS: 'RSD',
RU: 'RUB',
RW: 'RWF',
SA: 'SAR',
SB: 'SBD',
SC: 'SCR',
SD: 'SDG',
SE: 'SEK',
SG: 'SGD',
SH: 'SHP',
SI: 'EUR',
SJ: 'NOK',
SK: 'EUR',
SL: 'SLL',
SM: 'EUR',
SN: 'XOF',
SO: 'SOS',
SR: 'SRD',
ST: 'STD',
SV: 'SVC',
SX: 'ANG',
SY: 'SYP',
SZ: 'SZL',
TC: 'USD',
TD: 'XAF',
TF: 'EUR',
TG: 'XOF',
TH: 'THB',
TJ: 'TJS',
TK: 'NZD',
TL: 'USD',
TM: 'TMT',
TN: 'TND',
TO: 'TOP',
TR: 'TRY',
TT: 'TTD',
TV: 'AUD',
TW: 'TWD',
TZ: 'TZS',
UA: 'UAH',
UG: 'UGX',
UM: 'USD',
US: 'USD',
UY: 'UYU',
UZ: 'UZS',
VA: 'EUR',
VC: 'XCD',
VE: 'VEF',
VG: 'USD',
VI: 'USD',
VN: 'VND',
VU: 'VUV',
WF: 'XPF',
WS: 'WST',
YE: 'YER',
YT: 'EUR',
ZA: 'ZAR',
ZM: 'ZMK',
ZW: 'ZWL'
};

module.exports = map;

/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports = {"AED":{"code":"AED","symbol":"د.إ.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"AFN":{"code":"AFN","symbol":"؋","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"ALL":{"code":"ALL","symbol":"Lek","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"AMD":{"code":"AMD","symbol":"֏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"ANG":{"code":"ANG","symbol":"ƒ","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"AOA":{"code":"AOA","symbol":"Kz","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"ARS":{"code":"ARS","symbol":"$","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"AUD":{"code":"AUD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"AWG":{"code":"AWG","symbol":"ƒ","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"AZN":{"code":"AZN","symbol":"₼","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"BAM":{"code":"BAM","symbol":"КМ","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"BBD":{"code":"BBD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"BDT":{"code":"BDT","symbol":"৳","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":0},"BGN":{"code":"BGN","symbol":"лв.","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"BHD":{"code":"BHD","symbol":"د.ب.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":3},"BIF":{"code":"BIF","symbol":"FBu","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"BMD":{"code":"BMD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"BND":{"code":"BND","symbol":"$","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"BOB":{"code":"BOB","symbol":"Bs","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"BRL":{"code":"BRL","symbol":"R$","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"BSD":{"code":"BSD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"BTC":{"code":"BTC","symbol":"Ƀ","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":8},"BTN":{"code":"BTN","symbol":"Nu.","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":1},"BWP":{"code":"BWP","symbol":"P","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"BYR":{"code":"BYR","symbol":"р.","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"BYN":{"code":"BYN","symbol":"р.","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"BZD":{"code":"BZD","symbol":"BZ$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"CAD":{"code":"CAD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"CDF":{"code":"CDF","symbol":"FC","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"CHF":{"code":"CHF","symbol":"CHF","thousandsSeparator":"'","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"CLP":{"code":"CLP","symbol":"$","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":0},"CNY":{"code":"CNY","symbol":"¥","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"COP":{"code":"COP","symbol":"$","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"CRC":{"code":"CRC","symbol":"₡","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"CUC":{"code":"CUC","symbol":"CUC","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"CUP":{"code":"CUP","symbol":"$MN","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"CVE":{"code":"CVE","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"CZK":{"code":"CZK","symbol":"Kč","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"DJF":{"code":"DJF","symbol":"Fdj","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"DKK":{"code":"DKK","symbol":"kr.","thousandsSeparator":"","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"DOP":{"code":"DOP","symbol":"RD$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"DZD":{"code":"DZD","symbol":"د.ج.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"EGP":{"code":"EGP","symbol":"ج.م.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"ERN":{"code":"ERN","symbol":"Nfk","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"ETB":{"code":"ETB","symbol":"ETB","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"EUR":{"code":"EUR","symbol":"€","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"FJD":{"code":"FJD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"FKP":{"code":"FKP","symbol":"£","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"GBP":{"code":"GBP","symbol":"£","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"GEL":{"code":"GEL","symbol":"GEL","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"GHS":{"code":"GHS","symbol":"₵","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"GIP":{"code":"GIP","symbol":"£","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"GMD":{"code":"GMD","symbol":"D","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"GNF":{"code":"GNF","symbol":"FG","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"GTQ":{"code":"GTQ","symbol":"Q","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"GYD":{"code":"GYD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"HKD":{"code":"HKD","symbol":"HK$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"HNL":{"code":"HNL","symbol":"L.","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"HRK":{"code":"HRK","symbol":"kn","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"HTG":{"code":"HTG","symbol":"G","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"HUF":{"code":"HUF","symbol":"Ft","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"IDR":{"code":"IDR","symbol":"Rp","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"ILS":{"code":"ILS","symbol":"₪","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"INR":{"code":"INR","symbol":"₹","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"IQD":{"code":"IQD","symbol":"د.ع.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"IRR":{"code":"IRR","symbol":"﷼","thousandsSeparator":",","decimalSeparator":"/","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"ISK":{"code":"ISK","symbol":"kr.","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":0},"JMD":{"code":"JMD","symbol":"J$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"JOD":{"code":"JOD","symbol":"د.ا.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":3},"JPY":{"code":"JPY","symbol":"¥","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"KES":{"code":"KES","symbol":"KSh","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"KGS":{"code":"KGS","symbol":"сом","thousandsSeparator":" ","decimalSeparator":"-","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"KHR":{"code":"KHR","symbol":"៛","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"KMF":{"code":"KMF","symbol":"CF","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"KPW":{"code":"KPW","symbol":"₩","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"KRW":{"code":"KRW","symbol":"₩","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"KWD":{"code":"KWD","symbol":"د.ك.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":3},"KYD":{"code":"KYD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"KZT":{"code":"KZT","symbol":"₸","thousandsSeparator":" ","decimalSeparator":"-","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"LAK":{"code":"LAK","symbol":"₭","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"LBP":{"code":"LBP","symbol":"ل.ل.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"LKR":{"code":"LKR","symbol":"₨","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":0},"LRD":{"code":"LRD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"LSL":{"code":"LSL","symbol":"M","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"LYD":{"code":"LYD","symbol":"د.ل.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":3},"MAD":{"code":"MAD","symbol":"د.م.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"MDL":{"code":"MDL","symbol":"lei","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"MGA":{"code":"MGA","symbol":"Ar","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"MKD":{"code":"MKD","symbol":"ден.","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"MMK":{"code":"MMK","symbol":"K","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MNT":{"code":"MNT","symbol":"₮","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MOP":{"code":"MOP","symbol":"MOP$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MRO":{"code":"MRO","symbol":"UM","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MTL":{"code":"MTL","symbol":"₤","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MUR":{"code":"MUR","symbol":"₨","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MVR":{"code":"MVR","symbol":"MVR","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":1},"MWK":{"code":"MWK","symbol":"MK","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MXN":{"code":"MXN","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MYR":{"code":"MYR","symbol":"RM","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"MZN":{"code":"MZN","symbol":"MT","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"NAD":{"code":"NAD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"NGN":{"code":"NGN","symbol":"₦","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"NIO":{"code":"NIO","symbol":"C$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"NOK":{"code":"NOK","symbol":"kr","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"NPR":{"code":"NPR","symbol":"₨","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"NZD":{"code":"NZD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"OMR":{"code":"OMR","symbol":"﷼","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":3},"PAB":{"code":"PAB","symbol":"B/.","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"PEN":{"code":"PEN","symbol":"S/.","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"PGK":{"code":"PGK","symbol":"K","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"PHP":{"code":"PHP","symbol":"₱","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"PKR":{"code":"PKR","symbol":"₨","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"PLN":{"code":"PLN","symbol":"zł","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"PYG":{"code":"PYG","symbol":"₲","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"QAR":{"code":"QAR","symbol":"﷼","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"RON":{"code":"RON","symbol":"L","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"RSD":{"code":"RSD","symbol":"Дин.","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"RUB":{"code":"RUB","symbol":"₽","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"RWF":{"code":"RWF","symbol":"RWF","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"SAR":{"code":"SAR","symbol":"﷼","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"SBD":{"code":"SBD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SCR":{"code":"SCR","symbol":"₨","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SDD":{"code":"SDD","symbol":"LSd","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SDG":{"code":"SDG","symbol":"£‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SEK":{"code":"SEK","symbol":"kr","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"SGD":{"code":"SGD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SHP":{"code":"SHP","symbol":"£","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SLL":{"code":"SLL","symbol":"Le","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SOS":{"code":"SOS","symbol":"S","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SRD":{"code":"SRD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"STD":{"code":"STD","symbol":"Db","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SVC":{"code":"SVC","symbol":"₡","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"SYP":{"code":"SYP","symbol":"£","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"SZL":{"code":"SZL","symbol":"E","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"THB":{"code":"THB","symbol":"฿","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"TJS":{"code":"TJS","symbol":"TJS","thousandsSeparator":" ","decimalSeparator":";","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"TMT":{"code":"TMT","symbol":"m","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"TND":{"code":"TND","symbol":"د.ت.‏","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":3},"TOP":{"code":"TOP","symbol":"T$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"TRY":{"code":"TRY","symbol":"₺","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"TTD":{"code":"TTD","symbol":"TT$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"TVD":{"code":"TVD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"TWD":{"code":"TWD","symbol":"NT$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"TZS":{"code":"TZS","symbol":"TSh","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"UAH":{"code":"UAH","symbol":"₴","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"UGX":{"code":"UGX","symbol":"USh","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"USD":{"code":"USD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"UYU":{"code":"UYU","symbol":"$U","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"UZS":{"code":"UZS","symbol":"сўм","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"VEB":{"code":"VEB","symbol":"Bs.","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"VEF":{"code":"VEF","symbol":"Bs. F.","thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"VND":{"code":"VND","symbol":"₫","thousandsSeparator":".","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":0},"VUV":{"code":"VUV","symbol":"VT","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":0},"WST":{"code":"WST","symbol":"WS$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"XAF":{"code":"XAF","symbol":"F","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"XCD":{"code":"XCD","symbol":"$","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"XBT":{"code":"XBT","symbol":"Ƀ","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"XOF":{"code":"XOF","symbol":"F","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"XPF":{"code":"XPF","symbol":"F","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"YER":{"code":"YER","symbol":"﷼","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"ZAR":{"code":"ZAR","symbol":"R","thousandsSeparator":" ","decimalSeparator":",","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"ZMW":{"code":"ZMW","symbol":"ZK","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"WON":{"code":"WON","symbol":"₩","thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2}}

/***/ }),
/* 202 */
/***/ (function(module, exports) {

module.exports = {"de":{"thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"el":{"symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"thousandsSeparator":".","decimalSeparator":",","decimalDigits":2},"en-US":{"thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"en-IE":{"symbolOnLeft":true,"thousandsSeparator":",","decimalSeparator":".","spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"zh-CN":{"thousandsSeparator":",","decimalSeparator":".","symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"decimalDigits":2},"es":{"thousandsSeparator":".","decimalSeparator":",","symbolOnLeft":false,"spaceBetweenAmountAndSymbol":true,"decimalDigits":2},"it":{"symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"thousandsSeparator":".","decimalSeparator":",","decimalDigits":2},"nl":{"symbolOnLeft":true,"spaceBetweenAmountAndSymbol":false,"thousandsSeparator":".","decimalSeparator":",","decimalDigits":2}}

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configuration__ = __webpack_require__(59);









var url = __WEBPACK_IMPORTED_MODULE_5__configuration__["a" /* default */].apiHost + "convetion";

var ConventionService = function () {
  function ConventionService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ConventionService);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ConventionService, null, [{
    key: "getAll",
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var convention;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url);

              case 3:
                convention = _context.sent;
                return _context.abrupt("return", convention.data);

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                throw new Error(_context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function getAll() {
        return _ref.apply(this, arguments);
      }

      return getAll;
    }() //getAll();

  }, {
    key: "save",
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(convention) {
        var conventionSaved;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url, convention);

              case 3:
                conventionSaved = _context2.sent;
                return _context2.abrupt("return", conventionSaved.data);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                throw new Error(_context2.t0);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function save(_x) {
        return _ref2.apply(this, arguments);
      }

      return save;
    }() //save()

  }, {
    key: "edit",
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(convention) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(url, convention);

              case 3:
                resp = _context3.sent;
                return _context3.abrupt("return", resp.data);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);

                console.log(_context3.t0);
                throw new Error(_context3.t0);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function edit(_x2) {
        return _ref3.apply(this, arguments);
      }

      return edit;
    }() //edit()

  }, {
    key: "remove",
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(convention) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete(url, {
                  data: convention
                });

              case 3:
                _context4.next = 8;
                break;

              case 5:
                _context4.prev = 5;
                _context4.t0 = _context4["catch"](0);
                throw new Error(_context4.t0);

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 5]]);
      }));

      function remove(_x3) {
        return _ref4.apply(this, arguments);
      }

      return remove;
    }() //remove()

  }, {
    key: "getByYear",
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(convention) {
        var conventionGet;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url + "/ano", convention);

              case 3:
                conventionGet = _context5.sent;
                return _context5.abrupt("return", conventionGet.data);

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5["catch"](0);
                throw new Error(_context5.t0);

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 7]]);
      }));

      function getByYear(_x4) {
        return _ref5.apply(this, arguments);
      }

      return getByYear;
    }() //getByYear()

  }, {
    key: "getById",
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(id) {
        var conventionGet;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url + "/" + id);

              case 3:
                conventionGet = _context6.sent;
                return _context6.abrupt("return", conventionGet.data);

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6["catch"](0);
                throw new Error(_context6.t0);

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 7]]);
      }));

      function getById(_x5) {
        return _ref6.apply(this, arguments);
      }

      return getById;
    }() //getById()

  }, {
    key: "getCurrentConvention",
    value: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var currentConvention;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url + "/current_convention");

              case 3:
                currentConvention = _context7.sent;
                return _context7.abrupt("return", currentConvention.data);

              case 7:
                _context7.prev = 7;
                _context7.t0 = _context7["catch"](0);
                throw new Error(_context7.t0);

              case 10:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 7]]);
      }));

      function getCurrentConvention() {
        return _ref7.apply(this, arguments);
      }

      return getCurrentConvention;
    }() //getCurrentConvention()

  }]);

  return ConventionService;
}(); //class


/* harmony default export */ __webpack_exports__["a"] = (ConventionService);

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configuration__ = __webpack_require__(59);


//import config from './../../configuration'







var url = __WEBPACK_IMPORTED_MODULE_5__configuration__["a" /* default */].apiHost;

var UtilService = function () {
  function UtilService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, UtilService);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(UtilService, null, [{
    key: 'findAddressByCep',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(cep) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('https://api.postmon.com.br/v1/cep/' + cep);

              case 3:
                response = _context.sent;
                return _context.abrupt('return', {
                  cep: cep,
                  addressType: response.data.logradouro,
                  district: response.data.bairro,
                  city: response.data.cidade,
                  state: response.data.estado_info.nome
                });

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);
                throw 'UtilService: Erro ao buscar endere\xE7o por CEP: ' + _context.t0.response.data;

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function findAddressByCep(_x) {
        return _ref.apply(this, arguments);
      }

      return findAddressByCep;
    }() // findAddressByCep()

  }]);

  return UtilService;
}();

/* harmony default export */ __webpack_exports__["a"] = (UtilService);

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configuration__ = __webpack_require__(59);









var url = __WEBPACK_IMPORTED_MODULE_5__configuration__["a" /* default */].apiHost;

var OfficceService = function () {
  function OfficceService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, OfficceService);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(OfficceService, null, [{
    key: 'getAll',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var officces;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url + "offices");

              case 3:
                officces = _context.sent;
                return _context.abrupt('return', officces.data);

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);
                throw _context.t0.response.data;

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function getAll() {
        return _ref.apply(this, arguments);
      }

      return getAll;
    }() // getAll()

  }, {
    key: 'getByName',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(description) {
        var officces;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url + ('offices/' + description));

              case 3:
                officces = _context2.sent;
                return _context2.abrupt('return', officces.data);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0.response.data;

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function getByName(_x) {
        return _ref2.apply(this, arguments);
      }

      return getByName;
    }()
  }, {
    key: 'save',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(officce) {
        var officceSaved;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url + "offices", officce);

              case 3:
                officceSaved = _context3.sent;
                return _context3.abrupt('return', officceSaved.data);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);
                throw _context3.t0.response.data;

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function save(_x2) {
        return _ref3.apply(this, arguments);
      }

      return save;
    }() // save()

  }, {
    key: 'update',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(officce) {
        var officceUpdated;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(url + "offices", officce);

              case 3:
                officceUpdated = _context4.sent;
                return _context4.abrupt('return', officceUpdated.data);

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4['catch'](0);
                throw _context4.t0.response.data;

              case 10:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 7]]);
      }));

      function update(_x3) {
        return _ref4.apply(this, arguments);
      }

      return update;
    }() // update()

  }, {
    key: 'remove',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(officce) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete(url + "offices", {
                  data: officce
                });

              case 3:
                _context5.next = 8;
                break;

              case 5:
                _context5.prev = 5;
                _context5.t0 = _context5['catch'](0);
                throw _context5.t0.response.data;

              case 8:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 5]]);
      }));

      function remove(_x4) {
        return _ref5.apply(this, arguments);
      }

      return remove;
    }() // remove()

  }]);

  return OfficceService;
}(); // class


/* harmony default export */ __webpack_exports__["a"] = (OfficceService);

/***/ }),
/* 206 */,
/* 207 */,
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_UtilFormatter__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__configuration__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PersonService__ = __webpack_require__(190);











var url = __WEBPACK_IMPORTED_MODULE_6__configuration__["a" /* default */].apiHost + "companies";

var CompanyService = function () {
  function CompanyService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CompanyService);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CompanyService, null, [{
    key: 'getAll',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var companies;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('' + url);

              case 3:
                companies = _context.sent;
                return _context.abrupt('return', companies.data);

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);
                throw _context.t0.response.data;

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function getAll() {
        return _ref.apply(this, arguments);
      }

      return getAll;
    }() // getAll()

  }, {
    key: 'getCompaniesForSpecificData',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var companySaved;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url + '/find/ _id socialName fantasyName address');

              case 3:
                companySaved = _context2.sent;
                return _context2.abrupt('return', companySaved.data);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0.response.data;

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function getCompaniesForSpecificData() {
        return _ref2.apply(this, arguments);
      }

      return getCompaniesForSpecificData;
    }() //getCompaniesForSpecificData(data)

  }, {
    key: 'findWithoutDocuments',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var companySaved;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url + '/noDocument');

              case 3:
                companySaved = _context3.sent;
                return _context3.abrupt('return', companySaved.data);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);
                throw _context3.t0.response.data;

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function findWithoutDocuments() {
        return _ref3.apply(this, arguments);
      }

      return findWithoutDocuments;
    }() //getCompaniesForSpecificData(data)


  }, {
    key: 'save',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(company) {
        var companySaved;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('' + url, company);

              case 3:
                companySaved = _context4.sent;
                return _context4.abrupt('return', companySaved.data);

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4['catch'](0);
                throw _context4.t0.response.data;

              case 10:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 7]]);
      }));

      function save(_x) {
        return _ref4.apply(this, arguments);
      }

      return save;
    }() // save()

  }, {
    key: 'update',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(company) {
        var companyUpdated;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put('' + url, company);

              case 3:
                companyUpdated = _context5.sent;
                return _context5.abrupt('return', companyUpdated.data);

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5['catch'](0);
                throw _context5.t0.response.data;

              case 10:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 7]]);
      }));

      function update(_x2) {
        return _ref5.apply(this, arguments);
      }

      return update;
    }() // update()

  }, {
    key: 'remove',
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(company) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete('' + url, {
                  data: company
                });

              case 3:
                _context6.next = 8;
                break;

              case 5:
                _context6.prev = 5;
                _context6.t0 = _context6['catch'](0);
                throw _context6.t0.response.data;

              case 8:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 5]]);
      }));

      function remove(_x3) {
        return _ref6.apply(this, arguments);
      }

      return remove;
    }() // remove()

  }]);

  return CompanyService;
}(); // class


/* harmony default export */ __webpack_exports__["a"] = (CompanyService);

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configuration__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_sheet_SheetDefaultData__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__service_ModuleOneService__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__service_ModuleTwoService__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__service_ModuleThreeService__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__service_ModuleFourService__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__service_ModuleFiveService__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__service_ModuleSixService__ = __webpack_require__(242);
















var url = __WEBPACK_IMPORTED_MODULE_5__configuration__["a" /* default */].apiHost + "analyticals";

var AnalyticalWorksheetService = function () {
  function AnalyticalWorksheetService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AnalyticalWorksheetService);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AnalyticalWorksheetService, null, [{
    key: "generateDefault",
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(budget) {
        var analyticalWorksheet;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6__data_sheet_SheetDefaultData__["a" /* default */].getHeader(budget);

              case 2:
                _context.t0 = _context.sent;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_6__data_sheet_SheetDefaultData__["a" /* default */].getModuleOne();

              case 5:
                _context.t1 = _context.sent;
                _context.next = 8;
                return __WEBPACK_IMPORTED_MODULE_6__data_sheet_SheetDefaultData__["a" /* default */].getModuleTwo();

              case 8:
                _context.t2 = _context.sent;
                _context.next = 11;
                return __WEBPACK_IMPORTED_MODULE_6__data_sheet_SheetDefaultData__["a" /* default */].getModuleThree();

              case 11:
                _context.t3 = _context.sent;
                _context.next = 14;
                return __WEBPACK_IMPORTED_MODULE_6__data_sheet_SheetDefaultData__["a" /* default */].getModuleFour();

              case 14:
                _context.t4 = _context.sent;
                _context.next = 17;
                return __WEBPACK_IMPORTED_MODULE_6__data_sheet_SheetDefaultData__["a" /* default */].getModuleFive();

              case 17:
                _context.t5 = _context.sent;
                _context.next = 20;
                return __WEBPACK_IMPORTED_MODULE_6__data_sheet_SheetDefaultData__["a" /* default */].getModuleSix();

              case 20:
                _context.t6 = _context.sent;
                analyticalWorksheet = {
                  header: _context.t0,
                  moduleOne: _context.t1,
                  moduleTwo: _context.t2,
                  moduleThree: _context.t3,
                  moduleFour: _context.t4,
                  moduleFive: _context.t5,
                  moduleSix: _context.t6
                };
                return _context.abrupt("return", analyticalWorksheet);

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function generateDefault(_x) {
        return _ref.apply(this, arguments);
      }

      return generateDefault;
    }()
  }, {
    key: "generateModuleFive",
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6__data_sheet_SheetDefaultData__["a" /* default */].getModuleFive();

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function generateModuleFive() {
        return _ref2.apply(this, arguments);
      }

      return generateModuleFive;
    }()
  }, {
    key: "getAll",
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var alls;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url);

              case 3:
                alls = _context3.sent;
                return _context3.abrupt("return", alls.data);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);
                throw new Error(_context3.t0);

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function getAll() {
        return _ref3.apply(this, arguments);
      }

      return getAll;
    }()
  }, {
    key: "getBonds",
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(id, attachment) {
        var bonds;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(!id || !attachment)) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return", []);

              case 2:
                _context4.prev = 2;
                _context4.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url + "/bond/" + id + "/" + attachment);

              case 5:
                bonds = _context4.sent;
                return _context4.abrupt("return", bonds.data);

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](2);
                throw new Error(_context4.t0);

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[2, 9]]);
      }));

      function getBonds(_x2, _x3) {
        return _ref4.apply(this, arguments);
      }

      return getBonds;
    }()
  }, {
    key: "getById",
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(id) {
        var sheet;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url + "/" + id);

              case 3:
                sheet = _context5.sent;
                return _context5.abrupt("return", sheet.data);

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5["catch"](0);
                throw new Error(_context5.t0);

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 7]]);
      }));

      function getById(_x4) {
        return _ref5.apply(this, arguments);
      }

      return getById;
    }()
  }, {
    key: "save",
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(analyticalWorksheet) {
        var saved;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url, analyticalWorksheet);

              case 3:
                saved = _context6.sent;
                return _context6.abrupt("return", saved.data);

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6["catch"](0);
                throw new Error(_context6.t0);

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 7]]);
      }));

      function save(_x5) {
        return _ref6.apply(this, arguments);
      }

      return save;
    }() // save()

  }, {
    key: "edit",
    value: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(analytical) {
        var updated;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(url, analytical);

              case 3:
                updated = _context7.sent;
                return _context7.abrupt("return", updated.data);

              case 7:
                _context7.prev = 7;
                _context7.t0 = _context7["catch"](0);
                throw new Error(_context7.t0);

              case 10:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 7]]);
      }));

      function edit(_x6) {
        return _ref7.apply(this, arguments);
      }

      return edit;
    }() // edit()

  }, {
    key: "remove",
    value: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(analytical) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete(url, {
                  data: analytical
                });

              case 3:
                _context8.next = 8;
                break;

              case 5:
                _context8.prev = 5;
                _context8.t0 = _context8["catch"](0);
                throw new Error(_context8.t0);

              case 8:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 5]]);
      }));

      function remove(_x7) {
        return _ref8.apply(this, arguments);
      }

      return remove;
    }() // remove()  

  }, {
    key: "findHeaderByBudgetId",
    value: function () {
      var _ref9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(budgetid) {
        var all;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url + "/header/" + budgetid);

              case 3:
                all = _context9.sent;
                return _context9.abrupt("return", all.data);

              case 7:
                _context9.prev = 7;
                _context9.t0 = _context9["catch"](0);
                throw new Error(_context9.t0);

              case 10:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 7]]);
      }));

      function findHeaderByBudgetId(_x8) {
        return _ref9.apply(this, arguments);
      }

      return findHeaderByBudgetId;
    }() // findHeaderByBudgetId()

  }, {
    key: "findByBudgetId",
    value: function () {
      var _ref10 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(budgetid) {
        var all;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url + "/budget/" + budgetid);

              case 3:
                all = _context10.sent;
                return _context10.abrupt("return", all.data);

              case 7:
                _context10.prev = 7;
                _context10.t0 = _context10["catch"](0);
                throw new Error(_context10.t0);

              case 10:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[0, 7]]);
      }));

      function findByBudgetId(_x9) {
        return _ref10.apply(this, arguments);
      }

      return findByBudgetId;
    }() // findHeaderByBudgetId()

  }, {
    key: "updateComputedDataSheet",
    value: function () {
      var _ref11 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(sheet) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                return _context11.abrupt("return", sheet);

              case 4:
                _context11.prev = 4;
                _context11.t0 = _context11["catch"](0);
                throw new Error(_context11.t0);

              case 7:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[0, 4]]);
      }));

      function updateComputedDataSheet(_x10) {
        return _ref11.apply(this, arguments);
      }

      return updateComputedDataSheet;
    }() // findHeaderByBudgetId()

    // Sem necessidade de comunicação com a API

  }, {
    key: "getAmountMonthly",
    value: function () {
      var _ref12 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(budget, sheet) {
        var basicSalaryCCT, amountOfModuleOne, amountOfModuleTwoOne, moduleOneAndModuleTwoOne, amountOfModuleTwoTwo, amountOfModuleTwoThree, amountOfModuleThree, amountOfModuleFour, amountOfModuleFive, subTotal, amountOfModuleSix;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                basicSalaryCCT = sheet.header.professionalCategory.basicSalary;
                _context12.next = 3;
                return __WEBPACK_IMPORTED_MODULE_7__service_ModuleOneService__["a" /* default */].getAmountOfModuleOne(sheet.header, sheet.moduleOne);

              case 3:
                amountOfModuleOne = _context12.sent;
                _context12.next = 6;
                return __WEBPACK_IMPORTED_MODULE_8__service_ModuleTwoService__["a" /* default */].getAmountOfModuleTwoOne(amountOfModuleOne, sheet.moduleTwo);

              case 6:
                amountOfModuleTwoOne = _context12.sent;
                moduleOneAndModuleTwoOne = amountOfModuleOne + amountOfModuleTwoOne;
                _context12.next = 10;
                return __WEBPACK_IMPORTED_MODULE_8__service_ModuleTwoService__["a" /* default */].getAmountOfModuleTwoTwo(moduleOneAndModuleTwoOne, sheet.moduleTwo);

              case 10:
                amountOfModuleTwoTwo = _context12.sent;
                _context12.next = 13;
                return __WEBPACK_IMPORTED_MODULE_8__service_ModuleTwoService__["a" /* default */].getAmountOfModuleTwoThree(basicSalaryCCT, sheet.moduleTwo);

              case 13:
                amountOfModuleTwoThree = _context12.sent;
                _context12.next = 16;
                return __WEBPACK_IMPORTED_MODULE_9__service_ModuleThreeService__["a" /* default */].getAmountOfModuleThree(moduleOneAndModuleTwoOne, sheet.moduleThree);

              case 16:
                amountOfModuleThree = _context12.sent;
                _context12.next = 19;
                return __WEBPACK_IMPORTED_MODULE_10__service_ModuleFourService__["a" /* default */].getAmountOfModuleFour(moduleOneAndModuleTwoOne, sheet.moduleFour);

              case 19:
                amountOfModuleFour = _context12.sent;
                _context12.next = 22;
                return __WEBPACK_IMPORTED_MODULE_11__service_ModuleFiveService__["a" /* default */].getAmountOfModuleFive(sheet._id, sheet.moduleFive);

              case 22:
                amountOfModuleFive = _context12.sent;
                subTotal = amountOfModuleOne + amountOfModuleTwoOne + amountOfModuleTwoTwo + amountOfModuleTwoThree + amountOfModuleThree + amountOfModuleFour + amountOfModuleFive;
                _context12.next = 26;
                return __WEBPACK_IMPORTED_MODULE_12__service_ModuleSixService__["a" /* default */].getAmountOfModuleSix(budget, sheet.moduleSix, subTotal);

              case 26:
                amountOfModuleSix = _context12.sent;
                return _context12.abrupt("return", subTotal + amountOfModuleSix);

              case 28:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getAmountMonthly(_x11, _x12) {
        return _ref12.apply(this, arguments);
      }

      return getAmountMonthly;
    }()
  }]);

  return AnalyticalWorksheetService;
}(); // class


/* harmony default export */ __webpack_exports__["a"] = (AnalyticalWorksheetService);

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_CityService__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_StatesAndCitiesBR__ = __webpack_require__(225);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// SERVICES //



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      city: {},
      citiesOffState: [],
      states: __WEBPACK_IMPORTED_MODULE_3__utils_StatesAndCitiesBR__["a" /* default */]
    };
  }, //data()

  methods: {
    save: function save() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2__service_CityService__["a" /* default */].save(_this.city);

              case 3:
                _this.city = _context.sent;
                _context.next = 6;
                return _this.$eventHub.$emit("savedNewCity");

              case 6:
                _this.$emit('savedCity');
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);

                _this.$eventHub.$emit("newCityNotSaved");

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 9]]);
      }))();
    },
    //save()

    cancel: function cancel() {
      this.city = {};
      this.$eventHub.$emit("cancelDialogAddNewCity");
      this.$emit('cancelNewCity');
    },
    //cancel()
    filterCities: function filterCities() {
      var _this2 = this;

      this.states.forEach(function (state) {
        if (state.uf == _this2.city.uf) {
          _this2.citiesOffState = state.cities;
          _this2.city.state = state.name;
        }
      });
    }
  } //methods
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var MessageFormatterUtil = function () {
    function MessageFormatterUtil() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MessageFormatterUtil);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(MessageFormatterUtil, null, [{
        key: 'formatErrorMessage',


        /**
         * Método para formatar mensagem de erro. 
         * O argumento deve ser um array onde a função construirá uma String formatada.
         * Basicamente o procedimento consiste em adicionar, no início da String, um artigo no singular,
         * e adicionar a String 'é obrigatório' ou 'são obrigatórios' no final.
         * @param {Array} errors 
         * @returns {String} errorMessage
         */
        value: function formatErrorMessage(errors) {
            if (!errors || !errors.length) return errors;
            if (errors.length == 1) return 'O(a) ' + errors.toString() + ' \xE9 obrigat\xF3rio';
            var errorMessage = 'O(a) ';
            for (var i = 0; i < errors.length; i++) {
                if (i == errors.length - 1) errorMessage += 'e ' + errors[i] + ' ';else if (i == errors.length - 2) errorMessage += errors[i] + ' ';else errorMessage += errors[i] + ', ';
            }
            errorMessage += 'são obrigatórios.';
            return errorMessage;
        }
    }]);

    return MessageFormatterUtil;
}();

/* harmony default export */ __webpack_exports__["a"] = (MessageFormatterUtil);

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlertDelete_vue__ = __webpack_require__(213);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_679e9ae8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlertDelete_vue__ = __webpack_require__(250);
function injectStyle (ssrContext) {
  __webpack_require__(248)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlertDelete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_679e9ae8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlertDelete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dialogStatus: false,
      item: null
    };
  },

  methods: {
    openDialog: function openDialog(item) {
      this.item = item;
      this.dialogStatus = true;
    },
    closeDialog: function closeDialog() {
      this.item = {};
      this.dialogStatus = false;
    },
    remove: function remove() {
      this.$emit('deleteItem', this.item);
      this.closeDialog();
    }
  }
});

/***/ }),
/* 214 */,
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__configuration__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_utils_SystemConfiguration__ = __webpack_require__(237);









var url = __WEBPACK_IMPORTED_MODULE_4__configuration__["a" /* default */].apiHost;

var SystemConfigurationService = function () {
  function SystemConfigurationService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SystemConfigurationService);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(SystemConfigurationService, null, [{
    key: "getConfigurations",
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__src_utils_SystemConfiguration__["a" /* default */];

              case 3:
                return _context.abrupt("return", _context.sent);

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);
                throw new Error(_context.t0);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 6]]);
      }));

      function getConfigurations() {
        return _ref.apply(this, arguments);
      }

      return getConfigurations;
    }() // getConfigurations();

  }]);

  return SystemConfigurationService;
}(); // class


/* harmony default export */ __webpack_exports__["a"] = (SystemConfigurationService);

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AnalyticalWorksheetService__ = __webpack_require__(209);






var ModuleFiveService = function () {
  function ModuleFiveService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModuleFiveService);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ModuleFiveService, null, [{
    key: "amountCalculate",
    value: function amountCalculate(item, depreciation) {
      var amount = 0;
      if (depreciation.toString() == "true") amount = item.quantity * item.value * (item.lifetime / 100);else amount = item.quantity * item.value / item.lifetime;

      return amount;
    }
  }, {
    key: "getAmountMonthly",
    value: function getAmountMonthly(selectedItems, depreciation) {
      if (!selectedItems) return 0;

      var amount = 0;
      for (var i = 0; i < selectedItems.length; i++) {
        amount += this.amountCalculate(selectedItems[i], depreciation);
      }return amount;
    }
  }, {
    key: "getAmountMonthlyByEmployee",
    value: function getAmountMonthlyByEmployee(attachment, amountMonthly, numberOfEmployees) {
      var amount = 0;
      if (attachment === "uniformsAndEPIs") {
        return amountMonthly;
      } else {
        if (numberOfEmployees > 0) amount = amountMonthly / numberOfEmployees;
      }
      return amount;
    }
  }, {
    key: "getAmountOfAttachment",
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(sheetId, moduleFive, attachment) {
        var sheetBondId, bonds, selectedItems, amountMonthly, numberOfEmployees;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                sheetBondId = moduleFive[attachment].bond ? moduleFive[attachment].bond : sheetId;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__AnalyticalWorksheetService__["a" /* default */].getBonds(sheetBondId, attachment);

              case 3:
                bonds = _context.sent;
                _context.next = 6;
                return this.getSelectItems(bonds, attachment);

              case 6:
                selectedItems = _context.sent;
                _context.next = 9;
                return this.getAmountMonthly(selectedItems, moduleFive[attachment].depreciation);

              case 9:
                amountMonthly = _context.sent;
                _context.next = 12;
                return this.getNumberOfEmployees(bonds);

              case 12:
                numberOfEmployees = _context.sent;
                _context.next = 15;
                return this.getAmountMonthlyByEmployee(attachment, amountMonthly, numberOfEmployees);

              case 15:
                return _context.abrupt("return", _context.sent);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAmountOfAttachment(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return getAmountOfAttachment;
    }()
  }, {
    key: "getAmountOfModuleFive",
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(sheetId, moduleFive) {
        var amount;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getAmountOfAttachment(sheetId, moduleFive, 'consumables');

              case 2:
                _context2.t0 = _context2.sent;
                _context2.next = 5;
                return this.getAmountOfAttachment(sheetId, moduleFive, 'equipments');

              case 5:
                _context2.t1 = _context2.sent;
                _context2.t2 = _context2.t0 + _context2.t1;
                _context2.next = 9;
                return this.getAmountOfAttachment(sheetId, moduleFive, 'uniformsAndEPIs');

              case 9:
                _context2.t3 = _context2.sent;
                _context2.t4 = _context2.t2 + _context2.t3;
                _context2.next = 13;
                return this.getAmountOfAttachment(sheetId, moduleFive, 'utensils');

              case 13:
                _context2.t5 = _context2.sent;
                _context2.t6 = _context2.t4 + _context2.t5;
                _context2.next = 17;
                return this.getOthers(moduleFive.others);

              case 17:
                _context2.t7 = _context2.sent;
                amount = _context2.t6 + _context2.t7;
                return _context2.abrupt("return", amount);

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getAmountOfModuleFive(_x4, _x5) {
        return _ref2.apply(this, arguments);
      }

      return getAmountOfModuleFive;
    }()
  }, {
    key: "getNumberOfEmployees",
    value: function getNumberOfEmployees(bonds) {
      if (!bonds) return 0;

      var numberOfEmployees = 0;

      for (var i = 0; i < bonds.length; i++) {
        numberOfEmployees += bonds[i].header ? parseInt(bonds[i].header.numberOfEmployees) : 0;
      }return numberOfEmployees;
    }
  }, {
    key: "getOthers",
    value: function getOthers(others) {
      if (!others) return 0;
      var amount = 0;
      for (var i = 0; i < others.length; i++) {
        amount += others[i].value;
      }
      return amount;
    }
  }, {
    key: "getSelectItems",
    value: function getSelectItems(bonds, attachment) {
      if (!bonds) return [];

      for (var i = 0; i < bonds.length; i++) {
        if (bonds[i].moduleFive[attachment].items.length > 0) return bonds[i].moduleFive[attachment].items;
      }
      return [];
    }
  }, {
    key: "getSubTotalOfAttachment",
    value: function getSubTotalOfAttachment(items) {
      if (!items) return 0;

      var amount = 0;

      for (var i = 0; i < items.length; i++) {
        amount += items[i].value * items[i].quantity;
      }return amount;
    }
  }]);

  return ModuleFiveService;
}(); // class


/* harmony default export */ __webpack_exports__["a"] = (ModuleFiveService);

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(218), __esModule: true };

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(219);
module.exports = 0x1fffffffffffff;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(8);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(221), __esModule: true };

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(222);
module.exports = -0x1fffffffffffff;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(8);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 223 */,
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormCity_vue__ = __webpack_require__(210);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a61974d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormCity_vue__ = __webpack_require__(247);
function injectStyle (ssrContext) {
  __webpack_require__(245)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormCity_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a61974d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormCity_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var states = [{
  uf: "AC",
  name: "Acre",
  capita: "Rio Branco",
  cities: ["Acrelândia", "Assis Brasil", "Brasiléia", "Bujari", "Capixaba", "Cruzeiro do Sul", "Epitaciolândia", "Feijó", "Jordão", "Mâncio Lima", "Manoel Urbano", "Marechal Thaumaturgo", "Plácido de Castro", "Porto Acre", "Porto Walter", "Rio Branco", "Rodrigues Alves", "Santa Rosa do Purus", "Sena Madureira", "Senador Guiomard", "Tarauacá", "Xapuri"]
}, {
  uf: "AL",
  name: "Alagoas",
  capital: "Maceió",
  cities: ["Água Branca", "Anadia", "Arapiraca", "Atalaia", "Barra de Santo Antônio", "Barra de São Miguel", "Batalha", "Belém", "Belo Monte", "Boca da Mata", "Branquinha", "Cacimbinhas", "Cajueiro", "Campestre", "Campo Alegre", "Campo Grande", "Canapi", "Capela", "Carneiros", "Chã Preta", "Coité do Nóia", "Colônia Leopoldina", "Coqueiro Seco", "Coruripe", "Craíbas", "Delmiro Gouveia", "Dois Riachos", "Estrela de Alagoas", "Feira Grande", "Feliz Deserto", "Flexeiras", "Girau do Ponciano", "Ibateguara", "Igaci", "Igreja Nova", "Inhapi", "Jacaré dos Homens", "Jacuípe", "Japaratinga", "Jaramataia", "Jequiá da Praia", "Joaquim Gomes", "Jundiá", "Junqueiro", "Lagoa da Canoa", "Limoeiro de Anadia", "Maceió", "Major Isidoro", "Mar Vermelho", "Maragogi", "Maravilha", "Marechal Deodoro", "Maribondo", "Mata Grande", "Matriz de Camaragibe", "Messias", "Minador do Negrão", "Monteirópolis", "Murici", "Novo Lino", "Olho d'Água das Flores", "Olho d'Água do Casado", "Olho d'Água Grande", "Olivença", "Ouro Branco", "Palestina", "Palmeira dos Índios", "Pão de Açúcar", "Pariconha", "Paripueira", "Passo de Camaragibe", "Paulo Jacinto", "Penedo", "Piaçabuçu", "Pilar", "Pindoba", "Piranhas", "Poço das Trincheiras", "Porto Calvo", "Porto de Pedras", "Porto Real do Colégio", "Quebrangulo", "Rio Largo", "Roteiro", "Santa Luzia do Norte", "Santana do Ipanema", "Santana do Mundaú", "São Brás", "São José da Laje", "São José da Tapera", "São Luís do Quitunde", "São Miguel dos Campos", "São Miguel dos Milagres", "São Sebastião", "Satuba", "Senador Rui Palmeira", "Tanque d'Arca", "Taquarana", "Teotônio Vilela", "Traipu", "União dos Palmares", "Viçosa"]
}, {
  uf: "AM",
  name: "Amazonas",
  capital: "Manaus",
  cities: ["Alvarães", "Amaturá", "Anamã", "Anori", "Apuí", "Atalaia do Norte", "Autazes", "Barcelos", "Barreirinha", "Benjamin Constant", "Beruri", "Boa Vista do Ramos", "Boca do Acre", "Borba", "Caapiranga", "Canutama", "Carauari", "Careiro", "Careiro da Várzea", "Coari", "Codajás", "Eirunepé", "Envira", "Fonte Boa", "Guajará", "Humaitá", "Ipixuna", "Iranduba", "Itacoatiara", "Itamarati", "Itapiranga", "Japurá", "Juruá", "Jutaí", "Lábrea", "Manacapuru", "Manaquiri", "Manaus", "Manicoré", "Maraã", "Maués", "Nhamundá", "Nova Olinda do Norte", "Novo Airão", "Novo Aripuanã", "Parintins", "Pauini", "Presidente Figueiredo", "Rio Preto da Eva", "Santa Isabel do Rio Negro", "Santo Antônio do Içá", "São Gabriel da Cachoeira", "São Paulo de Olivença", "São Sebastião do Uatumã", "Silves", "Tabatinga", "Tapauá", "Tefé", "Tonantins", "Uarini", "Urucará", "Urucurituba"]
}, {
  uf: "AP",
  name: "Amapá",
  capital: "Macapá",
  cities: ["Amapá", "Calçoene", "Cutias", "Ferreira Gomes", "Itaubal", "Laranjal do Jari", "Macapá", "Mazagão", "Oiapoque", "Pedra Branca do Amapari", "Porto Grande", "Pracuúba", "Santana", "Serra do Navio", "Tartarugalzinho", "Vitória do Jari"]
}, {
  uf: "BA",
  name: "Bahia",
  capital: "Salvador",
  cities: ["Abaíra", "Abaré", "Acajutiba", "Adustina", "Água Fria", "Aiquara", "Alagoinhas", "Alcobaça", "Almadina", "Amargosa", "Amélia Rodrigues", "América Dourada", "Anagé", "Andaraí", "Andorinha", "Angical", "Anguera", "Antas", "Antônio Cardoso", "Antônio Gonçalves", "Aporá", "Apuarema", "Araças", "Aracatu", "Araci", "Aramari", "Arataca", "Aratuípe", "Aurelino Leal", "Baianópolis", "Baixa Grande", "Banzaê", "Barra", "Barra da Estiva", "Barra do Choça", "Barra do Mendes", "Barra do Rocha", "Barreiras", "Barro Alto", "Barrocas", "Barro Preto", "Belmonte", "Belo Campo", "Biritinga", "Boa Nova", "Boa Vista do Tupim", "Bom Jesus da Lapa", "Bom Jesus da Serra", "Boninal", "Bonito", "Boquira", "Botuporã", "Brejões", "Brejolândia", "Brotas de Macaúbas", "Brumado", "Buerarema", "Buritirama", "Caatiba", "Cabaceiras do Paraguaçu", "Cachoeira", "Caculé", "Caém", "Caetanos", "Caetité", "Cafarnaum", "Cairu", "Caldeirão Grande", "Camacan", "Camaçari", "Camamu", "Campo Alegre de Lourdes", "Campo Formoso", "Canápolis", "Canarana", "Canavieiras", "Candeal", "Candeias", "Candiba", "Cândido Sales", "Cansanção", "Canudos", "Capela do Alto Alegre", "Capim Grosso", "Caraíbas", "Caravelas", "Cardeal da Silva", "Carinhanha", "Casa Nova", "Castro Alves", "Catolândia", "Catu", "Caturama", "Central", "Chorrochó", "Cícero Dantas", "Cipó", "Coaraci", "Cocos", "Conceição da Feira", "Conceição do Almeida", "Conceição do Coité", "Conceição do Jacuípe", "Conde", "Condeúba", "Contendas do Sincorá", "Coração de Maria", "Cordeiros", "Coribe", "Coronel João Sá", "Correntina", "Cotegipe", "Cravolândia", "Crisópolis", "Cristópolis", "Cruz das Almas", "Curaçá", "Dário Meira", "Dias d'Ávila", "Dom Basílio", "Dom Macedo Costa", "Elísio Medrado", "Encruzilhada", "Entre Rios", "Érico Cardoso", "Esplanada", "Euclides da Cunha", "Eunápolis", "Fátima", "Feira da Mata", "Feira de Santana", "Filadélfia", "Firmino Alves", "Floresta Azul", "Formosa do Rio Preto", "Gandu", "Gavião", "Gentio do Ouro", "Glória", "Gongogi", "Governador Mangabeira", "Guajeru", "Guanambi", "Guaratinga", "Heliópolis", "Iaçu", "Ibiassucê", "Ibicaraí", "Ibicoara", "Ibicuí", "Ibipeba", "Ibipitanga", "Ibiquera", "Ibirapitanga", "Ibirapuã", "Ibirataia", "Ibitiara", "Ibititá", "Ibotirama", "Ichu", "Igaporã", "Igrapiúna", "Iguaí", "Ilhéus", "Inhambupe", "Ipecaetá", "Ipiaú", "Ipirá", "Ipupiara", "Irajuba", "Iramaia", "Iraquara", "Irará", "Irecê", "Itabela", "Itaberaba", "Itabuna", "Itacaré", "Itaeté", "Itagi", "Itagibá", "Itagimirim", "Itaguaçu da Bahia", "Itaju do Colônia", "Itajuípe", "Itamaraju", "Itamari", "Itambé", "Itanagra", "Itanhém", "Itaparica", "Itapé", "Itapebi", "Itapetinga", "Itapicuru", "Itapitanga", "Itaquara", "Itarantim", "Itatim", "Itiruçu", "Itiúba", "Itororó", "Ituaçu", "Ituberá", "Iuiú", "Jaborandi", "Jacaraci", "Jacobina", "Jaguaquara", "Jaguarari", "Jaguaripe", "Jandaíra", "Jequié", "Jeremoabo", "Jiquiriçá", "Jitaúna", "João Dourado", "Juazeiro", "Jucuruçu", "Jussara", "Jussari", "Jussiape", "Lafaiete Coutinho", "Lagoa Real", "Laje", "Lajedão", "Lajedinho", "Lajedo do Tabocal", "Lamarão", "Lapão", "Lauro de Freitas", "Lençóis", "Licínio de Almeida", "Livramento de Nossa Senhora", "Luís Eduardo Magalhães", "Macajuba", "Macarani", "Macaúbas", "Macururé", "Madre de Deus", "Maetinga", "Maiquinique", "Mairi", "Malhada", "Malhada de Pedras", "Manoel Vitorino", "Mansidão", "Maracás", "Maragogipe", "Maraú", "Marcionílio Souza", "Mascote", "Mata de São João", "Matina", "Medeiros Neto", "Miguel Calmon", "Milagres", "Mirangaba", "Mirante", "Monte Santo", "Morpará", "Morro do Chapéu", "Mortugaba", "Mucugê", "Mucuri", "Mulungu do Morro", "Mundo Novo", "Muniz Ferreira", "Muquém de São Francisco", "Muritiba", "Mutuípe", "Nazaré", "Nilo Peçanha", "Nordestina", "Nova Canaã", "Nova Fátima", "Nova Ibiá", "Nova Itarana", "Nova Redenção", "Nova Soure", "Nova Viçosa", "Novo Horizonte", "Novo Triunfo", "Olindina", "Oliveira dos Brejinhos", "Ouriçangas", "Ourolândia", "Palmas de Monte Alto", "Palmeiras", "Paramirim", "Paratinga", "Paripiranga", "Pau Brasil", "Paulo Afonso", "Pé de Serra", "Pedrão", "Pedro Alexandre", "Piatã", "Pilão Arcado", "Pindaí", "Pindobaçu", "Pintadas", "Piraí do Norte", "Piripá", "Piritiba", "Planaltino", "Planalto", "Poções", "Pojuca", "Ponto Novo", "Porto Seguro", "Potiraguá", "Prado", "Presidente Dutra", "Presidente Jânio Quadros", "Presidente Tancredo Neves", "Queimadas", "Quijingue", "Quixabeira", "Rafael Jambeiro", "Remanso", "Retirolândia", "Riachão das Neves", "Riachão do Jacuípe", "Riacho de Santana", "Ribeira do Amparo", "Ribeira do Pombal", "Ribeirão do Largo", "Rio de Contas", "Rio do Antônio", "Rio do Pires", "Rio Real", "Rodelas", "Ruy Barbosa", "Salinas da Margarida", "Salvador", "Santa Bárbara", "Santa Brígida", "Santa Cruz Cabrália", "Santa Cruz da Vitória", "Santa Inês", "Santa Luzia", "Santa Maria da Vitória", "Santa Rita de Cássia", "Santa Teresinha", "Santaluz", "Santana", "Santanópolis", "Santo Amaro", "Santo Antônio de Jesus", "Santo Estêvão", "São Desidério", "São Domingos", "São Felipe", "São Félix", "São Félix do Coribe", "São Francisco do Conde", "São Gabriel", "São Gonçalo dos Campos", "São José da Vitória", "São José do Jacuípe", "São Miguel das Matas", "São Sebastião do Passé", "Sapeaçu", "Sátiro Dias", "Saubara", "Saúde", "Seabra", "Sebastião Laranjeiras", "Senhor do Bonfim", "Sento Sé", "Serra do Ramalho", "Serra Dourada", "Serra Preta", "Serrinha", "Serrolândia", "Simões Filho", "Sítio do Mato", "Sítio do Quinto", "Sobradinho", "Souto Soares", "Tabocas do Brejo Velho", "Tanhaçu", "Tanque Novo", "Tanquinho", "Taperoá", "Tapiramutá", "Teixeira de Freitas", "Teodoro Sampaio", "Teofilândia", "Teolândia", "Terra Nova", "Tremedal", "Tucano", "Uauá", "Ubaíra", "Ubaitaba", "Ubatã", "Uibaí", "Umburanas", "Una", "Urandi", "Uruçuca", "Utinga", "Valença", "Valente", "Várzea da Roça", "Várzea do Poço", "Várzea Nova", "Varzedo", "Vera Cruz", "Vereda", "Vitória da Conquista", "Wagner", "Wanderley", "Wenceslau Guimarães", "Xique-Xique"]
}, {
  uf: "CE",
  name: "Ceará",
  capital: "Fortaleza",
  cities: ["Abaiara", "Acarapé", "Acaraú", "Acopiara", "Aiuaba", "Alcântaras", "Altaneira", "Alto Santo", "Amontada", "Antonina do Norte", "Apuiarés", "Aquiraz", "Aracati", "Aracoiaba", "Ararendá", "Araripe", "Aratuba", "Arneiroz", "Assaré", "Aurora", "Baixio", "Banabuiú", "Barbalha", "Barreira", "Barro", "Barroquinha", "Baturité", "Beberibe", "Bela Cruz", "Boa Viagem", "Brejo Santo", "Camocim", "Campos Sales", "Canindé", "Capistrano", "Caridade", "Cariré", "Caririaçu", "Cariús", "Carnaubal", "Cascavel", "Catarina", "Catunda", "Caucaia", "Cedro", "Chaval", "Choró", "Chorozinho", "Coreaú", "Crateús", "Crato", "Croatá", "Cruz", "Deputado Irapuan Pinheiro", "Ererê", "Eusébio", "Farias Brito", "Forquilha", "Fortaleza", "Fortim", "Frecheirinha", "General Sampaio", "Graça", "Granja", "Granjeiro", "Groaíras", "Guaiúba", "Guaraciaba do Norte", "Guaramiranga", "Hidrolândia", "Horizonte", "Ibaretama", "Ibiapina", "Ibicuitinga", "Icapuí", "Icó", "Iguatu", "Independência", "Ipaporanga", "Ipaumirim", "Ipu", "Ipueiras", "Iracema", "Irauçuba", "Itaiçaba", "Itaitinga", "Itapagé", "Itapipoca", "Itapiúna", "Itarema", "Itatira", "Jaguaretama", "Jaguaribara", "Jaguaribe", "Jaguaruana", "Jardim", "Jati", "Jijoca de Jericoaroara", "Juazeiro do Norte", "Jucás", "Lavras da Mangabeira", "Limoeiro do Norte", "Madalena", "Maracanaú", "Maranguape", "Marco", "Martinópole", "Massapê", "Mauriti", "Meruoca", "Milagres", "Milhã", "Miraíma", "Missão Velha", "Mombaça", "Monsenhor Tabosa", "Morada Nova", "Moraújo", "Morrinhos", "Mucambo", "Mulungu", "Nova Olinda", "Nova Russas", "Novo Oriente", "Ocara", "Orós", "Pacajus", "Pacatuba", "Pacoti", "Pacujá", "Palhano", "Palmácia", "Paracuru", "Paraipaba", "Parambu", "Paramoti", "Pedra Branca", "Penaforte", "Pentecoste", "Pereiro", "Pindoretama", "Piquet Carneiro", "Pires Ferreira", "Poranga", "Porteiras", "Potengi", "Potiretama", "Quiterianópolis", "Quixadá", "Quixelô", "Quixeramobim", "Quixeré", "Redenção", "Reriutaba", "Russas", "Saboeiro", "Salitre", "Santa Quitéria", "Santana do Acaraú", "Santana do Cariri", "São Benedito", "São Gonçalo do Amarante", "São João do Jaguaribe", "São Luís do Curu", "Senador Pompeu", "Senador Sá", "Sobral", "Solonópole", "Tabuleiro do Norte", "Tamboril", "Tarrafas", "Tauá", "Tejuçuoca", "Tianguá", "Trairi", "Tururu", "Ubajara", "Umari", "Umirim", "Uruburetama", "Uruoca", "Varjota", "Várzea Alegre", "Viçosa do Ceará"]
}, {
  uf: "DF",
  name: "Distrito Federal",
  capital: "Brasília",
  cities: ["Brasília"]
}, {
  uf: "ES",
  name: "Espírito Santo",
  capital: "Vitória",
  cities: ["Afonso Cláudio", "Água Doce do Norte", "Águia Branca", "Alegre", "Alfredo Chaves", "Alto Rio Novo", "Anchieta", "Apiacá", "Aracruz", "Atilio Vivacqua", "Baixo Guandu", "Barra de São Francisco", "Boa Esperança", "Bom Jesus do Norte", "Brejetuba", "Cachoeiro de Itapemirim", "Cariacica", "Castelo", "Colatina", "Conceição da Barra", "Conceição do Castelo", "Divino de São Lourenço", "Domingos Martins", "Dores do Rio Preto", "Ecoporanga", "Fundão", "Governador Lindenberg", "Guaçuí", "Guarapari", "Ibatiba", "Ibiraçu", "Ibitirama", "Iconha", "Irupi", "Itaguaçu", "Itapemirim", "Itarana", "Iúna", "Jaguaré", "Jerônimo Monteiro", "João Neiva", "Laranja da Terra", "Linhares", "Mantenópolis", "Marataizes", "Marechal Floriano", "Marilândia", "Mimoso do Sul", "Montanha", "Mucurici", "Muniz Freire", "Muqui", "Nova Venécia", "Pancas", "Pedro Canário", "Pinheiros", "Piúma", "Ponto Belo", "Presidente Kennedy", "Rio Bananal", "Rio Novo do Sul", "Santa Leopoldina", "Santa Maria de Jetibá", "Santa Teresa", "São Domingos do Norte", "São Gabriel da Palha", "São José do Calçado", "São Mateus", "São Roque do Canaã", "Serra", "Sooretama", "Vargem Alta", "Venda Nova do Imigrante", "Viana", "Vila Pavão", "Vila Valério", "Vila Velha", "Vitória"]
}, {
  uf: "GO",
  name: "Goiás",
  capital: "Goiânia",
  cities: ["Abadia de Goiás", "Abadiânia", "Acreúna", "Adelândia", "Água Fria de Goiás", "Água Limpa", "Águas Lindas de Goiás", "Alexânia", "Aloândia", "Alto Horizonte", "Alto Paraíso de Goiás", "Alvorada do Norte", "Amaralina", "Americano do Brasil", "Amorinópolis", "Anápolis", "Anhanguera", "Anicuns", "Aparecida de Goiânia", "Aparecida do Rio Doce", "Aporé", "Araçu", "Aragarças", "Aragoiânia", "Araguapaz", "Arenópolis", "Aruanã", "Aurilândia", "Avelinópolis", "Baliza", "Barro Alto", "Bela Vista de Goiás", "Bom Jardim de Goiás", "Bom Jesus de Goiás", "Bonfinópolis", "Bonópolis", "Brazabrantes", "Britânia", "Buriti Alegre", "Buriti de Goiás", "Buritinópolis", "Cabeceiras", "Cachoeira Alta", "Cachoeira de Goiás", "Cachoeira Dourada", "Caçu", "Caiapônia", "Caldas Novas", "Caldazinha", "Campestre de Goiás", "Campinaçu", "Campinorte", "Campo Alegre de Goiás", "Campos Limpo de Goiás", "Campos Belos", "Campos Verdes", "Carmo do Rio Verde", "Castelândia", "Catalão", "Caturaí", "Cavalcante", "Ceres", "Cezarina", "Chapadão do Céu", "Cidade Ocidental", "Cocalzinho de Goiás", "Colinas do Sul", "Córrego do Ouro", "Corumbá de Goiás", "Corumbaíba", "Cristalina", "Cristianópolis", "Crixás", "Cromínia", "Cumari", "Damianópolis", "Damolândia", "Davinópolis", "Diorama", "Divinópolis de Goiás", "Doverlândia", "Edealina", "Edéia", "Estrela do Norte", "Faina", "Fazenda Nova", "Firminópolis", "Flores de Goiás", "Formosa", "Formoso", "Gameleira de Goiás", "Goianápolis", "Goiandira", "Goianésia", "Goiânia", "Goianira", "Goiás", "Goiatuba", "Gouvelândia", "Guapó", "Guaraíta", "Guarani de Goiás", "Guarinos", "Heitoraí", "Hidrolândia", "Hidrolina", "Iaciara", "Inaciolândia", "Indiara", "Inhumas", "Ipameri", "Ipiranga de Goiás", "Iporá", "Israelândia", "Itaberaí", "Itaguari", "Itaguaru", "Itajá", "Itapaci", "Itapirapuã", "Itapuranga", "Itarumã", "Itauçu", "Itumbiara", "Ivolândia", "Jandaia", "Jaraguá", "Jataí", "Jaupaci", "Jesúpolis", "Joviânia", "Jussara", "Lagoa Santa", "Leopoldo de Bulhões", "Luziânia", "Mairipotaba", "Mambaí", "Mara Rosa", "Marzagão", "Matrinchã", "Maurilândia", "Mimoso de Goiás", "Minaçu", "Mineiros", "Moiporá", "Monte Alegre de Goiás", "Montes Claros de Goiás", "Montividiu", "Montividiu do Norte", "Morrinhos", "Morro Agudo de Goiás", "Mossâmedes", "Mozarlândia", "Mundo Novo", "Mutunópolis", "Nazário", "Nerópolis", "Niquelândia", "Nova América", "Nova Aurora", "Nova Crixás", "Nova Glória", "Nova Iguaçu de Goiás", "Nova Roma", "Nova Veneza", "Novo Brasil", "Novo Gama", "Novo Planalto", "Orizona", "Ouro Verde de Goiás", "Ouvidor", "Padre Bernardo", "Palestina de Goiás", "Palmeiras de Goiás", "Palmelo", "Palminópolis", "Panamá", "Paranaiguara", "Paraúna", "Perolândia", "Petrolina de Goiás", "Pilar de Goiás", "Piracanjuba", "Piranhas", "Pirenópolis", "Pires do Rio", "Planaltina", "Pontalina", "Porangatu", "Porteirão", "Portelândia", "Posse", "Professor Jamil", "Quirinópolis", "Rialma", "Rianápolis", "Rio Quente", "Rio Verde", "Rubiataba", "Sanclerlândia", "Santa Bárbara de Goiás", "Santa Cruz de Goiás", "Santa Fé de Goiás", "Santa Helena de Goiás", "Santa Isabel", "Santa Rita do Araguaia", "Santa Rita do Novo Destino", "Santa Rosa de Goiás", "Santa Tereza de Goiás", "Santa Terezinha de Goiás", "Santo Antônio da Barra", "Santo Antônio de Goiás", "Santo Antônio do Descoberto", "São Domingos", "São Francisco de Goiás", "São João d'Aliança", "São João da Paraúna", "São Luís de Montes Belos", "São Luíz do Norte", "São Miguel do Araguaia", "São Miguel do Passa Quatro", "São Patrício", "São Simão", "Senador Canedo", "Serranópolis", "Silvânia", "Simolândia", "Sítio d'Abadia", "Taquaral de Goiás", "Teresina de Goiás", "Terezópolis de Goiás", "Três Ranchos", "Trindade", "Trombas", "Turvânia", "Turvelândia", "Uirapuru", "Uruaçu", "Uruana", "Urutaí", "Valparaíso de Goiás", "Varjão", "Vianópolis", "Vicentinópolis", "Vila Boa", "Vila Propício"]
}, {
  uf: "MA",
  name: "Maranhão",
  capital: "São Luis",
  cities: ["Açailândia", "Afonso Cunha", "Água Doce do Maranhão", "Alcântara", "Aldeias Altas", "Altamira do Maranhão", "Alto Alegre do Maranhão", "Alto Alegre do Pindaré", "Alto Parnaíba", "Amapá do Maranhão", "Amarante do Maranhão", "Anajatuba", "Anapurus", "Apicum-Açu", "Araguanã", "Araioses", "Arame", "Arari", "Axixá", "Bacabal", "Bacabeira", "Bacuri", "Bacurituba", "Balsas", "Barão de Grajaú", "Barra do Corda", "Barreirinhas", "Bela Vista do Maranhão", "Belágua", "Benedito Leite", "Bequimão", "Bernardo do Mearim", "Boa Vista do Gurupi", "Bom Jardim", "Bom Jesus das Selvas", "Bom Lugar", "Brejo", "Brejo de Areia", "Buriti", "Buriti Bravo", "Buriticupu", "Buritirana", "Cachoeira Grande", "Cajapió", "Cajari", "Campestre do Maranhão", "Cândido Mendes", "Cantanhede", "Capinzal do Norte", "Carolina", "Carutapera", "Caxias", "Cedral", "Central do Maranhão", "Centro do Guilherme", "Centro Novo do Maranhão", "Chapadinha", "Cidelândia", "Codó", "Coelho Neto", "Colinas", "Conceição do Lago-Açu", "Coroatá", "Cururupu", "Davinópolis", "Dom Pedro", "Duque Bacelar", "Esperantinópolis", "Estreito", "Feira Nova do Maranhão", "Fernando Falcão", "Formosa da Serra Negra", "Fortaleza dos Nogueiras", "Fortuna", "Godofredo Viana", "Gonçalves Dias", "Governador Archer", "Governador Edison Lobão", "Governador Eugênio Barros", "Governador Luiz Rocha", "Governador Newton Bello", "Governador Nunes Freire", "Graça Aranha", "Grajaú", "Guimarães", "Humberto de Campos", "Icatu", "Igarapé do Meio", "Igarapé Grande", "Imperatriz", "Itaipava do Grajaú", "Itapecuru Mirim", "Itinga do Maranhão", "Jatobá", "Jenipapo dos Vieiras", "João Lisboa", "Joselândia", "Junco do Maranhão", "Lago da Pedra", "Lago do Junco", "Lago dos Rodrigues", "Lago Verde", "Lagoa do Mato", "Lagoa Grande do Maranhão", "Lajeado Novo", "Lima Campos", "Loreto", "Luís Domingues", "Magalhães de Almeida", "Maracaçumé", "Marajá do Sena", "Maranhãozinho", "Mata Roma", "Matinha", "Matões", "Matões do Norte", "Milagres do Maranhão", "Mirador", "Miranda do Norte", "Mirinzal", "Monção", "Montes Altos", "Morros", "Nina Rodrigues", "Nova Colinas", "Nova Iorque", "Nova Olinda do Maranhão", "Olho d'Água das Cunhãs", "Olinda Nova do Maranhão", "Paço do Lumiar", "Palmeirândia", "Paraibano", "Parnarama", "Passagem Franca", "Pastos Bons", "Paulino Neves", "Paulo Ramos", "Pedreiras", "Pedro do Rosário", "Penalva", "Peri Mirim", "Peritoró", "Pindaré Mirim", "Pinheiro", "Pio XII", "Pirapemas", "Poção de Pedras", "Porto Franco", "Porto Rico do Maranhão", "Presidente Dutra", "Presidente Juscelino", "Presidente Médici", "Presidente Sarney", "Presidente Vargas", "Primeira Cruz", "Raposa", "Riachão", "Ribamar Fiquene", "Rosário", "Sambaíba", "Santa Filomena do Maranhão", "Santa Helena", "Santa Inês", "Santa Luzia", "Santa Luzia do Paruá", "Santa Quitéria do Maranhão", "Santa Rita", "Santana do Maranhão", "Santo Amaro do Maranhão", "Santo Antônio dos Lopes", "São Benedito do Rio Preto", "São Bento", "São Bernardo", "São Domingos do Azeitão", "São Domingos do Maranhão", "São Félix de Balsas", "São Francisco do Brejão", "São Francisco do Maranhão", "São João Batista", "São João do Carú", "São João do Paraíso", "São João do Soter", "São João dos Patos", "São José de Ribamar", "São José dos Basílios", "São Luís", "São Luís Gonzaga do Maranhão", "São Mateus do Maranhão", "São Pedro da Água Branca", "São Pedro dos Crentes", "São Raimundo das Mangabeiras", "São Raimundo do Doca Bezerra", "São Roberto", "São Vicente Ferrer", "Satubinha", "Senador Alexandre Costa", "Senador La Rocque", "Serrano do Maranhão", "Sítio Novo", "Sucupira do Norte", "Sucupira do Riachão", "Tasso Fragoso", "Timbiras", "Timon", "Trizidela do Vale", "Tufilândia", "Tuntum", "Turiaçu", "Turilândia", "Tutóia", "Urbano Santos", "Vargem Grande", "Viana", "Vila Nova dos Martírios", "Vitória do Mearim", "Vitorino Freire", "Zé Doca"]
}, {
  uf: "MG",
  name: "Minas Gerais",
  capital: "Belo Horizonte",
  cities: ["Abadia dos Dourados", "Abaeté", "Abre Campo", "Acaiaca", "Açucena", "Água Boa", "Água Comprida", "Aguanil", "Águas Formosas", "Águas Vermelhas", "Aimorés", "Aiuruoca", "Alagoa", "Albertina", "Além Paraíba", "Alfenas", "Alfredo Vasconcelos", "Almenara", "Alpercata", "Alpinópolis", "Alterosa", "Alto Caparaó", "Alto Jequitibá", "Alto Rio Doce", "Alvarenga", "Alvinópolis", "Alvorada de Minas", "Amparo do Serra", "Andradas", "Andrelândia", "Angelândia", "Antônio Carlos", "Antônio Dias", "Antônio Prado de Minas", "Araçaí", "Aracitaba", "Araçuaí", "Araguari", "Arantina", "Araponga", "Araporã", "Arapuá", "Araújos", "Araxá", "Arceburgo", "Arcos", "Areado", "Argirita", "Aricanduva", "Arinos", "Astolfo Dutra", "Ataléia", "Augusto de Lima", "Baependi", "Baldim", "Bambuí", "Bandeira", "Bandeira do Sul", "Barão de Cocais", "Barão de Monte Alto", "Barbacena", "Barra Longa", "Barroso", "Bela Vista de Minas", "Belmiro Braga", "Belo Horizonte", "Belo Oriente", "Belo Vale", "Berilo", "Berizal", "Bertópolis", "Betim", "Bias Fortes", "Bicas", "Biquinhas", "Boa Esperança", "Bocaina de Minas", "Bocaiúva", "Bom Despacho", "Bom Jardim de Minas", "Bom Jesus da Penha", "Bom Jesus do Amparo", "Bom Jesus do Galho", "Bom Repouso", "Bom Sucesso", "Bonfim", "Bonfinópolis de Minas", "Bonito de Minas", "Borda da Mata", "Botelhos", "Botumirim", "Brás Pires", "Brasilândia de Minas", "Brasília de Minas", "Brasópolis", "Braúnas", "Brumadinho", "Bueno Brandão", "Buenópolis", "Bugre", "Buritis", "Buritizeiro", "Cabeceira Grande", "Cabo Verde", "Cachoeira da Prata", "Cachoeira de Minas", "Cachoeira de Pajeú", "Cachoeira Dourada", "Caetanópolis", "Caeté", "Caiana", "Cajuri", "Caldas", "Camacho", "Camanducaia", "Cambuí", "Cambuquira", "Campanário", "Campanha", "Campestre", "Campina Verde", "Campo Azul", "Campo Belo", "Campo do Meio", "Campo Florido", "Campos Altos", "Campos Gerais", "Cana Verde", "Canaã", "Canápolis", "Candeias", "Cantagalo", "Caparaó", "Capela Nova", "Capelinha", "Capetinga", "Capim Branco", "Capinópolis", "Capitão Andrade", "Capitão Enéas", "Capitólio", "Caputira", "Caraí", "Caranaíba", "Carandaí", "Carangola", "Caratinga", "Carbonita", "Careaçu", "Carlos Chagas", "Carmésia", "Carmo da Cachoeira", "Carmo da Mata", "Carmo de Minas", "Carmo do Cajuru", "Carmo do Paranaíba", "Carmo do Rio Claro", "Carmópolis de Minas", "Carneirinho", "Carrancas", "Carvalhópolis", "Carvalhos", "Casa Grande", "Cascalho Rico", "Cássia", "Cataguases", "Catas Altas", "Catas Altas da Noruega", "Catuji", "Catuti", "Caxambu", "Cedro do Abaeté", "Central de Minas", "Centralina", "Chácara", "Chalé", "Chapada do Norte", "Chapada Gaúcha", "Chiador", "Cipotânea", "Claraval", "Claro dos Poções", "Cláudio", "Coimbra", "Coluna", "Comendador Gomes", "Comercinho", "Conceição da Aparecida", "Conceição da Barra de Minas", "Conceição das Alagoas", "Conceição das Pedras", "Conceição de Ipanema", "Conceição do Mato Dentro", "Conceição do Pará", "Conceição do Rio Verde", "Conceição dos Ouros", "Cônego Marinho", "Confins", "Congonhal", "Congonhas", "Congonhas do Norte", "Conquista", "Conselheiro Lafaiete", "Conselheiro Pena", "Consolação", "Contagem", "Coqueiral", "Coração de Jesus", "Cordisburgo", "Cordislândia", "Corinto", "Coroaci", "Coromandel", "Coronel Fabriciano", "Coronel Murta", "Coronel Pacheco", "Coronel Xavier Chaves", "Córrego Danta", "Córrego do Bom Jesus", "Córrego Fundo", "Córrego Novo", "Couto de Magalhães de Minas", "Crisólita", "Cristais", "Cristália", "Cristiano Otoni", "Cristina", "Crucilândia", "Cruzeiro da Fortaleza", "Cruzília", "Cuparaque", "Curral de Dentro", "Curvelo", "Datas", "Delfim Moreira", "Delfinópolis", "Delta", "Descoberto", "Desterro de Entre Rios", "Desterro do Melo", "Diamantina", "Diogo de Vasconcelos", "Dionísio", "Divinésia", "Divino", "Divino das Laranjeiras", "Divinolândia de Minas", "Divinópolis", "Divisa Alegre", "Divisa Nova", "Divisópolis", "Dom Bosco", "Dom Cavati", "Dom Joaquim", "Dom Silvério", "Dom Viçoso", "Dona Euzébia", "Dores de Campos", "Dores de Guanhães", "Dores do Indaiá", "Dores do Turvo", "Doresópolis", "Douradoquara", "Durandé", "Elói Mendes", "Engenheiro Caldas", "Engenheiro Navarro", "Entre Folhas", "Entre Rios de Minas", "Ervália", "Esmeraldas", "Espera Feliz", "Espinosa", "Espírito Santo do Dourado", "Estiva", "Estrela Dalva", "Estrela do Indaiá", "Estrela do Sul", "Eugenópolis", "Ewbank da Câmara", "Extrema", "Fama", "Faria Lemos", "Felício dos Santos", "Felisburgo", "Felixlândia", "Fernandes Tourinho", "Ferros", "Fervedouro", "Florestal", "Formiga", "Formoso", "Fortaleza de Minas", "Fortuna de Minas", "Francisco Badaró", "Francisco Dumont", "Francisco Sá", "Franciscópolis", "Frei Gaspar", "Frei Inocêncio", "Frei Lagonegro", "Fronteira", "Fronteira dos Vales", "Fruta de Leite", "Frutal", "Funilândia", "Galiléia", "Gameleiras", "Glaucilândia", "Goiabeira", "Goianá", "Gonçalves", "Gonzaga", "Gouveia", "Governador Valadares", "Grão Mogol", "Grupiara", "Guanhães", "Guapé", "Guaraciaba", "Guaraciama", "Guaranésia", "Guarani", "Guarará", "Guarda-Mor", "Guaxupé", "Guidoval", "Guimarânia", "Guiricema", "Gurinhatã", "Heliodora", "Iapu", "Ibertioga", "Ibiá", "Ibiaí", "Ibiracatu", "Ibiraci", "Ibirité", "Ibitiúra de Minas", "Ibituruna", "Icaraí de Minas", "Igarapé", "Igaratinga", "Iguatama", "Ijaci", "Ilicínea", "Imbé de Minas", "Inconfidentes", "Indaiabira", "Indianópolis", "Ingaí", "Inhapim", "Inhaúma", "Inimutaba", "Ipaba", "Ipanema", "Ipatinga", "Ipiaçu", "Ipuiúna", "Iraí de Minas", "Itabira", "Itabirinha de Mantena", "Itabirito", "Itacambira", "Itacarambi", "Itaguara", "Itaipé", "Itajubá", "Itamarandiba", "Itamarati de Minas", "Itambacuri", "Itambé do Mato Dentro", "Itamogi", "Itamonte", "Itanhandu", "Itanhomi", "Itaobim", "Itapagipe", "Itapecerica", "Itapeva", "Itatiaiuçu", "Itaú de Minas", "Itaúna", "Itaverava", "Itinga", "Itueta", "Ituiutaba", "Itumirim", "Iturama", "Itutinga", "Jaboticatubas", "Jacinto", "Jacuí", "Jacutinga", "Jaguaraçu", "Jaíba", "Jampruca", "Janaúba", "Januária", "Japaraíba", "Japonvar", "Jeceaba", "Jenipapo de Minas", "Jequeri", "Jequitaí", "Jequitibá", "Jequitinhonha", "Jesuânia", "Joaíma", "Joanésia", "João Monlevade", "João Pinheiro", "Joaquim Felício", "Jordânia", "José Gonçalves de Minas", "José Raydan", "Josenópolis", "Juatuba", "Juiz de Fora", "Juramento", "Juruaia", "Juvenília", "Ladainha", "Lagamar", "Lagoa da Prata", "Lagoa dos Patos", "Lagoa Dourada", "Lagoa Formosa", "Lagoa Grande", "Lagoa Santa", "Lajinha", "Lambari", "Lamim", "Laranjal", "Lassance", "Lavras", "Leandro Ferreira", "Leme do Prado", "Leopoldina", "Liberdade", "Lima Duarte", "Limeira do Oeste", "Lontra", "Luisburgo", "Luislândia", "Luminárias", "Luz", "Machacalis", "Machado", "Madre de Deus de Minas", "Malacacheta", "Mamonas", "Manga", "Manhuaçu", "Manhumirim", "Mantena", "Mar de Espanha", "Maravilhas", "Maria da Fé", "Mariana", "Marilac", "Mário Campos", "Maripá de Minas", "Marliéria", "Marmelópolis", "Martinho Campos", "Martins Soares", "Mata Verde", "Materlândia", "Mateus Leme", "Mathias Lobato", "Matias Barbosa", "Matias Cardoso", "Matipó", "Mato Verde", "Matozinhos", "Matutina", "Medeiros", "Medina", "Mendes Pimentel", "Mercês", "Mesquita", "Minas Novas", "Minduri", "Mirabela", "Miradouro", "Miraí", "Miravânia", "Moeda", "Moema", "Monjolos", "Monsenhor Paulo", "Montalvânia", "Monte Alegre de Minas", "Monte Azul", "Monte Belo", "Monte Carmelo", "Monte Formoso", "Monte Santo de Minas", "Monte Sião", "Montes Claros", "Montezuma", "Morada Nova de Minas", "Morro da Garça", "Morro do Pilar", "Munhoz", "Muriaé", "Mutum", "Muzambinho", "Nacip Raydan", "Nanuque", "Naque", "Natalândia", "Natércia", "Nazareno", "Nepomuceno", "Ninheira", "Nova Belém", "Nova Era", "Nova Lima", "Nova Módica", "Nova Ponte", "Nova Porteirinha", "Nova Resende", "Nova Serrana", "Nova União", "Novo Cruzeiro", "Novo Oriente de Minas", "Novorizonte", "Olaria", "Olhos-d'Água", "Olímpio Noronha", "Oliveira", "Oliveira Fortes", "Onça de Pitangui", "Oratórios", "Orizânia", "Ouro Branco", "Ouro Fino", "Ouro Preto", "Ouro Verde de Minas", "Padre Carvalho", "Padre Paraíso", "Pai Pedro", "Paineiras", "Pains", "Paiva", "Palma", "Palmópolis", "Papagaios", "Pará de Minas", "Paracatu", "Paraguaçu", "Paraisópolis", "Paraopeba", "Passa Quatro", "Passa Tempo", "Passa-Vinte", "Passabém", "Passos", "Patis", "Patos de Minas", "Patrocínio", "Patrocínio do Muriaé", "Paula Cândido", "Paulistas", "Pavão", "Peçanha", "Pedra Azul", "Pedra Bonita", "Pedra do Anta", "Pedra do Indaiá", "Pedra Dourada", "Pedralva", "Pedras de Maria da Cruz", "Pedrinópolis", "Pedro Leopoldo", "Pedro Teixeira", "Pequeri", "Pequi", "Perdigão", "Perdizes", "Perdões", "Periquito", "Pescador", "Piau", "Piedade de Caratinga", "Piedade de Ponte Nova", "Piedade do Rio Grande", "Piedade dos Gerais", "Pimenta", "Pingo-d'Água", "Pintópolis", "Piracema", "Pirajuba", "Piranga", "Piranguçu", "Piranguinho", "Pirapetinga", "Pirapora", "Piraúba", "Pitangui", "Piumhi", "Planura", "Poço Fundo", "Poços de Caldas", "Pocrane", "Pompéu", "Ponte Nova", "Ponto Chique", "Ponto dos Volantes", "Porteirinha", "Porto Firme", "Poté", "Pouso Alegre", "Pouso Alto", "Prados", "Prata", "Pratápolis", "Pratinha", "Presidente Bernardes", "Presidente Juscelino", "Presidente Kubitschek", "Presidente Olegário", "Prudente de Morais", "Quartel Geral", "Queluzito", "Raposos", "Raul Soares", "Recreio", "Reduto", "Resende Costa", "Resplendor", "Ressaquinha", "Riachinho", "Riacho dos Machados", "Ribeirão das Neves", "Ribeirão Vermelho", "Rio Acima", "Rio Casca", "Rio do Prado", "Rio Doce", "Rio Espera", "Rio Manso", "Rio Novo", "Rio Paranaíba", "Rio Pardo de Minas", "Rio Piracicaba", "Rio Pomba", "Rio Preto", "Rio Vermelho", "Ritápolis", "Rochedo de Minas", "Rodeiro", "Romaria", "Rosário da Limeira", "Rubelita", "Rubim", "Sabará", "Sabinópolis", "Sacramento", "Salinas", "Salto da Divisa", "Santa Bárbara", "Santa Bárbara do Leste", "Santa Bárbara do Monte Verde", "Santa Bárbara do Tugúrio", "Santa Cruz de Minas", "Santa Cruz de Salinas", "Santa Cruz do Escalvado", "Santa Efigênia de Minas", "Santa Fé de Minas", "Santa Helena de Minas", "Santa Juliana", "Santa Luzia", "Santa Margarida", "Santa Maria de Itabira", "Santa Maria do Salto", "Santa Maria do Suaçuí", "Santa Rita de Caldas", "Santa Rita de Ibitipoca", "Santa Rita de Jacutinga", "Santa Rita de Minas", "Santa Rita do Itueto", "Santa Rita do Sapucaí", "Santa Rosa da Serra", "Santa Vitória", "Santana da Vargem", "Santana de Cataguases", "Santana de Pirapama", "Santana do Deserto", "Santana do Garambéu", "Santana do Jacaré", "Santana do Manhuaçu", "Santana do Paraíso", "Santana do Riacho", "Santana dos Montes", "Santo Antônio do Amparo", "Santo Antônio do Aventureiro", "Santo Antônio do Grama", "Santo Antônio do Itambé", "Santo Antônio do Jacinto", "Santo Antônio do Monte", "Santo Antônio do Retiro", "Santo Antônio do Rio Abaixo", "Santo Hipólito", "Santos Dumont", "São Bento Abade", "São Brás do Suaçuí", "São Domingos das Dores", "São Domingos do Prata", "São Félix de Minas", "São Francisco", "São Francisco de Paula", "São Francisco de Sales", "São Francisco do Glória", "São Geraldo", "São Geraldo da Piedade", "São Geraldo do Baixio", "São Gonçalo do Abaeté", "São Gonçalo do Pará", "São Gonçalo do Rio Abaixo", "São Gonçalo do Rio Preto", "São Gonçalo do Sapucaí", "São Gotardo", "São João Batista do Glória", "São João da Lagoa", "São João da Mata", "São João da Ponte", "São João das Missões", "São João del Rei", "São João do Manhuaçu", "São João do Manteninha", "São João do Oriente", "São João do Pacuí", "São João do Paraíso", "São João Evangelista", "São João Nepomuceno", "São Joaquim de Bicas", "São José da Barra", "São José da Lapa", "São José da Safira", "São José da Varginha", "São José do Alegre", "São José do Divino", "São José do Goiabal", "São José do Jacuri", "São José do Mantimento", "São Lourenço", "São Miguel do Anta", "São Pedro da União", "São Pedro do Suaçuí", "São Pedro dos Ferros", "São Romão", "São Roque de Minas", "São Sebastião da Bela Vista", "São Sebastião da Vargem Alegre", "São Sebastião do Anta", "São Sebastião do Maranhão", "São Sebastião do Oeste", "São Sebastião do Paraíso", "São Sebastião do Rio Preto", "São Sebastião do Rio Verde", "São Thomé das Letras", "São Tiago", "São Tomás de Aquino", "São Vicente de Minas", "Sapucaí-Mirim", "Sardoá", "Sarzedo", "Sem-Peixe", "Senador Amaral", "Senador Cortes", "Senador Firmino", "Senador José Bento", "Senador Modestino Gonçalves", "Senhora de Oliveira", "Senhora do Porto", "Senhora dos Remédios", "Sericita", "Seritinga", "Serra Azul de Minas", "Serra da Saudade", "Serra do Salitre", "Serra dos Aimorés", "Serrania", "Serranópolis de Minas", "Serranos", "Serro", "Sete Lagoas", "Setubinha", "Silveirânia", "Silvianópolis", "Simão Pereira", "Simonésia", "Sobrália", "Soledade de Minas", "Tabuleiro", "Taiobeiras", "Taparuba", "Tapira", "Tapiraí", "Taquaraçu de Minas", "Tarumirim", "Teixeiras", "Teófilo Otoni", "Timóteo", "Tiradentes", "Tiros", "Tocantins", "Tocos do Moji", "Toledo", "Tombos", "Três Corações", "Três Marias", "Três Pontas", "Tumiritinga", "Tupaciguara", "Turmalina", "Turvolândia", "Ubá", "Ubaí", "Ubaporanga", "Uberaba", "Uberlândia", "Umburatiba", "Unaí", "União de Minas", "Uruana de Minas", "Urucânia", "Urucuia", "Vargem Alegre", "Vargem Bonita", "Vargem Grande do Rio Pardo", "Varginha", "Varjão de Minas", "Várzea da Palma", "Varzelândia", "Vazante", "Verdelândia", "Veredinha", "Veríssimo", "Vermelho Novo", "Vespasiano", "Viçosa", "Vieiras", "Virgem da Lapa", "Virgínia", "Virginópolis", "Virgolândia", "Visconde do Rio Branco", "Volta Grande", "Wenceslau Braz"]
}, {
  uf: "MS",
  name: "Mato Grosso do Sul",
  capital: "Campo Grande",
  cities: ["Água Clara", "Alcinópolis", "Amambaí", "Anastácio", "Anaurilândia", "Angélica", "Antônio João", "Aparecida do Taboado", "Aquidauana", "Aral Moreira", "Bandeirantes", "Bataguassu", "Bataiporã", "Bela Vista", "Bodoquena", "Bonito", "Brasilândia", "Caarapó", "Camapuã", "Campo Grande", "Caracol", "Cassilândia", "Chapadão do Sul", "Corguinho", "Coronel Sapucaia", "Corumbá", "Costa Rica", "Coxim", "Deodápolis", "Dois Irmãos do Buriti", "Douradina", "Dourados", "Eldorado", "Fátima do Sul", "Glória de Dourados", "Guia Lopes da Laguna", "Iguatemi", "Inocência", "Itaporã", "Itaquiraí", "Ivinhema", "Japorã", "Jaraguari", "Jardim", "Jateí", "Juti", "Ladário", "Laguna Carapã", "Maracaju", "Miranda", "Mundo Novo", "Naviraí", "Nioaque", "Nova Alvorada do Sul", "Nova Andradina", "Novo Horizonte do Sul", "Paranaíba", "Paranhos", "Pedro Gomes", "Ponta Porã", "Porto Murtinho", "Ribas do Rio Pardo", "Rio Brilhante", "Rio Negro", "Rio Verde de Mato Grosso", "Rochedo", "Santa Rita do Pardo", "São Gabriel do Oeste", "Selvíria", "Sete Quedas", "Sidrolândia", "Sonora", "Tacuru", "Taquarussu", "Terenos", "Três Lagoas", "Vicentina"]
}, {
  uf: "MT",
  name: "Mato Grosso",
  capital: "Cuiabá",
  cities: ["Acorizal", "Água Boa", "Alta Floresta", "Alto Araguaia", "Alto Boa Vista", "Alto Garças", "Alto Paraguai", "Alto Taquari", "Apiacás", "Araguaiana", "Araguainha", "Araputanga", "Arenápolis", "Aripuanã", "Barão de Melgaço", "Barra do Bugres", "Barra do Garças", "Bom Jesus do Araguaia", "Brasnorte", "Cáceres", "Campinápolis", "Campo Novo do Parecis", "Campo Verde", "Campos de Júlio", "Canabrava do Norte", "Canarana", "Carlinda", "Castanheira", "Chapada dos Guimarães", "Cláudia", "Cocalinho", "Colíder", "Colniza", "Comodoro", "Confresa", "Conquista d'Oeste", "Cotriguaçu", "Curvelândia", "Cuiabá", "Denise", "Diamantino", "Dom Aquino", "Feliz Natal", "Figueirópolis d'Oeste", "Gaúcha do Norte", "General Carneiro", "Glória d'Oeste", "Guarantã do Norte", "Guiratinga", "Indiavaí", "Itaúba", "Itiquira", "Jaciara", "Jangada", "Jauru", "Juara", "Juína", "Juruena", "Juscimeira", "Lambari d'Oeste", "Lucas do Rio Verde", "Luciára", "Marcelândia", "Matupá", "Mirassol d'Oeste", "Nobres", "Nortelândia", "Nossa Senhora do Livramento", "Nova Bandeirantes", "Nova Brasilândia", "Nova Canãa do Norte", "Nova Guarita", "Nova Lacerda", "Nova Marilândia", "Nova Maringá", "Nova Monte Verde", "Nova Mutum", "Nova Nazaré", "Nova Olímpia", "Nova Santa Helena", "Nova Ubiratã", "Nova Xavantina", "Novo Horizonte do Norte", "Novo Mundo", "Novo Santo Antônio", "Novo São Joaquim", "Paranaíta", "Paranatinga", "Pedra Preta", "Peixoto de Azevedo", "Planalto da Serra", "Poconé", "Pontal do Araguaia", "Ponte Branca", "Pontes e Lacerda", "Porto Alegre do Norte", "Porto dos Gaúchos", "Porto Esperidião", "Porto Estrela", "Poxoréo", "Primavera do Leste", "Querência", "Reserva do Cabaçal", "Ribeirão Cascalheira", "Ribeirãozinho", "Rio Branco", "Rondolândia", "Rondonópolis", "Rosário Oeste", "Salto do Céu", "Santa Carmem", "Santa Cruz do Xingu", "Santa Rita do Trivelato", "Santa Terezinha", "Santo Afonso", "Santo Antônio do Leste", "Santo Antônio do Leverger", "São Félix do Araguaia", "São José do Povo", "São José do Rio Claro", "São José do Xingu", "São José dos Quatro Marcos", "São Pedro da Cipa", "Sapezal", "Serra Nova Dourada", "Sinop", "Sorriso", "Tabaporã", "Tangará da Serra", "Tapurah", "Terra Nova do Norte", "Tesouro", "Torixoréu", "União do Sul", "Vale de São Domingos", "Várzea Grande", "Vera", "Vila Bela da Santíssima Trindade", "Vila Rica"]
}, {
  uf: "PA",
  name: "Pará",
  capital: "Belém",
  cities: ["Abaetetuba", "Abel Figueiredo", "Acará", "Afuá", "Água Azul do Norte", "Alenquer", "Almeirim", "Altamira", "Anajás", "Ananindeua", "Anapu", "Augusto Corrêa", "Aurora do Pará", "Aveiro", "Bagre", "Baião", "Bannach", "Barcarena", "Belém", "Belterra", "Benevides", "Bom Jesus do Tocantins", "Bonito", "Bragança", "Brasil Novo", "Brejo Grande do Araguaia", "Breu Branco", "Breves", "Bujaru", "Cachoeira do Arari", "Cachoeira do Piriá", "Cametá", "Canaã dos Carajás", "Capanema", "Capitão Poço", "Castanhal", "Chaves", "Colares", "Conceição do Araguaia", "Concórdia do Pará", "Cumaru do Norte", "Curionópolis", "Curralinho", "Curuá", "Curuçá", "Dom Eliseu", "Eldorado dos Carajás", "Faro", "Floresta do Araguaia", "Garrafão do Norte", "Goianésia do Pará", "Gurupá", "Igarapé-Açu", "Igarapé-Miri", "Inhangapi", "Ipixuna do Pará", "Irituia", "Itaituba", "Itupiranga", "Jacareacanga", "Jacundá", "Juruti", "Limoeiro do Ajuru", "Mãe do Rio", "Magalhães Barata", "Marabá", "Maracanã", "Marapanim", "Marituba", "Medicilândia", "Melgaço", "Mocajuba", "Moju", "Monte Alegre", "Muaná", "Nova Esperança do Piriá", "Nova Ipixuna", "Nova Timboteua", "Novo Progresso", "Novo Repartimento", "Óbidos", "Oeiras do Pará", "Oriximiná", "Ourém", "Ourilândia do Norte", "Pacajá", "Palestina do Pará", "Paragominas", "Parauapebas", "Pau d'Arco", "Peixe-Boi", "Piçarra", "Placas", "Ponta de Pedras", "Portel", "Porto de Moz", "Prainha", "Primavera", "Quatipuru", "Redenção", "Rio Maria", "Rondon do Pará", "Rurópolis", "Salinópolis", "Salvaterra", "Santa Bárbara do Pará", "Santa Cruz do Arari", "Santa Isabel do Pará", "Santa Luzia do Pará", "Santa Maria das Barreiras", "Santa Maria do Pará", "Santana do Araguaia", "Santarém", "Santarém Novo", "Santo Antônio do Tauá", "São Caetano de Odivela", "São Domingos do Araguaia", "São Domingos do Capim", "São Félix do Xingu", "São Francisco do Pará", "São Geraldo do Araguaia", "São João da Ponta", "São João de Pirabas", "São João do Araguaia", "São Miguel do Guamá", "São Sebastião da Boa Vista", "Sapucaia", "Senador José Porfírio", "Soure", "Tailândia", "Terra Alta", "Terra Santa", "Tomé-Açu", "Tracuateua", "Trairão", "Tucumã", "Tucuruí", "Ulianópolis", "Uruará", "Vigia", "Viseu", "Vitória do Xingu", "Xinguara"]
}, {
  uf: "PB",
  name: "Paraíba",
  capital: "João Pessoa",
  cities: ["Água Branca", "Aguiar", "Alagoa Grande", "Alagoa Nova", "Alagoinha", "Alcantil", "Algodão de Jandaíra", "Alhandra", "Amparo", "Aparecida", "Araçagi", "Arara", "Araruna", "Areia", "Areia de Baraúnas", "Areial", "Aroeiras", "Assunção", "Baía da Traição", "Bananeiras", "Baraúna", "Barra de Santa Rosa", "Barra de Santana", "Barra de São Miguel", "Bayeux", "Belém", "Belém do Brejo do Cruz", "Bernardino Batista", "Boa Ventura", "Boa Vista", "Bom Jesus", "Bom Sucesso", "Bonito de Santa Fé", "Boqueirão", "Borborema", "Brejo do Cruz", "Brejo dos Santos", "Caaporã", "Cabaceiras", "Cabedelo", "Cachoeira dos Índios", "Cacimba de Areia", "Cacimba de Dentro", "Cacimbas", "Caiçara", "Cajazeiras", "Cajazeirinhas", "Caldas Brandão", "Camalaú", "Campina Grande", "Campo de Santana", "Capim", "Caraúbas", "Carrapateira", "Casserengue", "Catingueira", "Catolé do Rocha", "Caturité", "Conceição", "Condado", "Conde", "Congo", "Coremas", "Coxixola", "Cruz do Espírito Santo", "Cubati", "Cuité", "Cuité de Mamanguape", "Cuitegi", "Curral de Cima", "Curral Velho", "Damião", "Desterro", "Diamante", "Dona Inês", "Duas Estradas", "Emas", "Esperança", "Fagundes", "Frei Martinho", "Gado Bravo", "Guarabira", "Gurinhém", "Gurjão", "Ibiara", "Igaracy", "Imaculada", "Ingá", "Itabaiana", "Itaporanga", "Itapororoca", "Itatuba", "Jacaraú", "Jericó", "João Pessoa", "Juarez Távora", "Juazeirinho", "Junco do Seridó", "Juripiranga", "Juru", "Lagoa", "Lagoa de Dentro", "Lagoa Seca", "Lastro", "Livramento", "Logradouro", "Lucena", "Mãe d'Água", "Malta", "Mamanguape", "Manaíra", "Marcação", "Mari", "Marizópolis", "Massaranduba", "Mataraca", "Matinhas", "Mato Grosso", "Maturéia", "Mogeiro", "Montadas", "Monte Horebe", "Monteiro", "Mulungu", "Natuba", "Nazarezinho", "Nova Floresta", "Nova Olinda", "Nova Palmeira", "Olho d'Água", "Olivedos", "Ouro Velho", "Parari", "Passagem", "Patos", "Paulista", "Pedra Branca", "Pedra Lavrada", "Pedras de Fogo", "Pedro Régis", "Piancó", "Picuí", "Pilar", "Pilões", "Pilõezinhos", "Pirpirituba", "Pitimbu", "Pocinhos", "Poço Dantas", "Poço de José de Moura", "Pombal", "Prata", "Princesa Isabel", "Puxinanã", "Queimadas", "Quixabá", "Remígio", "Riachão", "Riachão do Bacamarte", "Riachão do Poço", "Riacho de Santo Antônio", "Riacho dos Cavalos", "Rio Tinto", "Salgadinho", "Salgado de São Félix", "Santa Cecília", "Santa Cruz", "Santa Helena", "Santa Inês", "Santa Luzia", "Santa Rita", "Santa Teresinha", "Santana de Mangueira", "Santana dos Garrotes", "Santarém", "Santo André", "São Bentinho", "São Bento", "São Domingos de Pombal", "São Domingos do Cariri", "São Francisco", "São João do Cariri", "São João do Rio do Peixe", "São João do Tigre", "São José da Lagoa Tapada", "São José de Caiana", "São José de Espinharas", "São José de Piranhas", "São José de Princesa", "São José do Bonfim", "São José do Brejo do Cruz", "São José do Sabugi", "São José dos Cordeiros", "São José dos Ramos", "São Mamede", "São Miguel de Taipu", "São Sebastião de Lagoa de Roça", "São Sebastião do Umbuzeiro", "Sapé", "Seridó", "Serra Branca", "Serra da Raiz", "Serra Grande", "Serra Redonda", "Serraria", "Sertãozinho", "Sobrado", "Solânea", "Soledade", "Sossêgo", "Sousa", "Sumé", "Taperoá", "Tavares", "Teixeira", "Tenório", "Triunfo", "Uiraúna", "Umbuzeiro", "Várzea", "Vieirópolis", "Vista Serrana", "Zabelê"]
}, {
  uf: "PE",
  name: "Pernambuco",
  capital: "Recife",
  cities: ["Abreu e Lima", "Afogados da Ingazeira", "Afrânio", "Agrestina", "Água Preta", "Águas Belas", "Alagoinha", "Aliança", "Altinho", "Amaraji", "Angelim", "Araçoiaba", "Araripina", "Arcoverde", "Barra de Guabiraba", "Barreiros", "Belém de Maria", "Belém de São Francisco", "Belo Jardim", "Betânia", "Bezerros", "Bodocó", "Bom Conselho", "Bom Jardim", "Bonito", "Brejão", "Brejinho", "Brejo da Madre de Deus", "Buenos Aires", "Buíque", "Cabo de Santo Agostinho", "Cabrobó", "Cachoeirinha", "Caetés", "Calçado", "Calumbi", "Camaragibe", "Camocim de São Félix", "Camutanga", "Canhotinho", "Capoeiras", "Carnaíba", "Carnaubeira da Penha", "Carpina", "Caruaru", "Casinhas", "Catende", "Cedro", "Chã de Alegria", "Chã Grande", "Condado", "Correntes", "Cortês", "Cumaru", "Cupira", "Custódia", "Dormentes", "Escada", "Exu", "Feira Nova", "Fernando de Noronha", "Ferreiros", "Flores", "Floresta", "Frei Miguelinho", "Gameleira", "Garanhuns", "Glória do Goitá", "Goiana", "Granito", "Gravatá", "Iati", "Ibimirim", "Ibirajuba", "Igarassu", "Iguaraci", "Inajá", "Ingazeira", "Ipojuca", "Ipubi", "Itacuruba", "Itaíba", "Itamaracá", "Itambé", "Itapetim", "Itapissuma", "Itaquitinga", "Jaboatão dos Guararapes", "Jaqueira", "Jataúba", "Jatobá", "João Alfredo", "Joaquim Nabuco", "Jucati", "Jupi", "Jurema", "Lagoa do Carro", "Lagoa do Itaenga", "Lagoa do Ouro", "Lagoa dos Gatos", "Lagoa Grande", "Lajedo", "Limoeiro", "Macaparana", "Machados", "Manari", "Maraial", "Mirandiba", "Moreilândia", "Moreno", "Nazaré da Mata", "Olinda", "Orobó", "Orocó", "Ouricuri", "Palmares", "Palmeirina", "Panelas", "Paranatama", "Parnamirim", "Passira", "Paudalho", "Paulista", "Pedra", "Pesqueira", "Petrolândia", "Petrolina", "Poção", "Pombos", "Primavera", "Quipapá", "Quixaba", "Recife", "Riacho das Almas", "Ribeirão", "Rio Formoso", "Sairé", "Salgadinho", "Salgueiro", "Saloá", "Sanharó", "Santa Cruz", "Santa Cruz da Baixa Verde", "Santa Cruz do Capibaribe", "Santa Filomena", "Santa Maria da Boa Vista", "Santa Maria do Cambucá", "Santa Terezinha", "São Benedito do Sul", "São Bento do Una", "São Caitano", "São João", "São Joaquim do Monte", "São José da Coroa Grande", "São José do Belmonte", "São José do Egito", "São Lourenço da Mata", "São Vicente Ferrer", "Serra Talhada", "Serrita", "Sertânia", "Sirinhaém", "Solidão", "Surubim", "Tabira", "Tacaimbó", "Tacaratu", "Tamandaré", "Taquaritinga do Norte", "Terezinha", "Terra Nova", "Timbaúba", "Toritama", "Tracunhaém", "Trindade", "Triunfo", "Tupanatinga", "Tuparetama", "Venturosa", "Verdejante", "Vertente do Lério", "Vertentes", "Vicência", "Vitória de Santo Antão", "Xexéu"]
}, {
  uf: "PI",
  name: "Piauí",
  capital: "Teresina",
  cities: ["Acauã", "Agricolândia", "Água Branca", "Alagoinha do Piauí", "Alegrete do Piauí", "Alto Longá", "Altos", "Alvorada do Gurguéia", "Amarante", "Angical do Piauí", "Anísio de Abreu", "Antônio Almeida", "Aroazes", "Arraial", "Assunção do Piauí", "Avelino Lopes", "Baixa Grande do Ribeiro", "Barra d'Alcântara", "Barras", "Barreiras do Piauí", "Barro Duro", "Batalha", "Bela Vista do Piauí", "Belém do Piauí", "Beneditinos", "Bertolínia", "Betânia do Piauí", "Boa Hora", "Bocaina", "Bom Jesus", "Bom Princípio do Piauí", "Bonfim do Piauí", "Boqueirão do Piauí", "Brasileira", "Brejo do Piauí", "Buriti dos Lopes", "Buriti dos Montes", "Cabeceiras do Piauí", "Cajazeiras do Piauí", "Cajueiro da Praia", "Caldeirão Grande do Piauí", "Campinas do Piauí", "Campo Alegre do Fidalgo", "Campo Grande do Piauí", "Campo Largo do Piauí", "Campo Maior", "Canavieira", "Canto do Buriti", "Capitão de Campos", "Capitão Gervásio Oliveira", "Caracol", "Caraúbas do Piauí", "Caridade do Piauí", "Castelo do Piauí", "Caxingó", "Cocal", "Cocal de Telha", "Cocal dos Alves", "Coivaras", "Colônia do Gurguéia", "Colônia do Piauí", "Conceição do Canindé", "Coronel José Dias", "Corrente", "Cristalândia do Piauí", "Cristino Castro", "Curimatá", "Currais", "Curral Novo do Piauí", "Curralinhos", "Demerval Lobão", "Dirceu Arcoverde", "Dom Expedito Lopes", "Dom Inocêncio", "Domingos Mourão", "Elesbão Veloso", "Eliseu Martins", "Esperantina", "Fartura do Piauí", "Flores do Piauí", "Floresta do Piauí", "Floriano", "Francinópolis", "Francisco Ayres", "Francisco Macedo", "Francisco Santos", "Fronteiras", "Geminiano", "Gilbués", "Guadalupe", "Guaribas", "Hugo Napoleão", "Ilha Grande", "Inhuma", "Ipiranga do Piauí", "Isaías Coelho", "Itainópolis", "Itaueira", "Jacobina do Piauí", "Jaicós", "Jardim do Mulato", "Jatobá do Piauí", "Jerumenha", "João Costa", "Joaquim Pires", "Joca Marques", "José de Freitas", "Juazeiro do Piauí", "Júlio Borges", "Jurema", "Lagoa Alegre", "Lagoa de São Francisco", "Lagoa do Barro do Piauí", "Lagoa do Piauí", "Lagoa do Sítio", "Lagoinha do Piauí", "Landri Sales", "Luís Correia", "Luzilândia", "Madeiro", "Manoel Emídio", "Marcolândia", "Marcos Parente", "Massapê do Piauí", "Matias Olímpio", "Miguel Alves", "Miguel Leão", "Milton Brandão", "Monsenhor Gil", "Monsenhor Hipólito", "Monte Alegre do Piauí", "Morro Cabeça no Tempo", "Morro do Chapéu do Piauí", "Murici dos Portelas", "Nazaré do Piauí", "Nossa Senhora de Nazaré", "Nossa Senhora dos Remédios", "Nova Santa Rita", "Novo Oriente do Piauí", "Novo Santo Antônio", "Oeiras", "Olho d'Água do Piauí", "Padre Marcos", "Paes Landim", "Pajeú do Piauí", "Palmeira do Piauí", "Palmeirais", "Paquetá", "Parnaguá", "Parnaíba", "Passagem Franca do Piauí", "Patos do Piauí", "Pau d'Arco do Piauí", "Paulistana", "Pavussu", "Pedro II", "Pedro Laurentino", "Picos", "Pimenteiras", "Pio IX", "Piracuruca", "Piripiri", "Porto", "Porto Alegre do Piauí", "Prata do Piauí", "Queimada Nova", "Redenção do Gurguéia", "Regeneração", "Riacho Frio", "Ribeira do Piauí", "Ribeiro Gonçalves", "Rio Grande do Piauí", "Santa Cruz do Piauí", "Santa Cruz dos Milagres", "Santa Filomena", "Santa Luz", "Santa Rosa do Piauí", "Santana do Piauí", "Santo Antônio de Lisboa", "Santo Antônio dos Milagres", "Santo Inácio do Piauí", "São Braz do Piauí", "São Félix do Piauí", "São Francisco de Assis do Piauí", "São Francisco do Piauí", "São Gonçalo do Gurguéia", "São Gonçalo do Piauí", "São João da Canabrava", "São João da Fronteira", "São João da Serra", "São João da Varjota", "São João do Arraial", "São João do Piauí", "São José do Divino", "São José do Peixe", "São José do Piauí", "São Julião", "São Lourenço do Piauí", "São Luis do Piauí", "São Miguel da Baixa Grande", "São Miguel do Fidalgo", "São Miguel do Tapuio", "São Pedro do Piauí", "São Raimundo Nonato", "Sebastião Barros", "Sebastião Leal", "Sigefredo Pacheco", "Simões", "Simplício Mendes", "Socorro do Piauí", "Sussuapara", "Tamboril do Piauí", "Tanque do Piauí", "Teresina", "União", "Uruçuí", "Valença do Piauí", "Várzea Branca", "Várzea Grande", "Vera Mendes", "Vila Nova do Piauí", "Wall Ferraz"]
}, {
  uf: "PR",
  name: "Paraná",
  capital: "Curitiba",
  cities: ["Abatiá", "Adrianópolis", "Agudos do Sul", "Almirante Tamandaré", "Altamira do Paraná", "Alto Paraná", "Alto Piquiri", "Altônia", "Alvorada do Sul", "Amaporã", "Ampére", "Anahy", "Andirá", "Ângulo", "Antonina", "Antônio Olinto", "Apucarana", "Arapongas", "Arapoti", "Arapuã", "Araruna", "Araucária", "Ariranha do Ivaí", "Assaí", "Assis Chateaubriand", "Astorga", "Atalaia", "Balsa Nova", "Bandeirantes", "Barbosa Ferraz", "Barra do Jacaré", "Barracão", "Bela Vista da Caroba", "Bela Vista do Paraíso", "Bituruna", "Boa Esperança", "Boa Esperança do Iguaçu", "Boa Ventura de São Roque", "Boa Vista da Aparecida", "Bocaiúva do Sul", "Bom Jesus do Sul", "Bom Sucesso", "Bom Sucesso do Sul", "Borrazópolis", "Braganey", "Brasilândia do Sul", "Cafeara", "Cafelândia", "Cafezal do Sul", "Califórnia", "Cambará", "Cambé", "Cambira", "Campina da Lagoa", "Campina do Simão", "Campina Grande do Sul", "Campo Bonito", "Campo do Tenente", "Campo Largo", "Campo Magro", "Campo Mourão", "Cândido de Abreu", "Candói", "Cantagalo", "Capanema", "Capitão Leônidas Marques", "Carambeí", "Carlópolis", "Cascavel", "Castro", "Catanduvas", "Centenário do Sul", "Cerro Azul", "Céu Azul", "Chopinzinho", "Cianorte", "Cidade Gaúcha", "Clevelândia", "Colombo", "Colorado", "Congonhinhas", "Conselheiro Mairinck", "Contenda", "Corbélia", "Cornélio Procópio", "Coronel Domingos Soares", "Coronel Vivida", "Corumbataí do Sul", "Cruz Machado", "Cruzeiro do Iguaçu", "Cruzeiro do Oeste", "Cruzeiro do Sul", "Cruzmaltina", "Curitiba", "Curiúva", "Diamante d'Oeste", "Diamante do Norte", "Diamante do Sul", "Dois Vizinhos", "Douradina", "Doutor Camargo", "Doutor Ulysses", "Enéas Marques", "Engenheiro Beltrão", "Entre Rios do Oeste", "Esperança Nova", "Espigão Alto do Iguaçu", "Farol", "Faxinal", "Fazenda Rio Grande", "Fênix", "Fernandes Pinheiro", "Figueira", "Flor da Serra do Sul", "Floraí", "Floresta", "Florestópolis", "Flórida", "Formosa do Oeste", "Foz do Iguaçu", "Foz do Jordão", "Francisco Alves", "Francisco Beltrão", "General Carneiro", "Godoy Moreira", "Goioerê", "Goioxim", "Grandes Rios", "Guaíra", "Guairaçá", "Guamiranga", "Guapirama", "Guaporema", "Guaraci", "Guaraniaçu", "Guarapuava", "Guaraqueçaba", "Guaratuba", "Honório Serpa", "Ibaiti", "Ibema", "Ibiporã", "Icaraíma", "Iguaraçu", "Iguatu", "Imbaú", "Imbituva", "Inácio Martins", "Inajá", "Indianópolis", "Ipiranga", "Iporã", "Iracema do Oeste", "Irati", "Iretama", "Itaguajé", "Itaipulândia", "Itambaracá", "Itambé", "Itapejara d'Oeste", "Itaperuçu", "Itaúna do Sul", "Ivaí", "Ivaiporã", "Ivaté", "Ivatuba", "Jaboti", "Jacarezinho", "Jaguapitã", "Jaguariaíva", "Jandaia do Sul", "Janiópolis", "Japira", "Japurá", "Jardim Alegre", "Jardim Olinda", "Jataizinho", "Jesuítas", "Joaquim Távora", "Jundiaí do Sul", "Juranda", "Jussara", "Kaloré", "Lapa", "Laranjal", "Laranjeiras do Sul", "Leópolis", "Lidianópolis", "Lindoeste", "Loanda", "Lobato", "Londrina", "Luiziana", "Lunardelli", "Lupionópolis", "Mallet", "Mamborê", "Mandaguaçu", "Mandaguari", "Mandirituba", "Manfrinópolis", "Mangueirinha", "Manoel Ribas", "Marechal Cândido Rondon", "Maria Helena", "Marialva", "Marilândia do Sul", "Marilena", "Mariluz", "Maringá", "Mariópolis", "Maripá", "Marmeleiro", "Marquinho", "Marumbi", "Matelândia", "Matinhos", "Mato Rico", "Mauá da Serra", "Medianeira", "Mercedes", "Mirador", "Miraselva", "Missal", "Moreira Sales", "Morretes", "Munhoz de Melo", "Nossa Senhora das Graças", "Nova Aliança do Ivaí", "Nova América da Colina", "Nova Aurora", "Nova Cantu", "Nova Esperança", "Nova Esperança do Sudoeste", "Nova Fátima", "Nova Laranjeiras", "Nova Londrina", "Nova Olímpia", "Nova Prata do Iguaçu", "Nova Santa Bárbara", "Nova Santa Rosa", "Nova Tebas", "Novo Itacolomi", "Ortigueira", "Ourizona", "Ouro Verde do Oeste", "Paiçandu", "Palmas", "Palmeira", "Palmital", "Palotina", "Paraíso do Norte", "Paranacity", "Paranaguá", "Paranapoema", "Paranavaí", "Pato Bragado", "Pato Branco", "Paula Freitas", "Paulo Frontin", "Peabiru", "Perobal", "Pérola", "Pérola d'Oeste", "Piên", "Pinhais", "Pinhal de São Bento", "Pinhalão", "Pinhão", "Piraí do Sul", "Piraquara", "Pitanga", "Pitangueiras", "Planaltina do Paraná", "Planalto", "Ponta Grossa", "Pontal do Paraná", "Porecatu", "Porto Amazonas", "Porto Barreiro", "Porto Rico", "Porto Vitória", "Prado Ferreira", "Pranchita", "Presidente Castelo Branco", "Primeiro de Maio", "Prudentópolis", "Quarto Centenário", "Quatiguá", "Quatro Barras", "Quatro Pontes", "Quedas do Iguaçu", "Querência do Norte", "Quinta do Sol", "Quitandinha", "Ramilândia", "Rancho Alegre", "Rancho Alegre d'Oeste", "Realeza", "Rebouças", "Renascença", "Reserva", "Reserva do Iguaçu", "Ribeirão Claro", "Ribeirão do Pinhal", "Rio Azul", "Rio Bom", "Rio Bonito do Iguaçu", "Rio Branco do Ivaí", "Rio Branco do Sul", "Rio Negro", "Rolândia", "Roncador", "Rondon", "Rosário do Ivaí", "Sabáudia", "Salgado Filho", "Salto do Itararé", "Salto do Lontra", "Santa Amélia", "Santa Cecília do Pavão", "Santa Cruz Monte Castelo", "Santa Fé", "Santa Helena", "Santa Inês", "Santa Isabel do Ivaí", "Santa Izabel do Oeste", "Santa Lúcia", "Santa Maria do Oeste", "Santa Mariana", "Santa Mônica", "Santa Tereza do Oeste", "Santa Terezinha de Itaipu", "Santana do Itararé", "Santo Antônio da Platina", "Santo Antônio do Caiuá", "Santo Antônio do Paraíso", "Santo Antônio do Sudoeste", "Santo Inácio", "São Carlos do Ivaí", "São Jerônimo da Serra", "São João", "São João do Caiuá", "São João do Ivaí", "São João do Triunfo", "São Jorge d'Oeste", "São Jorge do Ivaí", "São Jorge do Patrocínio", "São José da Boa Vista", "São José das Palmeiras", "São José dos Pinhais", "São Manoel do Paraná", "São Mateus do Sul", "São Miguel do Iguaçu", "São Pedro do Iguaçu", "São Pedro do Ivaí", "São Pedro do Paraná", "São Sebastião da Amoreira", "São Tomé", "Sapopema", "Sarandi", "Saudade do Iguaçu", "Sengés", "Serranópolis do Iguaçu", "Sertaneja", "Sertanópolis", "Siqueira Campos", "Sulina", "Tamarana", "Tamboara", "Tapejara", "Tapira", "Teixeira Soares", "Telêmaco Borba", "Terra Boa", "Terra Rica", "Terra Roxa", "Tibagi", "Tijucas do Sul", "Toledo", "Tomazina", "Três Barras do Paraná", "Tunas do Paraná", "Tuneiras do Oeste", "Tupãssi", "Turvo", "Ubiratã", "Umuarama", "União da Vitória", "Uniflor", "Uraí", "Ventania", "Vera Cruz do Oeste", "Verê", "Vila Alta", "Virmond", "Vitorino", "Wenceslau Braz", "Xambrê"]
}, {
  uf: "RJ",
  name: "Rio de Janeiro",
  capital: "Rio de Janeiro",
  cities: ["Angra dos Reis", "Aperibé", "Araruama", "Areal", "Armação de Búzios", "Arraial do Cabo", "Barra do Piraí", "Barra Mansa", "Belford Roxo", "Bom Jardim", "Bom Jesus do Itabapoana", "Cabo Frio", "Cachoeiras de Macacu", "Cambuci", "Campos dos Goytacazes", "Cantagalo", "Carapebus", "Cardoso Moreira", "Carmo", "Casimiro de Abreu", "Comendador Levy Gasparian", "Conceição de Macabu", "Cordeiro", "Duas Barras", "Duque de Caxias", "Engenheiro Paulo de Frontin", "Guapimirim", "Iguaba Grande", "Itaboraí", "Itaguaí", "Italva", "Itaocara", "Itaperuna", "Itatiaia", "Japeri", "Laje do Muriaé", "Macaé", "Macuco", "Magé", "Mangaratiba", "Maricá", "Mendes", "Mesquita", "Miguel Pereira", "Miracema", "Natividade", "Nilópolis", "Niterói", "Nova Friburgo", "Nova Iguaçu", "Paracambi", "Paraíba do Sul", "Parati", "Paty do Alferes", "Petrópolis", "Pinheiral", "Piraí", "Porciúncula", "Porto Real", "Quatis", "Queimados", "Quissamã", "Resende", "Rio Bonito", "Rio Claro", "Rio das Flores", "Rio das Ostras", "Rio de Janeiro", "Santa Maria Madalena", "Santo Antônio de Pádua", "São Fidélis", "São Francisco de Itabapoana", "São Gonçalo", "São João da Barra", "São João de Meriti", "São José de Ubá", "São José do Vale do Rio Preto", "São Pedro da Aldeia", "São Sebastião do Alto", "Sapucaia", "Saquarema", "Seropédica", "Silva Jardim", "Sumidouro", "Tanguá", "Teresópolis", "Trajano de Morais", "Três Rios", "Valença", "Varre-Sai", "Vassouras", "Volta Redonda"]
}, {
  uf: "RN",
  name: "Rio Grande do Norte",
  capital: "Natal",
  cities: ["Acari", "Açu", "Afonso Bezerra", "Água Nova", "Alexandria", "Almino Afonso", "Alto do Rodrigues", "Angicos", "Antônio Martins", "Apodi", "Areia Branca", "Arês", "Augusto Severo", "Baía Formosa", "Baraúna", "Barcelona", "Bento Fernandes", "Bodó", "Bom Jesus", "Brejinho", "Caiçara do Norte", "Caiçara do Rio do Vento", "Caicó", "Campo Redondo", "Canguaretama", "Caraúbas", "Carnaúba dos Dantas", "Carnaubais", "Ceará-Mirim", "Cerro Corá", "Coronel Ezequiel", "Coronel João Pessoa", "Cruzeta", "Currais Novos", "Doutor Severiano", "Encanto", "Equador", "Espírito Santo", "Extremoz", "Felipe Guerra", "Fernando Pedroza", "Florânia", "Francisco Dantas", "Frutuoso Gomes", "Galinhos", "Goianinha", "Governador Dix-Sept Rosado", "Grossos", "Guamaré", "Ielmo Marinho", "Ipanguaçu", "Ipueira", "Itajá", "Itaú", "Jaçanã", "Jandaíra", "Janduís", "Januário Cicco", "Japi", "Jardim de Angicos", "Jardim de Piranhas", "Jardim do Seridó", "João Câmara", "João Dias", "José da Penha", "Jucurutu", "Jundiá", "Lagoa d'Anta", "Lagoa de Pedras", "Lagoa de Velhos", "Lagoa Nova", "Lagoa Salgada", "Lajes", "Lajes Pintadas", "Lucrécia", "Luís Gomes", "Macaíba", "Macau", "Major Sales", "Marcelino Vieira", "Martins", "Maxaranguape", "Messias Targino", "Montanhas", "Monte Alegre", "Monte das Gameleiras", "Mossoró", "Natal", "Nísia Floresta", "Nova Cruz", "Olho-d'Água do Borges", "Ouro Branco", "Paraná", "Paraú", "Parazinho", "Parelhas", "Parnamirim", "Passa e Fica", "Passagem", "Patu", "Pau dos Ferros", "Pedra Grande", "Pedra Preta", "Pedro Avelino", "Pedro Velho", "Pendências", "Pilões", "Poço Branco", "Portalegre", "Porto do Mangue", "Presidente Juscelino", "Pureza", "Rafael Fernandes", "Rafael Godeiro", "Riacho da Cruz", "Riacho de Santana", "Riachuelo", "Rio do Fogo", "Rodolfo Fernandes", "Ruy Barbosa", "Santa Cruz", "Santa Maria", "Santana do Matos", "Santana do Seridó", "Santo Antônio", "São Bento do Norte", "São Bento do Trairí", "São Fernando", "São Francisco do Oeste", "São Gonçalo do Amarante", "São João do Sabugi", "São José de Mipibu", "São José do Campestre", "São José do Seridó", "São Miguel", "São Miguel de Touros", "São Paulo do Potengi", "São Pedro", "São Rafael", "São Tomé", "São Vicente", "Senador Elói de Souza", "Senador Georgino Avelino", "Serra de São Bento", "Serra do Mel", "Serra Negra do Norte", "Serrinha", "Serrinha dos Pintos", "Severiano Melo", "Sítio Novo", "Taboleiro Grande", "Taipu", "Tangará", "Tenente Ananias", "Tenente Laurentino Cruz", "Tibau", "Tibau do Sul", "Timbaúba dos Batistas", "Touros", "Triunfo Potiguar", "Umarizal", "Upanema", "Várzea", "Venha-Ver", "Vera Cruz", "Viçosa", "Vila Flor"]
}, {
  uf: "RO",
  name: "Rondônia",
  capital: "Porto Velho",
  cities: ["Alta Floresta d'Oeste", "Alto Alegre do Parecis", "Alto Paraíso", "Alvorada d'Oeste", "Ariquemes", "Buritis", "Cabixi", "Cacaulândia", "Cacoal", "Campo Novo de Rondônia", "Candeias do Jamari", "Castanheiras", "Cerejeiras", "Chupinguaia", "Colorado do Oeste", "Corumbiara", "Costa Marques", "Cujubim", "Espigão d'Oeste", "Governador Jorge Teixeira", "Guajará-Mirim", "Itapuã do Oeste", "Jaru", "Ji-Paraná", "Machadinho d'Oeste", "Ministro Andreazza", "Mirante da Serra", "Monte Negro", "Nova Brasilândia d'Oeste", "Nova Mamoré", "Nova União", "Novo Horizonte do Oeste", "Ouro Preto do Oeste", "Parecis", "Pimenta Bueno", "Pimenteiras do Oeste", "Porto Velho", "Presidente Médici", "Primavera de Rondônia", "Rio Crespo", "Rolim de Moura", "Santa Luzia d'Oeste", "São Felipe d'Oeste", "São Francisco do Guaporé", "São Miguel do Guaporé", "Seringueiras", "Teixeirópolis", "Theobroma", "Urupá", "Vale do Anari", "Vale do Paraíso", "Vilhena"]
}, {
  uf: "RR",
  name: "Roraima",
  capital: "Boa Vista",
  cities: ["Alto Alegre", "Amajari", "Boa Vista", "Bonfim", "Cantá", "Caracaraí", "Caroebe", "Iracema", "Mucajaí", "Normandia", "Pacaraima", "Rorainópolis", "São João da Baliza", "São Luiz", "Uiramutã"]
}, {
  uf: "RS",
  name: "Rio Grande do Sul",
  capital: "Porto Alegre",
  cities: ["Aceguá", "Água Santa", "Agudo", "Ajuricaba", "Alecrim", "Alegrete", "Alegria", "Almirante Tamandaré do Sul", "Alpestre", "Alto Alegre", "Alto Feliz", "Alvorada", "Amaral Ferrador", "Ametista do Sul", "André da Rocha", "Anta Gorda", "Antônio Prado", "Arambaré", "Araricá", "Aratiba", "Arroio do Meio", "Arroio do Padre", "Arroio do Sal", "Arroio do Tigre", "Arroio dos Ratos", "Arroio Grande", "Arvorezinha", "Augusto Pestana", "Áurea", "Bagé", "Balneário Pinhal", "Barão", "Barão de Cotegipe", "Barão do Triunfo", "Barra do Guarita", "Barra do Quaraí", "Barra do Ribeiro", "Barra do Rio Azul", "Barra Funda", "Barracão", "Barros Cassal", "Benjamin Constan do Sul", "Bento Gonçalves", "Boa Vista das Missões", "Boa Vista do Buricá", "Boa Vista do Cadeado", "Boa Vista do Incra", "Boa Vista do Sul", "Bom Jesus", "Bom Princípio", "Bom Progresso", "Bom Retiro do Sul", "Boqueirão do Leão", "Bossoroca", "Bozano", "Braga", "Brochier", "Butiá", "Caçapava do Sul", "Cacequi", "Cachoeira do Sul", "Cachoeirinha", "Cacique Doble", "Caibaté", "Caiçara", "Camaquã", "Camargo", "Cambará do Sul", "Campestre da Serra", "Campina das Missões", "Campinas do Sul", "Campo Bom", "Campo Novo", "Campos Borges", "Candelária", "Cândido Godói", "Candiota", "Canela", "Canguçu", "Canoas", "Canudos do Vale", "Capão Bonito do Sul", "Capão da Canoa", "Capão do Cipó", "Capão do Leão", "Capela de Santana", "Capitão", "Capivari do Sul", "Caraá", "Carazinho", "Carlos Barbosa", "Carlos Gomes", "Casca", "Caseiros", "Catuípe", "Caxias do Sul", "Centenário", "Cerrito", "Cerro Branco", "Cerro Grande", "Cerro Grande do Sul", "Cerro Largo", "Chapada", "Charqueadas", "Charrua", "Chiapeta", "Chuí", "Chuvisca", "Cidreira", "Ciríaco", "Colinas", "Colorado", "Condor", "Constantina", "Coqueiro Baixo", "Coqueiros do Sul", "Coronel Barros", "Coronel Bicaco", "Coronel Pilar", "Cotiporã", "Coxilha", "Crissiumal", "Cristal", "Cristal do Sul", "Cruz Alta", "Cruzaltense", "Cruzeiro do Sul", "David Canabarro", "Derrubadas", "Dezesseis de Novembro", "Dilermando de Aguiar", "Dois Irmãos", "Dois Irmãos das Missões", "Dois Lajeados", "Dom Feliciano", "Dom Pedrito", "Dom Pedro de Alcântara", "Dona Francisca", "Doutor Maurício Cardoso", "Doutor Ricardo", "Eldorado do Sul", "Encantado", "Encruzilhada do Sul", "Engenho Velho", "Entre Rios do Sul", "Entre-Ijuís", "Erebango", "Erechim", "Ernestina", "Erval Grande", "Erval Seco", "Esmeralda", "Esperança do Sul", "Espumoso", "Estação", "Estância Velha", "Esteio", "Estrela", "Estrela Velha", "Eugênio de Castro", "Fagundes Varela", "Farroupilha", "Faxinal do Soturno", "Faxinalzinho", "Fazenda Vilanova", "Feliz", "Flores da Cunha", "Floriano Peixoto", "Fontoura Xavier", "Formigueiro", "Forquetinha", "Fortaleza dos Valos", "Frederico Westphalen", "Garibaldi", "Garruchos", "Gaurama", "General Câmara", "Gentil", "Getúlio Vargas", "Giruá", "Glorinha", "Gramado", "Gramado dos Loureiros", "Gramado Xavier", "Gravataí", "Guabiju", "Guaíba", "Guaporé", "Guarani das Missões", "Harmonia", "Herval", "Herveiras", "Horizontina", "Hulha Negra", "Humaitá", "Ibarama", "Ibiaçá", "Ibiraiaras", "Ibirapuitã", "Ibirubá", "Igrejinha", "Ijuí", "Ilópolis", "Imbé", "Imigrante", "Independência", "Inhacorá", "Ipê", "Ipiranga do Sul", "Iraí", "Itaara", "Itacurubi", "Itapuca", "Itaqui", "Itati", "Itatiba do Sul", "Ivorá", "Ivoti", "Jaboticaba", "Jacuizinho", "Jacutinga", "Jaguarão", "Jaguari", "Jaquirana", "Jari", "Jóia", "Júlio de Castilhos", "Lagoa Bonita do Sul", "Lagoa dos Três Cantos", "Lagoa Vermelha", "Lagoão", "Lajeado", "Lajeado do Bugre", "Lavras do Sul", "Liberato Salzano", "Lindolfo Collor", "Linha Nova", "Maçambara", "Machadinho", "Mampituba", "Manoel Viana", "Maquiné", "Maratá", "Marau", "Marcelino Ramos", "Mariana Pimentel", "Mariano Moro", "Marques de Souza", "Mata", "Mato Castelhano", "Mato Leitão", "Mato Queimado", "Maximiliano de Almeida", "Minas do Leão", "Miraguaí", "Montauri", "Monte Alegre dos Campos", "Monte Belo do Sul", "Montenegro", "Mormaço", "Morrinhos do Sul", "Morro Redondo", "Morro Reuter", "Mostardas", "Muçum", "Muitos Capões", "Muliterno", "Não-Me-Toque", "Nicolau Vergueiro", "Nonoai", "Nova Alvorada", "Nova Araçá", "Nova Bassano", "Nova Boa Vista", "Nova Bréscia", "Nova Candelária", "Nova Esperança do Sul", "Nova Hartz", "Nova Pádua", "Nova Palma", "Nova Petrópolis", "Nova Prata", "Nova Ramada", "Nova Roma do Sul", "Nova Santa Rita", "Novo Barreiro", "Novo Cabrais", "Novo Hamburgo", "Novo Machado", "Novo Tiradentes", "Novo Xingu", "Osório", "Paim Filho", "Palmares do Sul", "Palmeira das Missões", "Palmitinho", "Panambi", "Pântano Grande", "Paraí", "Paraíso do Sul", "Pareci Novo", "Parobé", "Passa Sete", "Passo do Sobrado", "Passo Fundo", "Paulo Bento", "Paverama", "Pedras Altas", "Pedro Osório", "Pejuçara", "Pelotas", "Picada Café", "Pinhal", "Pinhal da Serra", "Pinhal Grande", "Pinheirinho do Vale", "Pinheiro Machado", "Pirapó", "Piratini", "Planalto", "Poço das Antas", "Pontão", "Ponte Preta", "Portão", "Porto Alegre", "Porto Lucena", "Porto Mauá", "Porto Vera Cruz", "Porto Xavier", "Pouso Novo", "Presidente Lucena", "Progresso", "Protásio Alves", "Putinga", "Quaraí", "Quatro Irmãos", "Quevedos", "Quinze de Novembro", "Redentora", "Relvado", "Restinga Seca", "Rio dos Índios", "Rio Grande", "Rio Pardo", "Riozinho", "Roca Sales", "Rodeio Bonito", "Rolador", "Rolante", "Ronda Alta", "Rondinha", "Roque Gonzales", "Rosário do Sul", "Sagrada Família", "Saldanha Marinho", "Salto do Jacuí", "Salvador das Missões", "Salvador do Sul", "Sananduva", "Santa Bárbara do Sul", "Santa Cecília do Sul", "Santa Clara do Sul", "Santa Cruz do Sul", "Santa Margarida do Sul", "Santa Maria", "Santa Maria do Herval", "Santa Rosa", "Santa Tereza", "Santa Vitória do Palmar", "Santana da Boa Vista", "Santana do Livramento", "Santiago", "Santo Ângelo", "Santo Antônio da Patrulha", "Santo Antônio das Missões", "Santo Antônio do Palma", "Santo Antônio do Planalto", "Santo Augusto", "Santo Cristo", "Santo Expedito do Sul", "São Borja", "São Domingos do Sul", "São Francisco de Assis", "São Francisco de Paula", "São Gabriel", "São Jerônimo", "São João da Urtiga", "São João do Polêsine", "São Jorge", "São José das Missões", "São José do Herval", "São José do Hortêncio", "São José do Inhacorá", "São José do Norte", "São José do Ouro", "São José do Sul", "São José dos Ausentes", "São Leopoldo", "São Lourenço do Sul", "São Luiz Gonzaga", "São Marcos", "São Martinho", "São Martinho da Serra", "São Miguel das Missões", "São Nicolau", "São Paulo das Missões", "São Pedro da Serra", "São Pedro das Missões", "São Pedro do Butiá", "São Pedro do Sul", "São Sebastião do Caí", "São Sepé", "São Valentim", "São Valentim do Sul", "São Valério do Sul", "São Vendelino", "São Vicente do Sul", "Sapiranga", "Sapucaia do Sul", "Sarandi", "Seberi", "Sede Nova", "Segredo", "Selbach", "Senador Salgado Filho", "Sentinela do Sul", "Serafina Corrêa", "Sério", "Sertão", "Sertão Santana", "Sete de Setembro", "Severiano de Almeida", "Silveira Martins", "Sinimbu", "Sobradinho", "Soledade", "Tabaí", "Tapejara", "Tapera", "Tapes", "Taquara", "Taquari", "Taquaruçu do Sul", "Tavares", "Tenente Portela", "Terra de Areia", "Teutônia", "Tio Hugo", "Tiradentes do Sul", "Toropi", "Torres", "Tramandaí", "Travesseiro", "Três Arroios", "Três Cachoeiras", "Três Coroas", "Três de Maio", "Três Forquilhas", "Três Palmeiras", "Três Passos", "Trindade do Sul", "Triunfo", "Tucunduva", "Tunas", "Tupanci do Sul", "Tupanciretã", "Tupandi", "Tuparendi", "Turuçu", "Ubiretama", "União da Serra", "Unistalda", "Uruguaiana", "Vacaria", "Vale do Sol", "Vale Real", "Vale Verde", "Vanini", "Venâncio Aires", "Vera Cruz", "Veranópolis", "Vespasiano Correa", "Viadutos", "Viamão", "Vicente Dutra", "Victor Graeff", "Vila Flores", "Vila Lângaro", "Vila Maria", "Vila Nova do Sul", "Vista Alegre", "Vista Alegre do Prata", "Vista Gaúcha", "Vitória das Missões", "Westfália", "Xangri-lá"]
}, {
  uf: "SC",
  name: "Santa Catarina",
  capital: "Florianópolis",
  cities: ["Abdon Batista", "Abelardo Luz", "Agrolândia", "Agronômica", "Água Doce", "Águas de Chapecó", "Águas Frias", "Águas Mornas", "Alfredo Wagner", "Alto Bela Vista", "Anchieta", "Angelina", "Anita Garibaldi", "Anitápolis", "Antônio Carlos", "Apiúna", "Arabutã", "Araquari", "Araranguá", "Armazém", "Arroio Trinta", "Arvoredo", "Ascurra", "Atalanta", "Aurora", "Balneário Arroio do Silva", "Balneário Barra do Sul", "Balneário Camboriú", "Balneário Gaivota", "Bandeirante", "Barra Bonita", "Barra Velha", "Bela Vista do Toldo", "Belmonte", "Benedito Novo", "Biguaçu", "Blumenau", "Bocaina do Sul", "Bom Jardim da Serra", "Bom Jesus", "Bom Jesus do Oeste", "Bom Retiro", "Bombinhas", "Botuverá", "Braço do Norte", "Braço do Trombudo", "Brunópolis", "Brusque", "Caçador", "Caibi", "Calmon", "Camboriú", "Campo Alegre", "Campo Belo do Sul", "Campo Erê", "Campos Novos", "Canelinha", "Canoinhas", "Capão Alto", "Capinzal", "Capivari de Baixo", "Catanduvas", "Caxambu do Sul", "Celso Ramos", "Cerro Negro", "Chapadão do Lageado", "Chapecó", "Cocal do Sul", "Concórdia", "Cordilheira Alta", "Coronel Freitas", "Coronel Martins", "Correia Pinto", "Corupá", "Criciúma", "Cunha Porã", "Cunhataí", "Curitibanos", "Descanso", "Dionísio Cerqueira", "Dona Emma", "Doutor Pedrinho", "Entre Rios", "Ermo", "Erval Velho", "Faxinal dos Guedes", "Flor do Sertão", "Florianópolis", "Formosa do Sul", "Forquilhinha", "Fraiburgo", "Frei Rogério", "Galvão", "Garopaba", "Garuva", "Gaspar", "Governador Celso Ramos", "Grão Pará", "Gravatal", "Guabiruba", "Guaraciaba", "Guaramirim", "Guarujá do Sul", "Guatambú", "Herval d'Oeste", "Ibiam", "Ibicaré", "Ibirama", "Içara", "Ilhota", "Imaruí", "Imbituba", "Imbuia", "Indaial", "Iomerê", "Ipira", "Iporã do Oeste", "Ipuaçu", "Ipumirim", "Iraceminha", "Irani", "Irati", "Irineópolis", "Itá", "Itaiópolis", "Itajaí", "Itapema", "Itapiranga", "Itapoá", "Ituporanga", "Jaborá", "Jacinto Machado", "Jaguaruna", "Jaraguá do Sul", "Jardinópolis", "Joaçaba", "Joinville", "José Boiteux", "Jupiá", "Lacerdópolis", "Lages", "Laguna", "Lajeado Grande", "Laurentino", "Lauro Muller", "Lebon Régis", "Leoberto Leal", "Lindóia do Sul", "Lontras", "Luiz Alves", "Luzerna", "Macieira", "Mafra", "Major Gercino", "Major Vieira", "Maracajá", "Maravilha", "Marema", "Massaranduba", "Matos Costa", "Meleiro", "Mirim Doce", "Modelo", "Mondaí", "Monte Carlo", "Monte Castelo", "Morro da Fumaça", "Morro Grande", "Navegantes", "Nova Erechim", "Nova Itaberaba", "Nova Trento", "Nova Veneza", "Novo Horizonte", "Orleans", "Otacílio Costa", "Ouro", "Ouro Verde", "Paial", "Painel", "Palhoça", "Palma Sola", "Palmeira", "Palmitos", "Papanduva", "Paraíso", "Passo de Torres", "Passos Maia", "Paulo Lopes", "Pedras Grandes", "Penha", "Peritiba", "Petrolândia", "Piçarras", "Pinhalzinho", "Pinheiro Preto", "Piratuba", "Planalto Alegre", "Pomerode", "Ponte Alta", "Ponte Alta do Norte", "Ponte Serrada", "Porto Belo", "Porto União", "Pouso Redondo", "Praia Grande", "Presidente Castelo Branco", "Presidente Getúlio", "Presidente Nereu", "Princesa", "Quilombo", "Rancho Queimado", "Rio das Antas", "Rio do Campo", "Rio do Oeste", "Rio do Sul", "Rio dos Cedros", "Rio Fortuna", "Rio Negrinho", "Rio Rufino", "Riqueza", "Rodeio", "Romelândia", "Salete", "Saltinho", "Salto Veloso", "Sangão", "Santa Cecília", "Santa Helena", "Santa Rosa de Lima", "Santa Rosa do Sul", "Santa Terezinha", "Santa Terezinha do Progresso", "Santiago do Sul", "Santo Amaro da Imperatriz", "São Bento do Sul", "São Bernardino", "São Bonifácio", "São Carlos", "São Cristovão do Sul", "São Domingos", "São Francisco do Sul", "São João Batista", "São João do Itaperiú", "São João do Oeste", "São João do Sul", "São Joaquim", "São José", "São José do Cedro", "São José do Cerrito", "São Lourenço do Oeste", "São Ludgero", "São Martinho", "São Miguel da Boa Vista", "São Miguel do Oeste", "São Pedro de Alcântara", "Saudades", "Schroeder", "Seara", "Serra Alta", "Siderópolis", "Sombrio", "Sul Brasil", "Taió", "Tangará", "Tigrinhos", "Tijucas", "Timbé do Sul", "Timbó", "Timbó Grande", "Três Barras", "Treviso", "Treze de Maio", "Treze Tílias", "Trombudo Central", "Tubarão", "Tunápolis", "Turvo", "União do Oeste", "Urubici", "Urupema", "Urussanga", "Vargeão", "Vargem", "Vargem Bonita", "Vidal Ramos", "Videira", "Vitor Meireles", "Witmarsum", "Xanxerê", "Xavantina", "Xaxim", "Zortéa"]
}, {
  uf: "SE",
  name: "Sergipe",
  capital: "Aracaju",
  cities: ["Amparo de São Francisco", "Aquidabã", "Aracaju", "Arauá", "Areia Branca", "Barra dos Coqueiros", "Boquim", "Brejo Grande", "Campo do Brito", "Canhoba", "Canindé de São Francisco", "Capela", "Carira", "Carmópolis", "Cedro de São João", "Cristinápolis", "Cumbe", "Divina Pastora", "Estância", "Feira Nova", "Frei Paulo", "Gararu", "General Maynard", "Gracho Cardoso", "Ilha das Flores", "Indiaroba", "Itabaiana", "Itabaianinha", "Itabi", "Itaporanga d'Ajuda", "Japaratuba", "Japoatã", "Lagarto", "Laranjeiras", "Macambira", "Malhada dos Bois", "Malhador", "Maruim", "Moita Bonita", "Monte Alegre de Sergipe", "Muribeca", "Neópolis", "Nossa Senhora Aparecida", "Nossa Senhora da Glória", "Nossa Senhora das Dores", "Nossa Senhora de Lourdes", "Nossa Senhora do Socorro", "Pacatuba", "Pedra Mole", "Pedrinhas", "Pinhão", "Pirambu", "Poço Redondo", "Poço Verde", "Porto da Folha", "Propriá", "Riachão do Dantas", "Riachuelo", "Ribeirópolis", "Rosário do Catete", "Salgado", "Santa Luzia do Itanhy", "Santa Rosa de Lima", "Santana do São Francisco", "Santo Amaro das Brotas", "São Cristóvão", "São Domingos", "São Francisco", "São Miguel do Aleixo", "Simão Dias", "Siriri", "Telha", "Tobias Barreto", "Tomar do Geru", "Umbaúba"]
}, {
  uf: "SP",
  name: "São Paulo",
  capital: "São Paulo",
  cities: ["Adamantina", "Adolfo", "Aguaí", "Águas da Prata", "Águas de Lindóia", "Águas de Santa Bárbara", "Águas de São Pedro", "Agudos", "Alambari", "Alfredo Marcondes", "Altair", "Altinópolis", "Alto Alegre", "Alumínio", "Álvares Florence", "Álvares Machado", "Álvaro de Carvalho", "Alvinlândia", "Americana", "Américo Brasiliense", "Américo de Campos", "Amparo", "Analândia", "Andradina", "Angatuba", "Anhembi", "Anhumas", "Aparecida", "Aparecida d'Oeste", "Apiaí", "Araçariguama", "Araçatuba", "Araçoiaba da Serra", "Aramina", "Arandu", "Arapeí", "Araraquara", "Araras", "Arco-Íris", "Arealva", "Areias", "Areiópolis", "Ariranha", "Artur Nogueira", "Arujá", "Aspásia", "Assis", "Atibaia", "Auriflama", "Avaí", "Avanhandava", "Avaré", "Bady Bassitt", "Balbinos", "Bálsamo", "Bananal", "Barão de Antonina", "Barbosa", "Bariri", "Barra Bonita", "Barra do Chapéu", "Barra do Turvo", "Barretos", "Barrinha", "Barueri", "Bastos", "Batatais", "Bauru", "Bebedouro", "Bento de Abreu", "Bernardino de Campos", "Bertioga", "Bilac", "Birigui", "Biritiba-Mirim", "Boa Esperança do Sul", "Bocaina", "Bofete", "Boituva", "Bom Jesus dos Perdões", "Bom Sucesso de Itararé", "Borá", "Boracéia", "Borborema", "Borebi", "Botucatu", "Bragança Paulista", "Braúna", "Brejo Alegre", "Brodowski", "Brotas", "Buri", "Buritama", "Buritizal", "Cabrália Paulista", "Cabreúva", "Caçapava", "Cachoeira Paulista", "Caconde", "Cafelândia", "Caiabu", "Caieiras", "Caiuá", "Cajamar", "Cajati", "Cajobi", "Cajuru", "Campina do Monte Alegre", "Campinas", "Campo Limpo Paulista", "Campos do Jordão", "Campos Novos Paulista", "Cananéia", "Canas", "Cândido Mota", "Cândido Rodrigues", "Canitar", "Capão Bonito", "Capela do Alto", "Capivari", "Caraguatatuba", "Carapicuíba", "Cardoso", "Casa Branca", "Cássia dos Coqueiros", "Castilho", "Catanduva", "Catiguá", "Cedral", "Cerqueira César", "Cerquilho", "Cesário Lange", "Charqueada", "Chavantes", "Clementina", "Colina", "Colômbia", "Conchal", "Conchas", "Cordeirópolis", "Coroados", "Coronel Macedo", "Corumbataí", "Cosmópolis", "Cosmorama", "Cotia", "Cravinhos", "Cristais Paulista", "Cruzália", "Cruzeiro", "Cubatão", "Cunha", "Descalvado", "Diadema", "Dirce Reis", "Divinolândia", "Dobrada", "Dois Córregos", "Dolcinópolis", "Dourado", "Dracena", "Duartina", "Dumont", "Echaporã", "Eldorado", "Elias Fausto", "Elisiário", "Embaúba", "Embu", "Embu-Guaçu", "Emilianópolis", "Engenheiro Coelho", "Espírito Santo do Pinhal", "Espírito Santo do Turvo", "Estiva Gerbi", "Estrela d'Oeste", "Estrela do Norte", "Euclides da Cunha Paulista", "Fartura", "Fernando Prestes", "Fernandópolis", "Fernão", "Ferraz de Vasconcelos", "Flora Rica", "Floreal", "Florínia", "Flórida Paulista", "Franca", "Francisco Morato", "Franco da Rocha", "Gabriel Monteiro", "Gália", "Garça", "Gastão Vidigal", "Gavião Peixoto", "General Salgado", "Getulina", "Glicério", "Guaiçara", "Guaimbê", "Guaíra", "Guapiaçu", "Guapiara", "Guará", "Guaraçaí", "Guaraci", "Guarani d'Oeste", "Guarantã", "Guararapes", "Guararema", "Guaratinguetá", "Guareí", "Guariba", "Guarujá", "Guarulhos", "Guatapará", "Guzolândia", "Herculândia", "Holambra", "Hortolândia", "Iacanga", "Iacri", "Iaras", "Ibaté", "Ibirá", "Ibirarema", "Ibitinga", "Ibiúna", "Icém", "Iepê", "Igaraçu do Tietê", "Igarapava", "Igaratá", "Iguape", "Ilha Comprida", "Ilha Solteira", "Ilhabela", "Indaiatuba", "Indiana", "Indiaporã", "Inúbia Paulista", "Ipauçu", "Iperó", "Ipeúna", "Ipiguá", "Iporanga", "Ipuã", "Iracemápolis", "Irapuã", "Irapuru", "Itaberá", "Itaí", "Itajobi", "Itaju", "Itanhaém", "Itaóca", "Itapecerica da Serra", "Itapetininga", "Itapeva", "Itapevi", "Itapira", "Itapirapuã Paulista", "Itápolis", "Itaporanga", "Itapuí", "Itapura", "Itaquaquecetuba", "Itararé", "Itariri", "Itatiba", "Itatinga", "Itirapina", "Itirapuã", "Itobi", "Itu", "Itupeva", "Ituverava", "Jaborandi", "Jaboticabal", "Jacareí", "Jaci", "Jacupiranga", "Jaguariúna", "Jales", "Jambeiro", "Jandira", "Jardinópolis", "Jarinu", "Jaú", "Jeriquara", "Joanópolis", "João Ramalho", "José Bonifácio", "Júlio Mesquita", "Jumirim", "Jundiaí", "Junqueirópolis", "Juquiá", "Juquitiba", "Lagoinha", "Laranjal Paulista", "Lavínia", "Lavrinhas", "Leme", "Lençóis Paulista", "Limeira", "Lindóia", "Lins", "Lorena", "Lourdes", "Louveira", "Lucélia", "Lucianópolis", "Luís Antônio", "Luiziânia", "Lupércio", "Lutécia", "Macatuba", "Macaubal", "Macedônia", "Magda", "Mairinque", "Mairiporã", "Manduri", "Marabá Paulista", "Maracaí", "Marapoama", "Mariápolis", "Marília", "Marinópolis", "Martinópolis", "Matão", "Mauá", "Mendonça", "Meridiano", "Mesópolis", "Miguelópolis", "Mineiros do Tietê", "Mira Estrela", "Miracatu", "Mirandópolis", "Mirante do Paranapanema", "Mirassol", "Mirassolândia", "Mococa", "Mogi das Cruzes", "Mogi-Guaçu", "Mogi-Mirim", "Mombuca", "Monções", "Mongaguá", "Monte Alegre do Sul", "Monte Alto", "Monte Aprazível", "Monte Azul Paulista", "Monte Castelo", "Monte Mor", "Monteiro Lobato", "Morro Agudo", "Morungaba", "Motuca", "Murutinga do Sul", "Nantes", "Narandiba", "Natividade da Serra", "Nazaré Paulista", "Neves Paulista", "Nhandeara", "Nipoã", "Nova Aliança", "Nova Campina", "Nova Canaã Paulista", "Nova Castilho", "Nova Europa", "Nova Granada", "Nova Guataporanga", "Nova Independência", "Nova Luzitânia", "Nova Odessa", "Novais", "Novo Horizonte", "Nuporanga", "Ocauçu", "Óleo", "Olímpia", "Onda Verde", "Oriente", "Orindiúva", "Orlândia", "Osasco", "Oscar Bressane", "Osvaldo Cruz", "Ourinhos", "Ouro Verde", "Ouroeste", "Pacaembu", "Palestina", "Palmares Paulista", "Palmeira d'Oeste", "Palmital", "Panorama", "Paraguaçu Paulista", "Paraibuna", "Paraíso", "Paranapanema", "Paranapuã", "Parapuã", "Pardinho", "Pariquera-Açu", "Parisi", "Patrocínio Paulista", "Paulicéia", "Paulínia", "Paulistânia", "Paulo de Faria", "Pederneiras", "Pedra Bela", "Pedranópolis", "Pedregulho", "Pedreira", "Pedrinhas Paulista", "Pedro de Toledo", "Penápolis", "Pereira Barreto", "Pereiras", "Peruíbe", "Piacatu", "Piedade", "Pilar do Sul", "Pindamonhangaba", "Pindorama", "Pinhalzinho", "Piquerobi", "Piquete", "Piracaia", "Piracicaba", "Piraju", "Pirajuí", "Pirangi", "Pirapora do Bom Jesus", "Pirapozinho", "Pirassununga", "Piratininga", "Pitangueiras", "Planalto", "Platina", "Poá", "Poloni", "Pompéia", "Pongaí", "Pontal", "Pontalinda", "Pontes Gestal", "Populina", "Porangaba", "Porto Feliz", "Porto Ferreira", "Potim", "Potirendaba", "Pracinha", "Pradópolis", "Praia Grande", "Pratânia", "Presidente Alves", "Presidente Bernardes", "Presidente Epitácio", "Presidente Prudente", "Presidente Venceslau", "Promissão", "Quadra", "Quatá", "Queiroz", "Queluz", "Quintana", "Rafard", "Rancharia", "Redenção da Serra", "Regente Feijó", "Reginópolis", "Registro", "Restinga", "Ribeira", "Ribeirão Bonito", "Ribeirão Branco", "Ribeirão Corrente", "Ribeirão do Sul", "Ribeirão dos Índios", "Ribeirão Grande", "Ribeirão Pires", "Ribeirão Preto", "Rifaina", "Rincão", "Rinópolis", "Rio Claro", "Rio das Pedras", "Rio Grande da Serra", "Riolândia", "Riversul", "Rosana", "Roseira", "Rubiácea", "Rubinéia", "Sabino", "Sagres", "Sales", "Sales Oliveira", "Salesópolis", "Salmourão", "Saltinho", "Salto", "Salto de Pirapora", "Salto Grande", "Sandovalina", "Santa Adélia", "Santa Albertina", "Santa Bárbara d'Oeste", "Santa Branca", "Santa Clara d'Oeste", "Santa Cruz da Conceição", "Santa Cruz da Esperança", "Santa Cruz das Palmeiras", "Santa Cruz do Rio Pardo", "Santa Ernestina", "Santa Fé do Sul", "Santa Gertrudes", "Santa Isabel", "Santa Lúcia", "Santa Maria da Serra", "Santa Mercedes", "Santa Rita d'Oeste", "Santa Rita do Passa Quatro", "Santa Rosa de Viterbo", "Santa Salete", "Santana da Ponte Pensa", "Santana de Parnaíba", "Santo Anastácio", "Santo André", "Santo Antônio da Alegria", "Santo Antônio de Posse", "Santo Antônio do Aracanguá", "Santo Antônio do Jardim", "Santo Antônio do Pinhal", "Santo Expedito", "Santópolis do Aguapeí", "Santos", "São Bento do Sapucaí", "São Bernardo do Campo", "São Caetano do Sul", "São Carlos", "São Francisco", "São João da Boa Vista", "São João das Duas Pontes", "São João de Iracema", "São João do Pau d'Alho", "São Joaquim da Barra", "São José da Bela Vista", "São José do Barreiro", "São José do Rio Pardo", "São José do Rio Preto", "São José dos Campos", "São Lourenço da Serra", "São Luís do Paraitinga", "São Manuel", "São Miguel Arcanjo", "São Paulo", "São Pedro", "São Pedro do Turvo", "São Roque", "São Sebastião", "São Sebastião da Grama", "São Simão", "São Vicente", "Sarapuí", "Sarutaiá", "Sebastianópolis do Sul", "Serra Azul", "Serra Negra", "Serrana", "Sertãozinho", "Sete Barras", "Severínia", "Silveiras", "Socorro", "Sorocaba", "Sud Mennucci", "Sumaré", "Suzanápolis", "Suzano", "Tabapuã", "Tabatinga", "Taboão da Serra", "Taciba", "Taguaí", "Taiaçu", "Taiúva", "Tambaú", "Tanabi", "Tapiraí", "Tapiratiba", "Taquaral", "Taquaritinga", "Taquarituba", "Taquarivaí", "Tarabai", "Tarumã", "Tatuí", "Taubaté", "Tejupá", "Teodoro Sampaio", "Terra Roxa", "Tietê", "Timburi", "Torre de Pedra", "Torrinha", "Trabiju", "Tremembé", "Três Fronteiras", "Tuiuti", "Tupã", "Tupi Paulista", "Turiúba", "Turmalina", "Ubarana", "Ubatuba", "Ubirajara", "Uchoa", "União Paulista", "Urânia", "Uru", "Urupês", "Valentim Gentil", "Valinhos", "Valparaíso", "Vargem", "Vargem Grande do Sul", "Vargem Grande Paulista", "Várzea Paulista", "Vera Cruz", "Vinhedo", "Viradouro", "Vista Alegre do Alto", "Vitória Brasil", "Votorantim", "Votuporanga", "Zacarias"]
}, {
  uf: "TO",
  name: "Tocantins",
  capital: "Palmas",
  cities: ["Abreulândia", "Aguiarnópolis", "Aliança do Tocantins", "Almas", "Alvorada", "Ananás", "Angico", "Aparecida do Rio Negro", "Aragominas", "Araguacema", "Araguaçu", "Araguaína", "Araguanã", "Araguatins", "Arapoema", "Arraias", "Augustinópolis", "Aurora do Tocantins", "Axixá do Tocantins", "Babaçulândia", "Bandeirantes do Tocantins", "Barra do Ouro", "Barrolândia", "Bernardo Sayão", "Bom Jesus do Tocantins", "Brasilândia do Tocantins", "Brejinho de Nazaré", "Buriti do Tocantins", "Cachoeirinha", "Campos Lindos", "Cariri do Tocantins", "Carmolândia", "Carrasco Bonito", "Caseara", "Centenário", "Chapada da Natividade", "Chapada de Areia", "Colinas do Tocantins", "Colméia", "Combinado", "Conceição do Tocantins", "Couto de Magalhães", "Cristalândia", "Crixás do Tocantins", "Darcinópolis", "Dianópolis", "Divinópolis do Tocantins", "Dois Irmãos do Tocantins", "Dueré", "Esperantina", "Fátima", "Figueirópolis", "Filadélfia", "Formoso do Araguaia", "Fortaleza do Tabocão", "Goianorte", "Goiatins", "Guaraí", "Gurupi", "Ipueiras", "Itacajá", "Itaguatins", "Itapiratins", "Itaporã do Tocantins", "Jaú do Tocantins", "Juarina", "Lagoa da Confusão", "Lagoa do Tocantins", "Lajeado", "Lavandeira", "Lizarda", "Luzinópolis", "Marianópolis do Tocantins", "Mateiros", "Maurilândia do Tocantins", "Miracema do Tocantins", "Miranorte", "Monte do Carmo", "Monte Santo do Tocantins", "Muricilândia", "Natividade", "Nazaré", "Nova Olinda", "Nova Rosalândia", "Novo Acordo", "Novo Alegre", "Novo Jardim", "Oliveira de Fátima", "Palmas", "Palmeirante", "Palmeiras do Tocantins", "Palmeirópolis", "Paraíso do Tocantins", "Paranã", "Pau d'Arco", "Pedro Afonso", "Peixe", "Pequizeiro", "Pindorama do Tocantins", "Piraquê", "Pium", "Ponte Alta do Bom Jesus", "Ponte Alta do Tocantins", "Porto Alegre do Tocantins", "Porto Nacional", "Praia Norte", "Presidente Kennedy", "Pugmil", "Recursolândia", "Riachinho", "Rio da Conceição", "Rio dos Bois", "Rio Sono", "Sampaio", "Sandolândia", "Santa Fé do Araguaia", "Santa Maria do Tocantins", "Santa Rita do Tocantins", "Santa Rosa do Tocantins", "Santa Tereza do Tocantins", "Santa Terezinha Tocantins", "São Bento do Tocantins", "São Félix do Tocantins", "São Miguel do Tocantins", "São Salvador do Tocantins", "São Sebastião do Tocantins", "São Valério da Natividade", "Silvanópolis", "Sítio Novo do Tocantins", "Sucupira", "Taguatinga", "Taipas do Tocantins", "Talismã", "Tocantínia", "Tocantinópolis", "Tupirama", "Tupiratins", "Wanderlândia", "Xambioá"]
}];

/* harmony default export */ __webpack_exports__["a"] = (states);

/***/ }),
/* 226 */,
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__budget_FormCity__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_CollectiveConventionService__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__service_CityService__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__service_OfficceService_js__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__service_UtilService_js__ = __webpack_require__(204);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        finalizedContract: Boolean,
        contractHaveBudgetImported: Boolean,
        contractDontHaveBudgetButIsFinished: Boolean,
        isPageRequest: {
            type: Boolean,
            default: false
        }
    },
    components: {
        FormCity: __WEBPACK_IMPORTED_MODULE_2__budget_FormCity__["a" /* default */]
    },
    computed: {
        disableTagsInThePage: function disableTagsInThePage() {
            if (this.contractHaveBudgetImported || this.contractDontHaveBudgetButIsFinished) {
                return true;
            } else return false;
        }
    },
    data: function data() {
        return {
            agreementsYear: [],
            agreementYearSelected: '',
            agreementYearSelectedItems: [],
            cities: [],
            department: {
                address: {
                    cityOfService: {}
                }
            },

            isSearchingAddress: false,
            offices: [],
            sectorType: '',
            sectorTypes: ['Setor Sede', 'Outro Setor'],
            situationEditDisabled: true,
            unitsOfMeasurement: ['Posto de Serviço', 'M²'],
            showDialogAddNewCity: false
        };
    },

    methods: {
        init: function init() {
            this.changeOfficces();
            this.fillCitiesTable();
            this.changeAgreementsYear();
        },
        buttonAddNewCity: function buttonAddNewCity() {
            this.showDialogAddNewCity = true;
        },
        closeDialogNewCity: function closeDialogNewCity() {
            this.showDialogAddNewCity = false;
            /* 430 */
        },
        savedCity: function savedCity() {
            this.fillCitiesTable();
            this.showDialogAddNewCity = false;
        },
        editDepartment: function editDepartment(index) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.department = index;
                                if (_this.department.name == 'SEDE') {
                                    _this.sectorType = 'Setor Sede';
                                } else {
                                    _this.sectorType = 'Outro Setor';
                                }

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        saveDepartment: function saveDepartment() /* department */{
            var dep = this.department;
            dep.lastName = 'Função Indefinida';
            if (!dep.name) {
                dep.name = 'Setor Indefinido';
            }
            if (this.department.professionalCategory) {
                dep.lastName = this.department.professionalCategory.occupation;
            }
            this.resetDepartment();
            return dep;
        },
        changeAgreementsYear: function changeAgreementsYear() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.prev = 0;
                                _context2.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_3__service_CollectiveConventionService__["a" /* default */].getAll();

                            case 3:
                                _this2.agreementsYear = _context2.sent;

                                _this2.agreementsYear.sort();
                                _context2.next = 9;
                                break;

                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2['catch'](0);

                            case 9:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[0, 7]]);
            }))();
        },

        sectorText: function sectorText(item) {
            return '' + item;
        },
        changeOfficces: function changeOfficces() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.prev = 0;
                                _context3.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_5__service_OfficceService_js__["a" /* default */].getAll();

                            case 3:
                                _this3.offices = _context3.sent;

                                _this3.offices.sort();
                                _context3.next = 9;
                                break;

                            case 7:
                                _context3.prev = 7;
                                _context3.t0 = _context3['catch'](0);

                            case 9:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3, [[0, 7]]);
            }))();
        },
        //changeOfficces()
        changeSector: function changeSector() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                if (_this4.sectorType == 'Setor Sede') {
                                    _this4.department.name = 'SEDE';
                                    _this4.$emit('chengedSector');
                                } else {
                                    _this4.department.name = '';
                                    _this4.department.sectorType = 'OTHER';
                                    _this4.department.address.sectorType = 'OTHER';
                                    _this4.department.address.cityOfService = {};
                                    _this4.department.address.complement = '';
                                    _this4.department.address.district = '';
                                    _this4.department.address.number = '';
                                    _this4.department.address.addressType = '';
                                    _this4.department.address.cep = '';
                                    _this4.department.address.sector = '';
                                }

                            case 1:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4);
            }))();
        },
        setAddress: function setAddress(address) {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _this5.department.address = address;
                                _this5.department.address.sector = 'SEDE';
                                _this5.department.address.cityOfService = {};
                                _context5.next = 5;
                                return _this5.findCityByNameAndState(address);

                            case 5:
                                _this5.department.address.cityOfService = _context5.sent;

                            case 6:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this5);
            }))();
        },
        findCityByNameAndState: function findCityByNameAndState(address) {
            if (!this.cities) return;

            for (var i = 0; i < this.cities.length; i++) {
                if (address.city.toUpperCase() == this.cities[i].name.toUpperCase() && address.state.toUpperCase() == this.cities[i].state.toUpperCase()) {
                    return this.cities[i];
                }
            }
        },

        cityText: function cityText(item) {
            return item.name + ' - ' + item.state + ' (' + item.uf + ')';
        },

        fillCitiesTable: function fillCitiesTable() {
            var _this6 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.prev = 0;
                                _context6.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_4__service_CityService__["a" /* default */].getAll();

                            case 3:
                                _this6.cities = _context6.sent;
                                _context6.next = 9;
                                break;

                            case 6:
                                _context6.prev = 6;
                                _context6.t0 = _context6['catch'](0);

                                console.log(_context6.t0);

                            case 9:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this6, [[0, 6]]);
            }))();
        },
        findAddressByCep: function findAddressByCep() {
            var _this7 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.prev = 0;

                                if (!(_this7.department.address.cep && _this7.department.address.cep.length == 8)) {
                                    _context7.next = 6;
                                    break;
                                }

                                _this7.isSearchingAddress = true;
                                _context7.next = 5;
                                return __WEBPACK_IMPORTED_MODULE_6__service_UtilService_js__["a" /* default */].findAddressByCep(_this7.department.address.cep);

                            case 5:
                                _this7.department.address = _context7.sent;

                            case 6:
                                _context7.next = 11;
                                break;

                            case 8:
                                _context7.prev = 8;
                                _context7.t0 = _context7['catch'](0);

                                console.log(_context7.t0);

                            case 11:
                                _context7.prev = 11;

                                _this7.isSearchingAddress = false;
                                return _context7.finish(11);

                            case 14:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this7, [[0, 8, 11, 14]]);
            }))();
        },
        resetDepartment: function resetDepartment() {
            this.sectorType = '';
            this.department = {
                address: {
                    cityOfService: {}
                }
            };
        }
    },
    beforeMount: function beforeMount() {
        this.init();
    },

    watch: {
        'department.collectiveConvention': {
            handler: function handler(newValue, oldValue) {
                var _this8 = this;

                if (oldValue && newValue != oldValue) this.department.professionalCategory = {};

                var selected = this.agreementsYear.find(function (x) {
                    return x._id === _this8.department.collectiveConvention;
                });
                if (selected) {
                    this.department.minimalSalary = selected.minimalSalary;
                    this.agreementYearSelectedItems = selected.items;
                    this.department.dataBaseOfTheCategory = selected.dataBaseOfTheCategory;
                }
            },
            deep: true
        }
    }
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_headers_ContractHeaders__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_headers_InitialContractsHeaders__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dialogs_DialogUniformAndEPIs__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dialogs_DialogUtensil__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dialogs_DialogEquipments__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dialogs_DialogConsumables__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_UtilFormatter__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AlertDelete__ = __webpack_require__(212);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contractFinished: {
      type: Boolean,
      default: false
    },
    isContractInitialPage: {
      type: Boolean,
      default: false
    }
  },
  beforeMount: function beforeMount() {
    this.getHeaders();
  },
  data: function data() {
    return {
      //Headers
      utilFormatter: __WEBPACK_IMPORTED_MODULE_6__utils_UtilFormatter__["a" /* default */],
      consumablesHeader: [],
      equipmentsHeaders: [],
      utensilHeaders: [],
      uniformsAndEPIsHeaders: [],
      materials: {
        consumables: {
          itens: []
        },
        equipments: {
          itens: []
        },
        uniformsAndEPIs: {
          itens: []
        },
        utensils: {
          itens: []
        }
      },

      emptyRecordsText: "Nenhum registro encontrado",
      emptySearchText: "Nenhum registro encontrado para",
      editMaterialItem: false,
      editMaterialItemIndex: -1,
      loading: false,
      search: "",
      editingSheet: {}
    };
  },

  components: {
    AlertDelete: __WEBPACK_IMPORTED_MODULE_7__AlertDelete__["a" /* default */],
    DialogUniformAndEPIs: __WEBPACK_IMPORTED_MODULE_2__dialogs_DialogUniformAndEPIs__["a" /* default */],
    DialogUtensils: __WEBPACK_IMPORTED_MODULE_3__dialogs_DialogUtensil__["a" /* default */],
    DialogEquipments: __WEBPACK_IMPORTED_MODULE_4__dialogs_DialogEquipments__["a" /* default */],
    DialogConsumables: __WEBPACK_IMPORTED_MODULE_5__dialogs_DialogConsumables__["a" /* default */]
  },

  methods: {
    getHeaders: function getHeaders() {
      // esse metodo busca os cabeçalhos de um arquivo externo
      this.consumablesHeader = __WEBPACK_IMPORTED_MODULE_0__data_headers_ContractHeaders__["a" /* default */].getConsumablesHeaders();
      this.equipmentsHeaders = __WEBPACK_IMPORTED_MODULE_0__data_headers_ContractHeaders__["a" /* default */].getEquipamentHeaders();
      this.utensilHeaders = __WEBPACK_IMPORTED_MODULE_0__data_headers_ContractHeaders__["a" /* default */].getUtencilHeaders();
      this.uniformsAndEPIsHeaders = __WEBPACK_IMPORTED_MODULE_0__data_headers_ContractHeaders__["a" /* default */].getUniformsAndEPIsHeaders();
    },
    getHeadersFinishedContract: function getHeadersFinishedContract() {
      // esse metodo busca os cabeçalhos de um arquivo externo
      this.consumablesHeader = __WEBPACK_IMPORTED_MODULE_1__data_headers_InitialContractsHeaders__["a" /* default */].getConsumablesHeaders();
      this.equipmentsHeaders = __WEBPACK_IMPORTED_MODULE_1__data_headers_InitialContractsHeaders__["a" /* default */].getEquipamentHeaders();
      this.utensilHeaders = __WEBPACK_IMPORTED_MODULE_1__data_headers_InitialContractsHeaders__["a" /* default */].getUtencilHeaders();
      this.uniformsAndEPIsHeaders = __WEBPACK_IMPORTED_MODULE_1__data_headers_InitialContractsHeaders__["a" /* default */].getUniformsAndEPIsHeaders();
    },

    //table
    loadTables: function loadTables(materials) {
      this.materials = {};
      this.materials = materials;
      console.log(this.materials);
    },
    save: function save() {
      var mat = this.materials;

      this.materials = {
        consumables: {
          itens: []
        },
        equipments: {
          itens: []
        },
        uniformsAndEPIs: {
          itens: []
        },
        utensils: {
          itens: []
        }
      };
      return mat;
    },

    //table
    /*INICIO: METODOS REFERENTE AOS DIALOGS DE CADASTRO DE ITENS DO SETOR */
    //UniformAndEPIs
    OpenDialogUniformAndEPIs: function OpenDialogUniformAndEPIs() {
      this.$refs.dialogUniformAndEPIs.addNewItem();
    },
    OpenDialogUniformAndEPIsForDelete: function OpenDialogUniformAndEPIsForDelete(item) {
      this.$refs.alertToDeleteUniformAndEPIsItem.openDialog(item);
    },
    OpenDialogUniformAndEPIsForEdition: function OpenDialogUniformAndEPIsForEdition(item) {
      this.editMaterialItem = true;
      this.editMaterialItemIndex = this.materials.uniformsAndEPIs.items.indexOf(item);
      this.$refs.dialogUniformAndEPIs.editItem(item);
    },
    addItemUniformAndEPIs: function addItemUniformAndEPIs(item) {
      if (this.editMaterialItem) {
        this.materials.uniformsAndEPIs.items[this.editMaterialItemIndex] = item;
        this.editMaterialItemIndex = -1;
        this.editMaterialItem = false;
      } else {
        this.materials.uniformsAndEPIs.items.push(item);
      }
    },
    removeUniformItem: function removeUniformItem(item) {
      var index = this.materials.uniformsAndEPIs.items.indexOf(item);
      this.materials.uniformsAndEPIs.items.splice(index, 1);
    },

    /* UniformsAndEPIs */

    //Utencils
    OpenDialogUtensils: function OpenDialogUtensils() {
      this.$refs.dialogUtensils.addNewItem();
    },
    OpenDialogUtensilsForEdition: function OpenDialogUtensilsForEdition(item) {
      this.editMaterialItem = true;
      this.editMaterialItemIndex = this.materials.utensils.itens.indexOf(item);
      this.$refs.dialogUtensils.editItem(item);
    },
    OpenDialogUtensilsForDelete: function OpenDialogUtensilsForDelete(item) {
      this.$refs.alertToDeleteUtensilItem.openDialog(item);
    },
    addItemUtensil: function addItemUtensil(item) {
      if (this.editMaterialItem) {
        this.materials.utensils.itens[this.editMaterialItemIndex] = item;
        this.editMaterialItemIndex = -1;
        this.editMaterialItem = false;
      } else {
        this.materials.utensils.itens.push(item);
      }
    },
    removeUtensilItem: function removeUtensilItem(item) {
      var index = this.materials.utensils.itens.indexOf(item);
      this.materials.utensils.itens.splice(index, 1);
    },

    /* Utensils */

    //Equipaments
    OpenDialogEquipments: function OpenDialogEquipments() {
      this.$refs.dialogEquipments.addNewItem();
    },
    OpenDialogEquipmentsForDelete: function OpenDialogEquipmentsForDelete(item) {
      this.$refs.alertToDeleteEquipmentItem.openDialog(item);
    },
    OpenDialogEquipmentsForEdition: function OpenDialogEquipmentsForEdition(item) {
      this.editMaterialItem = true;
      this.editMaterialItemIndex = this.materials.equipments.itens.indexOf(item);
      this.$refs.dialogEquipments.editItem(item);
    },
    addItemEquipment: function addItemEquipment(item) {
      if (this.editMaterialItem) {
        this.materials.equipments.itens[this.editMaterialItemIndex] = item;
        this.editMaterialItemIndex = -1;
        this.editMaterialItem = false;
      } else {
        this.materials.equipments.itens.push(item);
      }
    },
    removeEquipmentItem: function removeEquipmentItem(item) {
      var index = this.materials.equipments.itens.indexOf(item);
      this.materials.equipments.itens.splice(index, 1);
    },

    /* Equipments */

    //Consumables
    OpenDialogConsumables: function OpenDialogConsumables() {
      this.$refs.dialogConsumables.addNewItem();
    },
    OpenDialogConsumablesForDelete: function OpenDialogConsumablesForDelete(item) {
      this.$refs.alertToDeleteComsumableItem.openDialog(item);
    },
    OpenDialogConsumablesForEdition: function OpenDialogConsumablesForEdition(item) {
      this.editMaterialItem = true;
      this.editMaterialItemIndex = this.materials.consumables.itens.indexOf(item);
      this.$refs.dialogConsumables.editItem(item);
    },
    addItemConsumables: function addItemConsumables(item) {
      if (this.editMaterialItem) {
        this.materials.consumables.itens[this.editMaterialItemIndex] = item;
        this.editMaterialItemIndex = -1;
        this.editMaterialItem = false;
      } else {
        this.materials.consumables.itens.push(item);
      }
    },
    removeConsumableItem: function removeConsumableItem(item) {
      var index = this.materials.consumables.itens.indexOf(item);
      this.materials.consumables.itens.splice(index, 1);
    },

    /* Consumables */

    /*FIM: METODOS REFERENTE AOS DIALOGS DE CADASTRO DE ITENS DO SETOR */

    /* SWITCH */
    updateStatusSwitch: function updateStatusSwitch(material) {
      var items = this.materials[material].itens;
      for (var index = 0; index < items.length; index++) {
        items[index].shippingFrequency.automaticShipping = this.materials[material].automaticShipping;
      }
    },


    /* SWITCH */
    resetAll: function resetAll() {
      this.materials = {
        consumables: {
          itens: []
        },
        equipments: {
          itens: []
        },
        uniformsAndEPIs: {
          itens: []
        },
        utensils: {
          itens: []
        }
      };
    }
  },
  computed: {
    footerDynamicText: function footerDynamicText() {
      var text = this.loading ? this.loadingRecordsText : this.emptyRecordsText;
      return text;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.resetAll();
  }
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_ProductService_js__ = __webpack_require__(186);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      showDialogItem: false,
      edit: false,
      uniformAndEPI: {},
      uniformsAndEPIs: []
    };
  },


  methods: {
    addNewItem: function addNewItem() {
      this.initialize();
      this.showDialogItem = true;
    },
    cancelNewItem: function cancelNewItem() {
      this.uniformAndEPI = {};
      this.uniformsAndEPIs = [];
      this.showDialogItem = false;
    },
    editItem: function editItem(item) {
      this.uniformAndEPI = item;
      this.edit = true;
      this.showDialogItem = true;
    },
    save: function save() {
      this.$emit('addUniformAndEPI', this.uniformAndEPI);
      this.showDialogItem = false;
    },
    loadDescription: function loadDescription() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__service_ProductService_js__["a" /* default */].getByCategory({
                  type: "Uniforme e EPI's"
                });

              case 2:
                _this.uniformsAndEPIs = _context.sent;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    initialize: function initialize() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                _context2.prev = 1;
                _context2.next = 4;
                return _this2.loadDescription();

              case 4:
                _this2.edit = false;
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](1);

                console.log(_context2.t0);

              case 10:
                _context2.prev = 10;

                _this2.loading = false;
                return _context2.finish(10);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 7, 10, 13]]);
      }))();
    }
  },
  computed: {
    titleComponent: function titleComponent() {
      return this.edit ? "Editar Item" : "Novo Item";
    }
  }
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_ProductService_js__ = __webpack_require__(186);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      showDialogItem: false,
      edit: false,
      utensil: {},
      utensils: []
    };
  },

  methods: {
    addNewItem: function addNewItem() {
      this.initialize();
      this.showDialogItem = true;
    },
    cancelNewItem: function cancelNewItem() {
      this.utensil = {};
      this.utensils = [];
      this.showDialogItem = false;
    },
    save: function save() {
      this.$emit('addUtensil', this.utensil);
      this.showDialogItem = false;
    },
    editItem: function editItem(item) {
      this.utensil = item;
      this.edit = true;
      this.showDialogItem = true;
    },
    initialize: function initialize() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _context.prev = 1;

                _this.utensil = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({});
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3__service_ProductService_js__["a" /* default */].getByCategory({
                  type: "Utensílio"
                });

              case 5:
                _this.utensils = _context.sent;

                _this.edit = false;
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](1);

                console.log(_context.t0);

              case 12:
                _context.prev = 12;

                _this.loading = false;
                return _context.finish(12);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 9, 12, 15]]);
      }))();
    }
  },
  computed: {
    titleComponent: function titleComponent() {
      return this.edit ? "Editar Item" : "Novo Item";
    }
  }
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_ProductService_js__ = __webpack_require__(186);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      showDialogItem: false,
      edit: false,
      equipment: {},
      equipments: []
    };
  },


  methods: {
    addNewItem: function addNewItem() {
      this.initialize();
      this.showDialogItem = true;
    },
    cancelNewItem: function cancelNewItem() {
      this.equipment = {};
      this.equipments = [];
      this.edit = false;
      this.showDialogItem = false;
    },
    editItem: function editItem(item) {
      this.edit = true;
      this.loadDescriptions();
      this.equipment = item;
      this.showDialogItem = true;
    },
    save: function save() {
      this.$emit('addEquipment', this.equipment);
      this.edit = false;
      this.showDialogItem = false;
    },
    loadDescriptions: function loadDescriptions() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__service_ProductService_js__["a" /* default */].getByCategory({
                  type: "Equipamento"
                });

              case 2:
                _this.equipments = _context.sent;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    initialize: function initialize() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                _this2.loadDescriptions();
                try {
                  _this2.equipment = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({});
                  _this2.isEditing = false;
                } catch (error) {
                  console.log(error);
                } finally {
                  _this2.loading = false;
                }

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  computed: {
    titleComponent: function titleComponent() {
      return this.edit ? "Editar Item" : "Novo Item";
    }
  }
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_ProductService_js__ = __webpack_require__(186);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      showDialogItem: false,
      consumable: {},
      consumables: [],
      edit: false
    };
  },

  methods: {
    addNewItem: function addNewItem() {
      this.initialize();
      this.showDialogItem = true;
    },
    editItem: function editItem(item) {
      this.loadDescriptions();
      this.edit = true;
      this.consumable = item;

      this.showDialogItem = true;
    },
    cancelNewItem: function cancelNewItem() {
      this.consumable = {};
      this.consumables = [];
      this.edit = false;
      this.showDialogItem = false;
    },
    loadDescriptions: function loadDescriptions() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__service_ProductService_js__["a" /* default */].getByCategory({
                  type: "Material de Consumo"
                });

              case 2:
                _this.consumables = _context.sent;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    save: function save() {
      this.$emit('addConsumable', this.consumable);
      this.showDialogItem = false;
    },
    initialize: function initialize() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                _this2.loadDescriptions();
                try {
                  _this2.consumable = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({});
                  _this2.edit = false;
                } catch (error) {
                  console.log(error);
                } finally {
                  _this2.loading = false;
                }

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  computed: {
    titleComponent: function titleComponent() {
      return this.edit ? "Editar Item" : "Novo Item";
    }
  }
});

/***/ }),
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var configurations = {
  basicSalary: 988,
  sheetDefault: {
    header: {
      mainNotes: "Nota 1: Esta tabela poderá ser adaptada às características do serviço contratado, inclusive no que concerne às rubricas e suas respectivas provisões e/ou estimativas, desde que haja justificativa.\nNota 2: As provisões constantes desta planilha poderão ser desnecessárias quando se tratar de determinados serviços que prescindam da dedicação exclusiva dos trabalhadores da contratada para com a Administração.",
      complementariesNotes: "Nota 1: Deverá ser elaborado um quadro para cada tipo de serviço.\nNota 2: A planilha será calculada considerando o valor mensal do empregado."
    },
    moduleOne: {
      notes: "Nota 1: O Módulo 1 refere-se ao valor mensal devido ao empregado pela prestação do serviço no período de 12 meses."
    },
    moduleTwo: {
      notesOne: "Nota 1: Como a planilha de custos e formação de preços é calculada mensalmente, provisiona-se proporcionalmente 1/12 (um doze avos) dos valores referentes a gratificação natalina, férias e adicional de férias.\nNota 2: O adicional de férias contido no Submódulo 2.1 corresponde a 1/3 (um terço) da remuneração que por sua vez é divido por 12 (doze) conforme Nota 1 acima.\nNota 3: Levando em consideração a vigência contratual prevista no art. 57 da Lei nº 8.666, de 23 de junho de 1993, a rubrica férias tem como objetivo principal suprir a necessidade do pagamento das férias remuneradas ao final do contrato de 12 meses. Esta rubrica, quando da prorrogação contratual, torna-se custo não renovável.",
      notesTwo: "Nota 1: Os percentuais dos encargos previdenciários, do FGTS e demais contribuições são aqueles estabelecidos pela legislação vigente.\nNota 2: O SAT a depender do grau de risco do serviço irá variar entre 1%, para risco leve, de 2%, para risco médio, e de 3% de risco grave.\nNota 3: Esses percentuais incidem sobre o Módulo 1, o Submódulo 2.1.",
      notesThree: "Nota 1: O valor informado deverá ser o custo real do benefício (descontado o valor eventualmente pago pelo empregado).\n      Nota 2: Observar a previsão dos benefícios contidos em Acordos, Convenções e Dissídios Coletivos de Trabalho e atentar-se ao disposto no art. 6º desta Instrução Normativa."
    },
    moduleThree: {},
    moduleFour: {
      notes: "Nota 1: Os itens que contemplam o módulo 4 se referem ao custo dos dias trabalhados pelo repositor/substituto, quando o empregado alocado na prestação de serviço estiver ausente, conforme as previsões estabelecidas na legislação."
    },
    moduleFive: {
      notes: "Nota: Valores mensais por empregado."
    },
    moduleSix: {
      notes: "Nota 1: Custos Indiretos, Tributos e Lucro por empregado.\nNota 2: O valor referente a tributos é obtido aplicando-se o percentual sobre o valor do faturamento."
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (configurations);

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var ModuleOneService = function () {
  function ModuleOneService() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ModuleOneService);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ModuleOneService, null, [{
    key: "getAmountOfModuleOne",
    value: function getAmountOfModuleOne(header, moduleOne) {
      var CCTSalary = header.professionalCategory.basicSalary;
      var minimalSalary = header.minimalSalary;
      var serviceStationGratification = this.getServiceStationGratification(moduleOne.serviceStationGratification);
      var remunarationBase = this.getRemunerationBase(header);
      var extraHour = this.getExtraHour(remunarationBase, serviceStationGratification, moduleOne.extraHour);
      var amount = remunarationBase + this.getAdditionalDanger(CCTSalary, moduleOne) + this.getAdditionalHealth(minimalSalary, moduleOne) + serviceStationGratification + this.getNocturneAdditional(remunarationBase, moduleOne.additionalNocturne) + extraHour + this.getDSR(extraHour, moduleOne.dsr, moduleOne.extraHour.has) + this.getOthers(moduleOne.others);
      return amount;
    }
    /** 
     * @param {Number} CCTSalary
     * @param {Object} moduleOne 
     */

  }, {
    key: "getAdditionalDanger",
    value: function getAdditionalDanger(CCTSalary, moduleOne) {
      return CCTSalary * moduleOne.percentOfAdditionalDanger / 100;
    }

    /** 
     * @param {Number} minimalSalary
     * @param {Object} moduleOne 
     */

  }, {
    key: "getAdditionalHealth",
    value: function getAdditionalHealth(minimalSalary, moduleOne) {
      return minimalSalary * moduleOne.percentOfAdditionalHealth / 100;
    }
    /**
     * @param {Number} extraHour 
     * @param {Object} dsr 
     * @param {Boolean} has 
     */

  }, {
    key: "getDSR",
    value: function getDSR(extraHour, dsr, has) {
      if (dsr.workingDays <= 0 || !has) return 0;

      return extraHour * dsr.sundayDays / dsr.workingDays;
    }
    /**
     * @param {Number} remunarationBase 
     * @param {Number} serviceStationGratification 
     * @param {Object} extraHour 
     */

  }, {
    key: "getExtraHour",
    value: function getExtraHour(remunarationBase, serviceStationGratification, extraHour) {
      if (extraHour.workJournie <= 0 || !extraHour.has) return 0;

      var normalHour = this.getNormalHour(remunarationBase, serviceStationGratification, extraHour);

      var hours50 = normalHour * 1.50 * extraHour.hours50;

      var hours75 = normalHour * 1.75 * extraHour.hours75;

      var hours100 = normalHour * 2.00 * extraHour.hours100;

      return hours50 + hours75 + hours100;
    }

    /**
     * @param {Object} professionalCategory 
     */

  }, {
    key: "getFunctionGratification",
    value: function getFunctionGratification(professionalCategory) {
      if (!professionalCategory || !professionalCategory.costs) return 0;
      var amount = 0;
      for (var i = 0; i < professionalCategory.costs.length; i++) {
        amount += professionalCategory.costs[i].value;
      }return amount;
    }
    /**
     * @param {Number} remunarationBase 
     * @param {Object} additionalNocturne 
     */

  }, {
    key: "getNocturneAdditional",
    value: function getNocturneAdditional(remunarationBase, additionalNocturne) {
      if (additionalNocturne.workJournie <= 0 || !additionalNocturne.has) return 0;
      var nocturneNormalHourValue = this.getNocturneNormalHour(remunarationBase, additionalNocturne);

      var nocturneNormalHourAddPercent = nocturneNormalHourValue + nocturneNormalHourValue * additionalNocturne.percent / 100;

      return nocturneNormalHourAddPercent * additionalNocturne.workedHours;
    }

    /** 
     * @param {Number} remunarationBase 
     * @param {Object} additionalNocturne 
     */

  }, {
    key: "getNocturneNormalHour",
    value: function getNocturneNormalHour(remunarationBase, additionalNocturne) {
      if (additionalNocturne.workJournie <= 0 || !additionalNocturne.has) return 0;

      return remunarationBase / additionalNocturne.workJournie;
    }
    /**
     * 
     * @param {Number} remunarationBase 
     * @param {Number} serviceStationGratification 
     * @param {Object} extraHour 
     * @returns {Number}
     */

  }, {
    key: "getNormalHour",
    value: function getNormalHour(remunarationBase, serviceStationGratification, extraHour) {
      if (extraHour.workJournie <= 0 || !extraHour.has) return 0;

      return (remunarationBase + serviceStationGratification) / extraHour.workJournie;
    }
    /**
     * @param {Array} others 
     */

  }, {
    key: "getOthers",
    value: function getOthers(others) {
      if (!others) return 0;
      var amount = 0;
      for (var i = 0; i < others.length; i++) {
        amount += others[i].value;
      }
      return amount;
    }
    /**
     * @param {Object} header 
     */

  }, {
    key: "getRemunerationBase",
    value: function getRemunerationBase(header) {
      var CCTSalary = header.professionalCategory.basicSalary;
      var functionGratification = this.getFunctionGratification(header.professionalCategory);

      return CCTSalary + functionGratification;
    }
    /**
     * @param {Array} serviceStationGratification 
     */

  }, {
    key: "getServiceStationGratification",
    value: function getServiceStationGratification(serviceStationGratification) {
      if (!serviceStationGratification) return 0;

      var amount = 0;
      for (var i = 0; i < serviceStationGratification.length; i++) {
        amount += serviceStationGratification[i].value;
      }return amount;
    }
  }]);

  return ModuleOneService;
}(); // class


/* harmony default export */ __webpack_exports__["a"] = (ModuleOneService);

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var ModuleTwoService = function () {
  function ModuleTwoService() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ModuleTwoService);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ModuleTwoService, null, [{
    key: "getAmountOfFoodAid",
    value: function getAmountOfFoodAid(foodAid) {
      if (!foodAid || !foodAid.has) return 0;

      return foodAid.mealByDay * foodAid.daysByMonth * foodAid.value;
    }
    /**
     * @param {Number} amountOfModuleOne 
     * @param {Object} moduleTwo 
     */

  }, {
    key: "getAmountOfModuleTwoOne",
    value: function getAmountOfModuleTwoOne(amountOfModuleOne, moduleTwo) {
      var thirteenFirstSalary = amountOfModuleOne * moduleTwo.thirteenFirstSalary / 100;
      var vacationAdditional = amountOfModuleOne * moduleTwo.vacationAdditional / 100;
      return thirteenFirstSalary + vacationAdditional;
    }
    /**
     * @param {Number} moduleOneAndModuleTwoOne 
     * @param {Object} moduleTwo 
     */

  }, {
    key: "getAmountOfModuleTwoTwo",
    value: function getAmountOfModuleTwoTwo(moduleOneAndModuleTwoOne, moduleTwo) {
      var amountOfPercents = this.getAmountOfModuleTwoTwoPercents(moduleTwo);

      return moduleOneAndModuleTwoOne * amountOfPercents / 100;
    }
  }, {
    key: "getAmountOfModuleTwoThree",
    value: function getAmountOfModuleTwoThree(basicSalaryCCT, moduleTwo) {
      return this.getAmountOfTransport(basicSalaryCCT, moduleTwo.transport) + this.getAmountOfFoodAid(moduleTwo.foodAid) + this.getOthers(moduleTwo.others);
    }
  }, {
    key: "getAmountOfModuleTwoOnePercents",
    value: function getAmountOfModuleTwoOnePercents(moduleTwo) {
      return moduleTwo.thirteenFirstSalary + moduleTwo.vacationAdditional;
    }
  }, {
    key: "getAmountOfModuleTwoTwoPercents",
    value: function getAmountOfModuleTwoTwoPercents(moduleTwo) {
      return moduleTwo.inss + moduleTwo.fgts + moduleTwo.sesiSesc + moduleTwo.senaiSenac + moduleTwo.incra + moduleTwo.sebrae + moduleTwo.educationSalary + moduleTwo.rat * moduleTwo.fap;
    }
  }, {
    key: "getOthers",
    value: function getOthers(others) {
      if (!others) return 0;
      var amount = 0;
      for (var i = 0; i < others.length; i++) {
        amount += others[i].value;
      }
      return amount;
    }
  }, {
    key: "getAmountOfTransport",
    value: function getAmountOfTransport(basicSalaryCCT, transport) {
      // só faz o cálculo caso use vale transporte, ou seja, a quantidade de vale por dia e
      // a quantidade de dias úteis forem maiores do que zero
      if (!transport || !transport.has) return 0;

      var partialAmount = this.getPartialAmountOfTransport(transport);

      if (partialAmount <= 0) return 0;

      var employeeCost = this.getEmployeeCost(basicSalaryCCT);

      return partialAmount - employeeCost;
    }
  }, {
    key: "getEmployeeCost",
    value: function getEmployeeCost(basicSalaryCCT) {
      return basicSalaryCCT * 6 / 100;
    }
  }, {
    key: "getPartialAmountOfTransport",
    value: function getPartialAmountOfTransport(transport) {
      if (!transport) return 0;

      var partialAmount = 0;
      if (transport.tariffValue > 0 && transport.ticketByDay > 0 && transport.daysByMonth > 0) partialAmount = transport.tariffValue * transport.ticketByDay * transport.daysByMonth;

      return partialAmount;
    }
  }]);

  return ModuleTwoService;
}(); // class


/* harmony default export */ __webpack_exports__["a"] = (ModuleTwoService);

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var ModuleThreeService = function () {
  function ModuleThreeService() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ModuleThreeService);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ModuleThreeService, null, [{
    key: "getAmountOfModuleThree",
    value: function getAmountOfModuleThree(moduleOneAndModuleTwoOne, moduleThree) {

      var amount = this.getFgtsIncidencePreviousNoticeIndemnified(moduleOneAndModuleTwoOne, moduleThree) + this.getFgtsIncidencePreviousNoticeWorked(moduleOneAndModuleTwoOne, moduleThree) + this.getFgtsPenaltyPreviousNoticeIndemnified(moduleOneAndModuleTwoOne, moduleThree) + this.getFgtsPenaltyPreviousNoticeWorked(moduleOneAndModuleTwoOne, moduleThree) + this.getPreviousNoticeIndemnified(moduleOneAndModuleTwoOne, moduleThree) + this.getPreviousNoticeWorked(moduleOneAndModuleTwoOne, moduleThree) + this.getOthers(moduleThree.others, moduleOneAndModuleTwoOne);

      return amount;
    }
  }, {
    key: "getFgtsIncidencePreviousNoticeIndemnified",
    value: function getFgtsIncidencePreviousNoticeIndemnified(moduleOneAndModuleTwoOne, moduleThree) {
      return moduleOneAndModuleTwoOne * moduleThree.fgtsIncidencePreviousNoticeIndemnified / 100;
    }
  }, {
    key: "getFgtsIncidencePreviousNoticeWorked",
    value: function getFgtsIncidencePreviousNoticeWorked(moduleOneAndModuleTwoOne, moduleThree) {
      return moduleOneAndModuleTwoOne * moduleThree.fgtsIncidencePreviousNoticeWorked / 100;
    }
  }, {
    key: "getFgtsPenaltyPreviousNoticeIndemnified",
    value: function getFgtsPenaltyPreviousNoticeIndemnified(moduleOneAndModuleTwoOne, moduleThree) {
      return moduleOneAndModuleTwoOne * moduleThree.fgtsPenaltyPreviousNoticeIndemnified / 100;
    }
  }, {
    key: "getFgtsPenaltyPreviousNoticeWorked",
    value: function getFgtsPenaltyPreviousNoticeWorked(moduleOneAndModuleTwoOne, moduleThree) {
      return moduleOneAndModuleTwoOne * moduleThree.fgtsPenaltyPreviousNoticeWorked / 100;
    }
  }, {
    key: "getOthers",
    value: function getOthers(others, moduleOneAndModuleTwoOne) {
      if (!others) return 0;
      var amount = 0;
      for (var i = 0; i < others.length; i++) {
        amount += others[i].percent * moduleOneAndModuleTwoOne / 100;
      }return amount;
    }
  }, {
    key: "getPreviousNoticeIndemnified",
    value: function getPreviousNoticeIndemnified(moduleOneAndModuleTwoOne, moduleThree) {
      return moduleOneAndModuleTwoOne * moduleThree.previousNoticeIndemnified / 100;
    }
  }, {
    key: "getPreviousNoticeWorked",
    value: function getPreviousNoticeWorked(moduleOneAndModuleTwoOne, moduleThree) {
      return moduleOneAndModuleTwoOne * moduleThree.previousNoticeWorked / 100;
    }
  }]);

  return ModuleThreeService;
}(); // class


/* harmony default export */ __webpack_exports__["a"] = (ModuleThreeService);

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var ModuleFourService = function () {
  function ModuleFourService() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ModuleFourService);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ModuleFourService, null, [{
    key: "getAmountOfModuleFour",

    /**
     * @param {Number} calculationBasis
     * @param {Object} moduleFour 
     */
    value: function getAmountOfModuleFour(calculationBasis, moduleFour) {
      return this.getAmountOfModuleFourOne(calculationBasis, moduleFour) + this.getAmountOfModuleFourTwo(calculationBasis, moduleFour);
    }

    /**
     * @param {Number} calculationBasis
     * @param {Object} moduleFour 
     */

  }, {
    key: "getAmountOfModuleFourOne",
    value: function getAmountOfModuleFourOne(calculationBasis, moduleFour) {
      var percent = this.getAmountOfModuleFourOnePercents(moduleFour);
      return calculationBasis * percent / 100;
    }
    /** 
     * @param {Object} moduleFour 
     */

  }, {
    key: "getAmountOfModuleFourOnePercents",
    value: function getAmountOfModuleFourOnePercents(moduleFour) {
      return moduleFour.vacation + moduleFour.legalAbsences + moduleFour.paternityLicence + moduleFour.workAccident + moduleFour.maternityLicence + moduleFour.professionalAbsent + this.getOthersPercent(moduleFour.others);
    }
    /** 
     * @param {Object} moduleFour 
     */

  }, {
    key: "getAmountOfModuleFourTwo",
    value: function getAmountOfModuleFourTwo(calculationBasis, moduleFour) {
      return calculationBasis * moduleFour.restAndFeeding / 100;
    }
  }, {
    key: "getOthersPercent",
    value: function getOthersPercent(others) {
      if (!others) return 0;
      var amount = 0;
      for (var i = 0; i < others.length; i++) {
        amount += others[i].percent;
      }
      return amount;
    }
  }]);

  return ModuleFourService;
}(); // class


/* harmony default export */ __webpack_exports__["a"] = (ModuleFourService);

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var ModuleSixService = function () {
  function ModuleSixService() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ModuleSixService);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ModuleSixService, null, [{
    key: "getAliquot",
    value: function getAliquot(taxation, taxationType) {
      if (!taxation || taxationType == "") {
        return 0;
      }

      /*OTHERS let sumOfOthers = 0
      if(this.moduleSix && this.moduleSix.others && this.moduleSix.others.length > 0){
        for (let i = 0; i < this.moduleSix.others.length; i++) {
          sumOfOthers += this.moduleSix.others[i].value
        }
      }*/

      if (taxationType.toUpperCase() == "SIMPLES NACIONAL") {
        //OTHERS return this.taxation.uniqueTaxation  + sumOfOthers
        return taxation.uniqueTaxation;
      } else {
        //OTHERS return this.taxation.pis + this.taxation.cofins + this.taxation.iss  + sumOfOthers;
        return taxation.pis + taxation.cofins + taxation.iss;
      }
    }
  }, {
    key: "getAdministrativeCosts",
    value: function getAdministrativeCosts() {
      var subTotalValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var administrativeCosts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      return subTotalValue * administrativeCosts / 100;
    }
    /**
     * @param {Number} amountOfModuleOne 
     * @param {Object} moduleTwo 
     */

  }, {
    key: "getAmountOfModuleSix",
    value: function getAmountOfModuleSix(budget, moduleSix, subTotalValue) {

      var taxation = this.getTaxation(budget);
      var taxationType = this.getTaxationType(taxation);

      if (!taxation || taxationType == "") return 0;

      var amount = 0;
      var aliquot = this.getAliquot(taxation, taxationType);
      var administrativeCostsValue = this.getAdministrativeCosts(subTotalValue, moduleSix.administrativeCosts);
      var basisOfCalculationForLucre = this.getBasisOfCalculationForLucre(subTotalValue, administrativeCostsValue);
      var lucreValue = this.getLucre(moduleSix.lucre, basisOfCalculationForLucre);
      var basisOfCalculationForTaxation = this.getBasisOfCalculationForTaxation(subTotalValue, administrativeCostsValue, lucreValue);

      if (taxationType.toUpperCase() == "SIMPLES NACIONAL") {
        //amount  = this.uniqueTaxationValue this.administrativeCostsValue + this.lucreValue + this.othersValue
        amount = this.getUniqueTaxation(taxation, basisOfCalculationForTaxation) + administrativeCostsValue + lucreValue;
      } else {
        //amount  = this.pisValue + this.cofinsValue + this.issValue this.administrativeCostsValue + this.lucreValue + this.othersValue
        amount = this.getPis(taxation, basisOfCalculationForTaxation, aliquot) + this.getCofins(taxation, basisOfCalculationForTaxation, aliquot) + this.getIss(taxation, basisOfCalculationForTaxation, aliquot) + administrativeCostsValue + lucreValue;
      }
      return amount;
    }
  }, {
    key: "getBasisOfCalculationForLucre",
    value: function getBasisOfCalculationForLucre(subTotalValue, administrativeCostsValue) {
      return subTotalValue + administrativeCostsValue;
    }
  }, {
    key: "getBasisOfCalculationForTaxation",
    value: function getBasisOfCalculationForTaxation(subTotalValue, administrativeCostsValue, lucreValue) {
      return subTotalValue + administrativeCostsValue + lucreValue;
    }
  }, {
    key: "getCofins",
    value: function getCofins(taxation, basisOfCalculationForTaxation, aliquot) {
      if (!taxation) return 0;
      return basisOfCalculationForTaxation / (100 - aliquot) * taxation.cofins;
    }
  }, {
    key: "getIss",
    value: function getIss(taxation, basisOfCalculationForTaxation, aliquot) {
      if (!taxation) return 0;
      return basisOfCalculationForTaxation / (100 - aliquot) * taxation.iss;
    }
  }, {
    key: "getLucre",
    value: function getLucre() {
      var lucre = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var basisOfCalculationForLucre = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      return basisOfCalculationForLucre * lucre / 100;
    }
  }, {
    key: "getOthers",
    value: function getOthers(others, aliquot, basisOfCalculationForTaxation) {
      if (!others) return 0;
      var sumOfOthers = 0;
      for (var i = 0; i < others.length; i++) {
        sumOfOthers += basisOfCalculationForTaxation / (100 - aliquot) * moduleSix.others[i].value;
      }return sumOfOthers;
    }
  }, {
    key: "getPis",
    value: function getPis(taxation, basisOfCalculationForTaxation, aliquot) {
      if (!taxation) return 0;
      return basisOfCalculationForTaxation / (100 - aliquot) * taxation.pis;
    }
  }, {
    key: "getTaxation",
    value: function getTaxation(budget) {
      if (!budget || !budget.company || !budget.company.taxation) return;
      return budget.company.taxation;
    }
  }, {
    key: "getTaxationType",
    value: function getTaxationType(taxation) {
      if (!taxation) return "";
      return taxation.taxationType;
    }
  }, {
    key: "getUniqueTaxation",
    value: function getUniqueTaxation(taxation, basisOfCalculationForTaxation) {
      if (!taxation) return 0;
      return basisOfCalculationForTaxation * taxation.uniqueTaxation / 100;
    }
  }]);

  return ModuleSixService;
}(); // class


/* harmony default export */ __webpack_exports__["a"] = (ModuleSixService);

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configuration__ = __webpack_require__(59);









var url = __WEBPACK_IMPORTED_MODULE_5__configuration__["a" /* default */].apiHost + "budgets";

var BudgetService = function () {
  function BudgetService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, BudgetService);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(BudgetService, null, [{
    key: "getAll",
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var alls;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url);

              case 3:
                alls = _context.sent;
                return _context.abrupt("return", alls.data);

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                throw new Error(_context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function getAll() {
        return _ref.apply(this, arguments);
      }

      return getAll;
    }()
  }, {
    key: "getAllApproved",
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var alls;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__configuration__["a" /* default */].apiHost + "budgets-status/APROVADO");

              case 3:
                alls = _context2.sent;
                return _context2.abrupt("return", alls.data);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                throw new Error(_context2.t0);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function getAllApproved() {
        return _ref2.apply(this, arguments);
      }

      return getAllApproved;
    }()
  }, {
    key: "getAllApprovedToUseInContract",
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var alls;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__configuration__["a" /* default */].apiHost + "budgets-status/");

              case 3:
                alls = _context3.sent;
                return _context3.abrupt("return", alls.data);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);
                throw new Error(_context3.t0);

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function getAllApprovedToUseInContract() {
        return _ref3.apply(this, arguments);
      }

      return getAllApprovedToUseInContract;
    }()
  }, {
    key: "findComplete",
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(id) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (id) {
                  _context4.next = 2;
                  break;
                }

                throw new Error("BudgetService: o id deve ser fornecido ao buscar orçamento");

              case 2:
                _context4.prev = 2;
                _context4.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__configuration__["a" /* default */].apiHost + "budgets-complete/" + id);

              case 5:
                response = _context4.sent;
                return _context4.abrupt("return", response.data);

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](2);
                throw new Error(_context4.t0);

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[2, 9]]);
      }));

      function findComplete(_x) {
        return _ref4.apply(this, arguments);
      }

      return findComplete;
    }()
  }, {
    key: "save",
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(budget) {
        var saved;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url, budget);

              case 3:
                saved = _context5.sent;
                return _context5.abrupt("return", saved.data);

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5["catch"](0);
                throw new Error(_context5.t0);

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 7]]);
      }));

      function save(_x2) {
        return _ref5.apply(this, arguments);
      }

      return save;
    }() // save()

  }, {
    key: "edit",
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(budget) {
        var updated;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(url, budget);

              case 3:
                updated = _context6.sent;
                return _context6.abrupt("return", updated.data);

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6["catch"](0);
                throw new Error(_context6.t0);

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 7]]);
      }));

      function edit(_x3) {
        return _ref6.apply(this, arguments);
      }

      return edit;
    }() // edit()

  }, {
    key: "remove",
    value: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(budget) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete(url, {
                  data: budget
                });

              case 3:
                _context7.next = 8;
                break;

              case 5:
                _context7.prev = 5;
                _context7.t0 = _context7["catch"](0);
                throw new Error(_context7.t0);

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 5]]);
      }));

      function remove(_x4) {
        return _ref7.apply(this, arguments);
      }

      return remove;
    }() // remove()

  }, {
    key: "download",
    value: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(budgetId) {
        var resp;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url + "/download/" + budgetId, { responseType: 'blob' });

              case 3:
                resp = _context8.sent;
                return _context8.abrupt("return", resp.data);

              case 7:
                _context8.prev = 7;
                _context8.t0 = _context8["catch"](0);
                throw new Error(_context8.t0);

              case 10:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 7]]);
      }));

      function download(_x5) {
        return _ref8.apply(this, arguments);
      }

      return download;
    }()
  }]);

  return BudgetService;
}(); // class


/* harmony default export */ __webpack_exports__["a"] = (BudgetService);

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//Posição 0 usada como padrão
/* harmony default export */ __webpack_exports__["a"] = ([{
  title: "EM EDIÇÃO",
  color: "#f1f1f1"
}, {
  title: "REPROVADO",
  color: "danger"
}, {
  title: "ENVIADO",
  color: "info"
}, {
  title: "APROVADO",
  color: "green"
}]);

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(246);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(155)("47d094ee", content, true, {});

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(154)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"FormCity.vue","sourceRoot":""}]);

// exports


/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('v-toolbar',{staticClass:"elevation-1",attrs:{"color":"white"}},[_c('v-toolbar-title',{staticClass:"black--text font-weight-light"},[_vm._v("Nova Cidade")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[(_vm.city && _vm.city.active != undefined || null)?_c('v-switch',{staticClass:"pt-switch",attrs:{"pt-2":"","label":_vm.city.active ? "Ativa" : "Inativa"},on:{"click":function($event){$event.preventDefault();_vm.city.active  == true ? _vm.desactivationDialog = true : _vm.activateCity()}},model:{value:(_vm.city.active),callback:function ($$v) {_vm.$set(_vm.city, "active", $$v)},expression:"city.active"}}):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"title":"Cancelar","color":"error","icon":"","round":"","flat":""},on:{"click":_vm.cancel}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":"","row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"box":"","prepend-icon":"business","items":_vm.states,"item-text":"name","item-value":"uf","label":"Estado","required":""},on:{"change":_vm.filterCities},model:{value:(_vm.city.uf),callback:function ($$v) {_vm.$set(_vm.city, "uf", $$v)},expression:"city.uf"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"box":"","prepend-icon":"label","items":_vm.citiesOffState,"label":"Cidade","required":"","disabled":_vm.city.uf == undefined},model:{value:(_vm.city.name),callback:function ($$v) {_vm.$set(_vm.city, "name", $$v)},expression:"city.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"box":"","prepend-icon":"attach_money","label":"Valor do passe de ônibus (R$)","type":"number","min":"0"},model:{value:(_vm.city.busPassValue),callback:function ($$v) {_vm.$set(_vm.city, "busPassValue", $$v)},expression:"city.busPassValue"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"success lighten-1","round":"","block":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.save();}}},[_vm._v("Salvar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(249);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(155)("c77ac3ee", content, true, {});

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(154)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"AlertDelete.vue","sourceRoot":""}]);

// exports


/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"300","persistent":""},model:{value:(_vm.dialogStatus),callback:function ($$v) {_vm.dialogStatus=$$v},expression:"dialogStatus"}},[_c('v-card',{attrs:{"align-center":""}},[_c('v-card-text',[_c('v-card-title',{staticClass:"headline text-xs-center",attrs:{"mx-4":""}},[_c('div',{staticStyle:{"width":"100%","text-align":"center"}},[_c('h5',[_vm._v("Dejesa excluir o registro?")])])]),_vm._v(" "),_c('v-card-text',{staticClass:"text-xs-center subtitle-2 pt-0",staticStyle:{"color":"brown !important"}},[_vm._v("\n          A ação será irreversivél!\n        ")]),_vm._v(" "),_c('v-card-actions',[_c('div',{staticStyle:{"width":"100%","text-align":"center"}},[_c('v-btn',{staticClass:"mx-2 white--text",attrs:{"color":"green darken-1"},on:{"click":function($event){return _vm.remove();}}},[_vm._v("\n              Sim\n            ")]),_vm._v(" "),_c('v-btn',{staticClass:"mx-2 white--text",attrs:{"color":"green darken-1"},on:{"click":_vm.closeDialog}},[_vm._v("\n              Não\n            ")])],1)])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


var headers = [{
  text: "Código do Contrato",
  align: "left",
  value: "contractCode"
}, {
  text: "Empresa",
  align: "center",
  value: "company",
  sortable: false
}, {
  text: "Cliente",
  align: "center",
  value: "client",
  sortable: false
}, {
  text: "Situação",
  align: "center",
  value: "status",
  sortable: false
}, {
  text: "Ações",
  align: "center",
  value: "name",
  sortable: false
}];
var budgetHeaders = [{
  text: "Código do Orçamento",
  align: "left",
  sortable: true,
  value: "code"
}, {
  text: "Empresa",
  align: "center",
  value: "company"
}, {
  text: "Tipo do Orçamento",
  align: "center",
  value: "tradingFloor"
}, {
  text: "Processo",
  align: "center",
  value: "process"
}, {
  text: "Cliente",
  align: "center",
  value: "client"
}, {
  text: "Data do Pregão",
  align: "center",
  value: "dateOfTheTradingFloor"
}];
var consumablesHeader = [{
  text: "Especificação / Descrição",
  align: "center",
  value: "description"
}, {
  text: "Unidade de Medida",
  align: "center",
  value: "unity"
}, {
  text: "Quantidade",
  align: "center",
  value: "quantity"
}, {
  text: "Valor Unitário",
  align: "center",
  value: "unitaryValue"
}, {
  text: "Sub-Total",
  align: "center",
  sortable: false
}, {
  text: "Vida Útil (mês)",
  align: "center",
  value: "lifetime"
},
/*  {
   text: "Valor Mensal",
   align: "center",
   value: "monthlyValue"
 }, */
{
  text: "Ação",
  align: "center",
  sortable: false
}];
var equipmentsHeaders = [{
  text: "Especificação / Descrição",
  align: "center",
  value: "description"
}, {
  text: "Marca / Modelo",
  align: "center",
  value: "stamp"
}, {
  text: "Quantidade",
  align: "center",
  value: "quantity"
}, {
  text: "Valor Unitário",
  align: "center",
  value: "unitaryValue"
}, {
  text: "Sub-Total",
  align: "center",
  sortable: false
}, {
  text: "Vida Útil (%)",
  align: "center",
  value: "lifetime"
},
/*  {
   text: "Valor Mensal",
   align: "center",
   value: "monthlyValue"
 }, */
{
  text: "Ação",
  align: "center",
  sortable: false
}];
var utencilHeaders = [{
  text: "Descrição / Especificação",
  align: "left",
  sortable: true,
  value: "description"
}, {
  text: "Unidade",
  align: "center",
  value: "unity"
}, {
  text: "Quantidade",
  align: "center",
  value: "quantity"
}, {
  text: "Valor Unitário",
  align: "center",
  value: "unitaryValue"
}, {
  text: "Sub-Total",
  align: "center",
  sortable: false
}, {
  text: "Vida Útil (mês)",
  align: "center",
  value: "lifetime"
},
/*   {
    text: "Valor Mensal",
    align: "center",
    value: "monthlyValue"
  }, */
{
  text: "Ações",
  align: "center",
  value: "name",
  sortable: false
}];
var uniformsAndEPIsHeaders = [{
  text: "Descrição / Especificação",
  align: "left",
  sortable: true,
  value: "description"
}, {
  text: "Unidade",
  align: "center",
  value: "unity"
}, {
  text: "Quantidade",
  align: "center",
  value: "quantity"
}, {
  text: "Valor Unitário",
  align: "center",
  value: "unitaryValue"
}, {
  text: "Sub-Total",
  align: "center",
  sortable: false
}, {
  text: "Vida Útil (mês)",
  align: "center",
  value: "lifetime"
},
/*  {
   text: "Valor Mensal",
   align: "center",
   value: "monthlyValue"
 }, */
{
  text: "Ações",
  align: "center",
  value: "name",
  sortable: false
}];

var Headers = function () {
  function Headers() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Headers);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Headers, null, [{
    key: "getHeaders",
    value: function getHeaders() {
      return headers;
    }
  }, {
    key: "getBudgetHeaders",
    value: function getBudgetHeaders() {
      return budgetHeaders;
    }
  }, {
    key: "getConsumablesHeaders",
    value: function getConsumablesHeaders() {
      return consumablesHeader;
    }
  }, {
    key: "getEquipamentHeaders",
    value: function getEquipamentHeaders() {
      return equipmentsHeaders;
    }
  }, {
    key: "getUtencilHeaders",
    value: function getUtencilHeaders() {
      return utencilHeaders;
    }
  }, {
    key: "getUniformsAndEPIsHeaders",
    value: function getUniformsAndEPIsHeaders() {
      return uniformsAndEPIsHeaders;
    }
  }]);

  return Headers;
}();

/* harmony default export */ __webpack_exports__["a"] = (Headers);

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


var headers = [{
  text: "Código do Contrato",
  align: "left",
  sortable: true,
  value: "contractCode"
}, {
  text: "Empresa",
  align: "center",
  value: "company",
  sortable: false
}, {
  text: "Cliente",
  align: "center",
  value: "client",
  sortable: false
}, {
  text: "Situação",
  align: "center",
  value: "status",
  sortable: false
}, {
  text: "Ações",
  align: "center",
  value: "name",
  sortable: false
}];
var budgetHeaders = [{
  text: "#",
  align: "left",
  sortable: true,
  value: "code"
}, {
  text: "Empresa",
  align: "center",
  value: "company"
}, {
  text: "Tipo do Orçamento",
  align: "center",
  value: "tradingFloor"
}, {
  text: "Processo",
  align: "center",
  value: "process"
}, {
  text: "Cliente",
  align: "center",
  value: "client"
}, {
  text: "Data do Pregão",
  align: "center",
  value: "dateOfTheTradingFloor"
}];
var consumablesHeader = [{
  text: "Especificação / Descrição",
  align: "center",
  value: "description"
}, {
  text: "Unidade de Medida",
  align: "center",
  value: "unity"
}, {
  text: "Quantidade Prevista",
  align: "center",
  value: "quantity"
}, {
  text: "Valor Unitário",
  align: "center",
  value: "unitaryValue"
},
/*  {
   text: "Sub-Total",
   align: "center",
   sortable: false
 }, */
{
  text: "Vida Útil (mês)",
  align: "center",
  value: "lifetime"
},

/*  {
   text: "Valor Mensal",
   align: "center",
   value: "monthlyValue"
 }, */
{
  text: "Quantidade Aprovada",
  align: "center",
  sortable: false
}, {
  text: "Frequência de Envio (mês)",
  align: "center",
  value: "shippingFrequency"
}, {
  text: "Envio Automático",
  align: "center",
  value: "automaticShipping"
}];
var equipmentsHeaders = [{
  text: "Especificação / Descrição",
  align: "center",
  value: "description"
}, {
  text: "Marca / Modelo",
  align: "center",
  value: "stamp"
}, {
  text: "Quantidade Prevista",
  align: "center",
  value: "quantity"
}, {
  text: "Valor Unitário",
  align: "center",
  value: "unitaryValue"
},
/*   {
    text: "Sub-Total",
    align: "center",
    sortable: false
  }, */
{
  text: "Vida Útil (%)",
  align: "center",
  value: "lifetime"
},
/*  {
   text: "Valor Mensal",
   align: "center",
   value: "monthlyValue"
 }, */
{
  text: "Quantidade Aprovada",
  align: "center",
  sortable: false
}, {
  text: "Frequência de Envio (mês)",
  align: "center",
  value: "shippingFrequency"
}, {
  text: "Envio Automático",
  align: "center",
  value: "automaticShipping"
}];
var utencilHeaders = [{
  text: "Descrição / Especificação",
  align: "left",
  sortable: true,
  value: "description"
}, {
  text: "Unidade",
  align: "center",
  value: "unity"
}, {
  text: "Quantidade Prevista",
  align: "center",
  value: "quantity"
}, {
  text: "Valor Unitário",
  align: "center",
  value: "unitaryValue"
},
/*  {
   text: "Sub-Total",
   align: "center",
   sortable: false
 }, */
{
  text: "Vida Útil (mês)",
  align: "center",
  value: "lifetime"
},
/*   {
    text: "Valor Mensal",
    align: "center",
    value: "monthlyValue"
  }, */
{
  text: "Quantidade Aprovada",
  align: "center",
  value: "name",
  sortable: false
}, {
  text: "Frequência de Envio (mês)",
  align: "center",
  value: "shippingFrequency"
}, {
  text: "Envio Automático",
  align: "center",
  value: "automaticShipping"
}];
var uniformsAndEPIsHeaders = [{
  text: "Descrição / Especificação",
  align: "left",
  sortable: true,
  value: "description"
}, {
  text: "Unidade",
  align: "center",
  value: "unity"
}, {
  text: "Quantidade Prevista",
  align: "center",
  value: "quantity"
}, {
  text: "Valor Unitário",
  align: "center",
  value: "unitaryValue"
},
/*   {
    text: "Sub-Total",
    align: "center",
    sortable: false
  }, */
{
  text: "Vida Útil (mês)",
  align: "center",
  value: "lifetime"
},

/*  {
   text: "Valor Mensal",
   align: "center",
   value: "monthlyValue"
 }, */
{
  text: "Quantidade Aprovada",
  align: "center",
  value: "name",
  sortable: false
}, {
  text: "Frequência de Envio (mês)",
  align: "center",
  value: "shippingFrequency"
}, {
  text: "Envio Automático",
  align: "center",
  value: "automaticShipping"
}];
var supervisorHeaders = [{
  text: "Nome",
  align: "center",
  sortable: true,
  value: "name"

}, {
  text: "Função",
  align: "center",
  sortable: true,
  value: "role"
}, {
  text: "Telefone",
  align: "center",
  sortable: true,
  value: "phone"
}, {
  text: "Email",
  align: "center",
  sortable: true,
  value: "email"
}, {
  text: "Ações",
  align: "center",
  sortable: true,
  value: "actions"
}];

var Headers = function () {
  function Headers() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Headers);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Headers, null, [{
    key: "getHeaders",
    value: function getHeaders() {
      return headers;
    }
  }, {
    key: "getBudgetHeaders",
    value: function getBudgetHeaders() {
      return budgetHeaders;
    }
  }, {
    key: "getConsumablesHeaders",
    value: function getConsumablesHeaders() {
      return consumablesHeader;
    }
  }, {
    key: "getEquipamentHeaders",
    value: function getEquipamentHeaders() {
      return equipmentsHeaders;
    }
  }, {
    key: "getUtencilHeaders",
    value: function getUtencilHeaders() {
      return utencilHeaders;
    }
  }, {
    key: "getUniformsAndEPIsHeaders",
    value: function getUniformsAndEPIsHeaders() {
      return uniformsAndEPIsHeaders;
    }
  }, {
    key: "getSupervisorHeaders",
    value: function getSupervisorHeaders() {
      return supervisorHeaders;
    }
  }]);

  return Headers;
}();

/* harmony default export */ __webpack_exports__["a"] = (Headers);

/***/ }),
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_budget_Attachment__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_budget_TabHeader__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_budget_TabModule1__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_budget_TabModule2__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_budget_TabModule3__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_budget_TabModule4__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_budget_TabModule5__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_budget_TabModule6__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_budget_TabSummaryTable_vue__ = __webpack_require__(360);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// COMPONENTS //












/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Attachment: __WEBPACK_IMPORTED_MODULE_2__components_budget_Attachment__["a" /* default */],
    TabHeader: __WEBPACK_IMPORTED_MODULE_3__components_budget_TabHeader__["a" /* default */],
    TabModule1: __WEBPACK_IMPORTED_MODULE_4__components_budget_TabModule1__["a" /* default */],
    TabModule2: __WEBPACK_IMPORTED_MODULE_5__components_budget_TabModule2__["a" /* default */],
    TabModule3: __WEBPACK_IMPORTED_MODULE_6__components_budget_TabModule3__["a" /* default */],
    TabModule4: __WEBPACK_IMPORTED_MODULE_7__components_budget_TabModule4__["a" /* default */],
    TabModule5: __WEBPACK_IMPORTED_MODULE_8__components_budget_TabModule5__["a" /* default */],
    TabModule6: __WEBPACK_IMPORTED_MODULE_9__components_budget_TabModule6__["a" /* default */],
    TabSummaryTable: __WEBPACK_IMPORTED_MODULE_10__components_budget_TabSummaryTable_vue__["a" /* default */]
  },
  data: function data() {
    return {
      itemsTab: ["Formação de Preços", "Módulo 1", "Módulo 2", "Módulo 3", "Módulo 4", "Módulo 5", "Módulo 6", "Equipamentos", "Materiais de Consumo", "Uniformes e EPIs", "Utensílios", "Quadro Resumo"],
      tabOpen: 'tab-Formação de Preços'
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])({ analyticalWorksheet: function analyticalWorksheet(state) {
      return state.budget.analyticalWorksheet;
    } }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])({ budget: function budget(state) {
      return state.budget.budget;
    } })),
  created: function created() {
    var _this = this;

    this.$eventHub.$on("initTabs", function (_) {
      _this.tabOpen = 'tab-' + _this.itemsTab[0];
    });
  },

  methods: {
    /**
     * @returns {Boolean}
     */
    validateComponents: function validateComponents() {
      /* Aqui voce pode colocar os resultados das validacões e retornar para o budget  */
      return this.$refs.tab_header.startValidationInVForm(); //<--aqui ele chama o metodo do componente com ref="tab_header"
    }
  }
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__service_AnalyticalWorksheetService_js__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_Currency__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_headers_AttachmentHeaders__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__service_ModuleFiveService__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__service_ProductService_js__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_sheet_SheetDefaultData__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(60);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: "attachment",
  data: function data() {
    return {
      analyticalsOfBudget: [],
      bond: false,
      bonds: [],
      bondAlert: false,
      bondDialog: false,
      bondDialogTitle: "Vínculo de Anexo",
      bondSheet: {},
      bondSheetDescription: "",
      currency_config: __WEBPACK_IMPORTED_MODULE_6__utils_Currency__["a" /* default */].real,
      // TIPO de CÁLCULO //
      depreciation: "false",
      removeDialog: false,
      removeDialogTitle: "Excluir Item",
      dialog: false,
      emptyRecordsText: "Nenhum registro encontrado",
      emptySearchText: "Nenhuma registro encontrado para",
      headers: [],
      index: -1,
      inputRules: [function (v) {
        return !!v || 'Campo obrigatório';
      }],
      isEditing: false,
      loading: false,
      loadingRecordsText: "Carregando registros...",
      search: "",
      sheetBondId: null,
      show: false,
      selectedItems: [],
      snackbar: {
        visible: false,
        title: "",
        color: "",
        timeout: 6000
      },
      input: {},
      filteredInputs: [],
      unbondDialog: false,
      validForm: true
    };
  },
  props: {
    attachment: String,
    filter: String,
    inputsVariables: Object
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
    amountMonthly: function amountMonthly() {
      var amount = __WEBPACK_IMPORTED_MODULE_8__service_ModuleFiveService__["a" /* default */].getAmountMonthly(this.selectedItems, this.depreciation);

      return amount;
    },
    amountMonthlyByEmployee: function amountMonthlyByEmployee() {
      var amount = __WEBPACK_IMPORTED_MODULE_8__service_ModuleFiveService__["a" /* default */].getAmountMonthlyByEmployee(this.attachment, this.amountMonthly, this.numberOfEmployees);

      this.$store.commit('SET_AMOUNT_OF_' + this.attachment.toUpperCase() + '_BY_MONTH', { value: amount, employees: this.numberOfEmployees });
      return amount;
    },
    editingNotAllowed: function editingNotAllowed() {
      return this.inputsVariables && this.inputsVariables[this.attachment].has ? true : false;
    },
    footerDynamicText: function footerDynamicText() {
      return this.loading ? this.loadingRecordsText : this.emptyRecordsText;
    },
    formTitle: function formTitle() {
      return this.isEditing ? "Editar Item" : "Novo Item";
    },
    hasBond: function hasBond() {
      if (!this.bonds) return;
      for (var i = 0; i < this.bonds.length; i++) {
        if (this.bonds[i].moduleFive && this.bonds[i].moduleFive[this.attachment].bond === this.analyticalWorksheet._id) return true;
      }
      return false;
    },
    informations: function informations() {
      var informations = new Array();

      informations.push({
        class: 'xs12 ' + (this.attachment === 'uniformsAndEPIs' ? 'md6' : 'md4'),
        title: "Sub-Total",
        subtitle: "",
        value: this.subTotalOfAttachment
      });
      if (this.attachment != 'uniformsAndEPIs') {
        informations.push({
          class: "xs12 md4",
          title: "Total Mensal Estimado",
          subtitle: "",
          value: this.amountMonthly
        });
      }

      informations.push({
        show: true,
        class: 'xs12 ' + (this.attachment === 'uniformsAndEPIs' ? 'md6' : 'md4'),
        title: "Total Mensal por Empregado",
        subtitle: this.attachment != 'uniformsAndEPIs' ? 'Total de Empregados: ' + this.numberOfEmployees : "",
        value: this.amountMonthlyByEmployee
      });
      return informations;
    },
    labelDepreciation: function labelDepreciation() {
      if (this.depreciation == "false") return "Vida Útil (mês)";

      return "Taxa de Depreciação (%)";
    },
    moduleFive: function moduleFive() {
      if (this.analyticalWorksheet.moduleFive) return this.analyticalWorksheet.moduleFive;

      return __WEBPACK_IMPORTED_MODULE_10__data_sheet_SheetDefaultData__["a" /* default */].getModuleFive();
    },
    numberOfEmployees: function numberOfEmployees() {
      return __WEBPACK_IMPORTED_MODULE_8__service_ModuleFiveService__["a" /* default */].getNumberOfEmployees(this.bonds);
    },
    subTotalOfAttachment: function subTotalOfAttachment() {
      return __WEBPACK_IMPORTED_MODULE_8__service_ModuleFiveService__["a" /* default */].getSubTotalOfAttachment(this.selectedItems);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_11_vuex__["c" /* mapState */])({ analyticalWorksheet: function analyticalWorksheet(state) {
      return state.budget.analyticalWorksheet;
    } }), Object(__WEBPACK_IMPORTED_MODULE_11_vuex__["c" /* mapState */])({ budgetFinalized: function budgetFinalized(state) {
      return state.budget.budgetFinalized;
    } })),

  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.depreciation = "false";
              _context.next = 3;
              return _this.getBonds();

            case 3:
              _this.bonds = _context.sent;

              _this.initialize();

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.getHeaders();

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },

  methods: {
    amountCalculate: function amountCalculate(item) {
      return __WEBPACK_IMPORTED_MODULE_8__service_ModuleFiveService__["a" /* default */].amountCalculate(item, this.depreciation);
    },
    checkDuplicateRecord: function checkDuplicateRecord() {
      if (this.selectedItems.length > 0) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.selectedItems), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var inp = _step.value;

            if (inp._id == this.input._id) return false;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      return true;
    },
    confirmBond: function confirmBond() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var savedSheet;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.bonds = new Array();
                _this3.moduleFive[_this3.attachment].items = new Array();
                _this3.moduleFive[_this3.attachment].bond = _this3.sheetBondId;
                _context3.prev = 3;
                _context3.next = 6;
                return __WEBPACK_IMPORTED_MODULE_5__service_AnalyticalWorksheetService_js__["a" /* default */].edit(_this3.analyticalWorksheet);

              case 6:
                savedSheet = _context3.sent;
                _context3.next = 9;
                return _this3.$store.commit("SET_ANALYTICAL_WORKSHEET", savedSheet.dataEdited);

              case 9:
                _context3.next = 11;
                return _this3.getBonds();

              case 11:
                _this3.bonds = _context3.sent;
                _context3.next = 17;
                break;

              case 14:
                _context3.prev = 14;
                _context3.t0 = _context3['catch'](3);

                console.log(_context3.t0);

              case 17:
                _context3.prev = 17;

                _this3.bondDialog = false;
                _this3.sheetBondId = "";
                return _context3.finish(17);

              case 21:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[3, 14, 17, 21]]);
      }))();
    },
    deleteItem: function deleteItem() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this4.loading || _this4.budgetFinalized)) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt('return');

              case 2:
                try {
                  _this4.loading = true;
                  _this4.selectedItems.splice(_this4.selectedItems.indexOf(_this4.input), 1);
                  _this4.showAlert("Item excluído com sucesso!!!", "success");
                } catch (error) {
                  _this4.showAlert("Erro ao excluir este item!!!", "error");
                  console.log(error);
                } finally {
                  _this4.loading = false;
                  _this4.removeDialog = false;
                  _this4.initialize();
                  _this4.$refs.form.resetValidation();
                }

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    editItem: function editItem(item) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!_this5.loading) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt('return');

              case 2:
                try {
                  _this5.loading = true;
                  _this5.isEditing = true;
                  _this5.show = true;
                  _this5.index = _this5.selectedItems.indexOf(item);
                  _this5.input = _this5.selectedItems[_this5.selectedItems.indexOf(item)];
                  _this5.dialog = true;
                } catch (error) {
                  console.log(error);
                } finally {
                  _this5.loading = false;
                }

              case 3:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    getBonds: function getBonds() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var sheetBondId;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                sheetBondId = _this6.moduleFive[_this6.attachment].bond ? _this6.moduleFive[_this6.attachment].bond : _this6.analyticalWorksheet._id;
                _context6.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__service_AnalyticalWorksheetService_js__["a" /* default */].getBonds(sheetBondId, _this6.attachment);

              case 3:
                return _context6.abrupt('return', _context6.sent);

              case 4:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    getHeaders: function getHeaders() {
      this.headers = __WEBPACK_IMPORTED_MODULE_7__data_headers_AttachmentHeaders__["a" /* default */].getHeaders();
    },
    getSelectedItems: function getSelectedItems() {
      if (!this.bonds) return new Array();

      this.depreciation = this.moduleFive[this.attachment].depreciation.toString();

      this.bondAlert = false;
      var selectedItems = new Array();
      for (var i = 0; i < this.bonds.length; i++) {
        if (!this.bonds[i].moduleFive) continue;
        if (this.bonds[i].moduleFive[this.attachment].items.length > 0) {
          selectedItems = this.bonds[i].moduleFive[this.attachment].items;
          if (this.bonds[i]._id != this.analyticalWorksheet._id) {
            this.bondSheetDescription = this.bonds[i].header.professionalCategory.occupation.name + ' ' + this.bonds[i].header.additionalInfo + ' - ' + this.bonds[i].header.deliveryAddress.sector;
            this.bondAlert = true;
          }
        }
      }
      return selectedItems;
    },
    initialize: function initialize() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this7.loading = true;
                _context7.prev = 1;

                _this7.input = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({});
                _context7.next = 5;
                return __WEBPACK_IMPORTED_MODULE_9__service_ProductService_js__["a" /* default */].getByCategory({
                  type: _this7.filter
                });

              case 5:
                _this7.filteredInputs = _context7.sent;

                _this7.isEditing = false;
                _context7.next = 12;
                break;

              case 9:
                _context7.prev = 9;
                _context7.t0 = _context7['catch'](1);

                console.log(_context7.t0);

              case 12:
                _context7.prev = 12;

                _this7.loading = false;
                return _context7.finish(12);

              case 15:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7, [[1, 9, 12, 15]]);
      }))();
    },
    openBondDialog: function openBondDialog() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var sheets, i;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;

                _this8.analyticalsOfBudget = new Array();

                _context8.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5__service_AnalyticalWorksheetService_js__["a" /* default */].findByBudgetId(_this8.analyticalWorksheet.budget);

              case 4:
                sheets = _context8.sent;
                i = 0;

              case 6:
                if (!(i < sheets.length)) {
                  _context8.next = 21;
                  break;
                }

                if (!(sheets[i]._id === _this8.analyticalWorksheet._id)) {
                  _context8.next = 11;
                  break;
                }

                return _context8.abrupt('continue', 18);

              case 11:
                if (!(sheets[i].moduleFive && sheets[i].moduleFive[_this8.attachment] && sheets[i].moduleFive[_this8.attachment].bond)) {
                  _context8.next = 15;
                  break;
                }

                return _context8.abrupt('continue', 18);

              case 15:
                if (!(sheets[i].header.unitOfMeasurement != _this8.analyticalWorksheet.header.unitOfMeasurement)) {
                  _context8.next = 17;
                  break;
                }

                return _context8.abrupt('continue', 18);

              case 17:
                _this8.analyticalsOfBudget.push(sheets[i]);

              case 18:
                i++;
                _context8.next = 6;
                break;

              case 21:
                _context8.next = 26;
                break;

              case 23:
                _context8.prev = 23;
                _context8.t0 = _context8['catch'](0);

                console.log(_context8.t0);

              case 26:
                _context8.prev = 26;

                _this8.bondDialog = true;
                return _context8.finish(26);

              case 29:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this8, [[0, 23, 26, 29]]);
      }))();
    },
    openRemoveDialog: function openRemoveDialog(item) {
      this.input = item;
      this.removeDialog = true;
    },
    save: function save() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var type, message;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!_this9.budgetFinalized) {
                  _context9.next = 2;
                  break;
                }

                return _context9.abrupt('return');

              case 2:
                if (_this9.$refs.form.validate()) {
                  _context9.next = 4;
                  break;
                }

                return _context9.abrupt('return');

              case 4:
                if (!_this9.loading) {
                  _context9.next = 6;
                  break;
                }

                return _context9.abrupt('return');

              case 6:
                _this9.loading = true;
                type = "success";
                message = "";

                try {
                  if (_this9.isEditing) {
                    _this9.loading = true;
                    _this9.selectedItems[_this9.index] = _this9.input;
                    message = "Item alterado com sucesso";
                  } else {
                    if (_this9.checkDuplicateRecord()) {
                      _this9.selectedItems.push(_this9.input);
                      message = "Item salvo com sucesso";
                    } else {
                      message = "Item já adicionado";
                      type = "warning";
                    }
                  }
                  _this9.showAlert(message, type);
                  _this9.loading = true;
                } catch (error) {
                  _this9.showAlert("Erro ao salvar este item", "error");
                  console.log(error);
                } finally {
                  _this9.dialog = false;
                  _this9.initialize();
                  _this9.loading = false;
                  _this9.input = {};
                  _this9.$refs.form.resetValidation();
                }

              case 10:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this9);
      }))();
    },
    setSheetModuleFive: function setSheetModuleFive() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var sheet;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                sheet = _this10.$store.getters.getAnalyticalWorksheet;

                if (!(sheet.moduleFive != _this10.moduleFive)) {
                  _context10.next = 5;
                  break;
                }

                sheet.moduleFive = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this10.moduleFive);
                _context10.next = 5;
                return _this10.$store.commit("SET_ANALYTICAL_WORKSHEET", sheet);

              case 5:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this10);
      }))();
    },
    // setSheetModuleFive() //
    showAlert: function showAlert(message, color) {
      this.snackbar.title = message;
      this.snackbar.color = color;
      this.snackbar.visible = true;
    },
    //showAlert()
    textDescription: function textDescription(item) {
      return item.description + ' - ' + item.stamp + ' - ' + item.unity;
    },
    unbond: function unbond() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var savedSheet;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this11.moduleFive[_this11.attachment].items = new Array();
                _this11.moduleFive[_this11.attachment].bond = null;
                _context11.prev = 2;
                _context11.next = 5;
                return __WEBPACK_IMPORTED_MODULE_5__service_AnalyticalWorksheetService_js__["a" /* default */].edit(_this11.analyticalWorksheet);

              case 5:
                savedSheet = _context11.sent;
                _context11.next = 8;
                return _this11.$store.commit("SET_ANALYTICAL_WORKSHEET", savedSheet.dataEdited);

              case 8:
                _context11.next = 10;
                return _this11.getBonds();

              case 10:
                _this11.bonds = _context11.sent;
                _context11.next = 16;
                break;

              case 13:
                _context11.prev = 13;
                _context11.t0 = _context11['catch'](2);

                console.log(_context11.t0);

              case 16:
                _context11.prev = 16;

                _this11.unbondDialog = false;
                _this11.bondAlert = false;
                return _context11.finish(16);

              case 20:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this11, [[2, 13, 16, 20]]);
      }))();
    }
  },
  watch: {
    bonds: {
      handler: function handler() {
        if (!this.bonds) this.selectedItems = [];

        this.selectedItems = this.getSelectedItems();
      },
      deep: true
    },
    depreciation: {
      handler: function handler() {
        this.headers[5].text = this.depreciation == "true" ? "Taxa de Depreciação (%)" : "Vida Útil (mês)";
        this.moduleFive[this.attachment].depreciation = this.depreciation;
      },
      deep: true
    },
    moduleFive: {
      handler: function handler() {
        this.setSheetModuleFive();
      },
      deep: true
    },
    selectedItems: {
      handler: function handler() {
        if (!this.moduleFive[this.attachment].bond) this.moduleFive[this.attachment].items = this.selectedItems;
      },
      deep: true
    }
  }
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_budget_FormCity__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_budget_FormProfessionalCategory__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_sheet_SheetDefaultData__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__service_CityService_js__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__service_CollectiveConventionService_js__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__service_OfficceService_js__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_UtilFormatter_js__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_RulesToForms__ = __webpack_require__(340);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//Components


//Data

//Libs

//Services



//Utils


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FormProfessionalCategory: __WEBPACK_IMPORTED_MODULE_5__components_budget_FormProfessionalCategory__["a" /* default */],
    FormCity: __WEBPACK_IMPORTED_MODULE_4__components_budget_FormCity__["a" /* default */]
  },
  data: function data() {
    return {
      agreementsYear: [],
      agreementsYearSelectedItems: [],
      allowChange: true,
      cities: [],
      formValid: true,
      isSearchingAddress: false,
      offices: [],
      ruleGeneric: [__WEBPACK_IMPORTED_MODULE_12__utils_RulesToForms__["a" /* default */].ruleToCheckIfTheValuesInTheFields],
      snackbar: {
        visible: false,
        title: "",
        subtitle: "",
        color: "",
        timeout: 6000
      },
      showDialogAddNewCity: false,
      showDialogAddNewFunction: false,
      showDialogAddNewProfessionalCategory: false,
      unitsOfMeasurement: ["Posto de Serviço", "M²"],
      utilFormatter: __WEBPACK_IMPORTED_MODULE_11__utils_UtilFormatter_js__["a" /* default */]
    };
  },


  methods: {
    buttonAddNewCity: function buttonAddNewCity() {
      this.showDialogAddNewCity = true;
    },
    //buttonAddNewCity()*/
    // AÇÕES DE BOTÕES QUE CHAMAM COMPONENTES //
    buttonAddNewFunction: function buttonAddNewFunction() {
      this.showDialogAddNewFunction = true;
    },
    //buttonAddNewFunction()
    buttonAddNewProfessionalCategory: function buttonAddNewProfessionalCategory() {
      this.showDialogAddNewProfessionalCategory = true;
    },
    //buttonAddNewProfessionalCategory()*/
    changeCollectiveConvention: function changeCollectiveConvention(collectiveConvention) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var j, element;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.header.collectiveConvention) _this.agreementsYearSelectedItems = new Array();

                _this.agreementsYearSelectedItems = collectiveConvention.items;

                _this.header.minimalSalary = collectiveConvention.minimalSalary;
                _this.header.dataBaseOfTheCategory = _this.utilFormatter.formatDateUS(collectiveConvention.dataBaseOfTheCategory.substr(0, 10));
                for (j = 0; j < collectiveConvention.items.length; j++) {
                  element = collectiveConvention.items[j];

                  if (_this.header.professionalCategory.occupation.code === element.occupation.code) {
                    _this.header.professionalCategory.basicSalary = element.basicSalary;
                    _this.header.professionalCategory.costs = element.costs;
                    j = collectiveConvention.items.length;
                  }
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    changeOfficces: function changeOfficces() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_10__service_OfficceService_js__["a" /* default */].getAll();

              case 3:
                _this2.offices = _context2.sent;

                _this2.offices.sort();
                _context2.next = 9;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 7]]);
      }))();
    },
    //changeOfficces()

    changeSector: function changeSector() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var deliveryAddress;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this3.sectorType == "SEDE") {
                  _this3.header.deliveryAddress = _this3.sedeAddress();
                } else {
                  deliveryAddress = {
                    sectorType: "OTHER",
                    cityOfService: {},
                    complement: "",
                    district: "",
                    number: "",
                    addressType: "",
                    cep: "",
                    sector: ""
                  };


                  _this3.header.deliveryAddress = deliveryAddress;
                }

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },

    cityText: function cityText(item) {
      return item.name + " - " + item.state + " (" + item.uf + ")";
    },
    findAddressByCep: function findAddressByCep() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var address, founded;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                if (!(_this4.header.deliveryAddress.cep && _this4.header.deliveryAddress.cep.length == 8)) {
                  _context4.next = 8;
                  break;
                }

                _this4.isSearchingAddress = true;
                _context4.next = 5;
                return UtilService.findAddressByCep(_this4.header.deliveryAddress.cep);

              case 5:
                address = _context4.sent;
                founded = _this4.cities.find(function (x) {
                  return x.name == address.city;
                });


                if (founded) {
                  _this4.header.deliveryAddress.addressType = address.addressType;
                  _this4.header.deliveryAddress.number = address.number;
                  _this4.header.deliveryAddress.complement = address.complement;
                  _this4.header.deliveryAddress.district = address.district;
                  _this4.header.deliveryAddress.cityOfService = founded;
                } else {
                  _this4.snackbar.color = "error";
                  _this4.snackbar.title = "Cidade não cadastrada!";
                  _this4.snackbar.subtitle = "Cadastre-a antes de continuar";
                  _this4.snackbar.visible = true;
                  _this4.snackbar.timeout = 500000;
                  _this4.header.deliveryAddress.cep = "";
                  _this4.header.deliveryAddress.number = "";
                  _this4.header.deliveryAddress.complement = "";
                  _this4.header.deliveryAddress.district = "";
                  _this4.header.deliveryAddress.cityOfService = "";
                  _this4.header.deliveryAddress.addressType = "";
                }

              case 8:
                _context4.next = 17;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](0);

                _this4.snackbar.color = "error";
                _this4.snackbar.title = "CEP inválido!";
                _this4.snackbar.subtitle = "Repita a operação";
                _this4.snackbar.timeout = 6000;
                _this4.snackbar.visible = true;

              case 17:
                _context4.prev = 17;

                _this4.isSearchingAddress = false;
                return _context4.finish(17);

              case 20:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 10, 17, 20]]);
      }))();
    },
    init: function init() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this5.fillCitiesTable();

              case 2:
                _context5.next = 4;
                return _this5.fillAgreementsData();

              case 4:
                _context5.next = 6;
                return _this5.fillAgreementsYear();

              case 6:
                _context5.next = 8;
                return _this5.changeOfficces();

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    //init()

    fillAgreementsYear: function fillAgreementsYear() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__service_CollectiveConventionService_js__["a" /* default */].getAll();

              case 3:
                _this6.agreementsYear = _context6.sent;
                _context6.next = 9;
                break;

              case 6:
                _context6.prev = 6;
                _context6.t0 = _context6["catch"](0);

                console.log(_context6.t0);

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[0, 6]]);
      }))();
    },
    fillAgreementsData: function fillAgreementsData() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var selected;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (_this7.header.collectiveConvention) {
                  _context7.next = 4;
                  break;
                }

                _this7.agreementsYearSelectedItems = new Array();
                _context7.next = 8;
                break;

              case 4:
                _context7.next = 6;
                return __WEBPACK_IMPORTED_MODULE_9__service_CollectiveConventionService_js__["a" /* default */].getById(_this7.header.collectiveConvention);

              case 6:
                selected = _context7.sent;


                if (selected) {
                  _this7.agreementsYearSelectedItems = selected.items;
                } else {
                  _this7.agreementsYearSelectedItems = new Array();
                }

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    fillCitiesTable: function fillCitiesTable() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return __WEBPACK_IMPORTED_MODULE_8__service_CityService_js__["a" /* default */].getAll();

              case 3:
                _this8.cities = _context8.sent;
                _context8.next = 9;
                break;

              case 6:
                _context8.prev = 6;
                _context8.t0 = _context8["catch"](0);

                console.log(_context8.t0);

              case 9:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this8, [[0, 6]]);
      }))();
    },
    findCityByNameAndState: function findCityByNameAndState(address) {
      for (var i = 0; i < this.cities.length; i++) {
        if (address.city.toUpperCase() == this.cities[i].name.toUpperCase() && address.state.toUpperCase() == this.cities[i].uf.toUpperCase()) {
          return this.cities[i];
        }
      }
    },


    occupationName: function occupationName(item) {
      return "" + item.occupation.name;
    },
    sedeAddress: function sedeAddress() {
      var address = { sectorType: "SEDE", sector: "SEDE" };
      if (this.budget && this.budget.client && this.budget.client.address) {

        address.cityOfService = this.findCityByNameAndState(this.budget.client.address);
        address.complement = this.budget.client.address.complement;
        address.district = this.budget.client.address.district;
        address.number = this.budget.client.address.number;
        address.addressType = this.budget.client.address.addressType;
        address.cep = this.budget.client.address.cep;
      } else {
        var _address = { sectorType: "OTHER", sector: "Outro" };
      }

      return address;
    },
    setSheetHeader: function setSheetHeader() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var sheet;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                sheet = _this9.analyticalWorksheet;

                if (!(sheet.header != _this9.header)) {
                  _context9.next = 5;
                  break;
                }

                sheet.header = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this9.header);
                _context9.next = 5;
                return _this9.$store.commit("SET_ANALYTICAL_WORKSHEET", sheet);

              case 5:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this9);
      }))();
    },


    /**
     * @returns {Boolean}
     */
    startValidationInVForm: function startValidationInVForm() {
      /* 
        O metodo validate() do v-form percorre em seus campos internos
        e verifica se aqueles que possuem rules cumprem com o esperado.
        Esse metodo retorna um boolean de acordo com o resultado das
        validaçẽos e se houver falhas ele pinta o campo
      */
      return this.$refs.form.validate();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    hasServiceStationGratification: function hasServiceStationGratification() {
      return this.analyticalWorksheet.moduleOne && this.analyticalWorksheet.moduleOne.serviceStationGratification && this.analyticalWorksheet.moduleOne.serviceStationGratification.length > 0;
    },
    header: function header() {
      this.init();
      var headerDefault = __WEBPACK_IMPORTED_MODULE_6__data_sheet_SheetDefaultData__["a" /* default */].getHeader();

      if (!this.analyticalWorksheet.header.professionalCategory) this.analyticalWorksheet.header.professionalCategory = headerDefault.professionalCategory;

      if (!this.analyticalWorksheet.header.deliveryAddress || this.analyticalWorksheet.header.deliveryAddress.sectorType === "") {
        this.analyticalWorksheet.header.deliveryAddress = this.sedeAddress();
      }

      this.sectorType = this.analyticalWorksheet.header.deliveryAddress && this.analyticalWorksheet.header.deliveryAddress.sectorType ? this.analyticalWorksheet.header.deliveryAddress.sectorType : null;

      return this.analyticalWorksheet.header;
    },
    informations: function informations() {
      return [{
        class: "xs12 md6",
        title: "Salário Mínimimo Nacional",
        subtitle: "De acordo com a Convenção Coletiva Cadastrada",
        value: this.header.minimalSalary
      }, {
        class: "xs12 md6",
        title: "Salário Normativo da Categoria Profissional",
        subtitle: "De acordo com a Convenção Coletiva Cadastrada",
        value: this.header.professionalCategory.basicSalary
      }];
    },
    msgCollectiveConvention: function msgCollectiveConvention() {
      return this.hasServiceStationGratification ? "Remova os adicionais de posto de serviço caso deseje alterar" : "";
    },
    professionalCategoryHint: function professionalCategoryHint() {
      return this.header.professionalCategory && this.header.professionalCategory.occupation && this.header.professionalCategory.occupation.code ? "CBO: " + this.header.professionalCategory.occupation.code.substring(0, 4) + "-" + this.header.professionalCategory.occupation.code.substring(4, 6) : "CBO:";
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapState */])({ analyticalWorksheet: function analyticalWorksheet(state) {
      return state.budget.analyticalWorksheet;
    } }), Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapState */])({ budget: function budget(state) {
      return state.budget.budget;
    } }), Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapState */])({ budgetFinalized: function budgetFinalized(state) {
      return state.budget.budgetFinalized;
    } })),
  beforeMount: function beforeMount() {
    this.init();
  },
  created: function created() {

    // Salvando instancia deste componente
    var thiss = this;

    // Gerando os listeners para EventHub //
    // FUNCTION

    this.$eventHub.$on("cancelDialogAddNewFunction", function (_) {
      thiss.showDialogAddNewFunction = false;
    });

    this.$eventHub.$on("savedNewFunction", function (_) {
      thiss.offices = [];
      thiss.changeOfficces();
      thiss.showDialogAddNewFunction = false;
    });

    //this.$ref.product
    // PROFESSIONAL CATEGORY
    this.$eventHub.$on("cancelDialogAddNewOccupation", function (_) {
      thiss.showDialogAddNewProfessionalCategory = false;
    });

    this.$eventHub.$on("savedNewOccupation", function (_) {
      thiss.showDialogAddNewProfessionalCategory = false;
    });

    this.$eventHub.$on("savedNewCity", function (_) {
      thiss.fillCitiesTable();
      thiss.showDialogAddNewCity = false;
      thiss.snackbar.color = "success";
      thiss.snackbar.title = "Cidade Cadastrada com Sucesso";
      thiss.snackbar.subtitle = "";
      thiss.snackbar.timeout = 6000;
      thiss.snackbar.visible = true;
    });

    this.$eventHub.$on("newCityNotSaved", function (_) {
      thiss.fillCitiesTable();
      thiss.showDialogAddNewCity = false;
      thiss.snackbar.color = "error";
      thiss.snackbar.title = "Não foi possível realizar essa operação!";
      thiss.snackbar.subtitle = "Tente Novamente";
      thiss.snackbar.timeout = 500000;
      thiss.snackbar.visible = true;
    });

    this.$eventHub.$on("cancelDialogAddNewCity", function (_) {
      thiss.fillCitiesTable();
      thiss.showDialogAddNewCity = false;
    });
  },
  //created

  watch: {
    header: {
      handler: function handler(newValue, oldValue) {
        this.setSheetHeader();
      },
      deep: true
    },

    'header.collectiveConvention': {
      handler: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee10(newValue, oldValue) {
          var convention;
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  console.log(this.allowChange);

                  if (this.allowChange) {
                    _context10.next = 4;
                    break;
                  }

                  this.allowChange = true;
                  return _context10.abrupt("return");

                case 4:
                  if (!(newValue && newValue != oldValue)) {
                    _context10.next = 15;
                    break;
                  }

                  _context10.next = 7;
                  return __WEBPACK_IMPORTED_MODULE_9__service_CollectiveConventionService_js__["a" /* default */].getById(newValue);

                case 7:
                  convention = _context10.sent;

                  if (!confirm("Os valores finais das funções serão alterados com base na nova convenção")) {
                    _context10.next = 12;
                    break;
                  }

                  this.changeCollectiveConvention(convention);
                  _context10.next = 15;
                  break;

                case 12:
                  this.header.collectiveConvention = oldValue;
                  this.allowChange = false;
                  return _context10.abrupt("return");

                case 15:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10, this);
        }));

        function handler(_x, _x2) {
          return _ref.apply(this, arguments);
        }

        return handler;
      }(),
      deep: true
    }
  }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_budget_FormSetConventionItem__ = __webpack_require__(335);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// SERVICES //

// COMPONENTS //


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FormSetConventionItem: __WEBPACK_IMPORTED_MODULE_2__components_budget_FormSetConventionItem__["a" /* default */]
  },

  props: {
    yearConventionSelected: {}
  },

  data: function data() {
    return {
      occupation: {},
      occupationSaved: "",
      checkbox: false,
      showDialogSetConventionItem: false
    };
  }, //data()

  methods: {
    init: function init() {
      this.occupation = {};
      this.checkbox = false;
      this.showDialogSetConventionItem = false;
    },
    //init()
    save: function save() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$eventHub.$emit("savedNewOccupation");

              case 3:
                if (!_this.checkbox) {
                  _context.next = 9;
                  break;
                }

                _this.occupationSaved = _this.occupation.data.description;
                _context.next = 7;
                return _this.yearConventionSelected;

              case 7:
                _this.yearConventionSelected = _context.sent;

                _this.showDialogSetConventionItem = true;

              case 9:
                _context.next = 13;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 11]]);
      }))();
    },
    //save()

    cancel: function cancel() {
      this.init();
      this.$eventHub.$emit("cancelDialogAddNewOccupation");
    } //cancel()

  }, //methods

  created: function created() {
    var _this2 = this;

    this.init();

    var thiss = this;

    thiss.$eventHub.$on("cancelDialogSetConventionItem", function (_) {
      _this2.init();
      thiss.showDialogSetConventionItem = false;
    });
  } //created

});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_CollectiveConventionService_js__ = __webpack_require__(203);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// SERVICES //


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    yearConventionSelected: {},
    occupationSelected: ""
  },

  data: function data() {
    return {
      convention: {},
      item: {},
      occupations: []
    };
  }, //data()

  methods: {
    init: function init() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.item = {};

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    //init()

    changeOccupations: function changeOccupations() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                try {
                  _this2.occupations = [];
                } catch (error) {}
                _this2.setConvention();

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    //changeOccupations()

    setConvention: function setConvention() {
      this.convention = this.yearConventionSelected;
    },
    //setConvention()

    setObject: function setObject() {
      this.item.occupation = this.occupationSelected;
    },
    //setObject()

    save: function save() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.setObject();
                _this3.convention.items.push(_this3.item);
                try {
                  __WEBPACK_IMPORTED_MODULE_2__service_CollectiveConventionService_js__["a" /* default */].edit(_this3.convention);
                } catch (error) {}

                _this3.cancel();

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    //save()

    cancel: function cancel() {
      this.$eventHub.$emit("cancelDialogSetConventionItem");
    } //cancel()

  }, //methods

  created: function created() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this4.init();

              _this4.$eventHub.$on("savedNewOccupation", function (_) {
                _this4.changeOccupations();
              });

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  } //created

});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__service_CollectiveConventionService_js__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_Currency__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__service_ModuleOneService__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_sheet_SheetDefaultData__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(60);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// BIBLIOTECAS //






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      currency_config: __WEBPACK_IMPORTED_MODULE_5__utils_Currency__["a" /* default */].real,
      currency_config_percent: __WEBPACK_IMPORTED_MODULE_5__utils_Currency__["a" /* default */].percent,
      // ADICIONAL NOTURNO //
      worksJournies: [{
        value: 200,
        text: "200 horas"
      }, {
        value: 220,
        text: "220 horas"
      }],
      // HORA EXTRA //
      serviceStationGratification: []
    };
  },

  methods: {
    addBenefit: function addBenefit() {
      if (!this.moduleOne.others) this.moduleOne.others = new Array();

      this.moduleOne.others.push({
        description: "",
        value: 0
      });
    },
    checkNocturneAdditional: function checkNocturneAdditional() {
      this.moduleOne.additionalNocturne.has ? false : true;

      if (!this.moduleOne.additionalNocturne.has) {
        // se não tiver adicional noturno zera todas as variáveis possíveis usadas para e como cálculo
        this.moduleOne.additionalNocturne = { has: false, workedHours: 0, workJournie: 0, percent: 0 };
      }
    },
    checkExtraHours: function checkExtraHours() {
      this.moduleOne.extraHour.has ? false : true;

      if (!this.moduleOne.extraHour.has) {
        this.moduleOne.extraHour = { has: false, workJournie: 0, hours50: 0, hours75: 0, hours100: 0 };
        this.moduleOne.dsr = { sundayDays: 0, workingDays: 0 };
      }
    },
    getServiceStationGratifications: function getServiceStationGratifications() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var convention;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.sheetHeader.collectiveConvention) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return', []);

              case 2:
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__service_CollectiveConventionService_js__["a" /* default */].getById(_this.sheetHeader.collectiveConvention);

              case 4:
                convention = _context.sent;

                _this.serviceStationGratification = convention ? convention.serviceStations : [];

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    // getServiceStationGratifications() //
    removeBenefit: function removeBenefit(item) {
      this.moduleOne.others.splice(this.moduleOne.others.indexOf(item), 1);
    },
    setSheetModuleOne: function setSheetModuleOne() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var sheet;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                sheet = _this2.$store.getters.getAnalyticalWorksheet;

                if (!(sheet.moduleOne != _this2.moduleOne)) {
                  _context2.next = 5;
                  break;
                }

                sheet.moduleOne = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this2.moduleOne);
                _context2.next = 5;
                return _this2.$store.commit("SET_ANALYTICAL_WORKSHEET", sheet);

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    additionalDangerValue: function additionalDangerValue() {
      // sobre Salário Base CCT
      return __WEBPACK_IMPORTED_MODULE_6__service_ModuleOneService__["a" /* default */].getAdditionalDanger(this.sheetHeader.professionalCategory.basicSalary, this.moduleOne);
    },
    additionalHealthValue: function additionalHealthValue() {
      // sobre Salário Mínimo
      return __WEBPACK_IMPORTED_MODULE_6__service_ModuleOneService__["a" /* default */].getAdditionalHealth(this.sheetHeader.minimalSalary, this.moduleOne);
    },
    dsrValue: function dsrValue() {
      return __WEBPACK_IMPORTED_MODULE_6__service_ModuleOneService__["a" /* default */].getDSR(this.extraHourValue, this.moduleOne.dsr, this.moduleOne.extraHour.has);
    },
    extraHourValue: function extraHourValue() {
      return __WEBPACK_IMPORTED_MODULE_6__service_ModuleOneService__["a" /* default */].getExtraHour(this.remunarationBaseValue, this.serviceStationGratificationValue, this.moduleOne.extraHour);
    },
    functionGratificationValue: function functionGratificationValue() {
      return __WEBPACK_IMPORTED_MODULE_6__service_ModuleOneService__["a" /* default */].getFunctionGratification(this.sheetHeader.professionalCategory);
    },
    hours100Hint: function hours100Hint() {
      return this.normalHour * 2.00 * this.moduleOne.extraHour.hours100;
    },
    hours50Hint: function hours50Hint() {
      return this.normalHour * 1.5 * this.moduleOne.extraHour.hours50;
    },
    hours75Hint: function hours75Hint() {
      return this.normalHour * 1.75 * this.moduleOne.extraHour.hours75;
    },
    informations: function informations() {
      return [{
        class: "xs12 sm6 md3",
        title: "Salário Mínimo",
        subtitle: "De acordo com a CCT cadastrada",
        value: this.sheetHeader.minimalSalary
      }, {
        class: "xs12 sm6 md3",
        title: "Salário da Convenção Coletiva",
        subtitle: "De acordo com a CCT Cadastrada",
        value: this.sheetHeader.professionalCategory.basicSalary
      }, {
        class: "xs12 sm6 md3",
        title: "Gratificação de Função",
        subtitle: "De acordo com a CCT Cadastrada",
        value: this.functionGratificationValue
      }, {
        class: "xs12 sm6 md3",
        title: "Gratificação por Posto de Serviço",
        subtitle: "De acordo com a Seleção abaixo",
        value: this.serviceStationGratificationValue
      }, {
        class: "xs12",
        title: "Total da Remuneração",
        subtitle: "Soma dos itens",
        value: this.remunerationValue
      }];
    },
    moduleOne: function moduleOne() {
      this.getServiceStationGratifications();
      if (this.analyticalWorksheet.moduleOne) return this.analyticalWorksheet.moduleOne;

      return __WEBPACK_IMPORTED_MODULE_7__data_sheet_SheetDefaultData__["a" /* default */].getModuleOne();
    },
    nocturneAdditionalValue: function nocturneAdditionalValue() {
      return __WEBPACK_IMPORTED_MODULE_6__service_ModuleOneService__["a" /* default */].getNocturneAdditional(this.remunarationBaseValue, this.moduleOne.additionalNocturne);
    },
    nocturneNormalHourAddPercentHint: function nocturneNormalHourAddPercentHint() {
      return this.nocturneNormalHourValue + this.nocturneNormalHourValue * this.moduleOne.additionalNocturne.percent / 100;
    },
    nocturneNormalHourValue: function nocturneNormalHourValue() {
      return __WEBPACK_IMPORTED_MODULE_6__service_ModuleOneService__["a" /* default */].getNocturneNormalHour(this.remunarationBaseValue, this.moduleOne.additionalNocturne);
    },
    normalHour: function normalHour() {
      return __WEBPACK_IMPORTED_MODULE_6__service_ModuleOneService__["a" /* default */].getNormalHour(this.remunarationBaseValue, this.serviceStationGratificationValue, this.moduleOne.extraHour);
    },
    othersValue: function othersValue() {
      return __WEBPACK_IMPORTED_MODULE_6__service_ModuleOneService__["a" /* default */].getOthers(this.moduleOne.others);
    },
    remunarationBaseValue: function remunarationBaseValue() {
      return __WEBPACK_IMPORTED_MODULE_6__service_ModuleOneService__["a" /* default */].getRemunerationBase(this.sheetHeader);
    },
    remunerationValue: function remunerationValue() {
      var amount = __WEBPACK_IMPORTED_MODULE_6__service_ModuleOneService__["a" /* default */].getAmountOfModuleOne(this.sheetHeader, this.moduleOne);
      this.$store.commit("SET_AMOUNT_OF_MODULE_ONE", amount);
      return amount;
    },
    serviceStationGratificationValue: function serviceStationGratificationValue() {
      return __WEBPACK_IMPORTED_MODULE_6__service_ModuleOneService__["a" /* default */].getServiceStationGratification(this.moduleOne.serviceStationGratification);
    },
    sheetHeader: function sheetHeader() {
      return this.analyticalWorksheet.header;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapState */])({ analyticalWorksheet: function analyticalWorksheet(state) {
      return state.budget.analyticalWorksheet;
    } }), Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapState */])({ amountOfModuleOne: function amountOfModuleOne(state) {
      return state.budget.amountOfModuleOne;
    } }), Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapState */])({ budgetFinalized: function budgetFinalized(state) {
      return state.budget.budgetFinalized;
    } })),
  watch: {
    moduleOne: {
      handler: function handler(newValue, oldValue) {
        this.setSheetModuleOne();
      },
      deep: true
    }
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__service_ModuleTwoService__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_sheet_SheetDefaultData__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_Currency__ = __webpack_require__(178);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "TabModule2",

  data: function data() {
    return {
      // CAMPOS //
      currency_config_percent: __WEBPACK_IMPORTED_MODULE_7__utils_Currency__["a" /* default */].percent,
      currency_config_normal: __WEBPACK_IMPORTED_MODULE_7__utils_Currency__["a" /* default */].normal,
      currency_config: __WEBPACK_IMPORTED_MODULE_7__utils_Currency__["a" /* default */].real
    };
  },

  methods: {
    addBenefit: function addBenefit() {
      if (!this.moduleTwo.others) this.moduleTwo.others = new Array();

      this.moduleTwo.others.push({
        description: "",
        value: 0
      });
    },
    changeFoodAid: function changeFoodAid() {
      if (!this.moduleTwo.foodAid.has) this.moduleTwo.foodAid = { mealByDay: 0, daysByMonth: 0, value: 0 };
    },
    changeTransport: function changeTransport() {
      if (!this.moduleTwo.transport.has) {
        this.moduleTwo.transport = { ticketByDay: 0, daysByMonth: 0, tariffValue: 0 };
      } else if (this.cityOfService) {
        this.moduleTwo.transport.tariffValue = this.cityOfService.busPassValue;
      }
    },
    removeBenefit: function removeBenefit(item) {
      this.moduleTwo.others.splice(this.moduleTwo.others.indexOf(item), 1);
    },
    setSheetModuleTwo: function setSheetModuleTwo() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var sheet;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                sheet = _this.analyticalWorksheet;

                if (!(sheet.moduleTwo != _this.moduleTwo)) {
                  _context.next = 5;
                  break;
                }

                sheet.moduleTwo = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this.moduleTwo);
                _context.next = 5;
                return _this.$store.commit("SET_ANALYTICAL_WORKSHEET", sheet);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    } // setSheetModuleTwo()

  }, // methods: //

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    amountOfModuleTwo: function amountOfModuleTwo() {
      var amount = parseFloat(this.amountOfModuleTwoOneValue) + parseFloat(this.amountOfModuleTwoTwoValue) + parseFloat(this.amountOfModuleTwoThreeValue);
      this.$store.commit("SET_AMOUNT_OF_MODULE_TWO", amount);

      return amount;
    },
    amountOfModuleTwoOnePercent: function amountOfModuleTwoOnePercent() {
      return __WEBPACK_IMPORTED_MODULE_4__service_ModuleTwoService__["a" /* default */].getAmountOfModuleTwoOnePercents(this.moduleTwo);
    },
    amountOfModuleTwoOneValue: function amountOfModuleTwoOneValue() {
      var amount = __WEBPACK_IMPORTED_MODULE_4__service_ModuleTwoService__["a" /* default */].getAmountOfModuleTwoOne(this.amountOfModuleOne, this.moduleTwo);
      this.$store.commit("SET_AMOUNT_OF_MODULE_TWO_ONE", amount);
      return amount;
    },
    amountOfModuleTwoTwoPercent: function amountOfModuleTwoTwoPercent() {
      var amount = __WEBPACK_IMPORTED_MODULE_4__service_ModuleTwoService__["a" /* default */].getAmountOfModuleTwoTwoPercents(this.moduleTwo);
      this.$store.commit("SET_AMOUNT_OF_MODULE_TWO_TWO_PERCENT", amount);

      return amount;
    },
    amountOfModuleTwoTwoValue: function amountOfModuleTwoTwoValue() {
      return __WEBPACK_IMPORTED_MODULE_4__service_ModuleTwoService__["a" /* default */].getAmountOfModuleTwoTwo(this.moduleOneAndModuleTwoOne, this.moduleTwo);
    },
    amountOfModuleTwoThreeValue: function amountOfModuleTwoThreeValue() {
      return __WEBPACK_IMPORTED_MODULE_4__service_ModuleTwoService__["a" /* default */].getAmountOfModuleTwoThree(this.basicSalaryCCT, this.moduleTwo);
    },
    basicSalaryCCT: function basicSalaryCCT() {
      return this.analyticalWorksheet.header.professionalCategory.basicSalary;
    },
    cityOfService: function cityOfService() {
      if (this.analyticalWorksheet && this.analyticalWorksheet.header && this.analyticalWorksheet.header.deliveryAddress && this.analyticalWorksheet.header.deliveryAddress.cityOfService) return this.analyticalWorksheet.header.deliveryAddress.cityOfService;
    },
    educationSalaryValue: function educationSalaryValue() {
      return this.moduleOneAndModuleTwoOne * this.moduleTwo.educationSalary / 100;
    },
    employeeCost: function employeeCost() {
      return __WEBPACK_IMPORTED_MODULE_4__service_ModuleTwoService__["a" /* default */].getEmployeeCost(this.basicSalaryCCT);
    },
    fgtsValue: function fgtsValue() {
      return this.moduleOneAndModuleTwoOne * this.moduleTwo.fgts / 100;
    },
    finalAmountOfTransport: function finalAmountOfTransport() {
      return __WEBPACK_IMPORTED_MODULE_4__service_ModuleTwoService__["a" /* default */].getAmountOfTransport(this.basicSalaryCCT, this.moduleTwo.transport);
    },
    incraValue: function incraValue() {
      return this.moduleOneAndModuleTwoOne * this.moduleTwo.incra / 100;
    },
    informations: function informations() {
      return [{
        class: "xs12 sm6",
        title: "Valor da Remuneração",
        subtitle: "Total do Módulo 1",
        value: this.amountOfModuleOne
      }, {
        class: "xs12 sm6",
        title: "Total do Módulo 2",
        subtitle: "Soma dos Submódulos (2.1, 2.2 e 2.3)",
        value: this.amountOfModuleTwo
      }];
    },
    inssValue: function inssValue() {
      return this.moduleOneAndModuleTwoOne * this.moduleTwo.inss / 100;
    },
    mealValue: function mealValue() {
      return __WEBPACK_IMPORTED_MODULE_4__service_ModuleTwoService__["a" /* default */].getAmountOfFoodAid(this.moduleTwo.foodAid);
    },
    moduleOneAndModuleTwoOne: function moduleOneAndModuleTwoOne() {
      return this.amountOfModuleTwoOneValue + this.amountOfModuleOne;
    },
    moduleTwo: function moduleTwo() {
      if (this.analyticalWorksheet.moduleTwo) return this.analyticalWorksheet.moduleTwo;

      return __WEBPACK_IMPORTED_MODULE_5__data_sheet_SheetDefaultData__["a" /* default */].getModuleTwo();
    },
    othersValue: function othersValue() {
      return __WEBPACK_IMPORTED_MODULE_4__service_ModuleTwoService__["a" /* default */].getOthers(this.moduleTwo.others);
    },
    partialAmountOfTransport: function partialAmountOfTransport() {
      return __WEBPACK_IMPORTED_MODULE_4__service_ModuleTwoService__["a" /* default */].getPartialAmountOfTransport(this.moduleTwo.transport);
    },
    ratFapPercent: function ratFapPercent() {
      return this.moduleTwo.rat * this.moduleTwo.fap;
    },
    ratFapValue: function ratFapValue() {
      return this.moduleOneAndModuleTwoOne * this.ratFapPercent / 100;
    },
    sebraeValue: function sebraeValue() {
      return this.moduleOneAndModuleTwoOne * this.moduleTwo.sebrae / 100;
    },
    senaiSenacValue: function senaiSenacValue() {
      return this.moduleOneAndModuleTwoOne * this.moduleTwo.senaiSenac / 100;
    },
    sesiSescValue: function sesiSescValue() {
      return this.moduleOneAndModuleTwoOne * this.moduleTwo.sesiSesc / 100;
    },
    tariffTransportHint: function tariffTransportHint() {
      if (!this.cityOfService) return "";
      return 'Cidade: ' + this.cityOfService.name + ' - ' + this.cityOfService.uf;
    },
    thirteenFirstSalaryValue: function thirteenFirstSalaryValue() {
      return this.amountOfModuleOne * this.moduleTwo.thirteenFirstSalary / 100;
    },
    vacationAdditionalValue: function vacationAdditionalValue() {
      return this.amountOfModuleOne * this.moduleTwo.vacationAdditional / 100;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapState */])({ amountOfModuleOne: function amountOfModuleOne(state) {
      return state.budget.amountOfModuleOne;
    } }), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapState */])({ analyticalWorksheet: function analyticalWorksheet(state) {
      return state.budget.analyticalWorksheet;
    } }), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapState */])({ budgetFinalized: function budgetFinalized(state) {
      return state.budget.budgetFinalized;
    } })), // computed: //
  watch: {
    moduleTwo: {
      handler: function handler(newValue, oldValue) {
        this.setSheetModuleTwo();
      },
      deep: true
    }
  }
}); // export default //

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__service_ModuleThreeService__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_sheet_SheetDefaultData__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_Currency__ = __webpack_require__(178);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "TabModule3",

  data: function data() {
    return {
      // CAMPOS //
      currency_config: __WEBPACK_IMPORTED_MODULE_7__utils_Currency__["a" /* default */].percent
    };
  },

  methods: {
    addBenefit: function addBenefit() {
      if (!this.moduleThree.others) this.moduleThree.others = new Array();

      this.moduleThree.others.push({
        description: "",
        percent: 0
      });
    },
    removeBenefit: function removeBenefit(item) {
      this.moduleThree.others.splice(this.moduleThree.others.indexOf(item), 1);
    },
    setSheetModuleThree: function setSheetModuleThree() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var sheet;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                sheet = _this.analyticalWorksheet;

                if (!(sheet.moduleThree != _this.moduleThree)) {
                  _context.next = 5;
                  break;
                }

                sheet.moduleThree = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this.moduleThree);
                _context.next = 5;
                return _this.$store.commit("SET_ANALYTICAL_WORKSHEET", sheet);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }, // METHODS //

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    amountOfModuleThree: function amountOfModuleThree() {
      var amount = this.fgtsIncidencePreviousNoticeIndemnifiedValue + this.fgtsIncidencePreviousNoticeWorkedValue + this.fgtsPenaltyPreviousNoticeIndemnifiedValue + this.fgtsPenaltyPreviousNoticeWorkedValue + this.previousNoticeIndemnifiedValue + this.previousNoticeWorkedValue + this.othersValue;

      this.$store.commit("SET_AMOUNT_OF_MODULE_THREE", amount);

      return amount;
    },
    calculationBasis: function calculationBasis() {
      return this.amountOfModuleOne + this.amountOfModuleTwoOne;
    },
    fgtsIncidencePreviousNoticeIndemnifiedValue: function fgtsIncidencePreviousNoticeIndemnifiedValue() {
      return __WEBPACK_IMPORTED_MODULE_4__service_ModuleThreeService__["a" /* default */].getFgtsIncidencePreviousNoticeIndemnified(this.calculationBasis, this.moduleThree);
    },
    fgtsIncidencePreviousNoticeWorkedValue: function fgtsIncidencePreviousNoticeWorkedValue() {
      return __WEBPACK_IMPORTED_MODULE_4__service_ModuleThreeService__["a" /* default */].getFgtsIncidencePreviousNoticeWorked(this.calculationBasis, this.moduleThree);
    },
    fgtsPenaltyPreviousNoticeIndemnifiedValue: function fgtsPenaltyPreviousNoticeIndemnifiedValue() {
      return __WEBPACK_IMPORTED_MODULE_4__service_ModuleThreeService__["a" /* default */].getFgtsPenaltyPreviousNoticeIndemnified(this.calculationBasis, this.moduleThree);
    },
    fgtsPenaltyPreviousNoticeWorkedValue: function fgtsPenaltyPreviousNoticeWorkedValue() {
      return __WEBPACK_IMPORTED_MODULE_4__service_ModuleThreeService__["a" /* default */].getFgtsPenaltyPreviousNoticeWorked(this.calculationBasis, this.moduleThree);
    },
    informations: function informations() {
      return [{
        class: "xs12 md4",
        title: "Valor da Remuneração",
        subtitle: "Total do Módulo 1",
        value: this.amountOfModuleOne
      }, {
        class: "xs12 md4",
        title: "Base de Cálculo",
        subtitle: "Módulo 1 + Submódulo 2.1",
        value: this.calculationBasis
      }, {
        class: "xs12 md4",
        title: "Total do Módulo 3",
        subtitle: "Soma dos valores",
        value: this.amountOfModuleThree
      }];
    },
    moduleThree: function moduleThree() {
      if (this.analyticalWorksheet.moduleThree) {
        return this.analyticalWorksheet.moduleThree;
      }
      return __WEBPACK_IMPORTED_MODULE_5__data_sheet_SheetDefaultData__["a" /* default */].getModuleThree();
    },
    othersValue: function othersValue() {
      return __WEBPACK_IMPORTED_MODULE_4__service_ModuleThreeService__["a" /* default */].getOthers(this.moduleThree.others, this.calculationBasis);
    },
    previousNoticeIndemnifiedValue: function previousNoticeIndemnifiedValue() {
      return __WEBPACK_IMPORTED_MODULE_4__service_ModuleThreeService__["a" /* default */].getPreviousNoticeIndemnified(this.calculationBasis, this.moduleThree);
    },
    previousNoticeWorkedValue: function previousNoticeWorkedValue() {
      return __WEBPACK_IMPORTED_MODULE_4__service_ModuleThreeService__["a" /* default */].getPreviousNoticeWorked(this.calculationBasis, this.moduleThree);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapState */])({ amountOfModuleOne: function amountOfModuleOne(state) {
      return state.budget.amountOfModuleOne;
    } }), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapState */])({ amountOfModuleTwoOne: function amountOfModuleTwoOne(state) {
      return state.budget.amountOfModuleTwoOne;
    } }), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapState */])({ amountOfModuleTwoTwoPercent: function amountOfModuleTwoTwoPercent(state) {
      return state.budget.amountOfModuleTwoTwoPercent;
    } }), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapState */])({ analyticalWorksheet: function analyticalWorksheet(state) {
      return state.budget.analyticalWorksheet;
    } }), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapState */])({ budgetFinalized: function budgetFinalized(state) {
      return state.budget.budgetFinalized;
    } })), // COMPUTED //
  watch: {
    moduleThree: {
      handler: function handler(newValue, oldValue) {
        this.setSheetModuleThree();
      },
      deep: true
    }
  }

});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__service_ModuleFourService__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_sheet_SheetDefaultData__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_Currency__ = __webpack_require__(178);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "TabModule3",

  data: function data() {
    return {
      currency_config_percent: __WEBPACK_IMPORTED_MODULE_7__utils_Currency__["a" /* default */].percent
    };
  },

  methods: {
    addBenefit: function addBenefit() {
      if (!this.moduleFour.others) this.moduleFour.others = new Array();

      this.moduleFour.others.push({
        description: "",
        percent: 0
      });
    },
    removeBenefit: function removeBenefit(item) {
      this.moduleFour.others.splice(this.moduleFour.others.indexOf(item), 1);
    },
    setSheetModuleFour: function setSheetModuleFour() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var sheet;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                sheet = _this.$store.getters.getAnalyticalWorksheet;

                if (!(sheet.moduleFour != _this.moduleFour)) {
                  _context.next = 5;
                  break;
                }

                sheet.moduleFour = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this.moduleFour);
                _context.next = 5;
                return _this.$store.commit("SET_ANALYTICAL_WORKSHEET", sheet);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    amountOfModuleFour: function amountOfModuleFour() {
      var amount = this.amountOfModuleFourOne + this.amountOfModuleFourTwo;

      this.$store.commit("SET_AMOUNT_OF_MODULE_FOUR", amount);

      return amount;
    },
    amountOfModuleFourOne: function amountOfModuleFourOne() {
      return __WEBPACK_IMPORTED_MODULE_4__service_ModuleFourService__["a" /* default */].getAmountOfModuleFourOne(this.calculationBasis, this.moduleFour);
    },
    amountOfModuleFourOnePercent: function amountOfModuleFourOnePercent() {
      return __WEBPACK_IMPORTED_MODULE_4__service_ModuleFourService__["a" /* default */].getAmountOfModuleFourOnePercents(this.moduleFour);
    },
    amountOfModuleFourTwo: function amountOfModuleFourTwo() {
      return __WEBPACK_IMPORTED_MODULE_4__service_ModuleFourService__["a" /* default */].getAmountOfModuleFourTwo(this.calculationBasis, this.moduleFour);
    },
    calculationBasis: function calculationBasis() {
      return this.amountOfModuleOne + this.amountOfModuleTwoOne;
    },
    informations: function informations() {
      return [{
        class: "xs12 sm4",
        title: "Valor da Remuneração",
        subtitle: "Total do Módulo 1",
        value: this.amountOfModuleOne
      }, {
        class: "xs12 sm4",
        title: "Base de Cálculo",
        subtitle: "Módulo 1 + Submódulo 2.1",
        value: this.calculationBasis
      }, {
        class: "xs12 sm4",
        title: "Total do Módulo 4",
        subtitle: "Soma dos valores",
        value: this.amountOfModuleFour
      }];
    },
    legalAbsencesValue: function legalAbsencesValue() {
      return this.calculationBasis * this.moduleFour.legalAbsences / 100;
    },
    maternityLicenceValue: function maternityLicenceValue() {
      return this.calculationBasis * this.moduleFour.maternityLicence / 100;
    },
    moduleFour: function moduleFour() {
      if (this.analyticalWorksheet.moduleFour) return this.analyticalWorksheet.moduleFour;

      return __WEBPACK_IMPORTED_MODULE_5__data_sheet_SheetDefaultData__["a" /* default */].getModuleFour();
    },
    othersPercent: function othersPercent() {
      return __WEBPACK_IMPORTED_MODULE_4__service_ModuleFourService__["a" /* default */].getOthersPercent(this.moduleFour.others);
    },
    othersValue: function othersValue() {
      return this.calculationBasis * this.othersPercent / 100;
    },
    paternityLicenceValue: function paternityLicenceValue() {
      return this.calculationBasis * this.moduleFour.paternityLicence / 100;
    },
    professionalAbsentValue: function professionalAbsentValue() {
      return this.calculationBasis * this.moduleFour.professionalAbsent / 100;
    },
    restAndFeedingValue: function restAndFeedingValue() {
      return this.calculationBasis * this.moduleFour.restAndFeeding / 100;
    },
    vacationValue: function vacationValue() {
      return this.calculationBasis * this.moduleFour.vacation / 100;
    },
    workAccidentValue: function workAccidentValue() {
      return this.calculationBasis * this.moduleFour.workAccident / 100;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapState */])({ analyticalWorksheet: function analyticalWorksheet(state) {
      return state.budget.analyticalWorksheet;
    } }), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapState */])({ amountOfModuleOne: function amountOfModuleOne(state) {
      return state.budget.amountOfModuleOne;
    } }), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapState */])({ amountOfModuleTwoOne: function amountOfModuleTwoOne(state) {
      return state.budget.amountOfModuleTwoOne;
    } }), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapState */])({ budgetFinalized: function budgetFinalized(state) {
      return state.budget.budgetFinalized;
    } })),
  watch: {
    moduleFour: {
      handler: function handler(newValue, oldValue) {
        this.setSheetModuleFour();
      },
      deep: true
    }
  }
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__service_ModuleFiveService__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_sheet_SheetDefaultData__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_Currency__ = __webpack_require__(178);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({

  name: "TabSummaryTable",
  data: function data() {
    return {
      currency_config: __WEBPACK_IMPORTED_MODULE_7__utils_Currency__["a" /* default */].real
    };
  },

  methods: {
    addBenefit: function addBenefit() {
      if (!this.moduleFive.others) this.moduleFive.others = new Array();

      this.moduleFive.others.push({
        description: "",
        value: 0
      });
    },
    removeBenefit: function removeBenefit(item) {
      this.moduleFive.others.splice(this.moduleFive.others.indexOf(item), 1);
    },
    setSheetModuleFive: function setSheetModuleFive() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var sheet;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                sheet = _this.$store.getters.getAnalyticalWorksheet;

                if (!(sheet.moduleFive != _this.moduleFive)) {
                  _context.next = 5;
                  break;
                }

                sheet.moduleFive = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this.moduleFive);
                _context.next = 5;
                return _this.$store.commit("SET_ANALYTICAL_WORKSHEET", sheet);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    othersValue: function othersValue() {
      return __WEBPACK_IMPORTED_MODULE_4__service_ModuleFiveService__["a" /* default */].getOthers(this.moduleFive.others);
    },
    informations: function informations() {

      return [{
        class: "xs12 sm6 md3",
        title: "Uniformes e EPI's (Mês)",
        subtitle: "",
        value: this.amountOfUniformsByMonth.value
      }, {
        class: "xs12 sm6 md3",
        title: "Materiais de Consumo (Mês)",
        subtitle: 'Total de Empregados: ' + this.amountOfConsumablesByMonth.employees,
        value: this.amountOfConsumablesByMonth.value
      }, {
        class: "xs12 sm6 md3",
        title: "Equipamentos (Mês)",
        subtitle: 'Total de Empregados: ' + this.amountOfEquipmentsByMonth.employees,
        value: this.amountOfEquipmentsByMonth.value
      }, {
        class: "xs12 sm6 md3",
        title: "Utensílios (Mês)",
        subtitle: 'Total de Empregados: ' + this.amountOfUtensilsByMonth.employees,
        value: this.amountOfUtensilsByMonth.value
      }, {
        class: "xs12",
        title: "TOTAL DO MÓDULO 5 (MÊS)",
        value: this.amountOfModuleFive
      }];
    },
    amountOfModuleFive: function amountOfModuleFive() {
      var amount = this.amountOfUniformsByMonth.value + this.amountOfUtensilsByMonth.value + this.amountOfEquipmentsByMonth.value + this.amountOfConsumablesByMonth.value + this.othersValue;
      this.$store.commit("SET_AMOUNT_OF_MODULE_FIVE", amount);
      return amount;
    },
    moduleFive: function moduleFive() {
      if (this.analyticalWorksheet.moduleFive) return this.analyticalWorksheet.moduleFive;

      return __WEBPACK_IMPORTED_MODULE_5__data_sheet_SheetDefaultData__["a" /* default */].getModuleFive();
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapState */])({ amountOfUniformsByMonth: function amountOfUniformsByMonth(state) {
      return state.budget.amountOfUniformsByMonth;
    } }), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapState */])({ amountOfUtensilsByMonth: function amountOfUtensilsByMonth(state) {
      return state.budget.amountOfUtensilsByMonth;
    } }), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapState */])({ amountOfConsumablesByMonth: function amountOfConsumablesByMonth(state) {
      return state.budget.amountOfConsumablesByMonth;
    } }), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapState */])({ amountOfEquipmentsByMonth: function amountOfEquipmentsByMonth(state) {
      return state.budget.amountOfEquipmentsByMonth;
    } }), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapState */])({ analyticalWorksheet: function analyticalWorksheet(state) {
      return state.budget.analyticalWorksheet;
    } }), Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapState */])({ budgetFinalized: function budgetFinalized(state) {
      return state.budget.budgetFinalized;
    } })),
  watch: {
    moduleFive: {
      handler: function handler(newValue, oldValue) {
        this.setSheetModuleFive();
      },
      deep: true
    }
  }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_sheet_SheetDefaultData__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_Currency__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__service_ModuleSixService__ = __webpack_require__(242);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "TabModule6",

  data: function data() {
    return {
      currency_config: __WEBPACK_IMPORTED_MODULE_6__utils_Currency__["a" /* default */].percent
    };
  },

  methods: {
    addOtherTaxation: function addOtherTaxation() {
      this.moduleSix.others.push({
        description: "",
        value: 0
      });
    },
    calculateOtherValue: function calculateOtherValue(other) {
      if (!this.taxation) return 0;
      return this.basisOfCalculationForTaxation / (100 - this.aliquot) * other.value;
    },
    removeTaxation: function removeTaxation(other) {
      this.moduleSix.others.splice(this.moduleSix.others.indexOf(other), 1);
    },
    setSheetModuleSix: function setSheetModuleSix() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var sheet;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                sheet = _this.analyticalWorksheet;

                if (!(sheet.moduleSix != _this.moduleSix)) {
                  _context.next = 5;
                  break;
                }

                sheet.moduleSix = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this.moduleSix);
                _context.next = 5;
                return _this.$store.commit("SET_ANALYTICAL_WORKSHEET", sheet);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    administrativeCostsValue: function administrativeCostsValue() {
      return __WEBPACK_IMPORTED_MODULE_7__service_ModuleSixService__["a" /* default */].getAdministrativeCosts(this.subTotalValue, this.moduleSix.administrativeCosts);
    },
    aliquot: function aliquot() {
      return __WEBPACK_IMPORTED_MODULE_7__service_ModuleSixService__["a" /* default */].getAliquot(this.taxation, this.taxationType);
    },
    amountOfModuleSix: function amountOfModuleSix() {
      var amount = __WEBPACK_IMPORTED_MODULE_7__service_ModuleSixService__["a" /* default */].getAmountOfModuleSix(this.budget, this.moduleSix, this.subTotalValue);
      this.$store.commit("SET_AMOUNT_OF_MODULE_SIX", amount);
      return amount;
    },
    basisOfCalculationForLucre: function basisOfCalculationForLucre() {
      return __WEBPACK_IMPORTED_MODULE_7__service_ModuleSixService__["a" /* default */].getBasisOfCalculationForLucre(this.subTotalValue, this.administrativeCostsValue);
    },
    basisOfCalculationForTaxation: function basisOfCalculationForTaxation() {
      return __WEBPACK_IMPORTED_MODULE_7__service_ModuleSixService__["a" /* default */].getBasisOfCalculationForTaxation(this.subTotalValue, this.administrativeCostsValue, this.lucreValue);
    },
    cofinsValue: function cofinsValue() {
      return __WEBPACK_IMPORTED_MODULE_7__service_ModuleSixService__["a" /* default */].getCofins(this.taxation, this.basisOfCalculationForTaxation, this.aliquot);
    },
    informations: function informations() {
      return [{
        class: "xs12 sm6 md3",
        title: "Base de Cálculo dos Custos Indiretos",
        subtitle: "Sub-Total (Soma dos Módulos 1, 2, 3, 4 e 5)",
        value: this.subTotalValue
      }, {
        class: "xs12 sm6 md3",
        title: "Base de Cálculo do Lucro",
        subtitle: "Sub-Total + Custos Indiretos",
        value: this.basisOfCalculationForLucre
      }, {
        class: "xs12 sm6 md3",
        title: "Base de Cálculo da Tributação",
        subtitle: "Sub-Total + Custos Indiretos + Lucro",
        value: this.basisOfCalculationForTaxation
      }, {
        class: "xs12 sm6 md3",
        title: "Base de Cálculo da Tributação",
        subtitle: this.taxationType.toUpperCase() != 'SIMPLES NACIONAL' ? 'Al\xEDquota: ' + this.aliquot + '%' : "",
        value: this.amountOfModuleSix
      }];
    },
    issValue: function issValue() {
      return __WEBPACK_IMPORTED_MODULE_7__service_ModuleSixService__["a" /* default */].getIss(this.taxation, this.basisOfCalculationForTaxation, this.aliquot);
    },
    lucreValue: function lucreValue() {
      return __WEBPACK_IMPORTED_MODULE_7__service_ModuleSixService__["a" /* default */].getLucre(this.moduleSix.lucre, this.basisOfCalculationForLucre);
    },
    moduleSix: function moduleSix() {
      if (this.analyticalWorksheet.moduleSix) return this.analyticalWorksheet.moduleSix;

      return __WEBPACK_IMPORTED_MODULE_4__data_sheet_SheetDefaultData__["a" /* default */].getModuleFive();
    },
    othersValue: function othersValue() {
      return __WEBPACK_IMPORTED_MODULE_7__service_ModuleSixService__["a" /* default */].getOthers(this.moduleSix.others, this.aliquot, this.basisOfCalculationForTaxation);
    },
    pisValue: function pisValue() {
      return __WEBPACK_IMPORTED_MODULE_7__service_ModuleSixService__["a" /* default */].getPis(this.taxation, this.basisOfCalculationForTaxation, this.aliquot);
    },
    subTotalValue: function subTotalValue() {
      return this.amountOfModuleOne + this.amountOfModuleTwo + this.amountOfModuleThree + this.amountOfModuleFour + this.amountOfModuleFive;
    },
    taxation: function taxation() {
      return __WEBPACK_IMPORTED_MODULE_7__service_ModuleSixService__["a" /* default */].getTaxation(this.budget);
    },
    taxationType: function taxationType() {
      return __WEBPACK_IMPORTED_MODULE_7__service_ModuleSixService__["a" /* default */].getTaxationType(this.taxation);
    },
    uniqueTaxationValue: function uniqueTaxationValue() {
      return __WEBPACK_IMPORTED_MODULE_7__service_ModuleSixService__["a" /* default */].getUniqueTaxation(this.taxation, this.basisOfCalculationForTaxation);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapState */])({ amountOfModuleOne: function amountOfModuleOne(state) {
      return state.budget.amountOfModuleOne;
    } }), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapState */])({ amountOfModuleTwo: function amountOfModuleTwo(state) {
      return state.budget.amountOfModuleTwo;
    } }), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapState */])({ amountOfModuleThree: function amountOfModuleThree(state) {
      return state.budget.amountOfModuleThree;
    } }), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapState */])({ amountOfModuleFour: function amountOfModuleFour(state) {
      return state.budget.amountOfModuleFour;
    } }), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapState */])({ amountOfModuleFive: function amountOfModuleFive(state) {
      return state.budget.amountOfModuleFive;
    } }), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapState */])({ analyticalWorksheet: function analyticalWorksheet(state) {
      return state.budget.analyticalWorksheet;
    } }), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapState */])({ budget: function budget(state) {
      return state.budget.budget;
    } }), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapState */])({ budgetFinalized: function budgetFinalized(state) {
      return state.budget.budgetFinalized;
    } })),
  watch: {
    moduleSix: {
      handler: function handler(newValue, oldValue) {
        this.setSheetModuleSix();
      },
      deep: true
    }
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(60);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({

  name: "TabSummaryTable",

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    numberOfEmployees: function numberOfEmployees() {
      if (this.analyticalWorksheet && this.analyticalWorksheet.header) return this.analyticalWorksheet.header.numberOfEmployees;
      return 0;
    },
    finalValue: function finalValue() {
      return this.total * this.numberOfEmployees;
    },
    subTotal: function subTotal() {
      return this.amountOfModuleOne + this.amountOfModuleTwo + this.amountOfModuleThree + this.amountOfModuleFour + this.amountOfModuleFive;
    },
    total: function total() {
      var amount = this.subTotal + this.amountOfModuleSix;

      if (this.analyticalWorksheet && this.analyticalWorksheet.header) this.analyticalWorksheet.header.amountMonthly = amount;

      return amount;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])({ amountOfModuleOne: function amountOfModuleOne(state) {
      return state.budget.amountOfModuleOne;
    } }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])({ amountOfModuleTwo: function amountOfModuleTwo(state) {
      return state.budget.amountOfModuleTwo;
    } }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])({ amountOfModuleThree: function amountOfModuleThree(state) {
      return state.budget.amountOfModuleThree;
    } }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])({ amountOfModuleFour: function amountOfModuleFour(state) {
      return state.budget.amountOfModuleFour;
    } }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])({ amountOfModuleFive: function amountOfModuleFive(state) {
      return state.budget.amountOfModuleFive;
    } }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])({ amountOfModuleSix: function amountOfModuleSix(state) {
      return state.budget.amountOfModuleSix;
    } }), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])({ analyticalWorksheet: function analyticalWorksheet(state) {
      return state.budget.analyticalWorksheet;
    } }))
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configuration__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OfficceService__ = __webpack_require__(205);










var ContractService = function () {
  function ContractService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ContractService);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ContractService, null, [{
    key: "validade",
    value: function validade(contract) {
      var errors = [];
      if (!contract.company) errors.push('empresa');
      if (!contract.client) errors.push('cliente');

      if (errors.length > 0) return errors;else return null;
    }
  }, {
    key: "findInitialContracts",
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__configuration__["a" /* default */].apiHost + "contracts/initial");

              case 3:
                response = _context.sent;
                return _context.abrupt("return", response.data);

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                throw new Error(_context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function findInitialContracts() {
        return _ref.apply(this, arguments);
      }

      return findInitialContracts;
    }()
  }, {
    key: "findAll",
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__configuration__["a" /* default */].apiHost + "contracts/");

              case 3:
                response = _context2.sent;
                return _context2.abrupt("return", response.data);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                throw new Error(_context2.t0);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function findAll() {
        return _ref2.apply(this, arguments);
      }

      return findAll;
    }()
  }, {
    key: "create",
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(contract) {
        var saved;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_5__configuration__["a" /* default */].apiHost + "contracts/", contract);

              case 3:
                saved = _context3.sent;
                return _context3.abrupt("return", saved.data);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);
                throw new Error(_context3.t0);

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function create(_x) {
        return _ref3.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "update",
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(contract) {
        var updated;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_5__configuration__["a" /* default */].apiHost + "contracts/", contract);

              case 3:
                updated = _context4.sent;
                return _context4.abrupt("return", updated.data);

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](0);
                throw new Error(_context4.t0);

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 7]]);
      }));

      function update(_x2) {
        return _ref4.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "budgetToContract",
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(budget, contract) {
        var i, element, off;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!contract) contract = {
                  address: {}
                };
                contract.client = budget.client;
                contract.company = budget.company;
                contract.departments = [];
                contract.amount = 0;
                // planilhas analiticas
                i = 0;

              case 6:
                if (!(i < budget.analyticalWorksheets.length)) {
                  _context5.next = 16;
                  break;
                }

                element = budget.analyticalWorksheets[i];
                _context5.next = 10;
                return __WEBPACK_IMPORTED_MODULE_6__OfficceService__["a" /* default */].getByName(element.header.office.description);

              case 10:
                off = _context5.sent;

                contract.amount += element.header.numberOfEmployees * element.header.amountMonthly;
                contract.departments.push({
                  name: "" + element.header.deliveryAddress.sector,
                  lastName: "" + element.header.professionalCategory.occupation,
                  address: element.header.deliveryAddress,
                  numberOfEmployees: element.header.numberOfEmployees,
                  amountMonthly: element.header.amountMonthly,
                  unitOfMeasurement: element.header.unitOfMeasurement,
                  office: off,
                  collectiveConvention: element.header.collectiveConvention,
                  additionalInfo: element.header.additionalInfo,
                  mainNotes: element.header.mainNotes,
                  professionalCategory: element.header.professionalCategory,
                  complementariesNotes: element.header.complementariesNotes,
                  materials: element.moduleFive

                });

              case 13:
                i++;
                _context5.next = 6;
                break;

              case 16:
                return _context5.abrupt("return", contract);

              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function budgetToContract(_x3, _x4) {
        return _ref5.apply(this, arguments);
      }

      return budgetToContract;
    }()
  }]);

  return ContractService;
}(); // class


/* harmony default export */ __webpack_exports__["a"] = (ContractService);

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Department_vue__ = __webpack_require__(227);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03e77033_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Department_vue__ = __webpack_require__(278);
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Department_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03e77033_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Department_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"justify-space-between":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","pa-0":""}},[_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-autocomplete',{attrs:{"label":"Tipo de Setor","items":_vm.sectorTypes,"return-object":"","item-text":_vm.sectorType,"dense":"","box":"","disabled":_vm.situationEditDisabled || _vm.finalizedContract || _vm.disableTagsInThePage},on:{"change":_vm.changeSector},model:{value:(_vm.sectorType),callback:function ($$v) {_vm.sectorType=$$v},expression:"sectorType"}}),_vm._v(" "),_c('v-btn',{staticStyle:{"float":"right"},attrs:{"dark":"","color":"primary","fab":"","small":"","disabled":_vm.finalizedContract || _vm.disableTagsInThePage},on:{"click":function($event){_vm.situationEditDisabled = !_vm.situationEditDisabled}}},[(_vm.situationEditDisabled)?_c('v-icon',{staticClass:"white--text"},[_vm._v("edit")]):_c('v-icon',{staticClass:"white--text"},[_vm._v("check")])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","mb-3":""}},[_c('v-divider')],1),_vm._v(" "),(_vm.isPageRequest)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","justify-end":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h2',{staticClass:"grey--text"},[_vm._v("Endereço de entrega")])])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Setor","disabled":_vm.disableTagsInThePage,"readonly":_vm.finalizedContract,"box":""},model:{value:(_vm.department.name),callback:function ($$v) {_vm.$set(_vm.department, "name", $$v)},expression:"department.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"type":"text","label":"CEP","disabled":_vm.disableTagsInThePage,"readonly":_vm.finalizedContract,"box":""},on:{"input":_vm.findAddressByCep},model:{value:(_vm.department.address.cep),callback:function ($$v) {_vm.$set(_vm.department.address, "cep", $$v)},expression:"department.address.cep"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm5":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Logradouro","readonly":_vm.finalizedContract,"box":"","disabled":_vm.isSearchingAddress || _vm.disableTagsInThePage},model:{value:(_vm.department.address.addressType),callback:function ($$v) {_vm.$set(_vm.department.address, "addressType", $$v)},expression:"department.address.addressType"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-text-field',{attrs:{"type":"text","readonly":_vm.finalizedContract,"label":"Número","box":"","disabled":_vm.isSearchingAddress || _vm.disableTagsInThePage},model:{value:(_vm.department.address.number),callback:function ($$v) {_vm.$set(_vm.department.address, "number", $$v)},expression:"department.address.number"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"type":"text","readonly":_vm.finalizedContract,"label":"Complemento","box":"","disabled":_vm.isSearchingAddress || _vm.disableTagsInThePage},model:{value:(_vm.department.address.complement),callback:function ($$v) {_vm.$set(_vm.department.address, "complement", $$v)},expression:"department.address.complement"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm5":""}},[_c('v-text-field',{attrs:{"type":"text","readonly":_vm.finalizedContract,"label":"Bairro","box":"","disabled":_vm.isSearchingAddress || _vm.disableTagsInThePage},model:{value:(_vm.department.address.district),callback:function ($$v) {_vm.$set(_vm.department.address, "district", $$v)},expression:"department.address.district"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-autocomplete',{attrs:{"label":"Município","readonly":_vm.finalizedContract,"items":_vm.cities,"item-text":_vm.cityText,"return-object":"","dense":"","solo":"","box":"","disabled":_vm.isSearchingAddress || _vm.disableTagsInThePage},scopedSlots:_vm._u([{key:"append-outer",fn:function(){return [_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({attrs:{"disabled":_vm.finalizedContract},on:{"click":_vm.buttonAddNewCity}},on),[_vm._v("add")])]}}])},[_vm._v("\n                                        Cadastrar nova Cidade!\n                                    ")])]},proxy:true}]),model:{value:(_vm.department.address.cityOfService),callback:function ($$v) {_vm.$set(_vm.department.address, "cityOfService", $$v)},expression:"department.address.cityOfService"}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500"},model:{value:(_vm.showDialogAddNewCity),callback:function ($$v) {_vm.showDialogAddNewCity=$$v},expression:"showDialogAddNewCity"}},[_c('form-city',{on:{"cancelNewCity":_vm.closeDialogNewCity,"savedCity":_vm.savedCity}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"pb-3"}),_vm._v(" "),(!_vm.isPageRequest)?_c('v-layout',{attrs:{"justify-space-between":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm2":""}},[_c('v-autocomplete',{attrs:{"label":"Unidade de medida","disabled":_vm.disableTagsInThePage,"readonly":_vm.finalizedContract,"items":_vm.unitsOfMeasurement,"box":""},model:{value:(_vm.department.unitOfMeasurement),callback:function ($$v) {_vm.$set(_vm.department, "unitOfMeasurement", $$v)},expression:"department.unitOfMeasurement"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-autocomplete',{attrs:{"label":"Descrição do Serviço","disabled":_vm.disableTagsInThePage,"readonly":_vm.finalizedContract,"items":_vm.offices,"item-text":"description","item-value":"_id","dense":"","return-object":"","box":""},model:{value:(_vm.department.office),callback:function ($$v) {_vm.$set(_vm.department, "office", $$v)},expression:"department.office"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"type":"number","min":"1","readonly":_vm.finalizedContract,"disabled":_vm.disableTagsInThePage,"label":"Quantidade de empregados a contratar","box":""},model:{value:(_vm.department.numberOfEmployees),callback:function ($$v) {_vm.$set(_vm.department, "numberOfEmployees", $$v)},expression:"department.numberOfEmployees"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-autocomplete',{attrs:{"readonly":_vm.finalizedContract,"label":"Ano do acordo, convenção ou dissído coletivo","items":_vm.agreementsYear,"item-text":"year","disabled":_vm.disableTagsInThePage,"item-value":"_id","dense":"","box":""},model:{value:(_vm.department.collectiveConvention),callback:function ($$v) {_vm.$set(_vm.department, "collectiveConvention", $$v)},expression:"department.collectiveConvention"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-autocomplete',{attrs:{"label":"Categoria profissional","readonly":_vm.finalizedContract,"items":_vm.agreementYearSelectedItems,"item-text":"occupation","dense":"","return-object":"","persistent-hint":"","box":"","disabled":!_vm.department.collectiveConvention || _vm.disableTagsInThePage},model:{value:(_vm.department.professionalCategory),callback:function ($$v) {_vm.$set(_vm.department, "professionalCategory", $$v)},expression:"department.professionalCategory"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"label":"Carga Horária","disabled":_vm.disableTagsInThePage,"readonly":_vm.finalizedContract,"box":""},model:{value:(_vm.department.additionalInfo),callback:function ($$v) {_vm.$set(_vm.department, "additionalInfo", $$v)},expression:"department.additionalInfo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"label":"Data base da categoria","disabled":_vm.disableTagsInThePage,"readonly":_vm.finalizedContract,"box":"","type":"date"},model:{value:(_vm.department.dataBaseOfTheCategory),callback:function ($$v) {_vm.$set(_vm.department, "dataBaseOfTheCategory", $$v)},expression:"department.dataBaseOfTheCategory"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{attrs:{"disabled":_vm.disableTagsInThePage,"readonly":_vm.finalizedContract,"label":"Notas Principais","rows":"5","box":""},model:{value:(_vm.department.mainNotes),callback:function ($$v) {_vm.$set(_vm.department, "mainNotes", $$v)},expression:"department.mainNotes"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{attrs:{"disabled":_vm.disableTagsInThePage,"readonly":_vm.finalizedContract,"label":"Notas Complementares","rows":"5","box":""},model:{value:(_vm.department.complementariesNotes),callback:function ($$v) {_vm.$set(_vm.department, "complementariesNotes", $$v)},expression:"department.complementariesNotes"}})],1)],1)],1)],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AlertDelete__ = __webpack_require__(212);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contractDocuments: {
      type: Array,
      default: []
    },
    disableActions: {
      type: Boolean,
      default: false
    }
  },
  components: {
    AlertDelete: __WEBPACK_IMPORTED_MODULE_3__AlertDelete__["a" /* default */]
  },
  data: function data() {
    return {
      //PDFs
      pdfName: "",
      pdfUrl: "",
      pdfWindow: false,
      pdfWindowTitle: "Editar Arquivo",
      pdfModel: {},
      editingPdf: false,
      savingcontract: false,
      //contractDocuments: [],
      loading: false,
      disabledButtonSave: true
    };
  },
  //data()

  methods: {
    initialize: function initialize() {
      this.pdfName = "";
      this.pdfUrl = "";
      this.pdfWindow = false;
      this.pdfWindowTitle = "Editar Arquivo";
      this.pdfModel = {};
      this.editingPdf = false;
      this.savingcontract = false;
    },

    //pdfs etc
    savePdf: function savePdf(pdf) {
      this.pdfWindow = false;
      var filter = this.contractDocuments.filter(function (document) {
        return document._id === pdf._id;
      });
      var index = this.contractDocuments.indexOf(filter[0]);
      if (index != -1) {
        this.contractDocuments.splice(index, 1, pdf);
        if (this.pdfModel) {
          this.pdfModel = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({});
          this.editingPdf = false;
        }
      }
    },
    editPdf: function editPdf(pdf) {
      this.pdfModel = pdf;
      this.pdfWindow = true;
      this.editingPdf = true;
    },
    openDialogToRemove: function openDialogToRemove(doc) {
      this.$refs.dialogToDeleteDocument.openDialog(doc);
    },
    removePdf: function removePdf(pdf) {
      var index = this.contractDocuments.indexOf(pdf); //indexOf, não findIndex lmao
      if (index != -1) {
        //Confirmar
        this.contractDocuments.splice(index, 1); //Remover o index achado pelo indexOf
      }
    },
    pickPdf: function pickPdf() {
      this.$refs.pdf.click(); //Simular um click no elemento que tem como ref "pdf"
    },
    saveAllDocuments: function saveAllDocuments() {
      return this.contractDocuments;
    },
    setDocuments: function setDocuments(documentsPdf) {
      if (documentsPdf.length > 0) {
        this.contractDocuments = documentsPdf;
      } else this.contractDocuments = [];
    },
    onPdfPicked: function onPdfPicked(e) {
      var _this = this;

      if (e && e.target.files) {
        //Caso tenha enviado arquivos
        var pdfs = e.target.files; //Pegar os arquivos enviados
      } else {
          return; //Else retornar e não deixar a função continuar
        }
      if (pdfs[0] != undefined && pdfs.hasOwnProperty(0)) {
        //Se o pdf realmente tem o item 0 , melhor se previnir do que se desculpar
        this.pdfName = pdfs[0].name; //Colocar o pdfName com o nome do arquivo
        if (this.pdfName.lastIndexOf(".") <= 0) {
          //Se o arquivo não tiver um tipo
          return;
        }
        var fileReader = new FileReader(); //Ler arquivo
        if (!pdfs.hasOwnProperty(0)) return;
        fileReader.readAsDataURL(pdfs[0]); //Transformar em base64
        fileReader.addEventListener("load", function () {
          //Callback para quando terminar de dar o upload
          _this.pdfUrl = fileReader.result; //Pegar o resultado do callback
          if (_this.contract != {} && _this.editingPdf == false) {
            _this.contractDocuments.push({
              //Inserir os documentos no registro caso não esteja em modo de edição
              name: _this.pdfName,
              file: _this.pdfUrl
            });
          } else if (_this.editingPdf == true) {
            //Caso em modo de edição
            _this.pdfModel.file = _this.pdfUrl; //Deixar o pdf a ser editado com o arquivo que levou upload
          }
        });
      } else {
        this.pdfName = ""; //Else deixar tudo vazio
        this.pdfUrl = "";
      }
    },
    openPdf: function openPdf(pdf) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var pdfWindow;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(pdf && pdf != undefined && pdf != null && pdf != "")) {
                  _context.next = 5;
                  break;
                }

                //Fon
                pdfWindow = window.open(""); //Cria a janela

                _context.next = 4;
                return pdfWindow.document.write("<iframe width='100%' height='100%' src='" + encodeURI(pdf) + "'></iframe>");

              case 4:
                //Abrir ela com o pdf
                pdfWindow.focus;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tables_vue__ = __webpack_require__(228);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2798b3a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tables_vue__ = __webpack_require__(291);
function injectStyle (ssrContext) {
  __webpack_require__(281)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b2798b3a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tables_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2798b3a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tables_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(282);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(155)("286de824", content, true, {});

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(154)(true);
// imports


// module
exports.push([module.i, ".input-quantity[data-v-b2798b3a]{border-bottom:thin solid #494949;background-color:#d8d8d8;border-radius:5px 5px 0 0;padding:3px;font-size:9pt}", "", {"version":3,"sources":["/vercel/path0/src/components/contract/department/Tables.vue"],"names":[],"mappings":"AACA,iCACE,iCAA0C,AAC1C,yBAAqC,AACrC,0BAA+B,AAC/B,YAAa,AACb,aAAe,CAChB","file":"Tables.vue","sourcesContent":["\n.input-quantity[data-v-b2798b3a] {\n  border-bottom: solid thin rgb(73, 73, 73);\n  background-color: rgb(216, 216, 216);\n  border-radius: 5px 5px 0px 0px;\n  padding: 3px;\n  font-size: 9pt;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DialogUniformAndEPIs_vue__ = __webpack_require__(229);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4caf39f1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DialogUniformAndEPIs_vue__ = __webpack_require__(284);
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DialogUniformAndEPIs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4caf39f1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DialogUniformAndEPIs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-dialog',{attrs:{"persistent":"","max-width":"600"},model:{value:(_vm.showDialogItem),callback:function ($$v) {_vm.showDialogItem=$$v},expression:"showDialogItem"}},[_c('v-card',[_c('v-toolbar',{staticClass:"elevation-1",attrs:{"color":"white"}},[_c('v-toolbar-title',{staticClass:"black--text font-weight-light"},[_vm._v(_vm._s(_vm.titleComponent))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"disabled":_vm.loading,"flat":"","color":"error","icon":"","round":""},nativeOn:{"click":function($event){return _vm.cancelNewItem()}}},[_c('v-icon',{attrs:{"large":"","color":"error"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"justify-space-between":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","py-0":""}},[_c('v-autocomplete',{attrs:{"items":_vm.uniformsAndEPIs,"box":"","item-value":"description","item-text":"description","label":"Descrição / Especificação","return-object":""},model:{value:(_vm.uniformAndEPI),callback:function ($$v) {_vm.uniformAndEPI=$$v},expression:"uniformAndEPI"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","py-0":""}},[_c('v-text-field',{attrs:{"box":"","label":"Unidade","title":"Unidade","disabled":""},model:{value:(_vm.uniformAndEPI.unity),callback:function ($$v) {_vm.$set(_vm.uniformAndEPI, "unity", $$v)},expression:"uniformAndEPI.unity"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","py-0":""}},[_c('v-text-field',{attrs:{"label":"Quantidade","box":""},model:{value:(_vm.uniformAndEPI.quantity),callback:function ($$v) {_vm.$set(_vm.uniformAndEPI, "quantity", $$v)},expression:"uniformAndEPI.quantity"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","py-0":""}},[_c('v-text-field',{attrs:{"label":"Valor Unitário (R$)","box":""},model:{value:(_vm.uniformAndEPI.value),callback:function ($$v) {_vm.$set(_vm.uniformAndEPI, "value", $$v)},expression:"uniformAndEPI.value"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"pb-3"},[_c('v-btn',{attrs:{"disabled":_vm.loading,"loading":_vm.loading,"block":"","round":"","color":"success lighten-1"},nativeOn:{"click":function($event){return _vm.save();}}},[_vm._v("\n          Salvar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DialogUtensil_vue__ = __webpack_require__(230);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87c17bbc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DialogUtensil_vue__ = __webpack_require__(286);
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DialogUtensil_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87c17bbc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DialogUtensil_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-dialog',{attrs:{"persistent":"","max-width":"600"},model:{value:(_vm.showDialogItem),callback:function ($$v) {_vm.showDialogItem=$$v},expression:"showDialogItem"}},[_c('v-card',[_c('v-toolbar',{staticClass:"elevation-1",attrs:{"color":"white"}},[_c('v-toolbar-title',{staticClass:"black--text font-weight-light"},[_vm._v(_vm._s(_vm.titleComponent))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"disabled":_vm.loading,"flat":"","color":"error","icon":"","round":""},nativeOn:{"click":function($event){return _vm.cancelNewItem()}}},[_c('v-icon',{attrs:{"large":"","color":"error"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"justify-space-between":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","py-0":""}},[_c('v-autocomplete',{attrs:{"items":_vm.utensils,"box":"","item-text":"description","label":"Descrição / Especificação","return-object":""},model:{value:(_vm.utensil),callback:function ($$v) {_vm.utensil=$$v},expression:"utensil"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","py-0":""}},[_c('v-text-field',{attrs:{"box":"","label":"Unidade","title":"Unidade","disabled":""},model:{value:(_vm.utensil.unity),callback:function ($$v) {_vm.$set(_vm.utensil, "unity", $$v)},expression:"utensil.unity"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","py-0":""}},[_c('v-text-field',{attrs:{"label":"Quantidade","box":""},model:{value:(_vm.utensil.quantity),callback:function ($$v) {_vm.$set(_vm.utensil, "quantity", $$v)},expression:"utensil.quantity"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","py-0":""}},[_c('v-text-field',{attrs:{"label":"Valor Unitário (R$)","box":""},model:{value:(_vm.utensil.value),callback:function ($$v) {_vm.$set(_vm.utensil, "value", $$v)},expression:"utensil.value"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"pb-3"},[_c('v-btn',{attrs:{"disabled":_vm.loading,"loading":_vm.loading,"block":"","round":"","color":"success lighten-1"},nativeOn:{"click":function($event){return _vm.save();}}},[_vm._v("\n          Salvar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DialogEquipments_vue__ = __webpack_require__(231);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ecb6c44_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DialogEquipments_vue__ = __webpack_require__(288);
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DialogEquipments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ecb6c44_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DialogEquipments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-dialog',{attrs:{"persistent":"","max-width":"600"},model:{value:(_vm.showDialogItem),callback:function ($$v) {_vm.showDialogItem=$$v},expression:"showDialogItem"}},[_c('v-card',[_c('v-toolbar',{staticClass:"elevation-1",attrs:{"color":"white"}},[_c('v-toolbar-title',{staticClass:"black--text font-weight-light"},[_vm._v(_vm._s(_vm.titleComponent))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"disabled":_vm.loading,"flat":"","color":"error","icon":"","round":""},nativeOn:{"click":function($event){return _vm.cancelNewItem()}}},[_c('v-icon',{attrs:{"large":"","color":"error"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"justify-space-between":"","wrap":"","px-3":"","pt-4":""}},[_c('v-flex',{attrs:{"xs12":"","py-0":""}},[_c('v-autocomplete',{attrs:{"items":_vm.equipments,"box":"","item-text":"description","item-value":"description","label":"Descrição / Especificação","return-object":""},model:{value:(_vm.equipment),callback:function ($$v) {_vm.equipment=$$v},expression:"equipment"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","py-0":""}},[_c('v-text-field',{attrs:{"box":"","label":"Unidade","title":"Unidade","disabled":""},model:{value:(_vm.equipment.unity),callback:function ($$v) {_vm.$set(_vm.equipment, "unity", $$v)},expression:"equipment.unity"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","py-0":""}},[_c('v-text-field',{attrs:{"label":"Quantidade","box":""},model:{value:(_vm.equipment.quantity),callback:function ($$v) {_vm.$set(_vm.equipment, "quantity", $$v)},expression:"equipment.quantity"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","py-0":""}},[_c('v-text-field',{attrs:{"label":"Valor Unitário (R$)","box":""},model:{value:(_vm.equipment.value),callback:function ($$v) {_vm.$set(_vm.equipment, "value", $$v)},expression:"equipment.value"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"pb-3"},[_c('v-btn',{attrs:{"disabled":_vm.loading,"loading":_vm.loading,"block":"","round":"","color":"success lighten-1"},nativeOn:{"click":function($event){return _vm.save();}}},[_vm._v("\n          Salvar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DialogConsumables_vue__ = __webpack_require__(232);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6983dc02_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DialogConsumables_vue__ = __webpack_require__(290);
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DialogConsumables_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6983dc02_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DialogConsumables_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-dialog',{attrs:{"persistent":"","max-width":"600"},model:{value:(_vm.showDialogItem),callback:function ($$v) {_vm.showDialogItem=$$v},expression:"showDialogItem"}},[_c('v-card',[_c('v-toolbar',{staticClass:"elevation-1",attrs:{"color":"white"}},[_c('v-toolbar-title',{staticClass:"black--text font-weight-light"},[_vm._v(_vm._s(_vm.titleComponent))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"disabled":_vm.loading,"flat":"","color":"error","icon":"","round":""},nativeOn:{"click":function($event){return _vm.cancelNewItem()}}},[_c('v-icon',{attrs:{"large":"","color":"error"}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"justify-space-between":"","row":"","wrap":"","px-3":"","pt-4":""}},[_c('v-flex',{attrs:{"xs12":"","py-0":""}},[_c('v-autocomplete',{attrs:{"items":_vm.consumables,"box":"","item-text":"description","item-value":"description","label":"Descrição / Especificação","return-object":""},model:{value:(_vm.consumable),callback:function ($$v) {_vm.consumable=$$v},expression:"consumable"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","py-0":""}},[_c('v-text-field',{attrs:{"box":"","label":"Unidade","title":"Unidade","disabled":""},model:{value:(_vm.consumable.unity),callback:function ($$v) {_vm.$set(_vm.consumable, "unity", $$v)},expression:"consumable.unity"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","py-0":""}},[_c('v-text-field',{attrs:{"label":"Quantidade","box":""},model:{value:(_vm.consumable.quantity),callback:function ($$v) {_vm.$set(_vm.consumable, "quantity", $$v)},expression:"consumable.quantity"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","py-0":""}},[_c('v-text-field',{attrs:{"label":"Valor Unitário (R$)","box":""},model:{value:(_vm.consumable.value),callback:function ($$v) {_vm.$set(_vm.consumable, "value", $$v)},expression:"consumable.value"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"pb-3"},[_c('v-btn',{attrs:{"disabled":_vm.loading,"loading":_vm.loading,"block":"","round":"","color":"success lighten-1"},nativeOn:{"click":function($event){return _vm.save();}}},[_vm._v("\n          Salvar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","mt-5":""}},[_c('dialog-consumables',{ref:"dialogConsumables",on:{"addConsumable":_vm.addItemConsumables}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-end":"","align-center":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('h2',[_vm._v("Materiais de Consumo")])]),_vm._v(" "),_c('v-flex',{attrs:{"offset-xs2":"","xs2":""}},[(
              _vm.isContractInitialPage && _vm.materials.consumables.itens.length > 0
            )?_c('div',{staticStyle:{"width":"80%","float":"right"}},[_c('v-switch',{attrs:{"label":"Envio Automático"},on:{"change":function($event){return _vm.updateStatusSwitch('consumables')}},model:{value:(_vm.materials.consumables.automaticShipping),callback:function ($$v) {_vm.$set(_vm.materials.consumables, "automaticShipping", $$v)},expression:"materials.consumables.automaticShipping"}})],1):_c('div',{staticStyle:{"text-align":"right"}},[_c('v-btn',{staticClass:"mb-2",attrs:{"fab":"","dark":"","small":"","color":"primary","disabled":_vm.contractFinished},on:{"click":function($event){$event.preventDefault();return _vm.OpenDialogConsumables.apply(null, arguments)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("add")])],1)],1)])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"loading":_vm.loading,"headers":_vm.consumablesHeader,"search":_vm.search,"items":_vm.materials.consumables.itens,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.description))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.unity))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.quantity || 0))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v("\n            "+_vm._s(_vm.utilFormatter.setFormatValue(props.item.value))+"\n          ")]),_vm._v(" "),(!_vm.isContractInitialPage)?_c('td',{staticClass:"text-xs-center"},[_vm._v("\n            "+_vm._s(_vm.utilFormatter.setFormatValue(
                props.item.value * props.item.quantity
              ))+"\n          ")]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.lifetime || 0))]),_vm._v(" "),(_vm.isContractInitialPage)?_c('td',{staticClass:"text-xs-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(props.item.quantityApproved),expression:"props.item.quantityApproved"}],staticClass:"input-quantity",attrs:{"type":"number"},domProps:{"value":(props.item.quantityApproved)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(props.item, "quantityApproved", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.isContractInitialPage)?_c('td',{staticClass:"text-xs-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(props.item.shippingFrequency.quantity),expression:"props.item.shippingFrequency.quantity"}],staticClass:"input-quantity",attrs:{"type":"number"},domProps:{"value":(props.item.shippingFrequency.quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(props.item.shippingFrequency, "quantity", $event.target.value)}}})]):_c('td',{staticClass:"justify-center layout px-0 text-xs-center"},[_c('v-icon',{staticClass:"mr-2",attrs:{"color":"info","small":"","disabled":_vm.contractFinished},on:{"click":function($event){return _vm.OpenDialogConsumablesForEdition(props.item)}}},[_vm._v("edit")]),_vm._v(" "),_c('v-icon',{attrs:{"color":"error","small":"","disabled":_vm.contractFinished},on:{"click":function($event){return _vm.OpenDialogConsumablesForDelete(props.item)}}},[_vm._v("delete")])],1),_vm._v(" "),(_vm.isContractInitialPage)?_c('td',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-switch',{model:{value:(props.item.shippingFrequency.automaticShipping),callback:function ($$v) {_vm.$set(props.item.shippingFrequency, "automaticShipping", $$v)},expression:"props.item.shippingFrequency.automaticShipping"}})],1)],1)],1):_vm._e()]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_c('strong',[_vm._v(_vm._s(_vm.footerDynamicText))])])],2),_vm._v(" "),_c('alert-delete',{ref:"alertToDeleteComsumableItem",on:{"deleteItem":_vm.removeConsumableItem}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mt-5":""}},[_c('dialog-equipments',{ref:"dialogEquipments",on:{"addEquipment":_vm.addItemEquipment}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-end":"","align-center":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('h2',[_vm._v("Equipamentos")])]),_vm._v(" "),_c('v-flex',{attrs:{"offset-xs2":"","xs2":""}},[(
              _vm.isContractInitialPage && _vm.materials.equipments.itens.length > 0
            )?_c('div',{staticStyle:{"width":"80%","float":"right"}},[_c('v-switch',{attrs:{"label":"Envio Automático"},on:{"change":function($event){return _vm.updateStatusSwitch('equipments')}},model:{value:(_vm.materials.equipments.automaticShipping),callback:function ($$v) {_vm.$set(_vm.materials.equipments, "automaticShipping", $$v)},expression:"materials.equipments.automaticShipping"}})],1):_c('div',{staticStyle:{"text-align":"right"}},[_c('v-btn',{staticClass:"mb-2",attrs:{"fab":"","dark":"","small":"","color":"primary","disabled":_vm.contractFinished},on:{"click":function($event){$event.preventDefault();return _vm.OpenDialogEquipments.apply(null, arguments)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("add")])],1)],1)])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"loading":_vm.loading,"headers":_vm.equipmentsHeaders,"search":_vm.search,"items":_vm.materials.equipments.itens,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.description))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.stamp))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.quantity || 0))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v("\n            "+_vm._s(_vm.utilFormatter.setFormatValue(props.item.value))+"\n          ")]),_vm._v(" "),(!_vm.isContractInitialPage)?_c('td',{staticClass:"text-xs-center"},[_vm._v("\n            "+_vm._s(_vm.utilFormatter.setFormatValue(
                props.item.value * props.item.quantity
              ))+"\n          ")]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.lifetime))]),_vm._v(" "),(_vm.isContractInitialPage)?_c('td',{staticClass:"text-xs-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(props.item.quantityApproved),expression:"props.item.quantityApproved"}],staticClass:"input-quantity",attrs:{"type":"number"},domProps:{"value":(props.item.quantityApproved)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(props.item, "quantityApproved", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.isContractInitialPage)?_c('td',{staticClass:"text-xs-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(props.item.shippingFrequency.quantity),expression:"props.item.shippingFrequency.quantity"}],staticClass:"input-quantity",attrs:{"type":"number"},domProps:{"value":(props.item.shippingFrequency.quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(props.item.shippingFrequency, "quantity", $event.target.value)}}})]):_c('td',{staticClass:"justify-center layout px-0 text-xs-center"},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":"","color":"info","disabled":_vm.contractFinished},on:{"click":function($event){return _vm.OpenDialogEquipmentsForEdition(props.item)}}},[_vm._v("edit")]),_vm._v(" "),_c('v-icon',{attrs:{"small":"","color":"error","disabled":_vm.contractFinished},on:{"click":function($event){return _vm.OpenDialogEquipmentsForDelete(props.item)}}},[_vm._v("delete")])],1),_vm._v(" "),(_vm.isContractInitialPage)?_c('td',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-switch',{model:{value:(props.item.shippingFrequency.automaticShipping),callback:function ($$v) {_vm.$set(props.item.shippingFrequency, "automaticShipping", $$v)},expression:"props.item.shippingFrequency.automaticShipping"}})],1)],1)],1):_vm._e()]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_c('strong',[_vm._v(_vm._s(_vm.footerDynamicText))])])],2),_vm._v(" "),_c('alert-delete',{ref:"alertToDeleteEquipmentItem",on:{"deleteItem":_vm.removeEquipmentItem}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mt-5":""}},[_c('dialog-utensils',{ref:"dialogUtensils",on:{"addUtensil":_vm.addItemUtensil}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-end":"","align-center":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('h2',[_vm._v("Utensilios")])]),_vm._v(" "),_c('v-flex',{attrs:{"offset-xs2":"","xs2":""}},[(_vm.isContractInitialPage && _vm.materials.utensils.itens.length > 0)?_c('div',{staticStyle:{"width":"80%","float":"right"}},[_c('v-switch',{attrs:{"label":"Envio Automático"},on:{"change":function($event){return _vm.updateStatusSwitch('utensils')}},model:{value:(_vm.materials.utensils.automaticShipping),callback:function ($$v) {_vm.$set(_vm.materials.utensils, "automaticShipping", $$v)},expression:"materials.utensils.automaticShipping"}})],1):_c('div',{staticStyle:{"text-align":"right"}},[_c('v-btn',{staticClass:"mb-2",attrs:{"fab":"","dark":"","small":"","color":"primary","disabled":_vm.contractFinished},on:{"click":function($event){$event.preventDefault();return _vm.OpenDialogUtensils.apply(null, arguments)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("add")])],1)],1)])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.utensilHeaders,"search":_vm.search,"hide-actions":"","items":_vm.materials.utensils.itens},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.description))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.unity))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.quantity || 0))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v("\n            "+_vm._s(_vm.utilFormatter.setFormatValue(props.item.value))+"\n          ")]),_vm._v(" "),(!_vm.isContractInitialPage)?_c('td',{staticClass:"text-xs-center"},[_vm._v("\n            "+_vm._s(_vm.utilFormatter.setFormatValue(
                props.item.value * props.item.quantity
              ))+"\n          ")]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.lifetime))]),_vm._v(" "),(_vm.isContractInitialPage)?_c('td',{staticClass:"text-xs-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(props.item.quantityApproved),expression:"props.item.quantityApproved"}],staticClass:"input-quantity",attrs:{"type":"number"},domProps:{"value":(props.item.quantityApproved)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(props.item, "quantityApproved", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.isContractInitialPage)?_c('td',{staticClass:"text-xs-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(props.item.shippingFrequency.quantity),expression:"props.item.shippingFrequency.quantity"}],staticClass:"input-quantity",attrs:{"type":"number","mask":"##"},domProps:{"value":(props.item.shippingFrequency.quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(props.item.shippingFrequency, "quantity", $event.target.value)}}})]):_c('td',{staticClass:"justify-center layout px-0"},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":"","color":"info","disabled":_vm.contractFinished},on:{"click":function($event){return _vm.OpenDialogUtensilsForEdition(props.item)}}},[_vm._v("edit")]),_vm._v(" "),_c('v-icon',{attrs:{"small":"","color":"error","disabled":_vm.contractFinished},on:{"click":function($event){return _vm.OpenDialogUtensilsForDelete(props.item)}}},[_vm._v("delete")])],1),_vm._v(" "),(_vm.isContractInitialPage)?_c('td',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-switch',{model:{value:(props.item.shippingFrequency.automaticShipping),callback:function ($$v) {_vm.$set(props.item.shippingFrequency, "automaticShipping", $$v)},expression:"props.item.shippingFrequency.automaticShipping"}})],1)],1)],1):_vm._e()]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_c('strong',[_vm._v(_vm._s(_vm.footerDynamicText))])])],2),_vm._v(" "),_c('alert-delete',{ref:"alertToDeleteUtensilItem",on:{"deleteItem":_vm.removeUtensilItem}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mt-5":""}},[_c('DialogUniformAndEPIs',{ref:"dialogUniformAndEPIs",on:{"addUniformAndEPI":_vm.addItemUniformAndEPIs}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-end":"","align-center":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('h2',[_vm._v("Uniformes e EPI's")])]),_vm._v(" "),_c('v-flex',{attrs:{"offset-xs2":"","xs2":""}},[(
              _vm.isContractInitialPage &&
                _vm.materials.uniformsAndEPIs.itens.length > 0
            )?_c('div',{staticStyle:{"width":"80%","float":"right"}},[_c('v-switch',{attrs:{"label":"Envio Automático"},on:{"change":function($event){return _vm.updateStatusSwitch('uniformsAndEPIs')}},model:{value:(_vm.materials.uniformsAndEPIs.automaticShipping),callback:function ($$v) {_vm.$set(_vm.materials.uniformsAndEPIs, "automaticShipping", $$v)},expression:"materials.uniformsAndEPIs.automaticShipping"}})],1):_c('div',{staticStyle:{"text-align":"right"}},[_c('v-btn',{staticClass:"mb-2",attrs:{"fab":"","dark":"","small":"","color":"primary","disabled":_vm.contractFinished},on:{"click":function($event){$event.preventDefault();return _vm.OpenDialogUniformAndEPIs.apply(null, arguments)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("add")])],1)],1)])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.uniformsAndEPIsHeaders,"search":_vm.search,"items":_vm.materials.uniformsAndEPIs.itens},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.description))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.unity))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.quantity || 0))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v("\n            "+_vm._s(_vm.utilFormatter.setFormatValue(props.item.value))+"\n          ")]),_vm._v(" "),(!_vm.isContractInitialPage)?_c('td',{staticClass:"text-xs-center"},[_vm._v("\n            "+_vm._s(_vm.utilFormatter.setFormatValue(
                props.item.value * props.item.quantity
              ))+"\n          ")]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.lifetime))]),_vm._v(" "),(_vm.isContractInitialPage)?_c('td',{staticClass:"text-xs-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(props.item.quantityApproved),expression:"props.item.quantityApproved"}],staticClass:"input-quantity",attrs:{"type":"number"},domProps:{"value":(props.item.quantityApproved)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(props.item, "quantityApproved", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.isContractInitialPage)?_c('td',{staticClass:"text-xs-center"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(props.item.shippingFrequency.quantity),expression:"props.item.shippingFrequency.quantity",modifiers:{"number":true}}],staticClass:"input-quantity",attrs:{"type":"number","mask":"##"},domProps:{"value":(props.item.shippingFrequency.quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(props.item.shippingFrequency, "quantity", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]):_c('td',{staticClass:"justify-center layout px-0"},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":"","color":"info","disabled":_vm.contractFinished},on:{"click":function($event){return _vm.OpenDialogUniformAndEPIsForEdition(props.item)}}},[_vm._v("edit")]),_vm._v(" "),_c('v-icon',{attrs:{"small":"","color":"error","disabled":_vm.contractFinished},on:{"click":function($event){return _vm.OpenDialogUniformAndEPIsForDelete(props.item)}}},[_vm._v("delete")])],1),_vm._v(" "),(_vm.isContractInitialPage)?_c('td',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-switch',{model:{value:(props.item.shippingFrequency.automaticShipping),callback:function ($$v) {_vm.$set(props.item.shippingFrequency, "automaticShipping", $$v)},expression:"props.item.shippingFrequency.automaticShipping"}})],1)],1)],1):_vm._e()]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_c('strong',[_vm._v(_vm._s(_vm.footerDynamicText))])])],2),_vm._v(" "),_c('alert-delete',{ref:"alertToDeleteUniformAndEPIsItem",on:{"deleteItem":_vm.removeUniformItem}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


var headers = [{
  text: "Descrição / Especificação",
  align: "left",
  sortable: true,
  value: "description"
}, {
  text: "Unidade",
  align: "center",
  value: "unity"
}, {
  text: "Quantidade",
  align: "center",
  value: "quantity"
}, {
  text: "Valor Unitário",
  align: "center",
  value: "unitaryValue"
}, {
  text: "Sub-Total",
  align: "center",
  sortable: false
}, {
  text: "Vida Útil (mês)",
  align: "center",
  value: "lifetime"
}, {
  text: "Valor Mensal",
  align: "center",
  value: "monthlyValue"
}, {
  text: "Ações",
  align: "center",
  value: "name",
  sortable: false
}];

var Headers = function () {
  function Headers() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Headers);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Headers, null, [{
    key: "getHeaders",
    value: function getHeaders() {
      return headers;
    }
  }]);

  return Headers;
}();

/* harmony default export */ __webpack_exports__["a"] = (Headers);

/***/ }),
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnalyticalWorksheet_vue__ = __webpack_require__(264);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_395423c7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnalyticalWorksheet_vue__ = __webpack_require__(364);
function injectStyle (ssrContext) {
  __webpack_require__(323)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnalyticalWorksheet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_395423c7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnalyticalWorksheet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(324);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(155)("2504697c", content, true, {});

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(154)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"AnalyticalWorksheet.vue","sourceRoot":""}]);

// exports


/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Attachment_vue__ = __webpack_require__(265);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3676dc64_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Attachment_vue__ = __webpack_require__(328);
function injectStyle (ssrContext) {
  __webpack_require__(326)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Attachment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3676dc64_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Attachment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(327);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(155)("0aa84c5d", content, true, {});

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(154)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"Attachment.vue","sourceRoot":""}]);

// exports


/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.editingNotAllowed)?_c('v-container',{attrs:{"fluid":"","grid-list-sm":""}},[_c('v-layout',{attrs:{"justify-space-between":"","row":"","wrap":""}},_vm._l((_vm.informations),function(item,i){return _c('v-flex',{key:i,class:item.class},[_c('v-list',{staticClass:"py-0 elevation-2",attrs:{"three-line":"","light":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"text--primary"},[_vm._v(_vm._s(item.subtitle))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm._f("currency")(item.value)))])],1)],1)],1)],1)}),1),_vm._v(" "),_c('v-layout',{attrs:{"justify-space-between":"","row":"","wrap":""}},[(!_vm.budgetFinalized)?_c('v-flex',{attrs:{"xs12":""}},[(_vm.hasBond)?_c('v-alert',{staticClass:"mt-2",staticStyle:{"font-size":"18px !important"},attrs:{"value":true,"type":"warning","dismissible":"","icon":"priority_high","outline":""}},[_c('strong',[_vm._v("Atenção!")]),_vm._v(" Existem outros anexos vínculados à este!\n        ")]):(!_vm.moduleFive[this.attachment].bond)?_c('v-btn',{attrs:{"color":"green","block":"","large":"","dark":""},on:{"click":_vm.openBondDialog}},[_vm._v("Vincular à outro Anexo")]):_c('v-btn',{attrs:{"color":"green","block":"","large":"","dark":""},on:{"click":function($event){_vm.unbondDialog = true}}},[_vm._v("Desvincular")])],1):_vm._e(),_vm._v(" "),(_vm.moduleFive[this.attachment].bond != '')?_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{staticStyle:{"font-size":"18px !important"},attrs:{"type":"warning","dismissible":"","icon":"priority_high","outline":""},model:{value:(_vm.bondAlert),callback:function ($$v) {_vm.bondAlert=$$v},expression:"bondAlert"}},[_c('strong',[_vm._v("Atenção!")]),_vm._v(" Este anexo está vinculado à "),_c('strong',[_vm._v(_vm._s(_vm.bondSheetDescription))]),_vm._v(", clique no botão acima para desvincular.\n        ")])],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-space-between":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"mt-2 pt-2 elevation-3"},[_c('v-layout',{attrs:{"justify-space-between":"","wrap":"","px-3":""}},[_c('v-radio-group',{attrs:{"label":"Forma de Cálculo:","row":"","readonly":_vm.budgetFinalized},model:{value:(_vm.depreciation),callback:function ($$v) {_vm.depreciation=$$v},expression:"depreciation"}},[_c('v-radio',{staticClass:"ml-3",attrs:{"label":"Taxa de Depreciação (%)","value":"true"}}),_vm._v(" "),_c('v-radio',{staticClass:"ml-3",attrs:{"label":"Vida Útil (mês)","value":"false"}})],1)],1)],1)],1)],1),_vm._v(" "),(!_vm.moduleFive[this.attachment].bond)?_c('v-layout',{attrs:{"row":"","wrap":""}},[(!_vm.budgetFinalized)?_c('v-flex',{attrs:{"xs12":""}},[(_vm.show)?_c('v-card',{staticClass:"mt-2 elevation-3"},[_c('v-layout',{attrs:{"justify-space-between":"","wrap":"","pa-3":""}},[_c('v-spacer'),_vm._v(" "),_c('v-icon',{on:{"click":function($event){_vm.show = !_vm.show; _vm.input = {}}}},[_vm._v("close")])],1),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.validForm),callback:function ($$v) {_vm.validForm=$$v},expression:"validForm"}},[_c('v-layout',{attrs:{"justify-space-between":"","wrap":"","px-3":""}},[_c('v-flex',{attrs:{"xs12":"","md4":"","py-0":""}},[_c('v-autocomplete',{attrs:{"items":_vm.filteredInputs,"box":"","item-text":_vm.textDescription,"item-value":_vm.textDescription,"label":"Descrição / Especificação","return-object":"","rules":_vm.inputRules},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":"","py-0":""}},[_c('v-text-field',{attrs:{"box":"","label":"Unidade","title":"Unidade","disabled":"","rules":_vm.inputRules},model:{value:(_vm.input.unity),callback:function ($$v) {_vm.$set(_vm.input, "unity", $$v)},expression:"input.unity"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":"","py-0":""}},[_c('v-text-field',{attrs:{"label":"Quantidade","box":"","type":"number","rules":_vm.inputRules},model:{value:(_vm.input.quantity),callback:function ($$v) {_vm.$set(_vm.input, "quantity", $$v)},expression:"input.quantity"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":"","py-0":""}},[_c('v-text-field',{attrs:{"box":"","label":_vm.labelDepreciation,"type":"number","rules":_vm.inputRules},model:{value:(_vm.input.lifetime),callback:function ($$v) {_vm.$set(_vm.input, "lifetime", $$v)},expression:"input.lifetime"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":"","py-0":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","label":"Valor Unitário (R$)","rules":_vm.inputRules},model:{value:(_vm.input.value),callback:function ($$v) {_vm.$set(_vm.input, "value", $$v)},expression:"input.value"}},'v-currency-field',_vm.currency_config,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":"","offset-md10":"","py-0":""}},[_c('v-btn',{attrs:{"color":"success lighten-1","large":"","block":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.save();}}},[_vm._v("Salvar")])],1)],1)],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","pt-4":""}},[_c('v-toolbar',{staticClass:"elevation-1",attrs:{"flat":"","card":"","color":"grey lighten-3"}},[_c('v-toolbar-title',{staticClass:"font-weight-light"},[_vm._v("Itens Selecionados")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Pesquisar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[(!_vm.budgetFinalized)?_c('v-btn',{staticClass:"mb-2",attrs:{"slot":"activator","color":"info","round":"","icon":""},on:{"click":function($event){_vm.show = !_vm.show}},slot:"activator"},[_c('v-icon',[_vm._v("add")])],1):_vm._e()],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"search":_vm.search,"rows-per-page-text":"Registros por Página","rows-per-page-items":[10, 30, 50, 100],"items":_vm.selectedItems},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.description))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.unity))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.quantity))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm._f("currency")(props.item.value)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm._f("currency")((props.item.value * props.item.quantity))))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.lifetime)+" "+_vm._s(_vm.depreciation == "true" ? " %" : " (meses)"))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm._f("currency")(_vm.amountCalculate(props.item))))]),_vm._v(" "),(!_vm.budgetFinalized)?_c('td',{staticClass:"text-xs-center"},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.editItem(props.item)}}},[_vm._v("edit")]),_vm._v(" "),_c('v-icon',{attrs:{"small":""},on:{"click":function($event){return _vm.openRemoveDialog(props.item)}}},[_vm._v("delete")])],1):_c('td',{staticClass:"text-xs-center"},[_vm._v(" - ")])]}},{key:"pageText",fn:function(props){return [_vm._v("\n            "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de "+_vm._s(props.itemsLength)+"\n          ")]}}],null,false,735175014)},[_vm._v(" "),_vm._v(" "),_c('template',{slot:"no-data"},[_c('strong',[_vm._v(" "+_vm._s(_vm.footerDynamicText)+" ")])]),_vm._v(" "),_c('div',{attrs:{"slot":"no-results","value":true},slot:"no-results"},[_c('h3',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm.emptySearchText)+" \""+_vm._s(_vm.search)+"\".")])])],2)],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","overlay":true,"max-width":"500px","transition":"dialog-transition"},model:{value:(_vm.removeDialog),callback:function ($$v) {_vm.removeDialog=$$v},expression:"removeDialog"}},[_c('v-toolbar',{staticClass:"elevation-1",attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"font-weight-light"},[_vm._v("\n        "+_vm._s(_vm.removeDialogTitle)+"\n      ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"color":"error","title":"Cancelar","icon":"","round":"","flat":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.removeDialog = false}}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('p',[_vm._v("Tem certeza que deseja excluir este item?")])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{staticClass:"mb-3",attrs:{"color":"success lighten-1","block":"","outline":"","round":""},on:{"click":_vm.deleteItem}},[_vm._v("Aceitar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","overlay":true,"max-width":"500px","transition":"dialog-transition"},model:{value:(_vm.unbondDialog),callback:function ($$v) {_vm.unbondDialog=$$v},expression:"unbondDialog"}},[_c('v-toolbar',{staticClass:"elevation-1",attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"font-weight-light"},[_vm._v("\n        Remover Vínculo\n      ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"color":"error","title":"Cancelar","icon":"","round":"","flat":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.unbondDialog = false}}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('p',[_vm._v("Tem certeza que deseja remover o vínculo?")])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{staticClass:"mb-3",attrs:{"color":"success lighten-1","block":"","outline":"","round":""},on:{"click":_vm.unbond}},[_vm._v("Confirmar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","overlay":true,"max-width":"500px","transition":"dialog-transition"},model:{value:(_vm.bondDialog),callback:function ($$v) {_vm.bondDialog=$$v},expression:"bondDialog"}},[_c('v-toolbar',{staticClass:"elevation-1",attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"font-weight-light"},[_vm._v("\n        "+_vm._s(_vm.bondDialogTitle)+"\n      ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"color":"error","title":"Cancelar","icon":"","round":"","flat":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.bondDialog = false; _vm.sheetBondId=null}}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('p',[_vm._v("Tem certeza que deseja vincular este anexo?")]),_vm._v(" "),_c('p',{staticClass:"red--text"},[_vm._v("Uma vez vinculado você perderá os itens cadastrados neste anexo!")]),_vm._v(" "),_c('v-layout',[(_vm.analyticalsOfBudget)?_c('v-flex',[_c('p',[_vm._v("Selecione a Planilha que deseja vincular")]),_vm._v(" "),_c('v-radio-group',{model:{value:(_vm.sheetBondId),callback:function ($$v) {_vm.sheetBondId=$$v},expression:"sheetBondId"}},_vm._l((_vm.analyticalsOfBudget),function(item){return _c('v-radio',{key:item._id,attrs:{"label":((item.header.professionalCategory.occupation.name) + " " + (item.header.additionalInfo) + " - " + (item.header.deliveryAddress.sector)),"value":item._id}})}),1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{staticClass:"mb-3",attrs:{"color":"success lighten-1","block":"","outline":"","round":"","disabled":!_vm.sheetBondId},on:{"click":_vm.confirmBond}},[_vm._v("Confirmar")])],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.snackbar.color,"multi-line":"","timeout":_vm.snackbar.timeout,"vertical":"","right":"","button":""},model:{value:(_vm.snackbar.visible),callback:function ($$v) {_vm.$set(_vm.snackbar, "visible", $$v)},expression:"snackbar.visible"}},[_c('strong',[_vm._v(_vm._s(_vm.snackbar.title))]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","flat":""},on:{"click":function($event){_vm.snackbar.visible = false}}},[_vm._v("\n      Fechar\n    ")])],1),_vm._v(" "),_c('v-alert',{staticClass:"ma-5",staticStyle:{"font-size":"18px !important"},attrs:{"color":"warning","icon":"priority_high","outline":""},model:{value:(_vm.editingNotAllowed),callback:function ($$v) {_vm.editingNotAllowed=$$v},expression:"editingNotAllowed"}},[_c('strong',[_vm._v("A opção \"Venda Variável\" está selecionada para \""+_vm._s(_vm.filter)+"\"!")]),_vm._v(" "),_c('br'),_vm._v("Por isso não é possível fazer alterações nesta área.\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabHeader_vue__ = __webpack_require__(266);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71565592_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabHeader_vue__ = __webpack_require__(341);
function injectStyle (ssrContext) {
  __webpack_require__(330)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71565592_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(331);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(155)("d50cbe40", content, true, {});

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(154)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"TabHeader.vue","sourceRoot":""}]);

// exports


/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormProfessionalCategory_vue__ = __webpack_require__(267);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c4719a4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormProfessionalCategory_vue__ = __webpack_require__(339);
function injectStyle (ssrContext) {
  __webpack_require__(333)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormProfessionalCategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c4719a4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormProfessionalCategory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(334);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(155)("71f66ade", content, true, {});

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(154)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"FormProfessionalCategory.vue","sourceRoot":""}]);

// exports


/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSetConventionItem_vue__ = __webpack_require__(268);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5667753d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSetConventionItem_vue__ = __webpack_require__(338);
function injectStyle (ssrContext) {
  __webpack_require__(336)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSetConventionItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5667753d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSetConventionItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(337);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(155)("3d3f66ba", content, true, {});

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(154)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"FormSetConventionItem.vue","sourceRoot":""}]);

// exports


/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('v-card-title',[_c('h2',[_vm._v("Adicionar Função à Convenção")])]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"label":"Função","disabled":""},model:{value:(_vm.occupationSelected),callback:function ($$v) {_vm.occupationSelected=$$v},expression:"occupationSelected"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Salário Base (R$)","autofocus":""},model:{value:(_vm.item.basicSalary),callback:function ($$v) {_vm.$set(_vm.item, "basicSalary", $$v)},expression:"item.basicSalary"}}),_vm._v(" "),_c('label',[_vm._v("Adicionar gratificação")]),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","outline":"","small":"","fab":"","color":"teal"},slot:"activator"},[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('span',[_vm._v("Adicionar gratificação")])],1)],1),_vm._v(" "),_c('span',{staticClass:"blue--text pa-3"},[_vm._v("Os campos marcados com o (*) são obrigatórios")]),_c('br'),_c('br'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","dark":""},on:{"click":function($event){return _vm.cancel();}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","dark":""},on:{"click":function($event){return _vm.save();}}},[_vm._v("Salvar")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('v-card-title',[_c('h2',[_vm._v("Nova Função")])]),_vm._v(" "),_c('v-card-text',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Descrição*","box":"","autofocus":""},model:{value:(_vm.occupation.description),callback:function ($$v) {_vm.$set(_vm.occupation, "description", $$v)},expression:"occupation.description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Código CBO*","box":""},model:{value:(_vm.occupation.cbo),callback:function ($$v) {_vm.$set(_vm.occupation, "cbo", $$v)},expression:"occupation.cbo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{attrs:{"label":"Observações","box":"","no-resize":""},model:{value:(_vm.occupation.observation),callback:function ($$v) {_vm.$set(_vm.occupation, "observation", $$v)},expression:"occupation.observation"}})],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Incluir esta Função na Convenção"},model:{value:(_vm.checkbox),callback:function ($$v) {_vm.checkbox=$$v},expression:"checkbox"}})],1),_vm._v(" "),_c('span',{staticClass:"blue--text pa-3"},[_vm._v("Os campos marcados com o (*) são obrigatórios")]),_c('br'),_c('br'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","dark":""},on:{"click":function($event){return _vm.cancel();}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","dark":""},on:{"click":function($event){return _vm.save();}}},[_vm._v("Salvar")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500"},model:{value:(_vm.showDialogSetConventionItem),callback:function ($$v) {_vm.showDialogSetConventionItem=$$v},expression:"showDialogSetConventionItem"}},[_c('form-set-convention-item',{attrs:{"year-convention-selected":_vm.yearConventionSelected,"occupation-selected":_vm.occupationSaved}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /* 
   Essa é uma regra genérica que verirfica se 0 v-model está com algum 
   valor se estiver vazio ela irá pintar de vermelho e imprimir a mensagem.
   É possivel implementar mais de uma regra por variável, mas lembre-se, ao
   colocar mais de uma regra o campo terá que passar em todas, caso contrário 
   ele será invalidado.  
   exemplos de regras:
   v => (v && v.length <= 10) || 'Name must be less than 10 characters',
   v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
   */
  ruleToCheckIfEmailIsValid: function ruleToCheckIfEmailIsValid(value) {
    return (/.+@.+\..+/.test(v) || 'Utilize um email válido!'
    );
  },
  ruleToCheckIfTheValuesInTheFields: function ruleToCheckIfTheValuesInTheFields(value) {
    return !!value || 'Campo obrigatório!';
  },
  ruleToCheckTheLengthOfString: function ruleToCheckTheLengthOfString(value) {
    return v && v.length <= 10 || 'Name must be less than 10 characters';
  }
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[(_vm.header.collectiveConvention)?_c('v-layout',{attrs:{"justify-space-between":"","row":"","wrap":""}},_vm._l((_vm.informations),function(item,i){return _c('v-flex',{key:i,class:item.class},[_c('v-list',{staticClass:"py-0 elevation-2",attrs:{"three-line":"","light":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"text--primary"},[_vm._v(_vm._s(item.subtitle))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm._f("currency")(item.value)))])],1)],1)],1)],1)}),1):_vm._e(),_vm._v(" "),_c('v-divider',{staticClass:"mt-3"}),_vm._v(" "),_c('v-form',{ref:"form",model:{value:(_vm.formValid),callback:function ($$v) {_vm.formValid=$$v},expression:"formValid"}},[_c('v-layout',{attrs:{"justify-space-between":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","pa-0":""}},[_c('v-subheader',[_vm._v("Setor da Prestação do Serviço")]),_vm._v(" "),_c('v-radio-group',{attrs:{"row":"","readonly":_vm.budgetFinalized},on:{"change":_vm.changeSector},model:{value:(_vm.sectorType),callback:function ($$v) {_vm.sectorType=$$v},expression:"sectorType"}},[_c('v-radio',{attrs:{"label":"Outro Setor","value":"OTHER"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Setor SEDE","value":"SEDE"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"justify-space-between":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"type":"text","rules":_vm.ruleGeneric,"label":"Setor","box":"","readonly":_vm.budgetFinalized},model:{value:(_vm.header.deliveryAddress.sector),callback:function ($$v) {_vm.$set(_vm.header.deliveryAddress, "sector", $$v)},expression:"header.deliveryAddress.sector"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":""}},[_c('v-text-field',{attrs:{"type":"text","rules":_vm.ruleGeneric,"label":"CEP","box":"","readonly":_vm.budgetFinalized},on:{"input":_vm.findAddressByCep},model:{value:(_vm.header.deliveryAddress.cep),callback:function ($$v) {_vm.$set(_vm.header.deliveryAddress, "cep", $$v)},expression:"header.deliveryAddress.cep"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"type":"text","rules":_vm.ruleGeneric,"label":"Logradouro","box":"","disabled":_vm.isSearchingAddress,"readonly":_vm.budgetFinalized},model:{value:(_vm.header.deliveryAddress.addressType),callback:function ($$v) {_vm.$set(_vm.header.deliveryAddress, "addressType", $$v)},expression:"header.deliveryAddress.addressType"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":""}},[_c('v-text-field',{attrs:{"type":"text","rules":_vm.ruleGeneric,"label":"Número","box":"","disabled":_vm.isSearchingAddress,"readonly":_vm.budgetFinalized},model:{value:(_vm.header.deliveryAddress.number),callback:function ($$v) {_vm.$set(_vm.header.deliveryAddress, "number", $$v)},expression:"header.deliveryAddress.number"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Complemento","box":"","disabled":_vm.isSearchingAddress,"readonly":_vm.budgetFinalized},model:{value:(_vm.header.deliveryAddress.complement),callback:function ($$v) {_vm.$set(_vm.header.deliveryAddress, "complement", $$v)},expression:"header.deliveryAddress.complement"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-text-field',{attrs:{"type":"text","rules":_vm.ruleGeneric,"label":"Bairro","box":"","disabled":_vm.isSearchingAddress,"readonly":_vm.budgetFinalized},model:{value:(_vm.header.deliveryAddress.district),callback:function ($$v) {_vm.$set(_vm.header.deliveryAddress, "district", $$v)},expression:"header.deliveryAddress.district"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-autocomplete',{attrs:{"label":"Município","rules":_vm.ruleGeneric,"items":_vm.cities,"item-text":_vm.cityText,"return-object":"","dense":"","solo":"","box":"","disabled":_vm.isSearchingAddress,"readonly":_vm.budgetFinalized},scopedSlots:_vm._u([(!_vm.budgetFinalized)?{key:"append-outer",fn:function(){return [_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({on:{"click":_vm.buttonAddNewCity}},on),[_vm._v("add")])]}}],null,false,99973738)},[_vm._v("\n                      Cadastrar nova Cidade!\n                    ")])]},proxy:true}:null],null,true),model:{value:(_vm.header.deliveryAddress.cityOfService),callback:function ($$v) {_vm.$set(_vm.header.deliveryAddress, "cityOfService", $$v)},expression:"header.deliveryAddress.cityOfService"}})],1)],1)],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"pb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"justify-space-between":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-autocomplete',{attrs:{"label":"Unidade de medida","rules":_vm.ruleGeneric,"items":_vm.unitsOfMeasurement,"box":"","readonly":_vm.budgetFinalized},model:{value:(_vm.header.unitOfMeasurement),callback:function ($$v) {_vm.$set(_vm.header, "unitOfMeasurement", $$v)},expression:"header.unitOfMeasurement"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-autocomplete',{attrs:{"label":"Descrição do Serviço","rules":_vm.ruleGeneric,"items":_vm.offices,"item-text":"description","return-object":"","box":"","dense":"","readonly":_vm.budgetFinalized},model:{value:(_vm.header.office),callback:function ($$v) {_vm.$set(_vm.header, "office", $$v)},expression:"header.office"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"type":"number","min":"1","label":"Quantidade de empregados estimada total a contratar","rules":_vm.ruleGeneric,"readonly":_vm.budgetFinalized,"box":""},model:{value:(_vm.header.numberOfEmployees),callback:function ($$v) {_vm.$set(_vm.header, "numberOfEmployees", $$v)},expression:"header.numberOfEmployees"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-autocomplete',{attrs:{"label":"Ano do acordo, convenção ou dissído coletivo","items":_vm.agreementsYear,"rules":_vm.ruleGeneric,"persistent-hint":"","readonly":_vm.budgetFinalized,"item-text":"year","item-value":"_id","dense":"","box":"","disabled":_vm.hasServiceStationGratification,"hint":_vm.msgCollectiveConvention},model:{value:(_vm.header.collectiveConvention),callback:function ($$v) {_vm.$set(_vm.header, "collectiveConvention", $$v)},expression:"header.collectiveConvention"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-autocomplete',{attrs:{"label":"Categoria profissional","items":_vm.agreementsYearSelectedItems,"item-text":_vm.occupationName,"hint":_vm.professionalCategoryHint,"dense":"","return-object":"","readonly":_vm.budgetFinalized,"persistent-hint":"","box":"","disabled":!_vm.header.collectiveConvention,"rules":_vm.ruleGeneric},model:{value:(_vm.header.professionalCategory),callback:function ($$v) {_vm.$set(_vm.header, "professionalCategory", $$v)},expression:"header.professionalCategory"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Carga Horária","box":"","readonly":_vm.budgetFinalized},model:{value:(_vm.header.additionalInfo),callback:function ($$v) {_vm.$set(_vm.header, "additionalInfo", $$v)},expression:"header.additionalInfo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Data base da categoria","box":"","type":"date","rules":_vm.ruleGeneric,"readonly":_vm.budgetFinalized},model:{value:(_vm.header.dataBaseOfTheCategory),callback:function ($$v) {_vm.$set(_vm.header, "dataBaseOfTheCategory", $$v)},expression:"header.dataBaseOfTheCategory"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{attrs:{"rules":_vm.ruleGeneric,"label":"Notas Principais","rows":"5","box":"","readonly":_vm.budgetFinalized},model:{value:(_vm.header.mainNotes),callback:function ($$v) {_vm.$set(_vm.header, "mainNotes", $$v)},expression:"header.mainNotes"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{attrs:{"rules":_vm.ruleGeneric,"label":"Notas Complementares","rows":"5","box":"","readonly":_vm.budgetFinalized},model:{value:(_vm.header.complementariesNotes),callback:function ($$v) {_vm.$set(_vm.header, "complementariesNotes", $$v)},expression:"header.complementariesNotes"}})],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500"},model:{value:(_vm.showDialogAddNewProfessionalCategory),callback:function ($$v) {_vm.showDialogAddNewProfessionalCategory=$$v},expression:"showDialogAddNewProfessionalCategory"}},[_c('form-professional-category',{attrs:{"year-convention-selected":_vm.header.collectiveConvention}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500"},model:{value:(_vm.showDialogAddNewCity),callback:function ($$v) {_vm.showDialogAddNewCity=$$v},expression:"showDialogAddNewCity"}},[_c('form-city')],1),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.snackbar.color,"multi-line":"","timeout":_vm.snackbar.timeout,"vertical":"","right":"","button":""},model:{value:(_vm.snackbar.visible),callback:function ($$v) {_vm.$set(_vm.snackbar, "visible", $$v)},expression:"snackbar.visible"}},[_c('strong',[_vm._v(_vm._s(_vm.snackbar.title))]),_vm._v(" "+_vm._s(_vm.snackbar.subtitle)+"\n    "),_c('v-btn',{attrs:{"dark":"","flat":""},on:{"click":function($event){_vm.snackbar.visible = false}}},[_vm._v("\n      Fechar\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabModule1_vue__ = __webpack_require__(269);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b107edde_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabModule1_vue__ = __webpack_require__(343);
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabModule1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b107edde_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabModule1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"justify-space-between":"","row":"","wrap":""}},_vm._l((_vm.informations),function(item,i){return _c('v-flex',{key:i,class:item.class},[_c('v-list',{staticClass:"py-0 elevation-2",attrs:{"three-line":"","light":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"text--primary"},[_vm._v(_vm._s(item.subtitle))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm._f("currency")(item.value)))])],1)],1)],1)],1)}),1),_vm._v(" "),(_vm.serviceStationGratification && _vm.serviceStationGratification.length > 0)?_c('v-layout',{attrs:{"justify-start":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('v-subheader',[_vm._v("Gratificação por Posto de Serviço")])],1),_vm._v(" "),_vm._l((_vm.serviceStationGratification),function(item){return _c('v-flex',{key:item._id,attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-checkbox',{staticClass:"mt-0",attrs:{"label":item.description,"return-object":"","hint":_vm._f("currency")(item.value),"persistent-hint":"","value":item,"readonly":_vm.budgetFinalized},model:{value:(_vm.moduleOne.serviceStationGratification),callback:function ($$v) {_vm.$set(_vm.moduleOne, "serviceStationGratification", $$v)},expression:"moduleOne.serviceStationGratification"}})],1)})],2):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"justify-start":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('v-subheader',[_vm._v("Adicionais de Insalubridade e Periculosidade")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","label":"Adicional de Insalubridade (em %)","hint":_vm._f("currency")(_vm.additionalHealthValue),"persistent-hint":"","readonly":_vm.budgetFinalized},model:{value:(_vm.moduleOne.percentOfAdditionalHealth),callback:function ($$v) {_vm.$set(_vm.moduleOne, "percentOfAdditionalHealth", $$v)},expression:"moduleOne.percentOfAdditionalHealth"}},'v-currency-field',_vm.currency_config_percent,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","label":"Adicional de Periculosidade (em %)","hint":_vm._f("currency")(_vm.additionalDangerValue),"persistent-hint":"","readonly":_vm.budgetFinalized},model:{value:(_vm.moduleOne.percentOfAdditionalDanger),callback:function ($$v) {_vm.$set(_vm.moduleOne, "percentOfAdditionalDanger", $$v)},expression:"moduleOne.percentOfAdditionalDanger"}},'v-currency-field',_vm.currency_config_percent,false))],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-start":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Adicional Noturno","readonly":_vm.budgetFinalized},nativeOn:{"click":function($event){$event.preventDefault();return _vm.checkNocturneAdditional();}},model:{value:(_vm.moduleOne.additionalNocturne.has),callback:function ($$v) {_vm.$set(_vm.moduleOne.additionalNocturne, "has", $$v)},expression:"moduleOne.additionalNocturne.has"}})],1),_vm._v(" "),(_vm.moduleOne.additionalNocturne.has)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"justify-space-between":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-select',{staticClass:"pr-1",attrs:{"label":"Jornada de Trabalho","items":_vm.worksJournies,"item-text":"text","item-value":"value","hint":_vm._f("currency")(_vm.nocturneNormalHourValue,{symbol: 'Valor da Hora de Trabalho: R$'}),"persistent-hint":"","box":"","readonly":_vm.budgetFinalized},model:{value:(_vm.moduleOne.additionalNocturne.workJournie),callback:function ($$v) {_vm.$set(_vm.moduleOne.additionalNocturne, "workJournie", $$v)},expression:"moduleOne.additionalNocturne.workJournie"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","label":"Adicional Noturno (em %)","hint":_vm._f("currency")(_vm.nocturneNormalHourAddPercentHint),"persistent-hint":"","readonly":_vm.budgetFinalized},model:{value:(_vm.moduleOne.additionalNocturne.percent),callback:function ($$v) {_vm.$set(_vm.moduleOne.additionalNocturne, "percent", $$v)},expression:"moduleOne.additionalNocturne.percent"}},'v-currency-field',_vm.currency_config_percent,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{staticClass:"pr-1",attrs:{"type":"number","min":"0","label":"Total de Horas Noturnas Trabalhadas","box":"","readonly":_vm.budgetFinalized},model:{value:(_vm.moduleOne.additionalNocturne.workedHours),callback:function ($$v) {_vm.$set(_vm.moduleOne.additionalNocturne, "workedHours", $$v)},expression:"moduleOne.additionalNocturne.workedHours"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Valor do Adicional Noturno (em R$)","value":_vm._f("currency")(_vm.nocturneAdditionalValue),"box":"","disabled":"","readonly":_vm.budgetFinalized}})],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-start":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Hora Extra","readonly":_vm.budgetFinalized},nativeOn:{"click":function($event){$event.preventDefault();return _vm.checkExtraHours();}},model:{value:(_vm.moduleOne.extraHour.has),callback:function ($$v) {_vm.$set(_vm.moduleOne.extraHour, "has", $$v)},expression:"moduleOne.extraHour.has"}})],1),_vm._v(" "),(_vm.moduleOne.extraHour.has)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"justify-space-between":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"value":_vm._f("currency")(_vm.extraHourValue),"label":"Valor da Hora Extra (em R$)","disabled":"","box":"","readonly":_vm.budgetFinalized}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"value":_vm._f("currency")(_vm.dsrValue),"label":"Valor do DSR (em R$)","disabled":"","box":"","readonly":_vm.budgetFinalized}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-space-between":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":"","md2":""}},[_c('v-select',{attrs:{"label":"Jornada de Trabalho","items":_vm.worksJournies,"item-text":"text","item-value":"value","box":"","hint":_vm._f("currency")(_vm.nocturneNormalHourValue,{symbol: 'Valor da Hora de Trabalho: R$'}),"persistent-hint":"","readonly":_vm.budgetFinalized},model:{value:(_vm.moduleOne.extraHour.workJournie),callback:function ($$v) {_vm.$set(_vm.moduleOne.extraHour, "workJournie", $$v)},expression:"moduleOne.extraHour.workJournie"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md2":""}},[_c('v-text-field',{attrs:{"type":"number","min":"0","label":"Horas Trabalhadas com 50%","box":"","hint":_vm._f("currency")(_vm.hours50Hint),"persistent-hint":"","readonly":_vm.budgetFinalized},model:{value:(_vm.moduleOne.extraHour.hours50),callback:function ($$v) {_vm.$set(_vm.moduleOne.extraHour, "hours50", $$v)},expression:"moduleOne.extraHour.hours50"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md2":""}},[_c('v-text-field',{attrs:{"type":"number","min":"0","label":"Horas Trabalhadas com 75%","box":"","hint":_vm._f("currency")(_vm.hours75Hint),"persistent-hint":"","readonly":_vm.budgetFinalized},model:{value:(_vm.moduleOne.extraHour.hours75),callback:function ($$v) {_vm.$set(_vm.moduleOne.extraHour, "hours75", $$v)},expression:"moduleOne.extraHour.hours75"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md2":""}},[_c('v-text-field',{attrs:{"type":"number","min":"0","label":"Horas Trabalhadas com 100%","box":"","hint":_vm._f("currency")(_vm.hours100Hint),"persistent-hint":"","readonly":_vm.budgetFinalized},model:{value:(_vm.moduleOne.extraHour.hours100),callback:function ($$v) {_vm.$set(_vm.moduleOne.extraHour, "hours100", $$v)},expression:"moduleOne.extraHour.hours100"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md2":""}},[_c('v-text-field',{attrs:{"label":"Nº de Domingos / Feriados","type":"number","min":"0","box":"","readonly":_vm.budgetFinalized},model:{value:(_vm.moduleOne.dsr.sundayDays),callback:function ($$v) {_vm.$set(_vm.moduleOne.dsr, "sundayDays", $$v)},expression:"moduleOne.dsr.sundayDays"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md2":""}},[_c('v-text-field',{attrs:{"label":"Nº de Dias Úteis","type":"number","min":"0","box":"","readonly":_vm.budgetFinalized},model:{value:(_vm.moduleOne.dsr.workingDays),callback:function ($$v) {_vm.$set(_vm.moduleOne.dsr, "workingDays", $$v)},expression:"moduleOne.dsr.workingDays"}})],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-start":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-divider',{attrs:{"light":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('h3',[_vm._v("Outros Valores")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[(!_vm.budgetFinalized)?_c('v-btn',{attrs:{"block":"","color":"primary","title":"Adicionar Outro Valor"},nativeOn:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.addBenefit();}}},[_vm._v("\n        Adicionar\n        "),_c('v-icon',[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},_vm._l((_vm.moduleOne.others),function(item,i){return _c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.moduleOne.others.length > 0),expression:"moduleOne.others.length > 0"}],key:i},[_c('v-flex',{class:_vm.budgetFinalized ? 'xs12' : 'xs11'},[_c('v-layout',{attrs:{"justify-start":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"Descrição","box":"","readonly":_vm.budgetFinalized},model:{value:(item.description),callback:function ($$v) {_vm.$set(item, "description", $$v)},expression:"item.description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","label":"Valor","readonly":_vm.budgetFinalized},model:{value:(item.value),callback:function ($$v) {_vm.$set(item, "value", $$v)},expression:"item.value"}},'v-currency-field',_vm.currency_config,false))],1)],1)],1),_vm._v(" "),(_vm.budgetFinalized)?_c('v-flex',{attrs:{"xs1":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","fill-height":""}},[_c('v-icon',{staticClass:"red--text font-weight-black",attrs:{"title":"Remover benefício"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.removeBenefit(item);}}},[_vm._v("delete_forever")])],1)],1):_vm._e()],1)}),1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-divider',{attrs:{"light":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{attrs:{"label":"Notas","rows":"5","box":"","readonly":_vm.budgetFinalized},model:{value:(_vm.moduleOne.notes),callback:function ($$v) {_vm.$set(_vm.moduleOne, "notes", $$v)},expression:"moduleOne.notes"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabModule2_vue__ = __webpack_require__(270);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b6222d6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabModule2_vue__ = __webpack_require__(347);
function injectStyle (ssrContext) {
  __webpack_require__(345)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabModule2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b6222d6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabModule2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(346);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(155)("3d7ae204", content, true, {});

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(154)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"TabModule2.vue","sourceRoot":""}]);

// exports


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"justify-space-between":"","row":"","wrap":""}},_vm._l((_vm.informations),function(item,i){return _c('v-flex',{key:i,class:item.class},[_c('v-list',{staticClass:"py-0 elevation-2",attrs:{"three-line":"","light":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"text--primary"},[_vm._v(_vm._s(item.subtitle))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm._f("currency")(item.value)))])],1)],1)],1)],1)}),1),_vm._v(" "),_c('v-layout',{attrs:{"justify-start":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('h3',[_vm._v("Submódulo 2.1 - 13º (décimo terceiro) Salário, Férias e Adicional de Férias")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","label":"13º Salário (em %)","hint":_vm._f("currency")(_vm.thirteenFirstSalaryValue),"persistent-hint":"","readonly":_vm.budgetFinalized},model:{value:(_vm.moduleTwo.thirteenFirstSalary),callback:function ($$v) {_vm.$set(_vm.moduleTwo, "thirteenFirstSalary", $$v)},expression:"moduleTwo.thirteenFirstSalary"}},'v-currency-field',_vm.currency_config_percent,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","label":"Adicional de Férias (em %)","hint":_vm._f("currency")(_vm.vacationAdditionalValue),"persistent-hint":"","readonly":_vm.budgetFinalized},model:{value:(_vm.moduleTwo.vacationAdditional),callback:function ($$v) {_vm.$set(_vm.moduleTwo, "vacationAdditional", $$v)},expression:"moduleTwo.vacationAdditional"}},'v-currency-field',_vm.currency_config_percent,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","label":"Total Submódulo 2.1 (em %)","value":_vm.amountOfModuleTwoOnePercent,"hint":_vm._f("currency")(_vm.amountOfModuleTwoOneValue),"persistent-hint":"","disabled":""}},'v-currency-field',_vm.currency_config_percent,false))],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-0",attrs:{"xs12":""}},[_c('v-textarea',{attrs:{"label":"Notas","rows":"5","box":"","readonly":_vm.budgetFinalized},model:{value:(_vm.moduleTwo.notesOne),callback:function ($$v) {_vm.$set(_vm.moduleTwo, "notesOne", $$v)},expression:"moduleTwo.notesOne"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-start":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('h3',[_vm._v("Submódulo 2.2 – Encargos Previdenciários (GPS), Fundo de Garantia por Tempo de Serviço (FGTS) e outras contribuições")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":"","md2":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"INSS","hint":_vm._f("currency")(_vm.inssValue),"persistent-hint":""},model:{value:(_vm.moduleTwo.inss),callback:function ($$v) {_vm.$set(_vm.moduleTwo, "inss", $$v)},expression:"moduleTwo.inss"}},'v-currency-field',_vm.currency_config_percent,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":"","md2":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"FGTS","hint":_vm._f("currency")(_vm.fgtsValue),"persistent-hint":""},model:{value:(_vm.moduleTwo.fgts),callback:function ($$v) {_vm.$set(_vm.moduleTwo, "fgts", $$v)},expression:"moduleTwo.fgts"}},'v-currency-field',_vm.currency_config_percent,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":"","md2":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"SESI/SESC","hint":_vm._f("currency")(_vm.sesiSescValue),"persistent-hint":""},model:{value:(_vm.moduleTwo.sesiSesc),callback:function ($$v) {_vm.$set(_vm.moduleTwo, "sesiSesc", $$v)},expression:"moduleTwo.sesiSesc"}},'v-currency-field',_vm.currency_config_percent,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":"","md2":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"SENAI/SENAC","hint":_vm._f("currency")(_vm.senaiSenacValue),"persistent-hint":""},model:{value:(_vm.moduleTwo.senaiSenac),callback:function ($$v) {_vm.$set(_vm.moduleTwo, "senaiSenac", $$v)},expression:"moduleTwo.senaiSenac"}},'v-currency-field',_vm.currency_config_percent,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":"","md2":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"INCRA","hint":_vm._f("currency")(_vm.incraValue),"persistent-hint":""},model:{value:(_vm.moduleTwo.incra),callback:function ($$v) {_vm.$set(_vm.moduleTwo, "incra", $$v)},expression:"moduleTwo.incra"}},'v-currency-field',_vm.currency_config_percent,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":"","md2":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"SEBRAE","hint":_vm._f("currency")(_vm.sebraeValue),"persistent-hint":""},model:{value:(_vm.moduleTwo.sebrae),callback:function ($$v) {_vm.$set(_vm.moduleTwo, "sebrae", $$v)},expression:"moduleTwo.sebrae"}},'v-currency-field',_vm.currency_config_percent,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":"","md2":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"Salário Educação","hint":_vm._f("currency")(_vm.educationSalaryValue),"persistent-hint":""},model:{value:(_vm.moduleTwo.educationSalary),callback:function ($$v) {_vm.$set(_vm.moduleTwo, "educationSalary", $$v)},expression:"moduleTwo.educationSalary"}},'v-currency-field',_vm.currency_config_percent,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":"","md2":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"RAT","persistent-hint":""},model:{value:(_vm.moduleTwo.rat),callback:function ($$v) {_vm.$set(_vm.moduleTwo, "rat", $$v)},expression:"moduleTwo.rat"}},'v-currency-field',_vm.currency_config_percent,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":"","md2":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"FAP","persistent-hint":""},model:{value:(_vm.moduleTwo.fap),callback:function ($$v) {_vm.$set(_vm.moduleTwo, "fap", $$v)},expression:"moduleTwo.fap"}},'v-currency-field',_vm.currency_config_normal,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":"","md2":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","label":"RAT x FAP","value":_vm.ratFapPercent,"hint":_vm._f("currency")(_vm.ratFapValue),"persistent-hint":"","disabled":""}},'v-currency-field',_vm.currency_config_percent,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm8":"","md4":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","label":"Total Submódulo 2.2","value":_vm.amountOfModuleTwoTwoPercent,"hint":_vm._f("currency")(_vm.amountOfModuleTwoTwoValue),"persistent-hint":"","disabled":""}},'v-currency-field',_vm.currency_config_percent,false))],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-0",attrs:{"xs12":""}},[_c('v-textarea',{attrs:{"label":"Notas","rows":"5","box":"","readonly":_vm.budgetFinalized},model:{value:(_vm.moduleTwo.notesTwo),callback:function ($$v) {_vm.$set(_vm.moduleTwo, "notesTwo", $$v)},expression:"moduleTwo.notesTwo"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-start":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('h3',[_vm._v("Submódulo 2.3 – Benefícios Mensais e Diários")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{staticClass:"mt-2",attrs:{"readonly":_vm.budgetFinalized,"label":"Auxílio Transporte"},on:{"change":_vm.changeTransport},model:{value:(_vm.moduleTwo.transport.has),callback:function ($$v) {_vm.$set(_vm.moduleTwo.transport, "has", $$v)},expression:"moduleTwo.transport.has"}})],1),_vm._v(" "),(_vm.moduleTwo.transport.has)?_c('v-flex',{attrs:{"xs12":"","mt-0":""}},[_c('v-layout',{attrs:{"justify-start":"","row":"","wrap":"","mt-0":""}},[_c('v-flex',{attrs:{"xs6":"","sm4":"","md2":""}},[_c('v-text-field',{attrs:{"readonly":_vm.budgetFinalized,"label":"Bilhetes por dia","type":"number","min":"0","box":""},model:{value:(_vm.moduleTwo.transport.ticketByDay),callback:function ($$v) {_vm.$set(_vm.moduleTwo.transport, "ticketByDay", $$v)},expression:"moduleTwo.transport.ticketByDay"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":"","md2":""}},[_c('v-text-field',{attrs:{"readonly":_vm.budgetFinalized,"label":"Nº dias mês","type":"number","min":"0","box":""},model:{value:(_vm.moduleTwo.transport.daysByMonth),callback:function ($$v) {_vm.$set(_vm.moduleTwo.transport, "daysByMonth", $$v)},expression:"moduleTwo.transport.daysByMonth"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":"","md2":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"Valor da Tarifa (em R$)","persistent-hint":"","hint":_vm.tariffTransportHint},model:{value:(_vm.moduleTwo.transport.tariffValue),callback:function ($$v) {_vm.$set(_vm.moduleTwo.transport, "tariffValue", $$v)},expression:"moduleTwo.transport.tariffValue"}},'v-currency-field',_vm.currency_config,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":"","md2":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","label":"Custo Total","value":_vm.partialAmountOfTransport,"disabled":""}},'v-currency-field',_vm.currency_config,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":"","md2":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","label":"Custo Empregado","value":_vm.employeeCost,"disabled":""}},'v-currency-field',_vm.currency_config,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":"","md2":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","label":"Valor do Transporte","value":_vm.finalAmountOfTransport,"disabled":""}},'v-currency-field',_vm.currency_config,false))],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{staticClass:"mt-2",attrs:{"readonly":_vm.budgetFinalized,"label":"Auxílio Refeição / Alimentação"},on:{"change":_vm.changeFoodAid},model:{value:(_vm.moduleTwo.foodAid.has),callback:function ($$v) {_vm.$set(_vm.moduleTwo.foodAid, "has", $$v)},expression:"moduleTwo.foodAid.has"}})],1),_vm._v(" "),(_vm.moduleTwo.foodAid.has)?_c('v-flex',{attrs:{"xs12":"","mt-0":""}},[_c('v-layout',{attrs:{"justify-start":"","row":"","wrap":"","mt-0":""}},[_c('v-flex',{attrs:{"xs6":"","sm3":""}},[_c('v-text-field',{attrs:{"readonly":_vm.budgetFinalized,"label":"Refeição por Dia","type":"number","min":"0","box":""},model:{value:(_vm.moduleTwo.foodAid.mealByDay),callback:function ($$v) {_vm.$set(_vm.moduleTwo.foodAid, "mealByDay", $$v)},expression:"moduleTwo.foodAid.mealByDay"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm3":""}},[_c('v-text-field',{attrs:{"readonly":_vm.budgetFinalized,"label":"Nº dias mês","type":"number","min":"0","box":""},model:{value:(_vm.moduleTwo.foodAid.daysByMonth),callback:function ($$v) {_vm.$set(_vm.moduleTwo.foodAid, "daysByMonth", $$v)},expression:"moduleTwo.foodAid.daysByMonth"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm3":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"Valor"},model:{value:(_vm.moduleTwo.foodAid.value),callback:function ($$v) {_vm.$set(_vm.moduleTwo.foodAid, "value", $$v)},expression:"moduleTwo.foodAid.value"}},'v-currency-field',_vm.currency_config,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm3":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","label":"Total Refeição / Alimentação","value":_vm.mealValue,"disabled":""}},'v-currency-field',_vm.currency_config,false))],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-start":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('h3',[_vm._v("Outros Valores")]),_vm._v(" "),_c('h4',{staticClass:"grey--text"},[_vm._v("Ex: Benefício Social Familiar, Benefício Assistencial, etc.")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[(!_vm.budgetFinalized)?_c('v-btn',{attrs:{"block":"","color":"primary","title":"Adicionar benefício"},nativeOn:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.addBenefit();}}},[_vm._v("\n        Adicionar Benefício\n        "),_c('v-icon',[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},_vm._l((_vm.moduleTwo.others),function(item,i){return _c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.moduleTwo.others.length > 0),expression:"moduleTwo.others.length > 0"}],key:i},[_c('v-flex',{class:_vm.budgetFinalized ? 'xs12' : 'xs11'},[_c('v-layout',{attrs:{"justify-start":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"readonly":_vm.budgetFinalized,"label":"Descrição","box":""},model:{value:(item.description),callback:function ($$v) {_vm.$set(item, "description", $$v)},expression:"item.description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"Valor"},model:{value:(item.value),callback:function ($$v) {_vm.$set(item, "value", $$v)},expression:"item.value"}},'v-currency-field',_vm.currency_config,false))],1)],1)],1),_vm._v(" "),(!_vm.budgetFinalized)?_c('v-flex',{attrs:{"xs1":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","fill-height":""}},[_c('v-icon',{staticClass:"red--text font-weight-black",attrs:{"title":"Remover benefício"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.removeBenefit(item);}}},[_vm._v("delete_forever")])],1)],1):_vm._e()],1)}),1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","label":"Total Submódulo 2.3","disabled":""},model:{value:(_vm.amountOfModuleTwoThreeValue),callback:function ($$v) {_vm.amountOfModuleTwoThreeValue=$$v},expression:"amountOfModuleTwoThreeValue"}},'v-currency-field',_vm.currency_config,false))],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-0",attrs:{"xs12":""}},[_c('v-textarea',{attrs:{"label":"Notas","rows":"5","box":"","readonly":_vm.budgetFinalized},model:{value:(_vm.moduleTwo.notesThree),callback:function ($$v) {_vm.$set(_vm.moduleTwo, "notesThree", $$v)},expression:"moduleTwo.notesThree"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabModule3_vue__ = __webpack_require__(271);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5246139a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabModule3_vue__ = __webpack_require__(351);
function injectStyle (ssrContext) {
  __webpack_require__(349)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabModule3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5246139a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabModule3_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(350);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(155)("813bc91a", content, true, {});

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(154)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"TabModule3.vue","sourceRoot":""}]);

// exports


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"justify-space-between":"","row":"","wrap":""}},_vm._l((_vm.informations),function(item,i){return _c('v-flex',{key:i,class:item.class},[_c('v-list',{staticClass:"py-0 elevation-2",attrs:{"three-line":"","light":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"text--primary"},[_vm._v(_vm._s(item.subtitle))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm._f("currency")(item.value)))])],1)],1)],1)],1)}),1),_vm._v(" "),_c('v-layout',{attrs:{"justify-start":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-divider',{attrs:{"light":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"Aviso Prévio Indenizado (em %)","hint":_vm._f("currency")(_vm.previousNoticeIndemnifiedValue),"persistent-hint":""},model:{value:(_vm.moduleThree.previousNoticeIndemnified),callback:function ($$v) {_vm.$set(_vm.moduleThree, "previousNoticeIndemnified", $$v)},expression:"moduleThree.previousNoticeIndemnified"}},'v-currency-field',_vm.currency_config,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"Incidência do FGTS sobre Aviso Prévio Indenizado (em %)","hint":_vm._f("currency")(_vm.fgtsIncidencePreviousNoticeIndemnifiedValue),"persistent-hint":""},model:{value:(_vm.moduleThree.fgtsIncidencePreviousNoticeIndemnified),callback:function ($$v) {_vm.$set(_vm.moduleThree, "fgtsIncidencePreviousNoticeIndemnified", $$v)},expression:"moduleThree.fgtsIncidencePreviousNoticeIndemnified"}},'v-currency-field',_vm.currency_config,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"Multa do FGTS e Contribuição Social sobre o Aviso Prévio Indenizado (em %)","hint":_vm._f("currency")(_vm.fgtsPenaltyPreviousNoticeIndemnifiedValue),"persistent-hint":""},model:{value:(_vm.moduleThree.fgtsPenaltyPreviousNoticeIndemnified),callback:function ($$v) {_vm.$set(_vm.moduleThree, "fgtsPenaltyPreviousNoticeIndemnified", $$v)},expression:"moduleThree.fgtsPenaltyPreviousNoticeIndemnified"}},'v-currency-field',_vm.currency_config,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"Aviso Prévio Trabalhado (em %)","hint":_vm._f("currency")(_vm.previousNoticeWorkedValue),"persistent-hint":""},model:{value:(_vm.moduleThree.previousNoticeWorked),callback:function ($$v) {_vm.$set(_vm.moduleThree, "previousNoticeWorked", $$v)},expression:"moduleThree.previousNoticeWorked"}},'v-currency-field',_vm.currency_config,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"Incidência de GPS, FGTS e outras contribuições sobre o Aviso Prévio Trabalhado","hint":_vm._f("currency")(_vm.fgtsIncidencePreviousNoticeWorkedValue),"persistent-hint":""},model:{value:(_vm.moduleThree.fgtsIncidencePreviousNoticeWorked),callback:function ($$v) {_vm.$set(_vm.moduleThree, "fgtsIncidencePreviousNoticeWorked", $$v)},expression:"moduleThree.fgtsIncidencePreviousNoticeWorked"}},'v-currency-field',_vm.currency_config,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"Multa do FGTS e Contribuição Social sobre o Aviso Prévio Trabalhado (em %)","hint":_vm._f("currency")(_vm.fgtsPenaltyPreviousNoticeWorkedValue),"persistent-hint":""},model:{value:(_vm.moduleThree.fgtsPenaltyPreviousNoticeWorked),callback:function ($$v) {_vm.$set(_vm.moduleThree, "fgtsPenaltyPreviousNoticeWorked", $$v)},expression:"moduleThree.fgtsPenaltyPreviousNoticeWorked"}},'v-currency-field',_vm.currency_config,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[(!_vm.budgetFinalized)?_c('v-btn',{attrs:{"block":"","color":"primary","title":"Adicionar Outro Encargo"},nativeOn:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.addBenefit();}}},[_vm._v("\n        Adicionar Outro Engargo\n        "),_c('v-icon',[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},_vm._l((_vm.moduleThree.others),function(item,i){return _c('v-layout',{key:i},[_c('v-flex',{class:_vm.budgetFinalized ? 'xs12' : 'xs11'},[_c('v-layout',{attrs:{"justify-start":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"Descrição","box":"","readonly":_vm.budgetFinalized},model:{value:(item.description),callback:function ($$v) {_vm.$set(item, "description", $$v)},expression:"item.description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"Porcentagem de Cálculo (%)","title":"A porcentagem digitada será multiplicada pela base de cálculo (Módulo 1 + Submódulo 2.1)","hint":_vm._f("currency")(("" + (item.percent * _vm.calculationBasis / 100))),"persistent-hint":""},model:{value:(item.percent),callback:function ($$v) {_vm.$set(item, "percent", $$v)},expression:"item.percent"}},'v-currency-field',_vm.currency_config,false))],1)],1)],1),_vm._v(" "),(!_vm.budgetFinalized)?_c('v-flex',{attrs:{"xs1":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","fill-height":""}},[_c('v-icon',{staticClass:"red--text font-weight-black",attrs:{"title":"Remover benefício"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.removeBenefit(item);}}},[_vm._v("delete_forever")])],1)],1):_vm._e()],1)}),1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-divider',{attrs:{"light":""}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-0",attrs:{"xs12":""}},[_c('v-textarea',{attrs:{"label":"Notas","rows":"5","box":"","readonly":_vm.budgetFinalized},model:{value:(_vm.moduleThree.notes),callback:function ($$v) {_vm.$set(_vm.moduleThree, "notes", $$v)},expression:"moduleThree.notes"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabModule4_vue__ = __webpack_require__(272);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba0cf542_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabModule4_vue__ = __webpack_require__(353);
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabModule4_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba0cf542_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabModule4_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"justify-space-between":"","row":"","wrap":""}},_vm._l((_vm.informations),function(item,i){return _c('v-flex',{key:i,class:item.class},[_c('v-list',{staticClass:"py-0 elevation-2",attrs:{"three-line":"","light":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"text--primary"},[_vm._v(_vm._s(item.subtitle))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm._f("currency")(item.value)))])],1)],1)],1)],1)}),1),_vm._v(" "),_c('v-layout',{attrs:{"justify-start":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('h3',[_vm._v("Submódulo 4.1 - Ausencias Legais")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"Substituto na Corbetura de Férias (em %)","hint":_vm._f("currency")(_vm.vacationValue),"persistent-hint":""},model:{value:(_vm.moduleFour.vacation),callback:function ($$v) {_vm.$set(_vm.moduleFour, "vacation", $$v)},expression:"moduleFour.vacation"}},'v-currency-field',_vm.currency_config_percent,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"Substituto na Corbetura Ausências Legais (em %)","hint":_vm._f("currency")(_vm.legalAbsencesValue),"persistent-hint":""},model:{value:(_vm.moduleFour.legalAbsences),callback:function ($$v) {_vm.$set(_vm.moduleFour, "legalAbsences", $$v)},expression:"moduleFour.legalAbsences"}},'v-currency-field',_vm.currency_config_percent,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"Substituto na Corbetura Licença Paternidade (em %)","hint":_vm._f("currency")(_vm.paternityLicenceValue),"persistent-hint":""},model:{value:(_vm.moduleFour.paternityLicence),callback:function ($$v) {_vm.$set(_vm.moduleFour, "paternityLicence", $$v)},expression:"moduleFour.paternityLicence"}},'v-currency-field',_vm.currency_config_percent,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"Substituto na Corbetura Ausência por Acidente do Trabalho (em %)","hint":_vm._f("currency")(_vm.workAccidentValue),"persistent-hint":""},model:{value:(_vm.moduleFour.workAccident),callback:function ($$v) {_vm.$set(_vm.moduleFour, "workAccident", $$v)},expression:"moduleFour.workAccident"}},'v-currency-field',_vm.currency_config_percent,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"Substituto na Corbetura Afastamento Maternidade (em %)","hint":_vm._f("currency")(_vm.maternityLicenceValue),"persistent-hint":""},model:{value:(_vm.moduleFour.maternityLicence),callback:function ($$v) {_vm.$set(_vm.moduleFour, "maternityLicence", $$v)},expression:"moduleFour.maternityLicence"}},'v-currency-field',_vm.currency_config_percent,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"Incidência dos encargos do Submódulo 2.2 sobre o Custo de Reposição do Profissional Ausente (em %)","hint":_vm._f("currency")(_vm.professionalAbsentValue),"persistent-hint":""},model:{value:(_vm.moduleFour.professionalAbsent),callback:function ($$v) {_vm.$set(_vm.moduleFour, "professionalAbsent", $$v)},expression:"moduleFour.professionalAbsent"}},'v-currency-field',_vm.currency_config_percent,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},_vm._l((_vm.moduleFour.others),function(item,i){return _c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.moduleFour.others.length > 0),expression:"moduleFour.others.length > 0"}],key:i},[_c('v-flex',{class:_vm.budgetFinalized ? 'xs12' : 'xs11'},[_c('v-layout',{attrs:{"justify-start":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"Descrição","box":"","readonly":_vm.budgetFinalized},model:{value:(item.description),callback:function ($$v) {_vm.$set(item, "description", $$v)},expression:"item.description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"Porcentagem de Cálculo (%)","title":"A porcentagem digitada será multiplicada pela base de cálculo (Módulo 1 + Submódulo 2.1)","hint":_vm._f("currency")(("" + (item.percent * _vm.calculationBasis / 100))),"persistent-hint":""},model:{value:(item.percent),callback:function ($$v) {_vm.$set(item, "percent", $$v)},expression:"item.percent"}},'v-currency-field',_vm.currency_config_percent,false))],1)],1)],1),_vm._v(" "),(!_vm.budgetFinalized)?_c('v-flex',{attrs:{"xs1":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","fill-height":""}},[_c('v-icon',{staticClass:"red--text font-weight-black",attrs:{"title":"Remover benefício"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.removeBenefit(item);}}},[_vm._v("delete_forever")])],1)],1):_vm._e()],1)}),1),_vm._v(" "),(!_vm.budgetFinalized)?_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-btn',{attrs:{"block":"","color":"primary","title":"Adicionar Outro Benefício"},nativeOn:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.addBenefit();}}},[_vm._v("\n        Adicionar Outro Benefício\n        "),_c('v-icon',[_vm._v("add")])],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-list',{staticClass:"py-0 elevation-2",attrs:{"three-line":"","light":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"font-weight-bold"},[_vm._v("Total do Submódulo 4.1")]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"text--primary"},[_vm._v(_vm._s(_vm.amountOfModuleFourOnePercent.toFixed(4))+"%")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm._f("currency")(_vm.amountOfModuleFourOne)))])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-start":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('h3',[_vm._v("Submódulo 4.2 – Intrajornada")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"Substituto na Corbetura Intervalo para Repouso e Alimentação (em %)","hint":_vm._f("currency")(_vm.restAndFeedingValue),"persistent-hint":""},model:{value:(_vm.moduleFour.restAndFeeding),callback:function ($$v) {_vm.$set(_vm.moduleFour, "restAndFeeding", $$v)},expression:"moduleFour.restAndFeeding"}},'v-currency-field',_vm.currency_config_percent,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-list',{staticClass:"py-0 elevation-2",attrs:{"two-line":"","light":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"font-weight-bold"},[_vm._v("Total do Submódulo 4.2")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm._f("currency")(_vm.amountOfModuleFourTwo)))])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-divider',{attrs:{"light":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{attrs:{"label":"Notas","rows":"5","box":"","readonly":_vm.budgetFinalized},model:{value:(_vm.moduleFour.notes),callback:function ($$v) {_vm.$set(_vm.moduleFour, "notes", $$v)},expression:"moduleFour.notes"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabModule5_vue__ = __webpack_require__(273);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_299d3534_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabModule5_vue__ = __webpack_require__(355);
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabModule5_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_299d3534_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabModule5_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"justify-space-between":"","row":"","wrap":""}},_vm._l((_vm.informations),function(item,i){return _c('v-flex',{key:i,class:item.class},[_c('v-list',{staticClass:"py-0 elevation-2",attrs:{"three-line":"","light":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"text--primary"},[_vm._v(_vm._s(item.subtitle))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm._f("currency")(item.value)))])],1)],1)],1)],1)}),1),_vm._v(" "),_c('v-layout',{attrs:{"justify-start":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-divider',{attrs:{"light":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('h3',[_vm._v("Outros Valores")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[(!_vm.budgetFinalized)?_c('v-btn',{attrs:{"block":"","color":"primary","title":"Adicionar Outro Valor"},nativeOn:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.addBenefit();}}},[_vm._v("\n          Adicionar\n          "),_c('v-icon',[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},_vm._l((_vm.moduleFive.others),function(item,i){return _c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.moduleFive.others.length > 0),expression:"moduleFive.others.length > 0"}],key:i},[_c('v-flex',{class:_vm.budgetFinalized ? 'xs12' : 'xs11'},[_c('v-layout',{attrs:{"justify-start":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"Descrição","box":"","readonly":_vm.budgetFinalized},model:{value:(item.description),callback:function ($$v) {_vm.$set(item, "description", $$v)},expression:"item.description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"Valor"},model:{value:(item.value),callback:function ($$v) {_vm.$set(item, "value", $$v)},expression:"item.value"}},'v-currency-field',_vm.currency_config,false))],1)],1)],1),_vm._v(" "),(!_vm.budgetFinalized)?_c('v-flex',{attrs:{"xs1":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","fill-height":""}},[_c('v-icon',{staticClass:"red--text font-weight-black",attrs:{"title":"Remover benefício"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.removeBenefit(item);}}},[_vm._v("delete_forever")])],1)],1):_vm._e()],1)}),1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-divider',{attrs:{"light":""}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-0",attrs:{"xs12":""}},[_c('v-textarea',{attrs:{"label":"Notas","rows":"5","box":"","readonly":_vm.budgetFinalized},model:{value:(_vm.moduleFive.notes),callback:function ($$v) {_vm.$set(_vm.moduleFive, "notes", $$v)},expression:"moduleFive.notes"}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabModule6_vue__ = __webpack_require__(274);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6d9176a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabModule6_vue__ = __webpack_require__(359);
function injectStyle (ssrContext) {
  __webpack_require__(357)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabModule6_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6d9176a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabModule6_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(358);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(155)("2c757574", content, true, {});

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(154)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"TabModule6.vue","sourceRoot":""}]);

// exports


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"justify-space-between":"","row":"","wrap":""}},_vm._l((_vm.informations),function(item,i){return _c('v-flex',{key:i,class:item.class},[_c('v-list',{staticClass:"py-0 elevation-2",attrs:{"three-line":"","light":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"text--primary"},[_vm._v(_vm._s(item.subtitle))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm._f("currency")(item.value)))])],1)],1)],1)],1)}),1),_vm._v(" "),_c('v-layout',{attrs:{"justify-start":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('v-subheader',[_vm._v("Custos Indiretos e Lucro")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"Custos Indiretos / Despesas Administrativas (em %)","hint":_vm._f("currency")(_vm.administrativeCostsValue),"persistent-hint":""},model:{value:(_vm.moduleSix.administrativeCosts),callback:function ($$v) {_vm.$set(_vm.moduleSix, "administrativeCosts", $$v)},expression:"moduleSix.administrativeCosts"}},'v-currency-field',_vm.currency_config,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"Lucro (em %)","hint":_vm._f("currency")(_vm.lucreValue),"persistent-hint":""},model:{value:(_vm.moduleSix.lucre),callback:function ($$v) {_vm.$set(_vm.moduleSix, "lucre", $$v)},expression:"moduleSix.lucre"}},'v-currency-field',_vm.currency_config,false))],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-start":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('v-subheader',[_vm._v("Tributação pelo "+_vm._s(_vm.taxationType)+" (*valores de acordo com o cadastro da empresa)")])],1),_vm._v(" "),(_vm.taxationType.toUpperCase() == 'SIMPLES NACIONAL')?_c('v-flex',{attrs:{"xs12":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"Taxação Única (em %)","hint":_vm._f("currency")(_vm.uniqueTaxationValue),"persistent-hint":""},model:{value:(_vm.budget.company.taxation.uniqueTaxation),callback:function ($$v) {_vm.$set(_vm.budget.company.taxation, "uniqueTaxation", $$v)},expression:"budget.company.taxation.uniqueTaxation"}},'v-currency-field',_vm.currency_config,false))],1):(_vm.taxationType.toUpperCase() != '')?_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":""}},[_c('h4',[_vm._v("Tributos Federais")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"PIS (em %)","hint":_vm._f("currency")(_vm.pisValue),"persistent-hint":""},model:{value:(_vm.budget.company.taxation.pis),callback:function ($$v) {_vm.$set(_vm.budget.company.taxation, "pis", $$v)},expression:"budget.company.taxation.pis"}},'v-currency-field',_vm.currency_config,false))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"COFINS (em %)","hint":_vm._f("currency")(_vm.cofinsValue),"persistent-hint":""},model:{value:(_vm.budget.company.taxation.cofins),callback:function ($$v) {_vm.$set(_vm.budget.company.taxation, "cofins", $$v)},expression:"budget.company.taxation.cofins"}},'v-currency-field',_vm.currency_config,false))],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('h4',[_vm._v("Tributos Municipais")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs16":""}},[_c('v-currency-field',_vm._b({attrs:{"box":"","readonly":_vm.budgetFinalized,"label":"ISS (em %)","hint":_vm._f("currency")(_vm.issValue),"persistent-hint":""},model:{value:(_vm.budget.company.taxation.iss),callback:function ($$v) {_vm.$set(_vm.budget.company.taxation, "iss", $$v)},expression:"budget.company.taxation.iss"}},'v-currency-field',_vm.currency_config,false))],1)],1)],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-divider',{attrs:{"light":""}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-0",attrs:{"xs12":""}},[_c('v-textarea',{attrs:{"label":"Notas","rows":"5","box":"","readonly":_vm.budgetFinalized},model:{value:(_vm.moduleSix.notes),callback:function ($$v) {_vm.$set(_vm.moduleSix, "notes", $$v)},expression:"moduleSix.notes"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabSummaryTable_vue__ = __webpack_require__(275);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b897c368_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabSummaryTable_vue__ = __webpack_require__(363);
function injectStyle (ssrContext) {
  __webpack_require__(361)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabSummaryTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b897c368_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabSummaryTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(362);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(155)("b4d598b8", content, true, {});

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(154)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"TabSummaryTable.vue","sourceRoot":""}]);

// exports


/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-card',{staticClass:"font-weight-light",attrs:{"width":"450"}},[_c('v-card-title',[_c('h4',[_vm._v("(A) MÓDULO 01 – Composição da Remuneração")])])],1),_vm._v(" "),_c('v-card',{staticClass:"ml-2",attrs:{"color":"light-blue lighten-2","dark":"","light":"","width":"170"}},[_c('v-card-text',[_c('h3',[_vm._v(" "+_vm._s(_vm._f("currency")(_vm.amountOfModuleOne))+" ")])])],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-3",attrs:{"align-center":"","justify-center":""}},[_c('v-card',{staticClass:"font-weight-light",attrs:{"width":"450"}},[_c('v-card-title',[_c('h4',[_vm._v("(B) MÓDULO 02 –Encargos e benefícios anuais, mensais e diários")])])],1),_vm._v(" "),_c('v-card',{staticClass:"ml-2",attrs:{"color":"light-blue lighten-2","dark":"","light":"","width":"170"}},[_c('v-card-text',[_c('h3',[_vm._v(" "+_vm._s(_vm._f("currency")(_vm.amountOfModuleTwo))+" ")])])],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-3",attrs:{"align-center":"","justify-center":""}},[_c('v-card',{staticClass:"font-weight-light",attrs:{"width":"450"}},[_c('v-card-title',[_c('h4',[_vm._v("(C) MÓDULO 03 – Provisão para rescisão")])])],1),_vm._v(" "),_c('v-card',{staticClass:"ml-2",attrs:{"color":"light-blue lighten-2","dark":"","light":"","width":"170"}},[_c('v-card-text',[_c('h3',[_vm._v(" "+_vm._s(_vm._f("currency")(_vm.amountOfModuleThree))+" ")])])],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-3",attrs:{"align-center":"","justify-center":""}},[_c('v-card',{staticClass:"font-weight-light",attrs:{"width":"450"}},[_c('v-card-title',[_c('h4',[_vm._v("(D) MÓDULO 04 – Custo de reposiçao do profissional ausente")])])],1),_vm._v(" "),_c('v-card',{staticClass:"ml-2",attrs:{"color":"light-blue lighten-2","dark":"","light":"","width":"170"}},[_c('v-card-text',[_c('h3',[_vm._v(" "+_vm._s(_vm._f("currency")(_vm.amountOfModuleFour))+" ")])])],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-3",attrs:{"align-center":"","justify-center":""}},[_c('v-card',{staticClass:"font-weight-light",attrs:{"width":"450"}},[_c('v-card-title',[_c('h4',[_vm._v("(E) MÓDULO 05 – Insumos diversos")])])],1),_vm._v(" "),_c('v-card',{staticClass:"ml-2",attrs:{"color":"light-blue lighten-2","dark":"","light":"","width":"170"}},[_c('v-card-text',[_c('h3',[_vm._v(" "+_vm._s(_vm._f("currency")(_vm.amountOfModuleFive))+" ")])])],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-5 mb-5",attrs:{"align-center":"","justify-center":""}},[_c('v-card',{staticClass:"font-weight-light",attrs:{"width":"450"}},[_c('v-card-title',[_c('h4',[_vm._v("SUBTOTAL (A+B+C+D+E)")])])],1),_vm._v(" "),_c('v-card',{staticClass:"ml-2",attrs:{"color":"light-blue lighten-2","dark":"","light":"","width":"170"}},[_c('v-card-text',[_c('h3',[_vm._v(" "+_vm._s(_vm._f("currency")(_vm.subTotal))+" ")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-card',{staticClass:"font-weight-light",attrs:{"width":"450"}},[_c('v-card-title',[_c('h4',[_vm._v("(F) MÓDULO 06 – Custos Indireto, Lucros e Tributos")])])],1),_vm._v(" "),_c('v-card',{staticClass:"ml-2",attrs:{"color":"light-blue lighten-2","dark":"","light":"","width":"170"}},[_c('v-card-text',[_c('h3',[_vm._v(" "+_vm._s(_vm._f("currency")(_vm.amountOfModuleSix))+" ")])])],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-3",attrs:{"align-center":"","justify-center":""}},[_c('v-card',{staticClass:"font-weight-light",attrs:{"width":"450"}},[_c('v-card-title',[_c('h4',[_vm._v("VALOR TOTAL PROPOSTO POR EMPREGADO")])])],1),_vm._v(" "),_c('v-card',{staticClass:"ml-2",attrs:{"color":"light-blue lighten-2","dark":"","light":"","width":"170"}},[_c('v-card-text',[_c('h3',[_vm._v(" "+_vm._s(_vm._f("currency")(_vm.total))+" ")])])],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-3",attrs:{"align-center":"","justify-center":""}},[_c('v-card',{staticClass:"font-weight-light",attrs:{"width":"450"}},[_c('v-card-title',[_c('h4',[_vm._v(_vm._s(_vm.numberOfEmployees)+" EMPREGADO(S)")])])],1),_vm._v(" "),_c('v-card',{staticClass:"ml-2",attrs:{"color":"light-blue lighten-2","dark":"","light":"","width":"170"}},[_c('v-card-text',[_c('h3',[_vm._v(" "+_vm._s(_vm._f("currency")(_vm.finalValue))+" ")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.analyticalWorksheet)?_c('v-tabs',{attrs:{"color":"info","dark":"","show-arrows":""},model:{value:(_vm.tabOpen),callback:function ($$v) {_vm.tabOpen=$$v},expression:"tabOpen"}},[_c('v-tabs-slider',{attrs:{"color":"info darken-2"}}),_vm._v(" "),_vm._l((_vm.itemsTab),function(item){return _c('v-tab',{key:'#tab-' + item,attrs:{"href":'#tab-' + item}},[_vm._v("\n     "+_vm._s(item)+" ")])}),_vm._v(" "),_c('v-tabs-items',[(_vm.analyticalWorksheet.header)?_c('v-tab-item',{attrs:{"value":'tab-Formação de Preços'}},[_c('tab-header',{ref:"tab_header"})],1):_vm._e(),_vm._v(" "),(_vm.analyticalWorksheet.moduleOne)?_c('v-tab-item',{attrs:{"value":'tab-Módulo 1'}},[_c('tab-module1')],1):_vm._e(),_vm._v(" "),(_vm.analyticalWorksheet.moduleTwo)?_c('v-tab-item',{attrs:{"value":'tab-Módulo 2'}},[_c('tab-module2')],1):_vm._e(),_vm._v(" "),(_vm.analyticalWorksheet.moduleThree)?_c('v-tab-item',{attrs:{"value":'tab-Módulo 3'}},[_c('tab-module3')],1):_vm._e(),_vm._v(" "),(_vm.analyticalWorksheet.moduleFour)?_c('v-tab-item',{attrs:{"value":'tab-Módulo 4'}},[_c('tab-module4')],1):_vm._e(),_vm._v(" "),(_vm.analyticalWorksheet.moduleFive)?_c('v-tab-item',{attrs:{"value":'tab-Módulo 5'}},[_c('tab-module5')],1):_vm._e(),_vm._v(" "),(_vm.analyticalWorksheet.moduleSix)?_c('v-tab-item',{attrs:{"value":'tab-Módulo 6'}},[_c('tab-module6',{ref:"moduloSeis"})],1):_vm._e(),_vm._v(" "),(_vm.analyticalWorksheet.moduleFive)?_c('v-tab-item',{attrs:{"value":'tab-Equipamentos'}},[_c('attachment',{attrs:{"attachment":"equipments","filter":"Equipamento","inputsVariables":_vm.budget.inputsVariables}})],1):_vm._e(),_vm._v(" "),(_vm.analyticalWorksheet.moduleFive)?_c('v-tab-item',{attrs:{"value":'tab-Materiais de Consumo'}},[_c('attachment',{attrs:{"attachment":"consumables","filter":"Material de Consumo","inputsVariables":_vm.budget.inputsVariables}})],1):_vm._e(),_vm._v(" "),(_vm.analyticalWorksheet.moduleFive)?_c('v-tab-item',{attrs:{"value":'tab-Uniformes e EPIs'}},[_c('attachment',{attrs:{"attachment":"uniformsAndEPIs","filter":"Uniforme e EPI's","inputsVariables":_vm.budget.inputsVariables}})],1):_vm._e(),_vm._v(" "),(_vm.analyticalWorksheet.moduleFive)?_c('v-tab-item',{attrs:{"value":'tab-Utensílios'}},[_c('attachment',{attrs:{"attachment":"utensils","filter":"Utensílio","inputsVariables":_vm.budget.inputsVariables}})],1):_vm._e(),_vm._v(" "),(_vm.analyticalWorksheet.moduleOne)?_c('v-tab-item',{attrs:{"value":'tab-Quadro Resumo'}},[_c('tab-summary-table')],1):_vm._e()],1)],2):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 365 */,
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadPdf_vue__ = __webpack_require__(279);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a6ab144_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadPdf_vue__ = __webpack_require__(367);
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadPdf_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a6ab144_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadPdf_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-dialog',{attrs:{"persistent":_vm.loading == false ? false : true,"overlay":false,"max-width":"500px","transition":"dialog-transition"},model:{value:(_vm.pdfWindow),callback:function ($$v) {_vm.pdfWindow=$$v},expression:"pdfWindow"}},[_c('v-card',[_c('v-toolbar',{staticClass:"elevation-1",attrs:{"color":"white","card":""}},[_c('v-toolbar-title',{staticClass:"black--text font-weight-light"},[_vm._v("\n          "+_vm._s(_vm.pdfWindowTitle)+"\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"color":"error","title":"Cancelar","icon":"","round":"","flat":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.pdfWindow = false, _vm.editingPdf = false}}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"box":"","label":"Nome"},model:{value:(_vm.pdfModel.name),callback:function ($$v) {_vm.$set(_vm.pdfModel, "name", $$v)},expression:"pdfModel.name"}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":"","pa-3":""}},[(_vm.pdfModel.file && _vm.pdfName)?_c('v-chip',{staticClass:"white--text font-weight-light",attrs:{"color":"info"}},[_vm._v(_vm._s(_vm.pdfModel.file
            ? _vm.pdfName : _vm.pdfModel.file ? _vm.pdfModel.file :'Sem documentos'))]):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-tooltip',{staticStyle:{"width":"100%"},attrs:{"bottom":""}},[_c('v-btn',{staticClass:"white--text font-weight-light headline",attrs:{"slot":"activator","label":" Enviar seus documentos","color":"primary","round":"","block":"","outline":""},on:{"click":_vm.pickPdf},slot:"activator"},[_c('v-icon',[_vm._v("attach_file")])],1),_vm._v(" "),_c('span',{staticClass:"font-weight-light"},[_vm._v("Enviar arquivo (PDF)")])],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"success lighten-1","round":"","block":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.savePdf(_vm.pdfModel)}}},[_vm._v("\n          Salvar\n        ")])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center text-sm-center text-md-center text-lg-center",attrs:{"xs12":""}},[(!_vm.disableActions)?_c('v-footer',{staticClass:"pa-3 elevation-1",staticStyle:{"border-radius":"5px"},attrs:{"height":"auto","width":"100%","color":"info"}},[_c('span',{staticClass:"white--text"},[_c('strong',[_vm._v("AVISO:")]),_vm._v("\n        Todos arquivos enviados devem conter o formato '.pdf', caso contrário os arquivos não serão\n        aceitos!\n      ")])]):_vm._e(),_vm._v(" "),(!_vm.disableActions)?_c('v-layout',{staticClass:"px-3 pt-3",attrs:{"row":"","justify-center":""}},[_c('v-tooltip',{staticStyle:{"width":"100%"},attrs:{"bottom":""}},[_c('v-btn',{staticClass:"white--text font-weight-light headline",attrs:{"slot":"activator","label":" Enviar seus documentos","color":"primary","round":"","block":"","large":"","outline":""},on:{"click":_vm.pickPdf},slot:"activator"},[_vm._v("\n          E"),_c('a',{staticClass:"text-lowercase"},[_vm._v("nviar")]),_vm._v(" "),_c('v-icon',{attrs:{"right":""}},[_vm._v("attach_file")])],1),_vm._v(" "),_c('span',{staticClass:"font-weight-light"},[_vm._v("Enviar arquivos (PDF)")])],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[(_vm.pdfName)?_c('v-chip',{staticClass:"white--text font-weight-light",attrs:{"color":"info"}},[_vm._v("\n          "+_vm._s(_vm.pdfName ? _vm.pdfName : 'Sem documentos selecionados'))]):_vm._e()],1),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('input',{ref:"pdf",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"application/pdf"},on:{"change":_vm.onPdfPicked}}),_vm._v(" "),(_vm.contractDocuments)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[(_vm.contractDocuments.length > 0)?_c('v-data-iterator',{attrs:{"items":_vm.contractDocuments,"content-tag":"v-layout","row":"","wrap":"","hide-actions":"","no-data-text":""},scopedSlots:_vm._u([{key:"item",fn:function(props){return _c('v-flex',{staticClass:"px-0",attrs:{"xs12":""}},[_c('v-card',[_c('v-toolbar',{attrs:{"color":"primary","card":""}},[_c('v-toolbar-title',{staticClass:"white--text font-weight-light"},[_vm._v(_vm._s(props.item.name)+"\n                ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[(props.item.name.slice(-3) == 'pdf')?_c('v-btn',{attrs:{"color":"red accent-2","disabled":"","small":"","round":"","icon":""}},[_c('v-avatar',{staticClass:"font-weight-light white--text",attrs:{"size":"30","color":"red accent-2"}},[_vm._v("\n                      "+_vm._s(props.item.name.slice(-3))+"\n                    ")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"color":"white","icon":"","flat":"","title":"Abrir Documento","round":""},on:{"click":function($event){return _vm.openPdf(props.item.file)}}},[_c('v-icon',[_vm._v("call_made")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"teal lighten-2","icon":"","flat":"","round":"","title":"Editar Envio","disabled":_vm.disableActions},on:{"click":function($event){return _vm.editPdf(props.item)}}},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"error","icon":"","flat":"","title":"Remover Anexo","disabled":_vm.disableActions,"round":""},on:{"click":function($event){return _vm.openDialogToRemove(props.item)}}},[_c('v-icon',[_vm._v("delete")])],1)],1)],1)],1)],1)}}],null,false,584396291)}):_vm._e(),_vm._v(" "),_c('alert-delete',{ref:"dialogToDeleteDocument",on:{"deleteItem":_vm.removePdf}})],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__configuration__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_util__);











var RequestService = function () {
  function RequestService() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, RequestService);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(RequestService, null, [{
    key: 'validade',
    value: function validade(request) {
      var errors = [];
      if (!request.contract) errors.push('contrato');

      if (errors.length > 0) return errors;else return null;
    }
  }, {
    key: 'findAll',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_6__configuration__["a" /* default */].apiHost + 'requests/');

              case 3:
                response = _context.sent;
                return _context.abrupt('return', response.data);

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);
                throw new Error(_context.t0);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function findAll() {
        return _ref.apply(this, arguments);
      }

      return findAll;
    }()
  }, {
    key: 'create',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(request) {
        var saved;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_6__configuration__["a" /* default */].apiHost + 'requests/', request);

              case 3:
                saved = _context2.sent;
                return _context2.abrupt('return', saved.data);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);
                throw new Error(_context2.t0);

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function create(_x) {
        return _ref2.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: 'update',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(request) {
        var updated;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.put(__WEBPACK_IMPORTED_MODULE_6__configuration__["a" /* default */].apiHost + 'requests/', request);

              case 3:
                updated = _context3.sent;
                return _context3.abrupt('return', updated.data);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);
                throw new Error(_context3.t0);

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function update(_x2) {
        return _ref3.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: 'sliptArrays',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(array, index) {
        var repetir, arrayCopied, matriz, arrParticionado, indexesNulls, posicao;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                repetir = true;
                arrayCopied = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(array)); //copiar Array

                matriz = [];
                arrParticionado = [];
                indexesNulls = 0;
                posicao = [];

                while (repetir) {
                  if (indexesNulls == arrayCopied.length) repetir = false;else {
                    arrParticionado = arrayCopied.filter(function (value, i) {
                      if (value.address.cep == arrayCopied[index].address.cep && value.address.number == arrayCopied[index].address.number) {
                        indexesNulls++;
                        return true;
                      } else return false;
                    });
                    matriz.push(arrParticionado);
                    index++;
                  }
                }

                return _context4.abrupt('return', matriz);

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function sliptArrays(_x3, _x4) {
        return _ref4.apply(this, arguments);
      }

      return sliptArrays;
    }()
  }, {
    key: 'formatterContractToRequest',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(contract) {
        var request;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                request = {
                  departments: contract.departments,
                  contract: contract._id,
                  contractCode: contract.contractCode,
                  client: contract.client
                };

                RequestService.create(request);

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function formatterContractToRequest(_x5) {
        return _ref5.apply(this, arguments);
      }

      return formatterContractToRequest;
    }()
  }]);

  return RequestService;
}();
// class


/* harmony default export */ __webpack_exports__["a"] = (RequestService);

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = Object({"NODE_ENV":"production"}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(370);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(371);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb, null, ret) },
            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33)))

/***/ }),
/* 370 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 371 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__service_AnalyticalWorksheetService_js__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__service_BudgetService_js__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__service_ContractService_js__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__service_RequestService_js__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__service_CompanyService_js__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__service_PersonService_js__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__service_UserService_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__service_UtilService_js__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_TypesOfSituations_js__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_UtilFormatter_js__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_MessageFormatterUtil_js__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__service_SystemConfigurationService__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__service_CityService_js__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_budget_AnalyticalWorksheet__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_contract_department_Department__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_budget_FormCity__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_contract_department_Tables__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_contract_Request_ListItems__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_contract_Uploads_UploadPdf__ = __webpack_require__(366);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// SERVICES //














// COMPONENTES







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AnalyticalWorksheet: __WEBPACK_IMPORTED_MODULE_17__components_budget_AnalyticalWorksheet__["a" /* default */],
    Tables: __WEBPACK_IMPORTED_MODULE_20__components_contract_department_Tables__["a" /* default */],
    Department: __WEBPACK_IMPORTED_MODULE_18__components_contract_department_Department__["a" /* default */],
    ListProducts: __WEBPACK_IMPORTED_MODULE_21__components_contract_Request_ListItems__["a" /* default */],
    FormCity: __WEBPACK_IMPORTED_MODULE_19__components_budget_FormCity__["a" /* default */],
    UploadPdf: __WEBPACK_IMPORTED_MODULE_22__components_contract_Uploads_UploadPdf__["a" /* default */]
  },

  data: function data() {
    var _ref;

    return _ref = {
      typesItems: [
      /*   {title:"", type:"",value:""}, */
      {
        title: 'Materiais de Consumo',
        type: 'Material de Consumo',
        value: 'consumables'
      }, {
        title: 'Equipamentos',
        type: 'Equipamento',
        value: 'equipments'
      }, {
        title: 'Utensílios',
        type: 'Utensílio',
        value: 'utensils'
      }, {
        title: "Uniformes e EPI's",
        type: "Uniforme e EPI's",
        value: 'uniformsAndEPIs'
      }],
      showDialogAddNewCity: false,
      panel: [false, false, false],
      panelDepartment: [false, false, false, false],
      cep: '',
      cities: [],
      contract: {
        client: {
          supervisorResponsibles: []
        },
        situation: {},
        company: {
          address: {
            // Endereço
            cep: '',
            addressType: '', // Logradouro
            number: '',
            district: '',
            complement: '',
            city: '',
            state: ''
          }
        },
        departments: []
      },

      pagination: {
        sortBy: 'requestCode',
        descending: true
      },
      itemsKeys: ['requestCode', 'requestDate'],
      dialogDepartment: false,
      departmentIndex: -1,
      department: {
        professionalCategory: {},
        address: {}
      },
      materials: {
        consumables: {
          items: []
        },
        equipments: {
          items: []
        },
        uniformsAndEPIs: {
          items: []
        },
        utensils: {
          items: []
        }
      },
      editDepartmentItem: false,
      sectorType: 'SEDE',
      ationEditDisabled: true,
      dialogLoading: false,
      dialogImportBudget: false
    }, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'dialogDepartment', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'utilFormatter', __WEBPACK_IMPORTED_MODULE_13__utils_UtilFormatter_js__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'isNewRequest', true), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'isEditing', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'isSearchingAddress', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'situationEditDisabled', true), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'requestTypeEdit', true), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'msgAlert', ''), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'alertType', ''), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'alert', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'request', {
      requestDocuments: []
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'companies', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'clients', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'users', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'budgets', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'sheetRemovable', {}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'situations', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'removeDialog', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'requestTypes', ['Reserva', 'Envio']), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'loading', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'requests', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'emptyRecordsText', 'Nenhum registro encontrado'), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'emptySearchText', 'Nenhum registro encontrado para'), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'search', ''), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'editingSheet', {}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'headers', [{
      text: 'Código da Requisição',
      align: 'left',
      sortable: true,
      value: 'requestCode'
    }, {
      text: 'Data da requisição',
      align: 'center',
      value: 'requestDate'
    }, {
      text: 'Tipo de Requisição',
      align: 'center',
      value: 'requestType'
    }, {
      text: 'Código do Contrato',
      align: 'center',
      value: 'contract.contractCode'
    }, {
      text: 'Situação de Entrega',
      align: 'center',
      value: 'situation'
    }, {
      text: 'Ações',
      align: 'center',
      value: 'name',
      sortable: false
    }]), _ref;
  },


  methods: {
    init: function init() {
      this.alert = false;
      this.contract = {
        client: {},
        situation: {},
        address: {}
      };
      this.loading = false;
      this.isEditing = false;
      this.dialogLoading = true;
      this.isNewRequest = false;
      this.dialogLoading = false;
      this.editingSheet = {};
      this.department = {};
      this.findAllRequests();
    },
    buttonAddNewCity: function buttonAddNewCity() {
      this.showDialogAddNewCity = true;
    },
    closeDialogNewCity: function closeDialogNewCity() {
      this.showDialogAddNewCity = false;
      /* 430 */
    },
    savedCity: function savedCity() {
      this.fillCitiesTable();
      this.showDialogAddNewCity = false;
    },
    findCityByNameAndState: function findCityByNameAndState(address) {
      if (!this.cities) return;

      for (var i = 0; i < this.cities.length; i++) {
        if (address.city.toUpperCase() == this.cities[i].name.toUpperCase() && address.state.toUpperCase() == this.cities[i].state.toUpperCase()) {
          return this.cities[i];
        }
      }
    },

    cityText: function cityText(item) {
      return item.name + ' - ' + item.state + ' (' + item.uf + ')';
    },

    companyText: function companyText(item) {
      return item.socialName + ' - ' + item.fantasyName;
    },

    clientText: function clientText(item) {
      return item.isLegalPerson ? item.socialName + ' - ' + item.fantasyName : item.name + ' - ' + item.cpf;
    },

    addNewRequest: function addNewRequest() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogLoading = true;
                _context.next = 3;
                return _this.fillCompaniesTable();

              case 3:
                _context.next = 5;
                return _this.fillClientsTable();

              case 5:
                _context.next = 7;
                return _this.fillSituations();

              case 7:
                _context.next = 9;
                return _this.fillUsersTable();

              case 9:
                _context.next = 11;
                return _this.fillCitiesTable();

              case 11:
                _this.dialogLoading = false;
                _this.isNewRequest = true;

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    cancelNewRequest: function cancelNewRequest() {
      this.init();
    },
    findAllRequests: function findAllRequests() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.loading = true;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_7__service_RequestService_js__["a" /* default */].findAll();

              case 4:
                _this2.requests = _context2.sent;
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);

                console.log(_context2.t0);

              case 10:
                _context2.prev = 10;

                _this2.loading = false;
                return _context2.finish(10);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 7, 10, 13]]);
      }))();
    },
    fillCompaniesTable: function fillCompaniesTable() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_8__service_CompanyService_js__["a" /* default */].getCompaniesForSpecificData();

              case 3:
                _this3.companies = _context3.sent;
                _context3.next = 9;
                break;

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3['catch'](0);

                console.log(_context3.t0);

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 6]]);
      }))();
    },
    fillCitiesTable: function fillCitiesTable() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_16__service_CityService_js__["a" /* default */].getAll();

              case 3:
                _this4.cities = _context4.sent;
                _context4.next = 9;
                break;

              case 6:
                _context4.prev = 6;
                _context4.t0 = _context4['catch'](0);

                console.log(_context4.t0);

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 6]]);
      }))();
    },
    fillClientsTable: function fillClientsTable() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_9__service_PersonService_js__["a" /* default */].getAll();

              case 3:
                _this5.clients = _context5.sent;
                _context5.next = 9;
                break;

              case 6:
                _context5.prev = 6;
                _context5.t0 = _context5['catch'](0);

                console.log(_context5.t0);

              case 9:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 6]]);
      }))();
    },
    fillUsersTable: function fillUsersTable() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return __WEBPACK_IMPORTED_MODULE_10__service_UserService_js__["a" /* default */].getAll();

              case 3:
                _this6.users = _context6.sent;
                _context6.next = 9;
                break;

              case 6:
                _context6.prev = 6;
                _context6.t0 = _context6['catch'](0);

                console.log(_context6.t0);

              case 9:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[0, 6]]);
      }))();
    },
    fillSituations: function fillSituations() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this7.situations = [{
                  title: 'AGUARDANDO APROVAÇÃO',
                  color: '#f1f1f1'
                }, {
                  title: 'REPROVADO',
                  color: 'red'
                }, {
                  title: 'AGUARDANDO ENTREGA',
                  color: 'info'
                }, {
                  title: 'ENTREGUE',
                  color: 'green'
                }, {
                  title: 'ENTREGUE C/ DEVOLUÇÂO',
                  color: 'warning'
                }];

              case 1:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },

    situationText: function situationText(item) {
      return '' + item.title;
    },

    findAddressByCep: function findAddressByCep() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(_this8.contract != null)) {
                  _context8.next = 15;
                  break;
                }

                _context8.prev = 1;

                if (!(_this8.contract.address.cep && _this8.contract.address.cep.length == 8)) {
                  _context8.next = 7;
                  break;
                }

                _this8.isSearchingAddress = true;
                _context8.next = 6;
                return __WEBPACK_IMPORTED_MODULE_11__service_UtilService_js__["a" /* default */].findAddressByCep(_this8.contract.address.cep);

              case 6:
                _this8.contract.address = _context8.sent;

              case 7:
                _context8.next = 12;
                break;

              case 9:
                _context8.prev = 9;
                _context8.t0 = _context8['catch'](1);

                console.log(_context8.t0);

              case 12:
                _context8.prev = 12;

                _this8.isSearchingAddress = false;
                return _context8.finish(12);

              case 15:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this8, [[1, 9, 12, 15]]);
      }))();
    },
    showAlert: function showAlert(message, type) {
      this.msgAlert = message;
      this.alertType = type;
      this.alert = true;
    },
    editItem: function editItem(item) {
      this.isEditing = true;
      this.contract = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item.contract);
      this.request = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
      this.department = this.request.departments[0];
      this.addNewRequest();
    },
    save: function save() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
        var errors;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this9.dialogLoading = true;
                _context9.next = 3;
                return _this9.$refs.pdfs.saveAllDocuments();

              case 3:
                _this9.request.requestDocuments = _context9.sent;
                errors = __WEBPACK_IMPORTED_MODULE_7__service_RequestService_js__["a" /* default */].validade(_this9.request);

                if (!errors) {
                  _context9.next = 9;
                  break;
                }

                _this9.showAlert(__WEBPACK_IMPORTED_MODULE_14__utils_MessageFormatterUtil_js__["a" /* default */].formatErrorMessage(errors), 'error');
                _this9.dialogLoading = false;
                return _context9.abrupt('return');

              case 9:
                _context9.prev = 9;

                if (!_this9.isEditing) {
                  _context9.next = 16;
                  break;
                }

                _context9.next = 13;
                return __WEBPACK_IMPORTED_MODULE_7__service_RequestService_js__["a" /* default */].update(_this9.request);

              case 13:
                _this9.showAlert('Registro alterado com sucesso', 'success');
                _context9.next = 19;
                break;

              case 16:
                _context9.next = 18;
                return __WEBPACK_IMPORTED_MODULE_7__service_RequestService_js__["a" /* default */].create(_this9.request);

              case 18:
                _this9.showAlert('Registro salvo com sucesso', 'success');

              case 19:
                _context9.next = 25;
                break;

              case 21:
                _context9.prev = 21;
                _context9.t0 = _context9['catch'](9);

                _this9.showAlert('Erro ao salvar o requisição', 'error');
                console.log(_context9.t0);

              case 25:
                _context9.prev = 25;

                _this9.dialogLoading = false;
                return _context9.finish(25);

              case 28:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this9, [[9, 21, 25, 28]]);
      }))();
    },


    //###########################SETOR###########################//
    editDepartment: function editDepartment(index, item) {
      this.editDepartmentItem = true;
      this.$refs.departmentForm.editDepartment(item);
      this.materials = item.materials;
      this.departmentIndex = index;
      this.dialogDepartment = true;
    },
    removeDepartment: function removeDepartment(item) {
      var index = this.contract.departments.indexOf(item);
      confirm('Are you sure you want to delete this item?') && this.contract.departments.splice(index, 1);
    },
    saveDepartment: function saveDepartment() /* department */{
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var dep;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                dep = _this10.$refs.departmentForm.saveDepartment();

                _this10.department = dep;
                _context10.next = 4;
                return _this10.$refs.materialTables.save();

              case 4:
                _this10.department.materials = _context10.sent;

                if (_this10.editDepartmentItem) {
                  _this10.contract.departments[_this10.departmentIndex] = _this10.department;
                  _this10.editDepartmentItem = false;
                } else {
                  _this10.contract.departments.push(_this10.department);
                }

                _this10.closeDialogDepartment();

              case 7:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this10);
      }))();
    },
    sendAddress: function sendAddress() {
      this.$refs.departmentForm.setAddress(this.contract.company.address);
    },
    closeDialogDepartment: function closeDialogDepartment() {
      this.$refs.departmentForm.resetDepartment();
      this.materials = {
        consumables: {
          items: []
        },
        equipments: {
          items: []
        },
        uniformsAndEPIs: {
          items: []
        },
        utensils: {
          items: []
        }
      };
      this.$refs.materialTables;
      this.departmentIndex = -1;
      this.dialogDepartment = false;
      this.editDepartmentItem = false;
    },
    resetDepartment: function resetDepartment() {
      this.department = {
        materials: {
          consumables: {
            items: []
          },
          equipments: {
            items: []
          },
          uniformsAndEPIs: {
            items: []
          },
          utensils: {
            items: []
          }
        }
      };
    },
    download: function download() {
      // let sheet = await BudgetService.download(this.contract._id)
      // var blob = new Blob([sheet], {
      //   type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,"
      // });
      // var url = window.URL.createObjectURL(blob)
      // window.open(url);

      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, _this11);
      }))();
    }
  },

  computed: {
    footerDynamicText: function footerDynamicText() {
      var text = this.loading ? this.loadingRecordsText : this.emptyRecordsText;
      return text;
    },
    formTitle: function formTitle() {
      return this.isEditing ? 'Requisição' : 'Nova Requisição';
    }
  },

  created: function created() {
    this.init();
  }
});

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_ProductService_js__ = __webpack_require__(186);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        productList: {
            type: Array
        },
        typeProduct: String
    },
    data: function data() {
        return {
            pagination: {
                sortBy: 'description'
            },
            selected: [true],
            headers: [{ text: 'Descrição', align: 'left', value: 'description' }, { text: 'Marca', value: 'stamp' }, { text: 'Unidade de Medida', value: 'unity' }, { text: 'Quantidade', value: 'quantityApproved' }],
            products: []
        };
    },
    beforeMount: function beforeMount() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this.loadProducts();

                        case 2:
                            _this.selected = [true];

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },

    methods: {
        loadProducts: function loadProducts() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_2__service_ProductService_js__["a" /* default */].getByCategory({
                                    type: 'Material de Consumo'
                                });

                            case 2:
                                _this2.products = _context2.sent;

                            case 3:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        }
    }
});

/***/ }),
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(626);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(155)("56d11a2c", content, true, {});

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(154)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"Request.vue","sourceRoot":""}]);

// exports


/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListItems_vue__ = __webpack_require__(445);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85ab8d4a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListItems_vue__ = __webpack_require__(628);
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListItems_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85ab8d4a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListItems_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.productList,"pagination":_vm.pagination,"select-all":"","item-key":"description "},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [(props.item.quantityApproved>0 )?_c('tr',[_c('td',[_c('v-checkbox',{attrs:{"input-value":props.selected,"primary":"","hide-details":""}})],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.description))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.stamp))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.unity))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.quantityApproved))])]):_vm._e()]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isNewRequest)?_c('v-layout',{attrs:{"wrap":"","row":"","xs12":""}},[_c('v-toolbar',{attrs:{"flat":"","color":"white"}},[_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Pesquisar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mb-2",attrs:{"fab":"","dark":"","color":"primary","loading":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.addNewRequest();}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("add")])],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",staticStyle:{"width":"100%"},attrs:{"headers":_vm.headers,"search":_vm.search,"rows-per-page-text":"Registros por Página","rows-per-page-items":[5, 10, 30, 50],"items":_vm.requests,"loading":_vm.loading,"pagination":_vm.pagination,"item-key":"requestCode"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.requestCode))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm.utilFormatter.formatDateISOToBR( props.item.requestDate)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"font-weight-light",attrs:{"small":"","color":"#f1f1f1"}},[_vm._v(_vm._s(props.item.requestType))])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.contractCode ? props.item.contractCode :""))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"font-weight-light",attrs:{"small":"","color":props.item.situation.color}},[_vm._v("\n            "+_vm._s(props.item.situation.title || 'Teste'))])],1),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0"},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.editItem(props.item)}}},[_vm._v("edit")])],1)]}},{key:"pageText",fn:function(props){return [_vm._v("\n        "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de\n        "+_vm._s(props.itemsLength)+"\n      ")]}}],null,false,3247988290)},[_vm._v(" "),_vm._v(" "),_c('template',{slot:"no-data"},[_c('strong',[_vm._v(_vm._s(_vm.footerDynamicText))])]),_vm._v(" "),_c('div',{attrs:{"slot":"no-results","value":true},slot:"no-results"},[_c('h3',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm.emptySearchText)+" \""+_vm._s(_vm.search)+"\".")])])],2)],1):_c('v-layout',{attrs:{"wrap":"","row":""}},[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":"","dark":"","title":"Cancelar"},on:{"click":function($event){$event.preventDefault();return _vm.cancelNewRequest();}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.formTitle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-divider',{staticClass:"ml-2 mr-2",attrs:{"vertical":"","inset":"","dark":""}}),_vm._v(" "),_c('v-btn',{attrs:{"title":"Salvar Requisição","color":"primary","small":"","depressed":""},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n          Salvar Requisição\n          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1),_vm._v(" "),_c('v-btn',{attrs:{"title":"Download Requisição","color":"primary","small":"","depressed":""},on:{"click":function($event){$event.preventDefault();return _vm.download.apply(null, arguments)}}},[_vm._v("\n          Download Requisição\n          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("cloud")])],1)],1)],1),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-alert',{staticClass:"mb-3",attrs:{"value":_vm.alert,"color":_vm.alertType,"dismissible":""}},[_vm._v(_vm._s(_vm.msgAlert))]),_vm._v(" "),_c('v-expansion-panel',{attrs:{"expand":""},model:{value:(_vm.panel),callback:function ($$v) {_vm.panel=$$v},expression:"panel"}},[_c('v-expansion-panel-content',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('h1',{staticClass:"headline font-weight-bold pa-2 grey--text text--darken-1"},[_vm._v("Dados Gerais do Pedido")])]},proxy:true}])},[_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","py-0":""}},[_c('v-autocomplete',{attrs:{"readonly":_vm.isEditing,"label":"Empresa","item-value":"_id","items":_vm.companies,"item-text":_vm.companyText,"return-object":"","dense":"","flat":"","box":"","no-data-text":"Nenhuma empresa encontrada"},model:{value:(_vm.contract.company),callback:function ($$v) {_vm.$set(_vm.contract, "company", $$v)},expression:"contract.company"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","py-0":""}},[_c('v-autocomplete',{attrs:{"label":"Cliente (Contratante)","readonly":_vm.isEditing,"items":_vm.clients,"item-value":"_id","item-text":_vm.clientText,"return-object":"","dense":"","flat":"","box":"","no-data-text":"Nenhum cliente encontrado"},model:{value:(_vm.contract.client),callback:function ($$v) {_vm.$set(_vm.contract, "client", $$v)},expression:"contract.client"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md8":"","py-0":""}},[_c('v-autocomplete',{attrs:{"label":"Supervisor Responsável","readonly":_vm.isEditing,"item-value":"_id","items":_vm.users,"item-text":"name","return-object":"","dense":"","flat":"","box":"","no-data-text":"Nenhum responsável encontrado"},model:{value:(_vm.contract.supervisor),callback:function ($$v) {_vm.$set(_vm.contract, "supervisor", $$v)},expression:"contract.supervisor"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md4":"","py-0":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Dia de Envio","readonly":_vm.isEditing,"box":""},model:{value:(_vm.contract.sendDate),callback:function ($$v) {_vm.$set(_vm.contract, "sendDate", $$v)},expression:"contract.sendDate"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md6":"","py-0":""}},[_c('v-layout',{staticClass:"ma-0",attrs:{"row":"","wrap":""}},[_c('v-autocomplete',{attrs:{"label":"Situação","item-value":"title","items":_vm.situations,"item-text":_vm.situationText,"return-object":"","dense":"","box":"","disabled":_vm.situationEditDisabled},model:{value:(_vm.request.situation),callback:function ($$v) {_vm.$set(_vm.request, "situation", $$v)},expression:"request.situation"}}),_vm._v(" "),_c('v-btn',{staticStyle:{"float":"right"},attrs:{"dark":"","color":"primary","fab":"","small":""},on:{"click":function($event){_vm.situationEditDisabled = !_vm.situationEditDisabled}}},[(_vm.situationEditDisabled)?_c('v-icon',{staticClass:"white--text"},[_vm._v("edit")]):_c('v-icon',{staticClass:"white--text"},[_vm._v("check")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md6":"","py-0":""}},[_c('v-layout',{staticClass:"ma-0",attrs:{"row":"","wrap":""}},[_c('v-autocomplete',{attrs:{"label":"Tipo de Requisição","item-value":"name","items":_vm.requestTypes,"return-object":"","dense":"","box":"","disabled":_vm.requestTypeEdit,"readonly":_vm.isEditing},model:{value:(_vm.request.requestType),callback:function ($$v) {_vm.$set(_vm.request, "requestType", $$v)},expression:"request.requestType"}}),_vm._v(" "),_c('v-btn',{staticStyle:{"float":"right"},attrs:{"readonly":_vm.isEditing,"dark":"","color":"primary","fab":"","small":""},on:{"click":function($event){_vm.requestTypeEdit = !_vm.requestTypeEdit}}},[(_vm.requestTypeEdit)?_c('v-icon',{staticClass:"white--text"},[_vm._v("edit")]):_c('v-icon',{staticClass:"white--text"},[_vm._v("check")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('h1',{staticClass:"headline font-weight-bold pa-2 pb-0 grey--text text--darken-1"},[_vm._v("Setores")])]},proxy:true}])},[_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{staticClass:"pt-0",attrs:{"row":"","wrap":""}},_vm._l((_vm.contract.departments),function(department,i){return _c('v-flex',{key:department._id,attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-list',{staticClass:"py-0 elevation-2",attrs:{"two-line":"","light":""}},[_c('v-list-tile',[_c('v-list-tile-content',{staticClass:"descoration",on:{"click":function($event){return _vm.editDepartment(i, department)}}},[(department.lastName)?_c('v-list-tile-title',[_vm._v(_vm._s(department.name +"-"+department.lastName)+"\n                            ")]):_vm._e(),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("\n                              "+_vm._s(department.numberOfEmployees>0
                              ? department.numberOfEmployees+' funcionário(s)'
                              : "Nenhum Funcionário Cadastrado")+"\n                            ")])],1)],1)],1)],1)}),1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('h1',{staticClass:"headline font-weight-bold pa-2 pb-0 grey--text text--darken-1"},[_vm._v("Documentos")])]},proxy:true}])},[_vm._v(" "),_c('upload-pdf',{ref:"pdfs",attrs:{"contractDocuments":_vm.request.requestDocuments}})],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"fullscreen":"","persistent":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialogDepartment),callback:function ($$v) {_vm.dialogDepartment=$$v},expression:"dialogDepartment"}},[_c('v-card',[_c('v-toolbar',{staticClass:"elevation-1",attrs:{"dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":"","dark":"","title":"Cancelar"},on:{"click":_vm.closeDialogDepartment}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Setor")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"title":"Salvar Setor","color":"primary","small":"","depressed":""},on:{"click":_vm.saveDepartment}},[_vm._v("\n              Salvar\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","px-5":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('department',{ref:"departmentForm",attrs:{"finalizedContract":true,"contractHaveBudgetImported":_vm.contract.budgetImported,"contractDontHaveBudgetButIsFinished":true,"isPageRequest":true},on:{"chengedSector":_vm.sendAddress}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mt-5":"","mb-3":""}},[_c('v-expansion-panel',{attrs:{"expand":""},model:{value:(_vm.panelDepartment),callback:function ($$v) {_vm.panelDepartment=$$v},expression:"panelDepartment"}},_vm._l((4),function(i){return _c('v-expansion-panel-content',{key:i,scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('h1',{staticClass:"headline font-weight-bold pa-2 grey--text text--darken-1"},[_vm._v(_vm._s(_vm.typesItems[i-1].title))])]},proxy:true}],null,true)},[_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('list-products',{attrs:{"productList":_vm.materials[_vm.typesItems[i-1].value].items}})],1)],1)],1)}),1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"hide-overlay":"","persistent":"","width":"300"},model:{value:(_vm.dialogLoading),callback:function ($$v) {_vm.dialogLoading=$$v},expression:"dialogLoading"}},[_c('v-card',{attrs:{"color":"primary","dark":""}},[_c('v-card-text',[_vm._v("\n        Carregando\n        "),_c('v-progress-linear',{staticClass:"mb-0",attrs:{"indeterminate":"","color":"white"}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
]));


// WEBPACK FOOTER //
// static/js/1.84b9ffee59b3237e8da8.js